//old
import { Component, OnInit, Output, EventEmitter, ViewChild, Inject, LOCALE_ID } from '@angular/core';
import { TicketIssuanceService } from '../Services/ticketIssuance.service';
import { NgModule, ElementRef } from '@angular/core';
import { HttpEventType, HttpClient } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { TicketIssuanceProperties, PassengerInfoProperties, AirportCityProperties, PassengerBaggageProperties, TicketPnrRights, VoidTicketProperties, TicketAirlineProperties, TicketDataRequest, OfflineToOnlineProperties, buttonpropertiesforticketissueance, TicketPaxBaggageSectorSortedProperties, TicketSortedPaxs } from '../Models/TicketIssuanceProperties';
import { BookingInfoProperties, BookingPassengerInfoProperties, PassengerCreationResponse, SectorInformationProperties, TaxDetailsProperties } from '../Models/BookingPassengerTicketIssuanceProperties';
import { Router } from '@angular/router';
import { Observable, throwError, of } from 'rxjs';

import { DatePipe, formatDate } from '@angular/common';
import { saveAs } from 'file-saver';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { DxDataGridComponent, DxLoadPanelModule, DxDataGridModule } from 'devextreme-angular';
import DataSource from 'devextreme/data/data_source';
import { exportDataGrid } from 'devextreme/pdf_exporter';
import { AgencyBranchCreditProperties, AgencyBranchDataProperties, AgencyMasterProperties } from '../Models/AgencyMasterProperties';
import { AgencyService } from '../Services/Agency.service';
import { Canvg } from 'canvg';
import { UsersProperties, userBackCompanyCustomerCode } from '../Models/UsersProperties';
import { OfflineRequestService } from '../Services/offline-request.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EmailItineraryService } from '../Services/emailItinerary.service';
import { UsersService } from '../Services/users.service';
import { PassengerInfoService } from '../Services/passengerInfo.service';
import { TicketEmailProperties } from '../Models/ERPProperties';
import { Countries } from '../Models/Countries';
import { DxPopoverModule, DxTemplateModule } from 'devextreme-angular';
import autoTable from 'jspdf-autotable';
import { GroupTicketService } from '../Services/groupTicket.service';
import { ConfirmationService, MessageService, PrimeTemplate } from 'primeng/api';
import { EmiratesEnumsForExchangedDivide, EmiratesModificationFunctions } from './EmiratesModificationFunctions';
import { PostTicketingModificationService } from '../Services/PostTicketingModification.service';
import { PostAncillaryGetProperties } from '../Models/PostModificationProperties';

import { FlightSearchDestinationProperties, FlightSearchProperties } from '../Models/FlightSearchProperties';

import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { NavMenuComponent } from '../nav-menu/nav-menu.component';
import { Bind } from 'primeng/bind';
import { Toast } from 'primeng/toast';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { Dialog } from 'primeng/dialog';
import { Select } from 'primeng/select';
import { DxoAnimationModule, DxoShowModule, DxoHideModule } from 'devextreme-angular/ui/nested';
import { DxTemplateModule as DxTemplateModule_1 } from 'devextreme-angular/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { TableModule } from 'primeng/table';
import { ToggleSwitch } from 'primeng/toggleswitch';


pdfMake.vfs = pdfFonts.pdfMake.vfs;
/*import FileSaver = require("file-saver");*/
declare var $;

@Component({
    selector: 'ticket-issuance',
    templateUrl: './ticket-issuance.component.html',
    styleUrls: ['./ticket-issuance.component.css'],
    imports: [NavMenuComponent, DxLoadPanelModule, Bind, Toast, ConfirmDialog, PrimeTemplate, Dialog, DxDataGridModule, FormsModule, Select, DxPopoverModule, DxoAnimationModule, DxoShowModule, DxoHideModule, DxTemplateModule_1, NgSelectModule, TableModule, ToggleSwitch, DatePipe]
})

export class TicketIssuanceComponent {
  page: any;

  //@ViewChild('gridContainer1', { static: false }) dataGrid1: DxDataGridComponent;
  //@ViewChild('gridContainer2', { static: false }) dataGrid2: DxDataGridComponent;
  @ViewChild('gridContainer3') dataGrid3: DxDataGridComponent;
  @ViewChild('spprokmsg') mymodal: ElementRef | undefined;
  @ViewChild('ancierror') mymodalanci: ElementRef | undefined;
  bookingStatus: string;
  airlineNameStr: string;
  ticketAirlinesList: TicketAirlineProperties[] = [];
  //@ViewChild('gridContainer4', { static: false }) dataGrid4: DxDataGridComponent;
  withAnimationOptionsVisible: boolean[] = [];
  withAnimationOptionsVisibleexchange: boolean[] = [];
  ANCIMsg: string;
  netpayamount: number;
  removePassengerPopup: boolean;
  buttonsHideIfEmiratesOccur: boolean;
  messageshow: string;
  messageShowpop: boolean;
  constructor(@Inject(LOCALE_ID) public locale: string,
    private confirmationService: ConfirmationService, private postMofifyservice: PostTicketingModificationService, private messageservice: MessageService, private emailService: EmailItineraryService, private agencyService: AgencyService, private groupTicketService: GroupTicketService, private ticketIssuanceService: TicketIssuanceService, private http: HttpClient, private router: Router, private el: ElementRef, private NewSuccess: NgbModal, private service: OfflineRequestService, private userService: UsersService, public passengerInfoService: PassengerInfoService) {

  };
  toggleWithAnimationOptions(index) {
    this.withAnimationOptionsVisible[index] = !this.withAnimationOptionsVisible[index];
  }
  toggleWithAnimationOptionsexchaned(index) {
    this.withAnimationOptionsVisibleexchange[index] = !this.withAnimationOptionsVisibleexchange[index];
  }
  GetAllUserBackCompanyCustomerCode: userBackCompanyCustomerCode[] = [];
  ticketEmailObj = new TicketEmailProperties();
  bookingAllData$: TicketIssuanceProperties;
  bookingInfo = new BookingInfoProperties();
  bookingInfoList: BookingInfoProperties[] = [];
  bookingPassengerInfo: BookingPassengerInfoProperties[] = [];
  bookingPassengerInfoOffline: BookingPassengerInfoProperties[] = [];
  voidPassengerInfo: BookingPassengerInfoProperties[] = [];
  bookingInfoModif: BookingInfoProperties[] = [];
  sectorInfoModif: SectorInformationProperties[] = [];
  passengerInfo: PassengerInfoProperties[] = [];
  airportCities: AirportCityProperties[] = [];
  passengerBaggage: PassengerBaggageProperties[] = [];
  tktPnrRight = new TicketPnrRights();
  fromDestination: string;
  toDestination: string;
  bookingDate: string;
  departDate: string;
  arriveDate: string;
  isLoadPanelVisible: boolean = false;
  departureDay: string;
  departureMonth: string;
  departureD: string;
  departureYear: string;
  fromAirportX1: number;
  fromAirportY1: number;
  pnrsX: number;
  pnrsY: number;
  pnrY1: number;
  desX: number;
  desY: number;
  arrivalDay: string;
  arrivalMonth: string;
  arrivalD: string;
  arrivalYear: string;
  exchangedModel = new EmiratesModificationFunctions(this.postMofifyservice);
  bookingSingleList: TicketIssuanceProperties;
  emailAddress: string;
  subject: string;
  body: string;
  bookingID: number;
  passengerType: string;
  creditData: AgencyBranchCreditProperties;
  pcreditLimit: number = 0;
  creditLimit: number = 0;
  agencyID: string = "";
  agencyName: string = "";
  userId: number = 0;
  selectedBackCompanyUserId: number = 0;
  userOnline = new UsersProperties();
  agencyOnline = new AgencyMasterProperties();
  ticketReqFromOfflineList: string = "";
  voidReqFromOfflineList: string = "";
  pnrReqFromOfflineList: string = "";
  onlineRequestfromOfflineAgencyId: string = "";
  offlineIdRequestFromOfflineList: number = 0;
  nettosupplierbase: number = 0;
  exchangenettosupplierbase: number = 0;
  offlineTempId: number = 0;
  bookingrefundinfo = new BookingInfoProperties();
  bookingPassengerInfoRfnd: BookingPassengerInfoProperties[] = [];
  refundReqFromOfflineList: string = "";
  requestTypeIdOffline: string = "";
  fromroute: string = "";
  checkvoid: boolean = false;
  checkrfnd: boolean = false;
  offlineRequestNoRight: string;
  supplierMsg: string = "";
  emailRegex: boolean = false;
  supplierRemarksSingle: string = "";
  exchangedsupplieremarks: string = "";
  currency: string = "";
  buttonagreed_Issue: boolean = false;
  buttonagreed_Reprice: boolean = false;
  buttonagreed_cancel: boolean = false;
  buttonagreed_void: boolean = false;
  buttonagreed_refund: boolean = false;
  partialExchange: boolean = false;
  newsectorInfo: SectorInformationProperties[] = [];
  ExchangenewsectorInfo: SectorInformationProperties[] = [];
  offlinetoOnlineproperty = new OfflineToOnlineProperties();
  checkbuttonhideshow = new buttonpropertiesforticketissueance();
  loadervisible: boolean = true;
  ChangeCost: boolean = false;
  FZmodification: boolean = false;
  checkIssueTicket: boolean = false;
  showAddDetailButton: boolean = false;
  showNationalityFor1GGDS_1GNDc: boolean = false;
  showPostInvoiceBtnForBranches: boolean = false;
  showRepricebtn: boolean = false;
  isPostingInvoice: boolean = false;
  ChangePrice: number = 0;
  serviceChargesPerPassenger: number = 0;
  totalSumAmount: number = 0;
  countryList: Countries[] = [];
  ngOnDestroy() {
    this.loadervisible = false;
    localStorage.removeItem('OfflineToOnline');
    localStorage.removeItem("fromroutePageNoright");
    localStorage.removeItem("OffilineRequest");
    localStorage.removeItem("MessageforSeat");
    localStorage.removeItem("bookingID");
    this.stopTimerToRefresh();
  }

  refreshTktopen: boolean = false;

  private refreshInterval: any;
  startTimerToRefresh(): void {
    if (!this.refreshInterval) {
      this.refreshInterval = setInterval(() => {
        this.refreshPageClick();
      }, 300000);
    }
  }

  stopTimerToRefresh(): void {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
      this.refreshInterval = null;
    }
  }


  refreshPageClick() {
    this.refreshTktopen = false;
    this.loadBookingInfoData();
    this.startTimerToRefresh();
  }
  errorIssueticketMessage: string = "";
  isAirBlueSeatAdded = false;

  ngOnInit() {
    this.startTimerToRefresh();
    try {
      //this.buttonagreed_Issue = true;
      //localStorage.setItem("isAirBlueSeatAdded", JSON.stringify(false));
      this.messageshow = localStorage.getItem("MessageforSeat");
      if (this.messageshow != null && this.messageshow != undefined && this.messageshow != "") {
        this.messageShowpop = true;
        localStorage.removeItem("MessageforSeat");
      }
    }
    catch (e) {

    }
    this.loadervisible = true;
    try {
      this.offlinetoOnlineproperty = JSON.parse(localStorage.getItem('OfflineToOnline'));
      if (this.offlinetoOnlineproperty != null) {
        this.OfflineData();
      }
      else {
        this.offlinetoOnlineproperty = new OfflineToOnlineProperties();
        this.offlinetoOnlineproperty.TicketIssueReqFromOffline = false;
        this.offlinetoOnlineproperty.VoidReqFromOffline = false;
        this.offlinetoOnlineproperty.RefundReqFromOffline = false;
        this.offlinetoOnlineproperty.PNRReqFromOffline = false;
      }

      this.bookingID = Number(localStorage.getItem("bookingID"));
      this.offlineRequestNoRight = (localStorage.getItem("OffilineRequest"));
      this.fromroute = localStorage.getItem("fromroutePageNoright");


    }
    catch (e) {

    }
    this.agencyID = localStorage.getItem("AgencyId");
    this.userService.GetAllUserBackCompanyCustomerCode().subscribe((data) => {
      this.GetAllUserBackCompanyCustomerCode = data;
    });


    this.ticketIssuanceService.CheckTktPnrRightsAgainstBooking(localStorage.getItem("AgencyId"), localStorage.getItem("UserId"), this.bookingID).subscribe((data2) => {
      this.tktPnrRight = data2;

      this.loadBookingInfoData();
    });

  }
  getCountries() {
    try {
      this.passengerInfoService.getCountries().subscribe((data) => {
        this.countryList = data;

      });
    }
    catch (e) {
      ////////Console.log(e);
    }
  }
  OfflineData() {
    this.offlineIdRequestFromOfflineList = this.offlinetoOnlineproperty.OfflineId;
    this.offlineTempId = this.offlineIdRequestFromOfflineList;

    this.requestTypeIdOffline = this.offlinetoOnlineproperty.RequestTypeIdOffline;
    this.onlineRequestfromOfflineAgencyId = this.offlinetoOnlineproperty.AgencyTicketReqFromOffline;
  }

  multipleEmailRegex(value): boolean {
    var regex = /^\w+([-+.']\w+)*@([\w-]+\.)+[\w-]{2,4}(, ?\w+([-+.']\w+)*@([\w-]+\.)+[\w-]{2,4})*$/;
    if (value.match(regex)) {
      document.getElementById("messageEmail").innerHTML = '';
      this.emailRegex = true;
    }
    else {
      document.getElementById("messageEmail").innerHTML = 'Please Follow The Pattern';
      setTimeout(() => { document.getElementById("messageEmail").innerHTML = ''; }, 5000);
      this.emailRegex = false;
    }
    return this.emailRegex;
  }
  popupEmailItineraryFinance(targetmodel) {
    this.NewSuccess.open(targetmodel, {

      windowClass: "warningPopupmodal", centered: true
    })
  }
  popupEmailItineraryWithoutFinance(targetmodel) {

    this.NewSuccess.open(targetmodel, {

      windowClass: "warningPopupmodal", centered: true
    })
  }
  openspr(targetmodel) {
    this.NewSuccess.open(targetmodel, {

      windowClass: "warningPopupmodal", centered: true
    })
  }
  refundamount: boolean = false;
  loadBookingInfoData() {
    try {

      let ticketobj = new TicketDataRequest();
      ticketobj.agencyId = localStorage.getItem("AgencyId");
      ticketobj.userId = Number(localStorage.getItem("UserId"));
      ticketobj.bookingID = Number(localStorage.getItem("bookingID"));

      this.bookingAllData$ = new TicketIssuanceProperties;
      this.ticketIssuanceService.getBookingInfo(ticketobj).subscribe((data) => {
        this.newsectorInfo = [];
        this.ExchangenewsectorInfo = [];
        this.bookingAllData$ = data;
        //////////console.log (this.bookingAllData$);
        this.supplierMsg = this.bookingAllData$.pnrLocalMsg;
        /*    this.supplierMsg = "SHHGSHSHHS";*/
        //if (this.supplierMsg != "" && this.supplierMsg != undefined) {
        //  this.openspr(this.mymodal);

        //}
        if (this.bookingAllData$.bookingInfo.providerCode == "1GGDS" || this.bookingAllData$.bookingInfo.providerCode == "1GNDC" || this.bookingAllData$.bookingInfo.providerCode == "1G") {
          this.showAddDetailButton = true;
          

          this.getCountries();
        }
        if (this.bookingAllData$.bookingInfo.providerCode == "1GGDS" || this.bookingAllData$.bookingInfo.providerCode == "1GNDC") {
          this.showNationalityFor1GGDS_1GNDc = true;
        }
        const bookingDate = new Date(this.bookingAllData$.bookingInfo.bookingDate);
        const today = new Date();

        bookingDate.setHours(0, 0, 0, 0);
        today.setHours(0, 0, 0, 0);
        if (ticketobj.agencyId =="AG01" && this.bookingAllData$.bookingInfo.providerCode == "1GGDS" && this.bookingAllData$.bookingStatus == "Booked" && bookingDate < today)
       // if (this.bookingAllData$.bookingInfo.providerCode == "1GGDS" && this.bookingAllData$.bookingStatus == "Booked")
        {
          this.showRepricebtn = true;
        } else {
          this.showRepricebtn = false;
        }

        if (this.bookingAllData$.bookingInfo.providerCode == "EK") {
          if (this.bookingAllData$.bookingInfo.exchangeDivideCheck) {
            if (this.bookingAllData$.bookingInfo.exchangedBookingStatus > 1) {
              this.buttonsHideIfEmiratesOccur = true;
            }
            else {
              this.buttonsHideIfEmiratesOccur = false;
            }

          }
          else {
            this.buttonsHideIfEmiratesOccur = false;
          }
        }
        else {
          this.buttonsHideIfEmiratesOccur = false;
        }
        this.bookingInfo = this.bookingAllData$.bookingInfo;
        if (this.bookingInfo.bookingPassengerInfoProperties[0].costExchangeRate > 0) {
          sessionStorage.setItem('roe', JSON.stringify(this.bookingInfo.bookingPassengerInfoProperties[0].costExchangeRate));
        }
        if (this.bookingInfo.providerCode == 'PA') {
          if (localStorage.getItem("isAirBlueSeatAdded") != null) {
            this.isAirBlueSeatAdded = JSON.parse(localStorage.getItem("isAirBlueSeatAdded"));
            if (this.isAirBlueSeatAdded) {
              this.buttonagreed_Issue = false;
            } else {
              this.buttonagreed_Issue = true;
            }
          }
        }
        else {
          this.buttonagreed_Issue = false;
        }
        // this.bookingInfo.bookingPassengerInfoProperties = this.bookingAllData$.bookingPassengerInfo;
        if (this.bookingInfo.galileoBookingProp === null) {
          if (this.bookingInfo.flightlocationInfoDBSave === null) {
            this.flightSearchProperties = JSON.parse(this.bookingInfo.originDestinationDetails);
          } else {
            this.flightSearchProperties = JSON.parse(this.bookingInfo.flightlocationInfoDBSave).flightProp;
          }
        } else {
          this.flightSearchProperties = this.bookingInfo.galileoBookingProp.flightProp;
        }
        /*------------------------sector Information section start here----------------------------*/
        this.agencyOnline = this.bookingAllData$.agencyOnline;
        this.userOnline = this.bookingAllData$.userOnline;
        this.bookingStatus = this.bookingAllData$.bookingStatus;

        this.checkbuttonhideshow = this.bookingAllData$.buttonsProperties;
        if (this.bookingAllData$.bookingInfo.providerCode == "FZ") {
          let segmentChange = 0;
          let data = JSON.parse(this.bookingAllData$.bookingInfo.flightlocationInfoDBSave);
          //////////console.log (data);
          //bookingInfo.exchangeCheck
          if (data.flightProp.FlightLocationInfo.length == 2) {
            if (this.checkbuttonhideshow.modifybtn == true) {
              if (data.modifyflightProp) {
                if (data.flightProp.FlightLocationInfo[0].DepartureDate != data.modifyflightProp.FlightLocationInfo[0].DepartureDate.split('T')[0]) {
                  segmentChange++;
                }
                if (data.flightProp.FlightLocationInfo[1].DepartureDate != data.modifyflightProp.FlightLocationInfo[1].DepartureDate.split('T')[0]) {
                  segmentChange++;
                }
              }
            }
            if (segmentChange == 1) {
              this.partialExchange = true;
            } else {
              this.partialExchange = false;
            }
          }

        }
        if (this.offlineRequestNoRight == "True") {

          this.checkbuttonhideshow = new buttonpropertiesforticketissueance();
          this.buttonhidemethod();

        }
        else if (this.offlineRequestNoRight == "False") {
          this.checkbuttonhideshow.cancelbtn = false;
          this.checkbuttonhideshow.refundbtn = false;
          this.checkbuttonhideshow.ticketissuebtn = false;
          this.checkbuttonhideshow.voidbtn = false;
          this.checkbuttonhideshow.modifybtn = false;
        }
        if (this.fromroute == "B2BBackofficePage") {
          this.checkbuttonhideshow.cancelbtn = false;
          this.checkbuttonhideshow.refundbtn = false;
          this.checkbuttonhideshow.ticketissuebtn = false;
          this.checkbuttonhideshow.voidbtn = false;
          this.checkbuttonhideshow.modifybtn = false;
        }


        /*------------------------end section----------------------------------------*/

        /*------------------------Booking Information section start here----------------------------*/
        let num = 0;
        let supnum = 0;
        let refnum = 0;
        let markup = 0;
        this.netpayamount = 0;

        if (this.bookingAllData$.bookingInfo.exchangebookingPassengerInfoProperties != null) {
          for (let i = 0; i < this.bookingAllData$.bookingInfo.exchangebookingPassengerInfoProperties.length; i++) {
            this.netpayamount += this.bookingAllData$.bookingInfo.exchangebookingPassengerInfoProperties[i].exchange_TktFee;
          }
        }
        let refnumcust = 0;
        this.serviceChargesPerPassenger = 0;
        for (let i = 0; i < this.bookingAllData$.bookingPassengerInfo.length; i++) {

          this.serviceChargesPerPassenger += this.bookingAllData$.bookingPassengerInfo[i].serviceCharges;

          if (this.bookingAllData$.bookingPassengerInfo[i].isVoid == false) {
            num += this.bookingAllData$.bookingPassengerInfo[i].netFromCustomer;
          }
          if (this.bookingAllData$.bookingPassengerInfo[i].isVoid == false) {
            supnum += this.bookingAllData$.bookingPassengerInfo[i].netToSupplier;
            markup += this.bookingAllData$.bookingPassengerInfo[i].markup;//+ this.bookingAllData$.bookingPassengerInfo[i].runtimeMarkup;
          }
          if (this.bookingAllData$.bookingPassengerInfo[i].isOfflineRefund == true) {
            this.refundamount = true;
            refnum += this.bookingAllData$.bookingPassengerInfo[i].netRefundAmount;
          }
          else if (this.bookingAllData$.bookingPassengerInfo[i].isRefund == true) {
            this.refundamount = true;
            refnumcust += this.bookingAllData$.bookingPassengerInfo[i].netRefundAmountCustomer;
            refnum += this.bookingAllData$.bookingPassengerInfo[i].netToSupplierRefund;
            if (this.bookingAllData$.bookingPassengerInfo[i].refundPenalty != 0 && this.bookingAllData$.bookingInfo.providerCode == "FZ") {
              this.ChangeCost = true;
              this.ChangePrice += this.bookingAllData$.bookingPassengerInfo[i].refundPenalty;
            }
          }
          if (this.bookingAllData$.bookingPassengerInfo[i].modifyAdditionalServiceCharges > 0) {
            this.FZmodification = true;
            this.netpayamount += this.bookingAllData$.bookingPassengerInfo[i].modifyAdditionalServiceCharges;
          } else if (this.bookingAllData$.bookingPassengerInfo[i].refundAmount > 0) {
            this.refundamount = true;
            refnum += this.bookingAllData$.bookingPassengerInfo[i].refundAmount;
          }
        }
        this.showPostInvoiceBtnForBranches = false;
        if (this.bookingAllData$.bookingStatus == 'Ticketed' && ticketobj.agencyId.includes("AG01") && this.serviceChargesPerPassenger == 0 && this.isWithinServiceChargesWindow()) {
          this.showPostInvoiceBtnForBranches = true;
        }
        if (ticketobj.agencyId == 'AG01')
          this.nettosupplierbase = (supnum * this.bookingAllData$.bookingPassengerInfo[0].costExchangeRate) + markup;
        else
          this.nettosupplierbase = supnum + markup;

        this.bookingInfo.totalAmount = num;
        this.totalSumAmount = num;
        this.bookingInfo.totalrefundAmount = refnum;
        this.bookingInfo.totalrefundAmountCustomer = refnumcust;
        /*------------------------end section----------------------------------------*/

        /*--------------------------For Refund section------------------------------*/
        let refundbtnsdisabled: Boolean = false;
        this.bookingrefundinfo = JSON.parse(JSON.stringify(this.bookingInfo));
        this.bookingPassengerInfo = JSON.parse(JSON.stringify(this.bookingInfo.bookingPassengerInfoProperties));
        this.bookingPassengerInfoOffline = JSON.parse(JSON.stringify(this.bookingInfo.bookingPassengerInfoProperties));
        for (let k = 0; k < this.bookingPassengerInfo.length; k++) {
          if (this.bookingPassengerInfo[k].isOfflineRefund == true) {
            this.bookingPassengerInfo[k].isRefund = this.bookingPassengerInfo[k].isOfflineRefund;
            refundbtnsdisabled = true;
          }
          if (this.bookingPassengerInfo[k].netRefundAmount > 0) {
            this.bookingPassengerInfo[k].isRefund = false;
            this.bookingPassengerInfo[k].disabledrefund = true;
          }
        }
        if (refundbtnsdisabled) {
          for (let c = 0; c < this.bookingPassengerInfo.length; c++) {
            this.bookingPassengerInfo[c].disabledrefund = true;
          }
        }
        /*------------------------------ end section---------------------------------- */

        /*---------------------------- For Flight Details section------------------------*/
        let psId = this.bookingPassengerInfo[0].passengerID;
        for (let j = 0; j < this.bookingAllData$.sectorInfo.length; j++) {
          if (this.bookingAllData$.sectorInfo[j].passengerID == psId) {
            this.newsectorInfo.push(this.bookingAllData$.sectorInfo[j]);

          }
        }
        this.checkIssueTicket = this.checkRightForRequestToIssue();
        /*------------------------------ end section---------------------------------- */


        /* -------------------------- passenger details section---------------------*/

        this.passengerBaggage = this.bookingAllData$.passengerBaggage;
        for (let j = 0; j < this.passengerBaggage.length; j++) {
          this.withAnimationOptionsVisible.push(false);
        }
        /*------------------------------ end section---------------------------------- */
        /*      supplier remarks*/
        this.currency = this.bookingInfo.bookingPassengerInfoProperties[0].exchangeCurrency;
        if (this.bookingInfo.bookingPassengerInfoProperties[0].supplierRemarks != null) {
          this.supplierRemarksSingle = this.bookingInfo.bookingPassengerInfoProperties[0].supplierRemarks;


        }
        this.loadervisible = false;
        if (this.bookingInfo.exchangeCheck) {
          let exchangesupnum = 0;
          for (let i = 0; i < this.bookingAllData$.bookingInfo.exchangebookingPassengerInfoProperties.length; i++) {
            if (this.bookingAllData$.bookingInfo.exchangebookingPassengerInfoProperties[i].isRefund == false) {
              exchangesupnum += this.bookingAllData$.bookingInfo.exchangebookingPassengerInfoProperties[i].netToSupplier;
            }

          }
          this.exchangenettosupplierbase = exchangesupnum * this.bookingAllData$.bookingInfo.exchangebookingPassengerInfoProperties[0].costExchangeRate;
          let psIds = this.bookingInfo.exchangebookingPassengerInfoProperties[0].passengerID;
          for (let j = 0; j < this.bookingAllData$.sectorInfo.length; j++) {
            if (this.bookingAllData$.sectorInfo[j].passengerID == psIds) {
              this.ExchangenewsectorInfo.push(this.bookingAllData$.sectorInfo[j]);
            }
          }
          if (this.bookingInfo.exchangebookingPassengerInfoProperties[0].supplierRemarks != null) {
            this.exchangedsupplieremarks = this.bookingInfo.exchangebookingPassengerInfoProperties[0].supplierRemarks;


          }
          for (let j = 0; j < this.bookingAllData$.exchangePassengerBaggage.length; j++) {
            this.withAnimationOptionsVisibleexchange.push(false);
          }
        }
        /*------------------------------ end section---------------------------------- */
      });
      

      console.log("check issue ticket" + this.checkIssueTicket);
    }
    catch (e) {
      //////////console.log (e);
    }
  }
  buttonhidemethod() {
    if (this.requestTypeIdOffline == "Online Ticket Request") {
      if (this.tktPnrRight.issueTicket == false) {
        this.checkbuttonhideshow.ticketissuebtn = false;
        this.checkbuttonhideshow.refundbtn = false;
        this.checkbuttonhideshow.cancelbtn = false;
        this.checkbuttonhideshow.voidbtn = false;
        this.checkbuttonhideshow.ancibtn = false;
        this.checkbuttonhideshow.ssrIssueTicketbtn = false;
        this.checkbuttonhideshow.modifybtn = false;

        this.checkbuttonhideshow.ssrIssueTicketbtn = false;
      }
      else if (this.tktPnrRight.issueTicket) {
        if (this.tktPnrRight.userTicketIssueRightsPCCs.oneG.oneGRightStatus && this.bookingInfo.providerCode == "1G") {
          if (this.tktPnrRight.userTicketIssueRightsPCCs.oneG.oneG7KE2RightStatus && this.tktPnrRight.userTicketIssueRightsPCCs.oneG.assignedAirlines1G7KE2.includes(this.newsectorInfo[0].airlinePrefixCode)) {
            this.checkbuttonhideshow.refundbtn = false;
            if (this.bookingStatus != "Ticketed") {
              this.checkbuttonhideshow.ticketissuebtn = true;
            }
            this.checkbuttonhideshow.cancelbtn = false;
            this.checkbuttonhideshow.voidbtn = false;
            this.checkbuttonhideshow.ancibtn = false;
            this.checkbuttonhideshow.ssrIssueTicketbtn = false;
            this.checkbuttonhideshow.modifybtn = false;
          }
          else if (this.tktPnrRight.userTicketIssueRightsPCCs.oneG.oneG84XHRightStatus && this.tktPnrRight.userTicketIssueRightsPCCs.oneG.assignedAirlines1G84XH.includes(this.newsectorInfo[0].airlinePrefixCode)) {
            this.checkbuttonhideshow.refundbtn = false;
            if (this.bookingStatus != "Ticketed") {
              this.checkbuttonhideshow.ticketissuebtn = true;
            }
            this.checkbuttonhideshow.cancelbtn = false;
            this.checkbuttonhideshow.voidbtn = false;
            this.checkbuttonhideshow.ancibtn = false;
            this.checkbuttonhideshow.ssrIssueTicketbtn = false;
            this.checkbuttonhideshow.modifybtn = false;
          }
          else if (this.tktPnrRight.userTicketIssueRightsPCCs.oneG.oneG8X4IRightStatus && this.tktPnrRight.userTicketIssueRightsPCCs.oneG.assignedAirlines1G8X4I.includes(this.newsectorInfo[0].airlinePrefixCode)) {
            this.checkbuttonhideshow.refundbtn = false;
            if (this.bookingStatus != "Ticketed") {
              this.checkbuttonhideshow.ticketissuebtn = true;
            }
            this.checkbuttonhideshow.cancelbtn = false;
            this.checkbuttonhideshow.voidbtn = false;
            this.checkbuttonhideshow.ancibtn = false;
            this.checkbuttonhideshow.ssrIssueTicketbtn = false;
            this.checkbuttonhideshow.modifybtn = false;
          }
          else if (this.tktPnrRight.userTicketIssueRightsPCCs.oneG.oneGB2DRightStatus && this.tktPnrRight.userTicketIssueRightsPCCs.oneG.assignedAirlines1GB2D.includes(this.newsectorInfo[0].airlinePrefixCode)) {
            this.checkbuttonhideshow.refundbtn = false;
            if (this.bookingStatus != "Ticketed") {
              this.checkbuttonhideshow.ticketissuebtn = true;
            }
            this.checkbuttonhideshow.cancelbtn = false;
            this.checkbuttonhideshow.voidbtn = false;
            this.checkbuttonhideshow.ancibtn = false;
            this.checkbuttonhideshow.ssrIssueTicketbtn = false;
            this.checkbuttonhideshow.modifybtn = false;
          }
          else if (this.tktPnrRight.userTicketIssueRightsPCCs.oneG.oneG82QTRightStatus && this.tktPnrRight.userTicketIssueRightsPCCs.oneG.assignedAirlines1G82QT.includes(this.newsectorInfo[0].airlinePrefixCode)) {
            this.checkbuttonhideshow.refundbtn = false;
            if (this.bookingStatus != "Ticketed") {
              this.checkbuttonhideshow.ticketissuebtn = true;
            }
            this.checkbuttonhideshow.cancelbtn = false;
            this.checkbuttonhideshow.voidbtn = false;
            this.checkbuttonhideshow.ancibtn = false;
            this.checkbuttonhideshow.ssrIssueTicketbtn = false;
            this.checkbuttonhideshow.modifybtn = false;
          }
          else if (this.tktPnrRight.userTicketIssueRightsPCCs.oneG.oneG8K5XRightStatus && this.tktPnrRight.userTicketIssueRightsPCCs.oneG.assignedAirlines1G8K5X.includes(this.newsectorInfo[0].airlinePrefixCode)) {
            this.checkbuttonhideshow.refundbtn = false;
            if (this.bookingStatus != "Ticketed") {
              this.checkbuttonhideshow.ticketissuebtn = true;
            }
            this.checkbuttonhideshow.cancelbtn = false;
            this.checkbuttonhideshow.voidbtn = false;
            this.checkbuttonhideshow.ancibtn = false;
            this.checkbuttonhideshow.ssrIssueTicketbtn = false;
            this.checkbuttonhideshow.modifybtn = false;
          }
        }
        else if (this.tktPnrRight.userTicketIssueRightsPCCs.oneGGDS.oneGGDSRightStatus && this.bookingInfo.providerCode == "1GGDS") {
          if (this.tktPnrRight.userTicketIssueRightsPCCs.oneGGDS.oneGGDS8X4IRightStatus && this.tktPnrRight.userTicketIssueRightsPCCs.oneGGDS.assignedAirlinesGDS8X4I.includes(this.newsectorInfo[0].airlinePrefixCode)) {
            this.checkbuttonhideshow.refundbtn = false;
            if (this.bookingStatus != "Ticketed") {
              this.checkbuttonhideshow.ticketissuebtn = true;
            }
            this.checkbuttonhideshow.cancelbtn = false;
            this.checkbuttonhideshow.voidbtn = false;
            this.checkbuttonhideshow.ancibtn = false;
            this.checkbuttonhideshow.ssrIssueTicketbtn = false;
            this.checkbuttonhideshow.modifybtn = false;
          }
          else if (this.tktPnrRight.userTicketIssueRightsPCCs.oneGGDS.oneGGDS8K5XRightStatus && this.tktPnrRight.userTicketIssueRightsPCCs.oneGGDS.assignedAirlinesGDS8K5X.includes(this.newsectorInfo[0].airlinePrefixCode)) {
            this.checkbuttonhideshow.refundbtn = false;
            if (this.bookingStatus != "Ticketed") {
              this.checkbuttonhideshow.ticketissuebtn = true;
            }
            this.checkbuttonhideshow.cancelbtn = false;
            this.checkbuttonhideshow.voidbtn = false;
            this.checkbuttonhideshow.ancibtn = false;
            this.checkbuttonhideshow.ssrIssueTicketbtn = false;
            this.checkbuttonhideshow.modifybtn = false;
          }
          else if (this.tktPnrRight.userTicketIssueRightsPCCs.oneGGDS.oneGGDSB2DRightStatus && this.tktPnrRight.userTicketIssueRightsPCCs.oneGGDS.assignedAirlinesGDSB2D.includes(this.newsectorInfo[0].airlinePrefixCode)) {
            this.checkbuttonhideshow.refundbtn = false;
            if (this.bookingStatus != "Ticketed") {
              this.checkbuttonhideshow.ticketissuebtn = true;
            }
            this.checkbuttonhideshow.cancelbtn = false;
            this.checkbuttonhideshow.voidbtn = false;
            this.checkbuttonhideshow.ancibtn = false;
            this.checkbuttonhideshow.ssrIssueTicketbtn = false;
            this.checkbuttonhideshow.modifybtn = false;
          }
          else if (this.tktPnrRight.userTicketIssueRightsPCCs.oneGGDS.oneGGDS7KE2RightStatus && this.tktPnrRight.userTicketIssueRightsPCCs.oneGGDS.assignedAirlinesGDS7KE2.includes(this.newsectorInfo[0].airlinePrefixCode)) {
            this.checkbuttonhideshow.refundbtn = false;
            if (this.bookingStatus != "Ticketed") {
              this.checkbuttonhideshow.ticketissuebtn = true;
            }
            this.checkbuttonhideshow.cancelbtn = false;
            this.checkbuttonhideshow.voidbtn = false;
            this.checkbuttonhideshow.ancibtn = false;
            this.checkbuttonhideshow.ssrIssueTicketbtn = false;
            this.checkbuttonhideshow.modifybtn = false;
          }
        }
        else if (this.tktPnrRight.userTicketIssueRightsPCCs.oneGGDS.oneGGDSRightStatus && this.bookingInfo.providerCode == "1GNDC") {
          if (this.tktPnrRight.userTicketIssueRightsPCCs.oneGNDC.oneGNDC8X4IRightStatus && this.tktPnrRight.userTicketIssueRightsPCCs.oneGNDC.assignedAirlinesNDC8X4I.includes(this.newsectorInfo[0].airlinePrefixCode)) {
            this.checkbuttonhideshow.refundbtn = false;
            if (this.bookingStatus != "Ticketed") {
              this.checkbuttonhideshow.ticketissuebtn = true;
            }
            this.checkbuttonhideshow.cancelbtn = false;
            this.checkbuttonhideshow.voidbtn = false;
            this.checkbuttonhideshow.ancibtn = false;
            this.checkbuttonhideshow.ssrIssueTicketbtn = false;
            this.checkbuttonhideshow.modifybtn = false;
          }
          else if (this.tktPnrRight.userTicketIssueRightsPCCs.oneGNDC.oneGNDC8K5XRightStatus && this.tktPnrRight.userTicketIssueRightsPCCs.oneGNDC.assignedAirlinesNDC8K5X.includes(this.newsectorInfo[0].airlinePrefixCode)) {
            this.checkbuttonhideshow.refundbtn = false;
            if (this.bookingStatus != "Ticketed") {
              this.checkbuttonhideshow.ticketissuebtn = true;
            }
            this.checkbuttonhideshow.cancelbtn = false;
            this.checkbuttonhideshow.voidbtn = false;
            this.checkbuttonhideshow.ancibtn = false;
            this.checkbuttonhideshow.ssrIssueTicketbtn = false;
            this.checkbuttonhideshow.modifybtn = false;
          }
          else if (this.tktPnrRight.userTicketIssueRightsPCCs.oneGNDC.oneGNDCB2DRightStatus && this.tktPnrRight.userTicketIssueRightsPCCs.oneGNDC.assignedAirlinesNDCB2D.includes(this.newsectorInfo[0].airlinePrefixCode)) {
            this.checkbuttonhideshow.refundbtn = false;
            if (this.bookingStatus != "Ticketed") {
              this.checkbuttonhideshow.ticketissuebtn = true;
            }
            this.checkbuttonhideshow.cancelbtn = false;
            this.checkbuttonhideshow.voidbtn = false;
            this.checkbuttonhideshow.ancibtn = false;
            this.checkbuttonhideshow.ssrIssueTicketbtn = false;
            this.checkbuttonhideshow.modifybtn = false;
          }
          else if (this.tktPnrRight.userTicketIssueRightsPCCs.oneGNDC.oneGNDC7KE2RightStatus && this.tktPnrRight.userTicketIssueRightsPCCs.oneGNDC.assignedAirlinesNDC7KE2.includes(this.newsectorInfo[0].airlinePrefixCode)) {
            this.checkbuttonhideshow.refundbtn = false;
            if (this.bookingStatus != "Ticketed") {
              this.checkbuttonhideshow.ticketissuebtn = true;
            }
            this.checkbuttonhideshow.cancelbtn = false;
            this.checkbuttonhideshow.voidbtn = false;
            this.checkbuttonhideshow.ancibtn = false;
            this.checkbuttonhideshow.ssrIssueTicketbtn = false;
            this.checkbuttonhideshow.modifybtn = false;
          }
        }
        else if (this.tktPnrRight.userTicketIssueRightsPCCs.indNDC.rightStatus && this.tktPnrRight.userTicketIssueRightsPCCs.indNDC.assignedAirlines.includes(this.bookingInfo.providerCode)) {
          this.checkbuttonhideshow.refundbtn = false;
          if (this.bookingStatus != "Ticketed") {
            this.checkbuttonhideshow.ticketissuebtn = true;
          }
          this.checkbuttonhideshow.cancelbtn = false;
          this.checkbuttonhideshow.voidbtn = false;
          this.checkbuttonhideshow.ancibtn = false;
          this.checkbuttonhideshow.ssrIssueTicketbtn = false;
          this.checkbuttonhideshow.modifybtn = false;
        }
        else if (this.tktPnrRight.userTicketIssueRightsPCCs.lccs.rightStatus && this.tktPnrRight.userTicketIssueRightsPCCs.lccs.assignedAirlines.includes(this.bookingInfo.providerCode)) {
          this.checkbuttonhideshow.refundbtn = false;
          if (this.bookingStatus != "Ticketed") {
            this.checkbuttonhideshow.ticketissuebtn = true;
          }
          this.checkbuttonhideshow.cancelbtn = false;
          this.checkbuttonhideshow.voidbtn = false;
          this.checkbuttonhideshow.ancibtn = false;
          this.checkbuttonhideshow.ssrIssueTicketbtn = false;
          this.checkbuttonhideshow.modifybtn = false;
        }
        else {
          this.checkbuttonhideshow.ticketissuebtn = false;
        }
      }
    }
    else if (this.requestTypeIdOffline == "Online PNR Cancel Request") {
      if (this.tktPnrRight.cancelPnr == false) {
        this.checkbuttonhideshow.refundbtn = false;
        this.checkbuttonhideshow.ticketissuebtn = false;
        this.checkbuttonhideshow.cancelbtn = false;
        this.checkbuttonhideshow.voidbtn = false;
        this.checkbuttonhideshow.ancibtn = false;
        this.checkbuttonhideshow.ssrIssueTicketbtn = false;
        this.checkbuttonhideshow.modifybtn = false;
      }
      else if (this.tktPnrRight.cancelPnr) {
        this.checkbuttonhideshow.refundbtn = false;
        this.checkbuttonhideshow.ticketissuebtn = false;
        if (this.bookingStatus != "Cancelled") {
          this.checkbuttonhideshow.cancelbtn = true;
        }

        this.checkbuttonhideshow.voidbtn = false;
        this.checkbuttonhideshow.ancibtn = false;
        this.checkbuttonhideshow.ssrIssueTicketbtn = false;
        this.checkbuttonhideshow.modifybtn = false;

      }
    }
    else if (this.requestTypeIdOffline == "Online Void Request") {
      if (this.tktPnrRight.voidTicket == false) {
        this.checkbuttonhideshow.refundbtn = false;
        this.checkbuttonhideshow.ticketissuebtn = false;
        this.checkbuttonhideshow.cancelbtn = false;
        this.checkbuttonhideshow.voidbtn = false;
        this.checkbuttonhideshow.ancibtn = false;
        this.checkbuttonhideshow.ssrIssueTicketbtn = false;
        this.checkbuttonhideshow.modifybtn = false;
      }
      else if (this.tktPnrRight.voidTicket) {
        this.checkbuttonhideshow.refundbtn = false;
        this.checkbuttonhideshow.ticketissuebtn = false;
        this.checkbuttonhideshow.cancelbtn = false;
        if (this.bookingStatus != "Void") {
          this.checkbuttonhideshow.voidbtn = true;
        }
        this.checkbuttonhideshow.ancibtn = false;
        this.checkbuttonhideshow.ssrIssueTicketbtn = false;
        this.checkbuttonhideshow.modifybtn = false;
      }

    }
    else if (this.requestTypeIdOffline == "Online Refund Request") {
      //new refund work
      if (this.tktPnrRight.refund == false) {
        this.checkbuttonhideshow.refundbtn = false;
        this.checkbuttonhideshow.ticketissuebtn = false;
        this.checkbuttonhideshow.cancelbtn = false;
        this.checkbuttonhideshow.voidbtn = false;
        this.checkbuttonhideshow.ssrIssueTicketbtn = false;
        this.checkbuttonhideshow.modifybtn = false;
      }
      else if (this.tktPnrRight.refund) {
        if (this.bookingStatus != "Refund") {
          this.checkbuttonhideshow.refundbtn = true;
        }
        this.checkbuttonhideshow.ticketissuebtn = false;
        this.checkbuttonhideshow.cancelbtn = false;
        this.checkbuttonhideshow.voidbtn = false;
        this.checkbuttonhideshow.ssrIssueTicketbtn = false;
        this.checkbuttonhideshow.modifybtn = false;
      }
    }
  }


  //async  creditLimitDeduction(ticketIssuancePrice: number) {
  //  let agencyID = localStorage.getItem("AgencyId");
  //  let branchID = localStorage.getItem("BranchId");

  //  if (agencyID) {
  //    //this.airlineDetails = await firstValueFrom(this.flightService.GetAirSegmentStopDetails(this.str));
  //    this.creditData = await firstValueFrom(this.agencyService.GetAgencyBranchPendingCreditS(agencyID))//subscribe((data) => {
  //    //this.creditData = data;
  //    if (this.creditData.agencyMasterProp[0].pendingcreditLimit < ticketIssuancePrice) {

  //      //////console.log ("your can't purchae ticket because of low balance");
  //      return;
  //    }
  //    if (this.creditData.agencyMasterProp[0].pendingcreditLimit > ticketIssuancePrice) {
  //      let abdp = new AgencyBranchDataProperties();
  //      // //////console.log ("can buy ticket");
  //      abdp.pendingCreditLimit = this.creditData.agencyMasterProp[0].pendingcreditLimit;
  //      abdp.creditLimit = this.creditData.agencyMasterProp[0].creditLimit;
  //      abdp.agencyId = this.creditData.agencyMasterProp[0].agencyId;
  //      abdp.agencyName = this.creditData.agencyMasterProp[0].agencyName;
  //      this.agencyService.TicketIssuanceCreditDeduction(abdp).subscribe((data) => {
  //        //////console.log (data);
  //      });
  //    }

  //    //})

  //  }
  //  if (branchID) {
  //    this.creditData = await firstValueFrom(this.agencyService.GetAgencyBranchPendingCreditS(branchID))//subscribe((data) => {
  //    //this.creditData = data;
  //    if (this.creditData.branchInfoProp[0].pendingcreditLimit < ticketIssuancePrice) {
  //      //////console.log ("your can't purchae ticket because of low balance");
  //      return;
  //    }
  //    if (this.creditData.branchInfoProp[0].pendingcreditLimit > ticketIssuancePrice) {
  //      let abdp = new AgencyBranchDataProperties();
  //      // //////console.log ("can buy ticket");
  //      abdp.pendingCreditLimit = this.creditData.branchInfoProp[0].pendingcreditLimit;
  //      abdp.creditLimit = this.creditData.branchInfoProp[0].creditLimit;
  //      abdp.agencyId = this.creditData.branchInfoProp[0].agencyId;
  //      abdp.agencyName = this.creditData.branchInfoProp[0].branchName;
  //      this.agencyService.TicketIssuanceCreditDeduction(abdp).subscribe((data) => {

  //      });
  //    }

  //    //})

  //  }


  //}

  showBtnLoader() {
    var btnLoadingContainer = document.querySelector('#btn_loading_container') as HTMLDivElement;
    btnLoadingContainer.style.display = 'flex';
  }
  hideBtnLoader() {
    var btnLoadingContainer = document.querySelector('#btn_loading_container') as HTMLDivElement;
    btnLoadingContainer.style.display = 'none';
  }

  flightLogoX: number;
  flightLogoY: number;
  airlineNameX: number;
  airlineNameY: number;
  airlineCodeX: number;
  airlineCodeY: number;
  airBusTypeX: number;
  airBusTypeY: number;
  fromCityX: number;
  fromCityY: number;
  fromAirportX: number;
  fromAirportY: number;
  departDateX: number;
  departDateY: number;
  toCityX: number;
  toCityY: number;
  toAirportX: number;
  toAirportY: number;
  arrivalDateX: number;
  arrivalDateY: number;
  cabinClassX: number;
  cabinClassY: number;
  noStopsX: number;
  noStopsY: number;
  pnrX: number;
  pnrY: number;
  paxInfoY: number;
  agRectY: number;
  financeRectY: number;
  cityRouteX: number;
  paxInfoYZ: number;
  iterationWidth: number;

  sectSpace: number;






  editPassport() {

  }

  //checkRightForRequestToIssue(): boolean {

  //  if (!this.tktPnrRight || !this.tktPnrRight.issueTicket) {
  //    return false;
  //  }

  //  if (
  //    this.bookingInfo.providerCode === '1G' &&
  //    this.tktPnrRight.userTicketIssueRightsPCCs.oneG.oneGRightStatus &&
  //    this.tktPnrRight.userTicketIssueRightsPCCs.oneG.oneG7KE2RightStatus &&
  //    this.tktPnrRight.userTicketIssueRightsPCCs.oneG.assignedAirlines1G7KE2.includes(
  //      this.newsectorInfo[0].airlinePrefixCode
  //    )
  //  ) {
  //    return true;
  //  }
  //  else if()
  //  return false;
  //}
  checkRightForRequestToIssue(): boolean {
    if (this.agencyID == "AG01") {
      return true;
    }
    else {
      const airline = this.newsectorInfo[0].airlinePrefixCode;
      if (!this.tktPnrRight.issueTicket) {
        return false;
      }
      /// if he have 1G and 1GGDS booth true then he goes which if or both if
      // 1G  
      else if (this.bookingInfo.providerCode === '1G' && this.tktPnrRight.userTicketIssueRightsPCCs.oneG.oneGRightStatus) {
        const oneG = this.tktPnrRight.userTicketIssueRightsPCCs.oneG;
        ///// if 7ke2 right and 8x41 have no right then make according to this
        return (
          (oneG.oneG7KE2RightStatus && oneG.assignedAirlines1G7KE2.includes(airline)) || (oneG.oneG84XHRightStatus && oneG.assignedAirlines1G84XH.includes(airline)) ||
          (oneG.oneG8X4IRightStatus && oneG.assignedAirlines1G8X4I.includes(airline)) || (oneG.oneGB2DRightStatus && oneG.assignedAirlines1GB2D.includes(airline)) ||
          (oneG.oneG82QTRightStatus && oneG.assignedAirlines1G82QT.includes(airline)) || (oneG.oneG8K5XRightStatus && oneG.assignedAirlines1G8K5X.includes(airline))
        );
      }
      // 1GGDS
      else if (this.bookingInfo.providerCode === '1GGDS' && this.tktPnrRight.userTicketIssueRightsPCCs.oneGGDS.oneGGDSRightStatus) {
        const gds = this.tktPnrRight.userTicketIssueRightsPCCs.oneGGDS;
        return (
          (gds.oneGGDS8X4IRightStatus && gds.assignedAirlinesGDS8X4I.includes(airline)) || (gds.oneGGDS8K5XRightStatus && gds.assignedAirlinesGDS8K5X.includes(airline)) ||
          (gds.oneGGDSB2DRightStatus && gds.assignedAirlinesGDSB2D.includes(airline)) || (gds.oneGGDS7KE2RightStatus && gds.assignedAirlinesGDS7KE2.includes(airline))
        );
      }

      // 1GNDC
     else if (this.bookingInfo.providerCode === '1GNDC' && this.tktPnrRight.userTicketIssueRightsPCCs.oneGNDC.oneGNDCRightStatus) {
        const ndc = this.tktPnrRight.userTicketIssueRightsPCCs.oneGNDC;
        return (
          (ndc.oneGNDC8X4IRightStatus && ndc.assignedAirlinesNDC8X4I.includes(airline)) || (ndc.oneGNDC8K5XRightStatus && ndc.assignedAirlinesNDC8K5X.includes(airline)) ||
          (ndc.oneGNDCB2DRightStatus && ndc.assignedAirlinesNDCB2D.includes(airline)) || (ndc.oneGNDC7KE2RightStatus && ndc.assignedAirlinesNDC7KE2.includes(airline))
        );
      }
      // IND NDC
      else if (this.tktPnrRight.userTicketIssueRightsPCCs.indNDC.rightStatus && this.tktPnrRight.userTicketIssueRightsPCCs.indNDC.assignedAirlines.includes(airline)) {
        return true;
      }
      // LCC
      else if (this.tktPnrRight.userTicketIssueRightsPCCs.lccs.rightStatus && this.tktPnrRight.userTicketIssueRightsPCCs.lccs.assignedAirlines.includes(airline) && this.bookingInfo.providerCode !== '1G' && this.bookingInfo.providerCode !== '1GGDS' && this.bookingInfo.providerCode !== '1GNDC') {
        return true;
      }

      return false;
    }
   
  }
  issueTicket(targetmodel) {
     this.NewSuccess.dismissAll();

    if (this.agencyID == "AG01") {
      if (!this.selectedBackCompanyUserId) {
        this.messageservice.add({ severity: 'error', summary: 'Try Again', detail: 'Please select company first!' });
        return;
      }
    }
    //if (this.bookingInfo.providerCode == "1GGDS" || this.bookingInfo.providerCode == "1GNDC" || this.bookingInfo.providerCode == "1G") {
    //  if (this.SkipPassportNumberPassportExpiryDateValidation() == false) {
    //    this.messageservice.add({ severity: 'error', summary: 'Try Again', detail: 'Please check passangers details!' });
    //    return;
    //  }
    //}
    this.bookingInfo.backCompanyUserId = this.selectedBackCompanyUserId;
    this.buttonagreed_Issue = true;
    this.loadervisible = true;
    this.stopTimerToRefresh();
    // this.agencyService.GetAgencyBranchPendingCreditS(this.bookingInfo.finalBuyerID).subscribe((data) => {
    //this.creditData = data;
    // let credit = 0;
    // if (this.creditData.agencyMasterProp.length > 0)
    //  credit = this.creditData.agencyMasterProp[0].pendingcreditLimit;
    // else
    //  credit = this.creditData.branchInfoProp[0].pendingcreditLimit;
    //if (this.bookingInfo.totalAmount <= credit) {
    ////////console.log ("in the agency");
    ////////console.log (this.creditData);
    ////////console.log (this.creditLimit);
    //if (this.checkIssueTicket) {
    //  return;
    //}
    //else {
    //  return;
    //}
   
     if (this.tktPnrRight.issueTicket == false) {
      if (this.bookingInfo.groupTicketId > 0) {
        this.bookingInfo.groupTicketRequest = 1; //Issue Request
        this.groupTicketService.UpdateIssueGroupTicketStatus(this.bookingInfo.bookingID, this.bookingInfo.groupTicketId, this.bookingInfo.groupTicketRequest, this.bookingInfo.bookingPassengerInfoProperties.length).subscribe(data => {
          if (data == true) {
            this.router.navigateByUrl('/bookingList');
          }
          else {
            this.loadervisible = false;
            this.buttonagreed_Issue = false;
            document.querySelector(".error-dialogfor-ist").classList.remove("ist-hide");
            document.querySelector(".message-ist").innerHTML = "Something Went Wrong";
            const overlay = document.querySelector("#overlay") as HTMLElement;
            overlay.style.display = "block";
          }
        })
      }
      else {

        if (localStorage.getItem("AgencyId") != 'AG01') {

          localStorage.removeItem("IsTicket");
          localStorage.setItem("OnlineBookingId", JSON.stringify(this.bookingID));
          localStorage.setItem("IsTicket", "True");
          localStorage.setItem("TicketReRequest", "false");
          this.offlineTempId = 0;

          this.router.navigateByUrl('/offlineRequestList');
        }
        else {
          if (localStorage.getItem("AgencyId") == 'AG01') {
            this.loadervisible = false;
            this.buttonagreed_Issue = false;
            document.querySelector(".error-dialogfor-ist").classList.remove("ist-hide");
            document.querySelector(".message-ist").innerHTML = "You Do Not Have Right to Issue Ticket";
            const overlay = document.querySelector("#overlay") as HTMLElement;
            overlay.style.display = "block";
          }
        }
        //end
      }
    }

    else if (this.tktPnrRight.issueTicket) {

      if (this.tktPnrRight.userTicketIssueRightsPCCs.oneG.oneGRightStatus && this.bookingInfo.providerCode == "1G") {
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        if (this.tktPnrRight.userTicketIssueRightsPCCs.oneG.oneG7KE2RightStatus && this.tktPnrRight.userTicketIssueRightsPCCs.oneG.assignedAirlines1G7KE2.includes(this.newsectorInfo[0].airlinePrefixCode)) {
          this.bookingInfo.issuanceUser = Number(localStorage.getItem("UserId"));
          this.bookingInfo.userBackSystemCompanyId = Number(localStorage.getItem("BackSystemCompanyId"));
          this.bookingInfo.userBackSystemCustomer = localStorage.getItem("BackSystemCompanyCustomer");
          if (this.bookingInfo.groupTicketId > 0) {
            this.bookingInfo.bookingPassengerInfoProperties = this.bookingInfo.bookingPassengerInfoProperties.map(tkt => {
              return { ...tkt, ticketNo: "" }
            })
            this.groupTicketService.IssueGroupTicket(this.bookingInfo).subscribe(data => {
              if (data.isSaved) {
                this.ngOnInit();
              }
              else {
                this.loadervisible = false;
                this.buttonagreed_Issue = false;
                document.querySelector(".error-dialogfor-ist").classList.remove("ist-hide");
                document.querySelector(".message-ist").innerHTML = data.errorInfo;
                const overlay = document.querySelector("#overlay") as HTMLElement;
                overlay.style.display = "block";
              }
            })
          }
          else {
            this.ticketIssuanceService.IssueGalileoTicket(this.bookingInfo).subscribe((data) => {
              if (data.isSaved) {
                this.bookingID = data.bookingID;
                if (this.offlineIdRequestFromOfflineList > 0) {
                  this.service.UpdateOfflineTktRequest(this.offlineIdRequestFromOfflineList, localStorage.getItem("UserId")).subscribe((data) => {
                    if (data == true) {
                      this.offlinetoOnlineproperty = new OfflineToOnlineProperties();
                      this.ngOnInit();
                      this.offlineTempId = this.offlineIdRequestFromOfflineList;
                      this.offlineIdRequestFromOfflineList = 0;
                      this.router.navigateByUrl('/ticket-issuance');
                    }
                  });
                }
                else {
                  this.ngOnInit();
                  this.router.navigateByUrl('/ticket-issuance');
                }
              }
              else {
                this.loadervisible = false;
                this.buttonagreed_Issue = false;
                this.refreshTktopen = true;
                this.errorIssueticketMessage = data.errorInfo;
              }
            });
          }
        }
        ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        else if (this.tktPnrRight.userTicketIssueRightsPCCs.oneG.oneG84XHRightStatus && this.tktPnrRight.userTicketIssueRightsPCCs.oneG.assignedAirlines1G84XH.includes(this.newsectorInfo[0].airlinePrefixCode)) {
          this.bookingInfo.issuanceUser = Number(localStorage.getItem("UserId"));
          this.bookingInfo.userBackSystemCompanyId = Number(localStorage.getItem("BackSystemCompanyId"));
          this.bookingInfo.userBackSystemCustomer = localStorage.getItem("BackSystemCompanyCustomer");
          if (this.bookingInfo.groupTicketId > 0) {
            this.bookingInfo.bookingPassengerInfoProperties = this.bookingInfo.bookingPassengerInfoProperties.map(tkt => {
              return { ...tkt, ticketNo: "" }
            })
            this.groupTicketService.IssueGroupTicket(this.bookingInfo).subscribe(data => {
              if (data.isSaved) {
                this.ngOnInit();
              }
              else {
                this.loadervisible = false;
                this.buttonagreed_Issue = false;
                document.querySelector(".error-dialogfor-ist").classList.remove("ist-hide");
                document.querySelector(".message-ist").innerHTML = data.errorInfo;
                const overlay = document.querySelector("#overlay") as HTMLElement;
                overlay.style.display = "block";
              }
            })
          }
          else {
            this.ticketIssuanceService.IssueGalileoTicket(this.bookingInfo).subscribe((data) => {
              if (data.isSaved) {
                this.bookingID = data.bookingID;
                if (this.offlineIdRequestFromOfflineList > 0) {
                  this.service.UpdateOfflineTktRequest(this.offlineIdRequestFromOfflineList, localStorage.getItem("UserId")).subscribe((data) => {
                    if (data == true) {
                      this.offlinetoOnlineproperty = new OfflineToOnlineProperties();
                      this.ngOnInit();
                      this.offlineTempId = this.offlineIdRequestFromOfflineList;
                      this.offlineIdRequestFromOfflineList = 0;
                      this.router.navigateByUrl('/ticket-issuance');
                    }
                  });
                }
                else {
                  this.ngOnInit();
                  this.router.navigateByUrl('/ticket-issuance');
                }
              }
              else {
                this.loadervisible = false;
                this.buttonagreed_Issue = false;
                this.refreshTktopen = true;
                this.errorIssueticketMessage = data.errorInfo;
              }
            });
          }
        }
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        else if (this.tktPnrRight.userTicketIssueRightsPCCs.oneG.oneG8X4IRightStatus && this.tktPnrRight.userTicketIssueRightsPCCs.oneG.assignedAirlines1G8X4I.includes(this.newsectorInfo[0].airlinePrefixCode)) {
          this.bookingInfo.issuanceUser = Number(localStorage.getItem("UserId"));
          this.bookingInfo.userBackSystemCompanyId = Number(localStorage.getItem("BackSystemCompanyId"));
          this.bookingInfo.userBackSystemCustomer = localStorage.getItem("BackSystemCompanyCustomer");
          if (this.bookingInfo.groupTicketId > 0) {
            this.bookingInfo.bookingPassengerInfoProperties = this.bookingInfo.bookingPassengerInfoProperties.map(tkt => {
              return { ...tkt, ticketNo: "" }
            })
            this.groupTicketService.IssueGroupTicket(this.bookingInfo).subscribe(data => {
              if (data.isSaved) {
                this.ngOnInit();
              }
              else {
                this.loadervisible = false;
                this.buttonagreed_Issue = false;
                document.querySelector(".error-dialogfor-ist").classList.remove("ist-hide");
                document.querySelector(".message-ist").innerHTML = data.errorInfo;
                const overlay = document.querySelector("#overlay") as HTMLElement;
                overlay.style.display = "block";
              }
            })
          }
          else {
            this.ticketIssuanceService.IssueGalileoTicket(this.bookingInfo).subscribe((data) => {
              if (data.isSaved) {
                this.bookingID = data.bookingID;
                if (this.offlineIdRequestFromOfflineList > 0) {
                  this.service.UpdateOfflineTktRequest(this.offlineIdRequestFromOfflineList, localStorage.getItem("UserId")).subscribe((data) => {
                    if (data == true) {
                      this.offlinetoOnlineproperty = new OfflineToOnlineProperties();
                      this.ngOnInit();
                      this.offlineTempId = this.offlineIdRequestFromOfflineList;
                      this.offlineIdRequestFromOfflineList = 0;
                      this.router.navigateByUrl('/ticket-issuance');
                    }
                  });
                }
                else {
                  this.ngOnInit();
                  this.router.navigateByUrl('/ticket-issuance');
                }
              }
              else {
                this.loadervisible = false;
                this.buttonagreed_Issue = false;
                this.refreshTktopen = true;
                this.errorIssueticketMessage = data.errorInfo;
              }
            });
          }
        }
        ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        else if (this.tktPnrRight.userTicketIssueRightsPCCs.oneG.oneGB2DRightStatus && this.tktPnrRight.userTicketIssueRightsPCCs.oneG.assignedAirlines1GB2D.includes(this.newsectorInfo[0].airlinePrefixCode)) {
          this.bookingInfo.issuanceUser = Number(localStorage.getItem("UserId"));
          this.bookingInfo.userBackSystemCompanyId = Number(localStorage.getItem("BackSystemCompanyId"));
          this.bookingInfo.userBackSystemCustomer = localStorage.getItem("BackSystemCompanyCustomer");
          if (this.bookingInfo.groupTicketId > 0) {
            this.bookingInfo.bookingPassengerInfoProperties = this.bookingInfo.bookingPassengerInfoProperties.map(tkt => {
              return { ...tkt, ticketNo: "" }
            })
            this.groupTicketService.IssueGroupTicket(this.bookingInfo).subscribe(data => {
              if (data.isSaved) {
                this.ngOnInit();
              }
              else {
                this.loadervisible = false;
                this.buttonagreed_Issue = false;
                document.querySelector(".error-dialogfor-ist").classList.remove("ist-hide");
                document.querySelector(".message-ist").innerHTML = data.errorInfo;
                const overlay = document.querySelector("#overlay") as HTMLElement;
                overlay.style.display = "block";
              }
            })
          }
          else {
            this.ticketIssuanceService.IssueGalileoTicket(this.bookingInfo).subscribe((data) => {
              if (data.isSaved) {
                this.bookingID = data.bookingID;
                if (this.offlineIdRequestFromOfflineList > 0) {
                  this.service.UpdateOfflineTktRequest(this.offlineIdRequestFromOfflineList, localStorage.getItem("UserId")).subscribe((data) => {
                    if (data == true) {
                      this.offlinetoOnlineproperty = new OfflineToOnlineProperties();
                      this.ngOnInit();
                      this.offlineTempId = this.offlineIdRequestFromOfflineList;
                      this.offlineIdRequestFromOfflineList = 0;
                      this.router.navigateByUrl('/ticket-issuance');
                    }
                  });
                }
                else {
                  this.ngOnInit();
                  this.router.navigateByUrl('/ticket-issuance');
                }
              }
              else {
                this.loadervisible = false;
                this.buttonagreed_Issue = false;
                this.refreshTktopen = true;
                this.errorIssueticketMessage = data.errorInfo;
              }
            });
          }
        }
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        else if (this.tktPnrRight.userTicketIssueRightsPCCs.oneG.oneG82QTRightStatus && this.tktPnrRight.userTicketIssueRightsPCCs.oneG.assignedAirlines1G82QT.includes(this.newsectorInfo[0].airlinePrefixCode)) {
          this.bookingInfo.issuanceUser = Number(localStorage.getItem("UserId"));
          this.bookingInfo.userBackSystemCompanyId = Number(localStorage.getItem("BackSystemCompanyId"));
          this.bookingInfo.userBackSystemCustomer = localStorage.getItem("BackSystemCompanyCustomer");
          if (this.bookingInfo.groupTicketId > 0) {
            this.bookingInfo.bookingPassengerInfoProperties = this.bookingInfo.bookingPassengerInfoProperties.map(tkt => {
              return { ...tkt, ticketNo: "" }
            })
            this.groupTicketService.IssueGroupTicket(this.bookingInfo).subscribe(data => {
              if (data.isSaved) {
                this.ngOnInit();
              }
              else {
                this.loadervisible = false;
                this.buttonagreed_Issue = false;
                document.querySelector(".error-dialogfor-ist").classList.remove("ist-hide");
                document.querySelector(".message-ist").innerHTML = data.errorInfo;
                const overlay = document.querySelector("#overlay") as HTMLElement;
                overlay.style.display = "block";
              }
            })
          }
          else {
            this.ticketIssuanceService.IssueGalileoTicket(this.bookingInfo).subscribe((data) => {
              if (data.isSaved) {
                this.bookingID = data.bookingID;
                if (this.offlineIdRequestFromOfflineList > 0) {
                  this.service.UpdateOfflineTktRequest(this.offlineIdRequestFromOfflineList, localStorage.getItem("UserId")).subscribe((data) => {
                    if (data == true) {
                      this.offlinetoOnlineproperty = new OfflineToOnlineProperties();
                      this.ngOnInit();
                      this.offlineTempId = this.offlineIdRequestFromOfflineList;
                      this.offlineIdRequestFromOfflineList = 0;
                      this.router.navigateByUrl('/ticket-issuance');
                    }
                  });
                }
                else {
                  this.ngOnInit();
                  this.router.navigateByUrl('/ticket-issuance');
                }
              }
              else {
                this.loadervisible = false;
                this.buttonagreed_Issue = false;
                this.refreshTktopen = true;
                this.errorIssueticketMessage = data.errorInfo;
              }
            });
          }
        }
        /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        else if (this.tktPnrRight.userTicketIssueRightsPCCs.oneG.oneG8K5XRightStatus && this.tktPnrRight.userTicketIssueRightsPCCs.oneG.assignedAirlines1G8K5X.includes(this.newsectorInfo[0].airlinePrefixCode)) {
          this.bookingInfo.issuanceUser = Number(localStorage.getItem("UserId"));
          this.bookingInfo.userBackSystemCompanyId = Number(localStorage.getItem("BackSystemCompanyId"));
          this.bookingInfo.userBackSystemCustomer = localStorage.getItem("BackSystemCompanyCustomer");
          if (this.bookingInfo.groupTicketId > 0) {
            this.bookingInfo.bookingPassengerInfoProperties = this.bookingInfo.bookingPassengerInfoProperties.map(tkt => {
              return { ...tkt, ticketNo: "" }
            })
            this.groupTicketService.IssueGroupTicket(this.bookingInfo).subscribe(data => {
              if (data.isSaved) {
                this.ngOnInit();
              }
              else {
                this.loadervisible = false;
                this.buttonagreed_Issue = false;
                document.querySelector(".error-dialogfor-ist").classList.remove("ist-hide");
                document.querySelector(".message-ist").innerHTML = data.errorInfo;
                const overlay = document.querySelector("#overlay") as HTMLElement;
                overlay.style.display = "block";
              }
            })
          }
          else {
            this.ticketIssuanceService.IssueGalileoTicket(this.bookingInfo).subscribe((data) => {
              if (data.isSaved) {
                this.bookingID = data.bookingID;
                if (this.offlineIdRequestFromOfflineList > 0) {
                  this.service.UpdateOfflineTktRequest(this.offlineIdRequestFromOfflineList, localStorage.getItem("UserId")).subscribe((data) => {
                    if (data == true) {
                      this.offlinetoOnlineproperty = new OfflineToOnlineProperties();
                      this.ngOnInit();
                      this.offlineTempId = this.offlineIdRequestFromOfflineList;
                      this.offlineIdRequestFromOfflineList = 0;
                      this.router.navigateByUrl('/ticket-issuance');
                    }
                  });
                }
                else {
                  this.ngOnInit();
                  this.router.navigateByUrl('/ticket-issuance');
                }
              }
              else {
                this.loadervisible = false;
                this.buttonagreed_Issue = false;
                this.refreshTktopen = true;
                this.errorIssueticketMessage = data.errorInfo;
              }
            });
          }
        }
        else {
          /// for all agent if no right then go to requested  for 'ag01' giving error you have no issue rights check in later
          this.tktPnrRight.issueTicket = false;
        }
      }
      ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      else if (this.tktPnrRight.userTicketIssueRightsPCCs.oneGGDS.oneGGDSRightStatus && this.bookingInfo.providerCode == "1GGDS") {
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        if (this.tktPnrRight.userTicketIssueRightsPCCs.oneGGDS.oneGGDS8X4IRightStatus && this.tktPnrRight.userTicketIssueRightsPCCs.oneGGDS.assignedAirlinesGDS8X4I.includes(this.newsectorInfo[0].airlinePrefixCode)) {
          this.bookingInfo.issuanceUser = Number(localStorage.getItem("UserId"));
          this.bookingInfo.userBackSystemCompanyId = Number(localStorage.getItem("BackSystemCompanyId"));
          this.bookingInfo.userBackSystemCustomer = localStorage.getItem("BackSystemCompanyCustomer");
          if (this.bookingInfo.groupTicketId > 0) {
            this.bookingInfo.bookingPassengerInfoProperties = this.bookingInfo.bookingPassengerInfoProperties.map(tkt => {
              return { ...tkt, ticketNo: "" }
            })
            this.groupTicketService.IssueGroupTicket(this.bookingInfo).subscribe(data => {
              if (data.isSaved) {
                this.ngOnInit();
              }
              else {
                this.loadervisible = false;
                this.buttonagreed_Issue = false;
                document.querySelector(".error-dialogfor-ist").classList.remove("ist-hide");
                document.querySelector(".message-ist").innerHTML = data.errorInfo;
                const overlay = document.querySelector("#overlay") as HTMLElement;
                overlay.style.display = "block";
              }
            })
          }
          else {
            this.ticketIssuanceService.IssueGalileoTicket(this.bookingInfo).subscribe((data) => {
              if (data.isSaved) {
                this.bookingID = data.bookingID;
                if (this.offlineIdRequestFromOfflineList > 0) {
                  this.service.UpdateOfflineTktRequest(this.offlineIdRequestFromOfflineList, localStorage.getItem("UserId")).subscribe((data) => {
                    if (data == true) {
                      this.offlinetoOnlineproperty = new OfflineToOnlineProperties();
                      this.ngOnInit();
                      this.offlineTempId = this.offlineIdRequestFromOfflineList;
                      this.offlineIdRequestFromOfflineList = 0;
                      this.router.navigateByUrl('/ticket-issuance');
                    }
                  });
                }
                else {
                  this.ngOnInit();
                  this.router.navigateByUrl('/ticket-issuance');
                }
              }
              else {
                this.loadervisible = false;
                this.buttonagreed_Issue = false;
                this.refreshTktopen = true;
                this.errorIssueticketMessage = data.errorInfo;
              }
            });
          }
        }
        ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        else if (this.tktPnrRight.userTicketIssueRightsPCCs.oneGGDS.oneGGDS8K5XRightStatus && this.tktPnrRight.userTicketIssueRightsPCCs.oneGGDS.assignedAirlinesGDS8K5X.includes(this.newsectorInfo[0].airlinePrefixCode)) {
          this.bookingInfo.issuanceUser = Number(localStorage.getItem("UserId"));
          this.bookingInfo.userBackSystemCompanyId = Number(localStorage.getItem("BackSystemCompanyId"));
          this.bookingInfo.userBackSystemCustomer = localStorage.getItem("BackSystemCompanyCustomer");
          if (this.bookingInfo.groupTicketId > 0) {
            this.bookingInfo.bookingPassengerInfoProperties = this.bookingInfo.bookingPassengerInfoProperties.map(tkt => {
              return { ...tkt, ticketNo: "" }
            })
            this.groupTicketService.IssueGroupTicket(this.bookingInfo).subscribe(data => {
              if (data.isSaved) {
                this.ngOnInit();
              }
              else {
                this.loadervisible = false;
                this.buttonagreed_Issue = false;
                document.querySelector(".error-dialogfor-ist").classList.remove("ist-hide");
                document.querySelector(".message-ist").innerHTML = data.errorInfo;
                const overlay = document.querySelector("#overlay") as HTMLElement;
                overlay.style.display = "block";
              }
            })
          }
          else {
            this.ticketIssuanceService.IssueGalileoTicket(this.bookingInfo).subscribe((data) => {
              if (data.isSaved) {
                this.bookingID = data.bookingID;
                if (this.offlineIdRequestFromOfflineList > 0) {
                  this.service.UpdateOfflineTktRequest(this.offlineIdRequestFromOfflineList, localStorage.getItem("UserId")).subscribe((data) => {
                    if (data == true) {
                      this.offlinetoOnlineproperty = new OfflineToOnlineProperties();
                      this.ngOnInit();
                      this.offlineTempId = this.offlineIdRequestFromOfflineList;
                      this.offlineIdRequestFromOfflineList = 0;
                      this.router.navigateByUrl('/ticket-issuance');
                    }
                  });
                }
                else {
                  this.ngOnInit();
                  this.router.navigateByUrl('/ticket-issuance');
                }
              }
              else {
                this.loadervisible = false;
                this.buttonagreed_Issue = false;
                this.refreshTktopen = true;
                this.errorIssueticketMessage = data.errorInfo;
              }
            });
          }
        }
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        else if (this.tktPnrRight.userTicketIssueRightsPCCs.oneGGDS.oneGGDSB2DRightStatus && this.tktPnrRight.userTicketIssueRightsPCCs.oneGGDS.assignedAirlinesGDSB2D.includes(this.newsectorInfo[0].airlinePrefixCode)) {
          this.bookingInfo.issuanceUser = Number(localStorage.getItem("UserId"));
          this.bookingInfo.userBackSystemCompanyId = Number(localStorage.getItem("BackSystemCompanyId"));
          this.bookingInfo.userBackSystemCustomer = localStorage.getItem("BackSystemCompanyCustomer");
          if (this.bookingInfo.groupTicketId > 0) {
            this.bookingInfo.bookingPassengerInfoProperties = this.bookingInfo.bookingPassengerInfoProperties.map(tkt => {
              return { ...tkt, ticketNo: "" }
            })
            this.groupTicketService.IssueGroupTicket(this.bookingInfo).subscribe(data => {
              if (data.isSaved) {
                this.ngOnInit();
              }
              else {
                this.loadervisible = false;
                this.buttonagreed_Issue = false;
                document.querySelector(".error-dialogfor-ist").classList.remove("ist-hide");
                document.querySelector(".message-ist").innerHTML = data.errorInfo;
                const overlay = document.querySelector("#overlay") as HTMLElement;
                overlay.style.display = "block";
              }
            })
          }
          else {
            this.ticketIssuanceService.IssueGalileoTicket(this.bookingInfo).subscribe((data) => {
              if (data.isSaved) {
                this.bookingID = data.bookingID;
                if (this.offlineIdRequestFromOfflineList > 0) {
                  this.service.UpdateOfflineTktRequest(this.offlineIdRequestFromOfflineList, localStorage.getItem("UserId")).subscribe((data) => {
                    if (data == true) {
                      this.offlinetoOnlineproperty = new OfflineToOnlineProperties();
                      this.ngOnInit();
                      this.offlineTempId = this.offlineIdRequestFromOfflineList;
                      this.offlineIdRequestFromOfflineList = 0;
                      this.router.navigateByUrl('/ticket-issuance');
                    }
                  });
                }
                else {
                  this.ngOnInit();
                  this.router.navigateByUrl('/ticket-issuance');
                }
              }
              else {
                this.loadervisible = false;
                this.buttonagreed_Issue = false;
                this.refreshTktopen = true;
                this.errorIssueticketMessage = data.errorInfo;
              }
            });
          }
        }
        ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        else if (this.tktPnrRight.userTicketIssueRightsPCCs.oneGGDS.oneGGDS7KE2RightStatus && this.tktPnrRight.userTicketIssueRightsPCCs.oneGGDS.assignedAirlinesGDS7KE2.includes(this.newsectorInfo[0].airlinePrefixCode)) {
          this.bookingInfo.issuanceUser = Number(localStorage.getItem("UserId"));
          this.bookingInfo.userBackSystemCompanyId = Number(localStorage.getItem("BackSystemCompanyId"));
          this.bookingInfo.userBackSystemCustomer = localStorage.getItem("BackSystemCompanyCustomer");
          if (this.bookingInfo.groupTicketId > 0) {
            this.bookingInfo.bookingPassengerInfoProperties = this.bookingInfo.bookingPassengerInfoProperties.map(tkt => {
              return { ...tkt, ticketNo: "" }
            })
            this.groupTicketService.IssueGroupTicket(this.bookingInfo).subscribe(data => {
              if (data.isSaved) {
                this.ngOnInit();
              }
              else {
                this.loadervisible = false;
                this.buttonagreed_Issue = false;
                document.querySelector(".error-dialogfor-ist").classList.remove("ist-hide");
                document.querySelector(".message-ist").innerHTML = data.errorInfo;
                const overlay = document.querySelector("#overlay") as HTMLElement;
                overlay.style.display = "block";
              }
            })
          }
          else {
            this.ticketIssuanceService.IssueGalileoTicket(this.bookingInfo).subscribe((data) => {
              if (data.isSaved) {
                this.bookingID = data.bookingID;
                if (this.offlineIdRequestFromOfflineList > 0) {
                  this.service.UpdateOfflineTktRequest(this.offlineIdRequestFromOfflineList, localStorage.getItem("UserId")).subscribe((data) => {
                    if (data == true) {
                      this.offlinetoOnlineproperty = new OfflineToOnlineProperties();
                      this.ngOnInit();
                      this.offlineTempId = this.offlineIdRequestFromOfflineList;
                      this.offlineIdRequestFromOfflineList = 0;
                      this.router.navigateByUrl('/ticket-issuance');
                    }
                  });
                }
                else {
                  this.ngOnInit();
                  this.router.navigateByUrl('/ticket-issuance');
                }
              }
              else {
                this.loadervisible = false;
                this.buttonagreed_Issue = false;
                this.refreshTktopen = true;
                this.errorIssueticketMessage = data.errorInfo;
              }
            });
          }
        }
        else {
          /// for all agent if no right then go to requested  for 'ag01' giving error you have no issue rights check in later
          this.tktPnrRight.issueTicket = false;
        }
      }
      ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      else if (this.tktPnrRight.userTicketIssueRightsPCCs.oneGNDC.oneGNDCRightStatus && this.bookingInfo.providerCode == "1GNDC") {
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        if (this.tktPnrRight.userTicketIssueRightsPCCs.oneGNDC.oneGNDC8X4IRightStatus && this.tktPnrRight.userTicketIssueRightsPCCs.oneGNDC.assignedAirlinesNDC8X4I.includes(this.newsectorInfo[0].airlinePrefixCode)) {
          this.bookingInfo.issuanceUser = Number(localStorage.getItem("UserId"));
          this.bookingInfo.userBackSystemCompanyId = Number(localStorage.getItem("BackSystemCompanyId"));
          this.bookingInfo.userBackSystemCustomer = localStorage.getItem("BackSystemCompanyCustomer");
          if (this.bookingInfo.groupTicketId > 0) {
            this.bookingInfo.bookingPassengerInfoProperties = this.bookingInfo.bookingPassengerInfoProperties.map(tkt => {
              return { ...tkt, ticketNo: "" }
            })
            this.groupTicketService.IssueGroupTicket(this.bookingInfo).subscribe(data => {
              if (data.isSaved) {
                this.ngOnInit();
              }
              else {
                this.loadervisible = false;
                this.buttonagreed_Issue = false;
                document.querySelector(".error-dialogfor-ist").classList.remove("ist-hide");
                document.querySelector(".message-ist").innerHTML = data.errorInfo;
                const overlay = document.querySelector("#overlay") as HTMLElement;
                overlay.style.display = "block";
              }
            })
          }
          else {
            this.ticketIssuanceService.IssueGalileoTicket(this.bookingInfo).subscribe((data) => {
              if (data.isSaved) {
                this.bookingID = data.bookingID;
                if (this.offlineIdRequestFromOfflineList > 0) {
                  this.service.UpdateOfflineTktRequest(this.offlineIdRequestFromOfflineList, localStorage.getItem("UserId")).subscribe((data) => {
                    if (data == true) {
                      this.offlinetoOnlineproperty = new OfflineToOnlineProperties();
                      this.ngOnInit();
                      this.offlineTempId = this.offlineIdRequestFromOfflineList;
                      this.offlineIdRequestFromOfflineList = 0;
                      this.router.navigateByUrl('/ticket-issuance');
                    }
                  });
                }
                else {
                  this.ngOnInit();
                  this.router.navigateByUrl('/ticket-issuance');
                }
              }
              else {
                this.loadervisible = false;
                this.buttonagreed_Issue = false;
                this.refreshTktopen = true;
                this.errorIssueticketMessage = data.errorInfo;
              }
            });
          }
        }
        ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        else if (this.tktPnrRight.userTicketIssueRightsPCCs.oneGNDC.oneGNDC8K5XRightStatus && this.tktPnrRight.userTicketIssueRightsPCCs.oneGNDC.assignedAirlinesNDC8K5X.includes(this.newsectorInfo[0].airlinePrefixCode)) {
          this.bookingInfo.issuanceUser = Number(localStorage.getItem("UserId"));
          this.bookingInfo.userBackSystemCompanyId = Number(localStorage.getItem("BackSystemCompanyId"));
          this.bookingInfo.userBackSystemCustomer = localStorage.getItem("BackSystemCompanyCustomer");
          if (this.bookingInfo.groupTicketId > 0) {
            this.bookingInfo.bookingPassengerInfoProperties = this.bookingInfo.bookingPassengerInfoProperties.map(tkt => {
              return { ...tkt, ticketNo: "" }
            })
            this.groupTicketService.IssueGroupTicket(this.bookingInfo).subscribe(data => {
              if (data.isSaved) {
                this.ngOnInit();
              }
              else {
                this.loadervisible = false;
                this.buttonagreed_Issue = false;
                document.querySelector(".error-dialogfor-ist").classList.remove("ist-hide");
                document.querySelector(".message-ist").innerHTML = data.errorInfo;
                const overlay = document.querySelector("#overlay") as HTMLElement;
                overlay.style.display = "block";
              }
            })
          }
          else {
            this.ticketIssuanceService.IssueGalileoTicket(this.bookingInfo).subscribe((data) => {
              if (data.isSaved) {
                this.bookingID = data.bookingID;
                if (this.offlineIdRequestFromOfflineList > 0) {
                  this.service.UpdateOfflineTktRequest(this.offlineIdRequestFromOfflineList, localStorage.getItem("UserId")).subscribe((data) => {
                    if (data == true) {
                      this.offlinetoOnlineproperty = new OfflineToOnlineProperties();
                      this.ngOnInit();
                      this.offlineTempId = this.offlineIdRequestFromOfflineList;
                      this.offlineIdRequestFromOfflineList = 0;
                      this.router.navigateByUrl('/ticket-issuance');
                    }
                  });
                }
                else {
                  this.ngOnInit();
                  this.router.navigateByUrl('/ticket-issuance');
                }
              }
              else {
                this.loadervisible = false;
                this.buttonagreed_Issue = false;
                this.refreshTktopen = true;
                this.errorIssueticketMessage = data.errorInfo;
              }
            });
          }
        }
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        else if (this.tktPnrRight.userTicketIssueRightsPCCs.oneGNDC.oneGNDCB2DRightStatus && this.tktPnrRight.userTicketIssueRightsPCCs.oneGNDC.assignedAirlinesNDCB2D.includes(this.newsectorInfo[0].airlinePrefixCode)) {
          this.bookingInfo.issuanceUser = Number(localStorage.getItem("UserId"));
          this.bookingInfo.userBackSystemCompanyId = Number(localStorage.getItem("BackSystemCompanyId"));
          this.bookingInfo.userBackSystemCustomer = localStorage.getItem("BackSystemCompanyCustomer");
          if (this.bookingInfo.groupTicketId > 0) {
            this.bookingInfo.bookingPassengerInfoProperties = this.bookingInfo.bookingPassengerInfoProperties.map(tkt => {
              return { ...tkt, ticketNo: "" }
            })
            this.groupTicketService.IssueGroupTicket(this.bookingInfo).subscribe(data => {
              if (data.isSaved) {
                this.ngOnInit();
              }
              else {
                this.loadervisible = false;
                this.buttonagreed_Issue = false;
                document.querySelector(".error-dialogfor-ist").classList.remove("ist-hide");
                document.querySelector(".message-ist").innerHTML = data.errorInfo;
                const overlay = document.querySelector("#overlay") as HTMLElement;
                overlay.style.display = "block";
              }
            })
          }
          else {
            this.ticketIssuanceService.IssueGalileoTicket(this.bookingInfo).subscribe((data) => {
              if (data.isSaved) {
                this.bookingID = data.bookingID;
                if (this.offlineIdRequestFromOfflineList > 0) {
                  this.service.UpdateOfflineTktRequest(this.offlineIdRequestFromOfflineList, localStorage.getItem("UserId")).subscribe((data) => {
                    if (data == true) {
                      this.offlinetoOnlineproperty = new OfflineToOnlineProperties();
                      this.ngOnInit();
                      this.offlineTempId = this.offlineIdRequestFromOfflineList;
                      this.offlineIdRequestFromOfflineList = 0;
                      this.router.navigateByUrl('/ticket-issuance');
                    }
                  });
                }
                else {
                  this.ngOnInit();
                  this.router.navigateByUrl('/ticket-issuance');
                }
              }
              else {
                this.loadervisible = false;
                this.buttonagreed_Issue = false;
                this.refreshTktopen = true;
                this.errorIssueticketMessage = data.errorInfo;
              }
            });
          }
        }
        ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        else if (this.tktPnrRight.userTicketIssueRightsPCCs.oneGNDC.oneGNDC7KE2RightStatus && this.tktPnrRight.userTicketIssueRightsPCCs.oneGNDC.assignedAirlinesNDC7KE2.includes(this.newsectorInfo[0].airlinePrefixCode)) {
          this.bookingInfo.issuanceUser = Number(localStorage.getItem("UserId"));
          this.bookingInfo.userBackSystemCompanyId = Number(localStorage.getItem("BackSystemCompanyId"));
          this.bookingInfo.userBackSystemCustomer = localStorage.getItem("BackSystemCompanyCustomer");
          if (this.bookingInfo.groupTicketId > 0) {
            this.bookingInfo.bookingPassengerInfoProperties = this.bookingInfo.bookingPassengerInfoProperties.map(tkt => {
              return { ...tkt, ticketNo: "" }
            })
            this.groupTicketService.IssueGroupTicket(this.bookingInfo).subscribe(data => {
              if (data.isSaved) {
                this.ngOnInit();
              }
              else {
                this.loadervisible = false;
                this.buttonagreed_Issue = false;
                document.querySelector(".error-dialogfor-ist").classList.remove("ist-hide");
                document.querySelector(".message-ist").innerHTML = data.errorInfo;
                const overlay = document.querySelector("#overlay") as HTMLElement;
                overlay.style.display = "block";
              }
            })
          }
          else {
            this.ticketIssuanceService.IssueGalileoTicket(this.bookingInfo).subscribe((data) => {
              if (data.isSaved) {
                this.bookingID = data.bookingID;
                if (this.offlineIdRequestFromOfflineList > 0) {
                  this.service.UpdateOfflineTktRequest(this.offlineIdRequestFromOfflineList, localStorage.getItem("UserId")).subscribe((data) => {
                    if (data == true) {
                      this.offlinetoOnlineproperty = new OfflineToOnlineProperties();
                      this.ngOnInit();
                      this.offlineTempId = this.offlineIdRequestFromOfflineList;
                      this.offlineIdRequestFromOfflineList = 0;
                      this.router.navigateByUrl('/ticket-issuance');
                    }
                  });
                }
                else {
                  this.ngOnInit();
                  this.router.navigateByUrl('/ticket-issuance');
                }
              }
              else {
                this.loadervisible = false;
                this.buttonagreed_Issue = false;
                this.refreshTktopen = true;
                this.errorIssueticketMessage = data.errorInfo;
              }
            });
          }
        }
        else {
          /// for all agent if no right then go to requested  for 'ag01' giving error you have no issue rights check in later
          this.tktPnrRight.issueTicket = false;
        }
      }
      ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      else if (this.tktPnrRight.userTicketIssueRightsPCCs.indNDC.rightStatus && this.tktPnrRight.userTicketIssueRightsPCCs.indNDC.assignedAirlines.includes(this.newsectorInfo[0].airlinePrefixCode)) {
        this.bookingInfo.issuanceUser = Number(localStorage.getItem("UserId"));
        this.bookingInfo.userBackSystemCompanyId = Number(localStorage.getItem("BackSystemCompanyId"));
        this.bookingInfo.userBackSystemCustomer = localStorage.getItem("BackSystemCompanyCustomer");
        if (this.bookingInfo.groupTicketId > 0) {
          this.bookingInfo.bookingPassengerInfoProperties = this.bookingInfo.bookingPassengerInfoProperties.map(tkt => {
            return { ...tkt, ticketNo: "" }
          })
          this.groupTicketService.IssueGroupTicket(this.bookingInfo).subscribe(data => {
            if (data.isSaved) {
              this.ngOnInit();
            }
            else {
              this.loadervisible = false;
              this.buttonagreed_Issue = false;
              document.querySelector(".error-dialogfor-ist").classList.remove("ist-hide");
              document.querySelector(".message-ist").innerHTML = data.errorInfo;
              const overlay = document.querySelector("#overlay") as HTMLElement;
              overlay.style.display = "block";
            }
          })
        }
        else {
          this.ticketIssuanceService.IssueGalileoTicket(this.bookingInfo).subscribe((data) => {
            if (data.isSaved) {
              this.bookingID = data.bookingID;
              if (this.offlineIdRequestFromOfflineList > 0) {
                this.service.UpdateOfflineTktRequest(this.offlineIdRequestFromOfflineList, localStorage.getItem("UserId")).subscribe((data) => {
                  if (data == true) {
                    this.offlinetoOnlineproperty = new OfflineToOnlineProperties();
                    this.ngOnInit();
                    this.offlineTempId = this.offlineIdRequestFromOfflineList;
                    this.offlineIdRequestFromOfflineList = 0;
                    this.router.navigateByUrl('/ticket-issuance');
                  }
                });
              }
              else {
                this.ngOnInit();
                this.router.navigateByUrl('/ticket-issuance');
              }
            }
            else {
              this.loadervisible = false;
              this.buttonagreed_Issue = false;
              this.refreshTktopen = true;
              this.errorIssueticketMessage = data.errorInfo;
            }
          });
        }
      }
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      else if (this.tktPnrRight.userTicketIssueRightsPCCs.lccs.rightStatus && this.tktPnrRight.userTicketIssueRightsPCCs.lccs.assignedAirlines.includes(this.newsectorInfo[0].airlinePrefixCode) && this.bookingInfo.providerCode != "1GGDS" && this.bookingInfo.providerCode != "1GNDC" && this.bookingInfo.providerCode != "1G") {
        this.bookingInfo.issuanceUser = Number(localStorage.getItem("UserId"));
        this.bookingInfo.userBackSystemCompanyId = Number(localStorage.getItem("BackSystemCompanyId"));
        this.bookingInfo.userBackSystemCustomer = localStorage.getItem("BackSystemCompanyCustomer");
        if (this.bookingInfo.groupTicketId > 0) {
          this.bookingInfo.bookingPassengerInfoProperties = this.bookingInfo.bookingPassengerInfoProperties.map(tkt => {
            return { ...tkt, ticketNo: "" }
          })
          this.groupTicketService.IssueGroupTicket(this.bookingInfo).subscribe(data => {
            if (data.isSaved) {
              this.ngOnInit();
            }
            else {
              this.loadervisible = false;
              this.buttonagreed_Issue = false;
              document.querySelector(".error-dialogfor-ist").classList.remove("ist-hide");
              document.querySelector(".message-ist").innerHTML = data.errorInfo;
              const overlay = document.querySelector("#overlay") as HTMLElement;
              overlay.style.display = "block";
            }
          })
        }
        else {
          this.ticketIssuanceService.IssueGalileoTicket(this.bookingInfo).subscribe((data) => {
            if (data.isSaved) {
              this.bookingID = data.bookingID;
              if (this.offlineIdRequestFromOfflineList > 0) {
                this.service.UpdateOfflineTktRequest(this.offlineIdRequestFromOfflineList, localStorage.getItem("UserId")).subscribe((data) => {
                  if (data == true) {
                    this.offlinetoOnlineproperty = new OfflineToOnlineProperties();
                    this.ngOnInit();
                    this.offlineTempId = this.offlineIdRequestFromOfflineList;
                    this.offlineIdRequestFromOfflineList = 0;
                    this.router.navigateByUrl('/ticket-issuance');
                  }
                });
              }
              else {
                this.ngOnInit();
                this.router.navigateByUrl('/ticket-issuance');
              }
            }
            else {
              this.loadervisible = false;
              this.buttonagreed_Issue = false;
              this.refreshTktopen = true;
              this.errorIssueticketMessage = data.errorInfo;
            }
          });
        }
      }
      else {
        /// request for issue part for agent now 02-07-2026
        if (this.bookingInfo.groupTicketId > 0) {
          this.bookingInfo.groupTicketRequest = 1; //Issue Request
          this.groupTicketService.UpdateIssueGroupTicketStatus(this.bookingInfo.bookingID, this.bookingInfo.groupTicketId, this.bookingInfo.groupTicketRequest, this.bookingInfo.bookingPassengerInfoProperties.length).subscribe(data => {
            if (data == true) {
              this.router.navigateByUrl('/bookingList');
            }
            else {
              this.loadervisible = false;
              this.buttonagreed_Issue = false;
              document.querySelector(".error-dialogfor-ist").classList.remove("ist-hide");
              document.querySelector(".message-ist").innerHTML = "Something Went Wrong";
              const overlay = document.querySelector("#overlay") as HTMLElement;
              overlay.style.display = "block";
            }
          })
        }
        else {

          if (localStorage.getItem("AgencyId") != 'AG01') {

            localStorage.removeItem("IsTicket");
            localStorage.setItem("OnlineBookingId", JSON.stringify(this.bookingID));
            localStorage.setItem("IsTicket", "True");
            localStorage.setItem("TicketReRequest", "false");
            this.offlineTempId = 0;

            this.router.navigateByUrl('/offlineRequestList');
          }
          else {
            if (localStorage.getItem("AgencyId") == 'AG01') {
              //this.loadervisible = false;
              //this.buttonagreed_Issue = false;
              //document.querySelector(".error-dialogfor-ist").classList.remove("ist-hide");
              //document.querySelector(".message-ist").innerHTML = "You Do Not Have Right to Issue Ticket";
              //const overlay = document.querySelector("#overlay") as HTMLElement;
              //overlay.style.display = "block";
              this.loadervisible = false;
              this.NewSuccess.open(targetmodel, {
                windowClass: "warningPopupmodal", centered: true
              })
            }
          }
          //end
        }
      }
      if (this.tktPnrRight.issueTicket == false) {
         /// request for issue part for agent now 02-07-2026
         if (this.bookingInfo.groupTicketId > 0) {
           this.bookingInfo.groupTicketRequest = 1; //Issue Request
           this.groupTicketService.UpdateIssueGroupTicketStatus(this.bookingInfo.bookingID, this.bookingInfo.groupTicketId, this.bookingInfo.groupTicketRequest, this.bookingInfo.bookingPassengerInfoProperties.length).subscribe(data => {
             if (data == true) {
               this.router.navigateByUrl('/bookingList');
             }
             else {
               this.loadervisible = false;
               this.buttonagreed_Issue = false;
               document.querySelector(".error-dialogfor-ist").classList.remove("ist-hide");
               document.querySelector(".message-ist").innerHTML = "Something Went Wrong";
               const overlay = document.querySelector("#overlay") as HTMLElement;
               overlay.style.display = "block";
             }
           })
         }
         else {

           if (localStorage.getItem("AgencyId") != 'AG01') {

             localStorage.removeItem("IsTicket");
             localStorage.setItem("OnlineBookingId", JSON.stringify(this.bookingID));
             localStorage.setItem("IsTicket", "True");
             localStorage.setItem("TicketReRequest", "false");
             this.offlineTempId = 0;

             this.router.navigateByUrl('/offlineRequestList');
           }
           else {
             if (localStorage.getItem("AgencyId") == 'AG01') {
               this.loadervisible = false;
               this.buttonagreed_Issue = false;
               document.querySelector(".error-dialogfor-ist").classList.remove("ist-hide");
               document.querySelector(".message-ist").innerHTML = "You Do Not Have Right to Issue Ticket";
               const overlay = document.querySelector("#overlay") as HTMLElement;
               overlay.style.display = "block";
             }
           }
         //end
         }
       }
    }
    
    //else {
    //this.loadervisible = false;
    //  this.buttonagreed_Issue = false;
    //  document.querySelector(".error-dialogfor-ist").classList.remove("ist-hide");
    //  document.querySelector(".message-ist").innerHTML = "Ticket can't be issued due to low balance";
    //  const overlay = document.querySelector("#overlay") as HTMLElement;
    //  overlay.style.display = "block";
    //}
    // });

  }

  //openVoidPop() {
  //  this.voidPassengerInfo = [];
  //  this.NewSuccess.dismissAll();
  //  if (this.offlineTempId > 0) {
  //    for (let k = 0; k < this.bookingPassengerInfoOffline.length; k++) {
  //      if (this.bookingPassengerInfoOffline[k].isOfflineVoid == true) {
  //        this.bookingPassengerInfoOffline[k].isVoid = this.bookingPassengerInfoOffline[k].isOfflineVoid;
  //        this.checkvoid = true;
  //        this.voidPassengerInfo.push(this.bookingPassengerInfoOffline[k]);
  //      }
  //    }
  //    if (this.voidPassengerInfo.length > 0) {
  //      $("#myModalVoid").modal('show');
  //    }
  //  }
  //  else {
  //    for (let j = 0; j < this.bookingPassengerInfo.length; j++) {
  //      if (!this.bookingPassengerInfo[j].isVoid) {
  //        this.voidPassengerInfo.push(this.bookingPassengerInfo[j]);
  //      }
  //    }
  //    if (this.voidPassengerInfo.length > 0) {
  //      $("#myModalVoid").modal('show');
  //    }
  //  }




  //}

  openVoidPop() {
    this.voidPassengerInfo = [];
    this.NewSuccess.dismissAll();
    if (this.offlineTempId > 0) {
      for (let k = 0; k < this.bookingPassengerInfoOffline.length; k++) {
        if (this.bookingPassengerInfoOffline[k].isOfflineVoid == true) {
          this.bookingPassengerInfoOffline[k].isVoid = this.bookingPassengerInfoOffline[k].isOfflineVoid;
          this.checkvoid = true;
          this.voidPassengerInfo.push(this.bookingPassengerInfoOffline[k]);
        }
      }
      if (this.voidPassengerInfo.length > 0) {
        $("#myModalVoid").modal('show');
      }
    }
    else {
      if (this.bookingInfo.providerCode == "FZ") {
        for (let j = 0; j < this.bookingPassengerInfo.length; j++) {
          this.bookingPassengerInfo[j].isVoid = true;
          this.checkvoid = true;
          this.voidPassengerInfo.push(this.bookingPassengerInfo[j]);

        }
      } else {
        for (let j = 0; j < this.bookingPassengerInfo.length; j++) {
          if (!this.bookingPassengerInfo[j].isVoid) {
            this.voidPassengerInfo.push(this.bookingPassengerInfo[j]);
          }
        }
      }

      if (this.voidPassengerInfo.length > 0) {
        $("#myModalVoid").modal('show');
      }
    }




  }
  cancelPNR() {
    this.buttonagreed_cancel = true;
    this.NewSuccess.dismissAll();
    this.loadervisible = true;
    this.stopTimerToRefresh();
    if (this.tktPnrRight.cancelPnr == false) {
      if (this.bookingInfo.groupTicketId > 0) {
        this.bookingInfo.groupTicketRequest = 2; //Cancel Request
        this.groupTicketService.UpdateIssueGroupTicketStatus(this.bookingInfo.bookingID, this.bookingInfo.groupTicketId, this.bookingInfo.groupTicketRequest, this.bookingInfo.bookingPassengerInfoProperties.length).subscribe(data => {
          if (data == true) {
            this.router.navigateByUrl('/bookingList');
          }
          else {
            this.loadervisible = false;
            this.buttonagreed_Issue = false;
            document.querySelector(".error-dialogfor-ist").classList.remove("ist-hide");
            document.querySelector(".message-ist").innerHTML = "Something Went Wrong";
            const overlay = document.querySelector("#overlay") as HTMLElement;
            overlay.style.display = "block";
          }
        })
      }
      else {
        localStorage.setItem("OnlineBookingId", JSON.stringify(this.bookingID));
        localStorage.setItem("IsPnr", "True");
        this.offlineTempId = 0;

        this.router.navigateByUrl('/offlineRequestList');
      }
    }
    //new work
    else
      if (this.tktPnrRight.cancelPnr) {

        this.bookingInfo.cancelBookingUser = Number(localStorage.getItem("UserId"));
        if (this.bookingInfo.groupTicketId > 0) {
          this.bookingInfo.bookingStatus = 3;
          this.groupTicketService.CancelGroupTicket(this.bookingInfo).subscribe(data => {
            if (data == true) {
              this.ngOnInit();
              // this.router.navigateByUrl('/groupTicketList');
            }
            else {
              this.loadervisible = false;
              this.buttonagreed_Issue = false;
              document.querySelector(".error-dialogfor-ist").classList.remove("ist-hide");
              document.querySelector(".message-ist").innerHTML = "Something Went Wrong";
              const overlay = document.querySelector("#overlay") as HTMLElement;
              overlay.style.display = "block";
            }
          })
        }
        else {
          this.ticketIssuanceService.CancelGalileoPNR(this.bookingInfo).subscribe((data) => {
            if (data.isSaved) {
              this.bookingID = data.bookingID;

              this.ngOnInit();

              if (this.offlineIdRequestFromOfflineList > 0) {
                this.service.UpdateOfflineTktRequest(this.offlineIdRequestFromOfflineList, localStorage.getItem("UserId")).subscribe((data) => {
                  if (data == true) {
                    this.offlinetoOnlineproperty = new OfflineToOnlineProperties();
                    this.ngOnInit();
                    this.offlineTempId = this.offlineIdRequestFromOfflineList;
                    this.offlineIdRequestFromOfflineList = 0;
                    localStorage.removeItem("RequestTypeIdOffline");
                    //this.router.navigateByUrl('/ticket-issuance');
                  }
                  else {
                    this.buttonagreed_cancel = false;
                  }
                });
              }

            }
            else {
              this.loadervisible = false;
              this.buttonagreed_cancel = false;
              document.querySelector(".error-dialogfor-ist").classList.remove("ist-hide");
              document.querySelector(".message-ist").innerHTML = data.errorInfo;
              const overlay = document.querySelector("#overlay") as HTMLElement;
              overlay.style.display = "block";
            }
          });
        }

      }
      else if (this.tktPnrRight.offlineCancel) {
        //Make offline cancel Request
      }

  }

  reprice() {
    if (this.tktPnrRight.reprice) {

    }
    //else if (this.tktPnrRight)


  }
  voidTicket() {
    this.loadervisible = true;
    this.stopTimerToRefresh();
    this.buttonagreed_void = true;
    if (this.tktPnrRight.voidTicket == false) {
      this.bookingrefundinfo.bookingPassengerInfoProperties = this.voidPassengerInfo;
      this.ticketIssuanceService.VoidOfflineRequest(this.bookingrefundinfo).subscribe((data) => {
        if (data == true) {
          localStorage.setItem("OnlineBookingId", JSON.stringify(this.bookingID));
          localStorage.setItem("IsVoid", "True");
          $("#myModalVoid").modal('hide');
          this.offlineTempId = 0;

          this.router.navigateByUrl('/offlineRequestList');
        }
      })
    }
    //new work
    else if (this.tktPnrRight.voidTicket) {
      let voidticket: number = 0;
      for (let j = 0; j < this.voidPassengerInfo.length; j++) {
        if (this.voidPassengerInfo[j].isVoid) {
          voidticket++;
        }
      }
      if (voidticket == 0) {
        document.getElementById("voidrequiredmsg").innerHTML = "Required at least one!";
        setTimeout(() => {
          document.getElementById("voidrequiredmsg").innerHTML = "";
        }, 3000);
        return;
      }



      $("#myModalVoid").modal('hide');
      let voidprop = new VoidTicketProperties();
      if (this.bookingInfo.providerCode == "HITIT") {
        let voidcount = 0;
        for (let j = 0; j < this.voidPassengerInfo.length; j++) {
          if (this.voidPassengerInfo[j].isVoid) {
            voidcount++;
          }
        }
        if (voidcount != this.voidPassengerInfo.length) {
          for (let j = 0; j < this.voidPassengerInfo.length; j++) {
            if (this.voidPassengerInfo[j].isVoid) {
              if (this.voidPassengerInfo[j].passengerType == 1) {
                for (let k = 0; k < this.voidPassengerInfo.length; k++) {
                  if (this.voidPassengerInfo[j].firstName == this.voidPassengerInfo[k].associatedAdult) {
                    if (!this.voidPassengerInfo[k].isVoid) {
                      this.voidPassengerInfo[k].isVoid = true;
                      break;
                    }
                  }
                }
              }
              if (this.voidPassengerInfo[j].passengerType == 3) {
                for (let k = 0; k < this.voidPassengerInfo.length; k++) {
                  if (this.voidPassengerInfo[j].associatedAdult == this.voidPassengerInfo[k].firstName) {
                    if (!this.voidPassengerInfo[k].isVoid) {
                      this.voidPassengerInfo[k].isVoid = true;
                      break;
                    }
                  }
                }
              }
            }
          }
          for (let j = 0; j < this.voidPassengerInfo.length; j++) {
            if (this.voidPassengerInfo[j].isVoid) {
              if (this.voidPassengerInfo[j].passengerType != 3) {
                voidprop.Tickets.push(this.voidPassengerInfo[j].ticketNo);
              }
            }
          }
        }
        else {
          for (let j = 0; j < this.voidPassengerInfo.length; j++) {
            if (this.voidPassengerInfo[j].isVoid) {
              voidprop.Tickets.push(this.voidPassengerInfo[j].ticketNo);
            }
          }
        }


      }
      else {
        for (let j = 0; j < this.voidPassengerInfo.length; j++) {
          if (this.voidPassengerInfo[j].isVoid) {
            voidprop.Tickets.push(this.voidPassengerInfo[j].ticketNo);
          }
        }
      }



      //select Tickets needs to be voided.
      voidprop.bookingobj = new BookingInfoProperties();
      voidprop.bookingobj = this.bookingInfo;
      voidprop.bookingobj.parentHierarchy = localStorage.getItem("ParentHierarchy");
      this.ticketIssuanceService.VoidGalileoTicket(voidprop).subscribe((data) => {
        if (data.isSaved) {
          //this.hideTicketloader();
          this.bookingID = data.bookingID;

          // this.router.navigateByUrl('/ticket-issuance');
          if (this.offlineIdRequestFromOfflineList > 0) {
            this.service.UpdateOfflineTktRequest(this.offlineIdRequestFromOfflineList, localStorage.getItem("UserId")).subscribe((data) => {
              if (data == true) {
                this.offlinetoOnlineproperty = new OfflineToOnlineProperties();
                this.ngOnInit();

                this.offlineTempId = this.offlineIdRequestFromOfflineList;
                this.offlineIdRequestFromOfflineList = 0;

                this.router.navigateByUrl('/ticket-issuance');

              }

            });
          }
          else {

            this.router.navigateByUrl('/ticket-issuance');
          }
          this.ngOnInit();
        }
        else {
          this.buttonagreed_void = false;
          this.loadervisible = false;
          document.querySelector(".error-dialogfor-ist").classList.remove("ist-hide");
          document.querySelector(".message-ist").innerHTML = "Void cant be issued at this moment."
          const overlay = document.querySelector("#overlay") as HTMLElement;
          overlay.style.display = "block";
        }
      });
    }
    else if (this.tktPnrRight.offlineVoid) {

    }
  }
  bookingpassenger: BookingPassengerInfoProperties[] = [];
  hititAnciclick() {
    this.loadervisible = true;
    this.stopTimerToRefresh();
    if (this.bookingInfo.providerCode == "HITIT" || this.bookingInfo.providerCode == "HITITNDC") {
      this.postMofifyservice.PIAANCIAvailiability(this.bookingInfo).subscribe((data) => {
        if (data.availiable) {
          localStorage.setItem("postanci", JSON.stringify(this.bookingInfo));//todo: link it with booking data. in post anci, passenger info. bkdata.
          sessionStorage.setItem("seatandbaganci", JSON.stringify(data));
          localStorage.setItem("typeofbooking", this.emiratesEnumsForExchangedDivide.none.toString());
          this.loadervisible = false;
          this.router.navigate([("/postAncillary")]);
        }
        else {
          if (data.error.includes("SSL")) {
            this.messageservice.add({ severity: 'error', summary: 'Try Again', detail: 'Please Try Again!!' });

          }
          else {
            this.messageservice.add({ severity: 'error', summary: 'Unavailable', detail: 'Not Availiable!' });

          }
          this.loadervisible = false;
        }
      })
    }
    else if (this.bookingInfo.providerCode == "EK" || this.bookingInfo.providerCode == "1GGDS" || this.bookingInfo.providerCode == "1GNDC") {
      let postAncillary = new PostAncillaryGetProperties();
      postAncillary.bookingObj = this.bookingInfo;
      if (this.bookingInfo.exchangeCheck && this.bookingInfo.exchangedBookingStatus == 2) {
        this.bookingpassenger = [];
        for (let p = 0; p < this.bookingInfo.exchangebookingPassengerInfoProperties.length; p++) {
          if (!this.bookingInfo.exchangebookingPassengerInfoProperties[p].isRefund && !this.bookingInfo.exchangebookingPassengerInfoProperties[p].isVoid) {
            this.bookingpassenger.push(this.bookingInfo.exchangebookingPassengerInfoProperties[p]);
          }
        }
        postAncillary.bookingObj.bookingPassengerInfoProperties = [];
        postAncillary.bookingObj.bookingPassengerInfoProperties = this.bookingpassenger;
      }
      else {
        this.bookingpassenger = [];
        for (let p = 0; p < this.bookingInfo.bookingPassengerInfoProperties.length; p++) {
          if (!this.bookingInfo.bookingPassengerInfoProperties[p].isRefund && !this.bookingInfo.bookingPassengerInfoProperties[p].isVoid && this.bookingInfo.bookingPassengerInfoProperties[p].bookingStatus != "Exchanged") {
            this.bookingpassenger.push(this.bookingInfo.bookingPassengerInfoProperties[p]);
          }
        }
        postAncillary.bookingObj.bookingPassengerInfoProperties = [];
        postAncillary.bookingObj.bookingPassengerInfoProperties = this.bookingpassenger;
      }



      this.postMofifyservice.PostANCIAvailiabilityEmirates(postAncillary).subscribe((data) => {
        if (data.isBaggageAvailable || data.isSeatAvailable) {
          localStorage.setItem("postanci", JSON.stringify(data.bookingObj));
          sessionStorage.setItem("seatandbaganci", JSON.stringify(data));
          if (this.bookingInfo.exchangeCheck) {
            localStorage.setItem("typeofbooking", this.emiratesEnumsForExchangedDivide.exchanged.toString());
          }
          else {
            localStorage.setItem("typeofbooking", this.emiratesEnumsForExchangedDivide.none.toString());
          }

          this.loadervisible = false;
          this.router.navigate([("/postAncillary")]);
        }
        else {
          if (data.error.includes("SSL")) {
            this.messageservice.add({ severity: 'error', summary: 'Try Again', detail: 'Please Try Again!!' });

          }
          else {
            this.messageservice.add({ severity: 'error', summary: 'Unavailable', detail: 'Not Availiable!' });

          }
          this.loadervisible = false;
        }
      })
    }
  }
  // New method: 
  // Method start : airBlueAnciclick
  airBlueAnciclick() {
    this.loadervisible = true;
    this.stopTimerToRefresh();

    this.postMofifyservice.AirBlueANCIAvailiability(this.bookingInfo).subscribe({
      next: (data) => {
        if (data && data.availiable) {
          localStorage.setItem("postanci", JSON.stringify(this.bookingInfo));
          sessionStorage.setItem("seatandbaganci", JSON.stringify(data));
          this.loadervisible = false;
          this.router.navigate(["/postAncillary"]);
        } else {
          this.handleErrorResponse(data);
        }
      },
      error: (error) => {
        this.handleServiceError(error);
        this.loadervisible = false;
      }
    });
  }

  isWithinServiceChargesWindow(): boolean {
    const issuanceDate = new Date(this.bookingInfo.issuanceDateTime);
    if (isNaN(issuanceDate.getTime())) {
      return false;
    }
    const minutesSinceIssuance = (new Date().getTime() - issuanceDate.getTime()) / 60000;
    return minutesSinceIssuance >= 0 && minutesSinceIssuance <= 30;
  }

  applyServiceCharges() {
    const passengerCount = this.bookingInfo.bookingPassengerInfoProperties.length || 0;

    const servicePerPax = Number(this.serviceChargesPerPassenger) || 0;
    const baseAmount = Number(this.bookingInfo.totalAmount) || 0;

    const totalService = passengerCount * servicePerPax;

    this.totalSumAmount = baseAmount + totalService;
  }

  PostInvoiceForBranches() {
    if (this.isPostingInvoice) {
      return;
    }
    if (!this.isWithinServiceChargesWindow()) {
      this.messageservice.add({ severity: 'error', summary: 'Time Expired', detail: 'Service charges can only be added within 30 minutes of ticket issuance!' });
      this.NewSuccess.dismissAll();
      this.showPostInvoiceBtnForBranches = false;
      return;
    }
    const servicechargesForPassengers = Number(this.serviceChargesPerPassenger) || 0;

    if (servicechargesForPassengers <= 0) {
      this.messageservice.add({ severity: 'error', summary: 'Try Again', detail: 'Please enter service charges!' });
      return;
    }
    this.isPostingInvoice = true;
    for (let i = 0; i < this.bookingInfo.bookingPassengerInfoProperties.length; i++) {

      this.bookingInfo.bookingPassengerInfoProperties[i].serviceCharges = servicechargesForPassengers;
    }

    this.ticketIssuanceService.PostInvoiceForBranchesStaff(this.bookingInfo).subscribe((data) => {
      this.NewSuccess.dismissAll();
      if (data.isSaved) {
        this.ngOnInit();
        this.router.navigateByUrl('/ticket-issuance');
      }
      else {
        // this.errorIssueticketMessage = data.errorInfo;
        this.messageservice.add({ severity: 'error', summary: 'Try Again', detail: data.errorInfo });

        setTimeout(() => {
          this.ngOnInit();
          this.router.navigateByUrl('/ticket-issuance');
          this.isPostingInvoice = false;
        }, 2500); // 2000 ms = 2 seconds
      }
    });

  }
  private handleErrorResponse(data: any) {
    // Traditional null checking for older TypeScript
    let errorMessage: any;

    if (data && data.error && typeof data.error === 'string' && data.error.includes("SSL")) {
      errorMessage = { severity: 'error', summary: 'Try Again', detail: 'Please Try Again!!' };
    } else {
      errorMessage = { severity: 'error', summary: 'Unavailable', detail: 'Not Available!' };
    }

    this.messageservice.add(errorMessage);
    this.loadervisible = false;
  }

  private handleServiceError(error: any) {
    this.messageservice.add({
      severity: 'error',
      summary: 'Service Error',
      detail: 'Please try again later'
    });
  }
  // method ends airBlueAnciclick and helper methods.
  //
  voidcheckpassenger(j) {
    if (this.bookingInfo.providerCode == "HITIT" || this.bookingInfo.providerCode == "EK") {
      if (this.voidPassengerInfo[j].isVoid) {
        if (this.voidPassengerInfo[j].passengerType == 1) {
          for (let k = 0; k < this.voidPassengerInfo.length; k++) {
            if (this.voidPassengerInfo[j].firstName == this.voidPassengerInfo[k].associatedAdult) {
              if (!this.voidPassengerInfo[k].isVoid) {
                this.voidPassengerInfo[k].isVoid = true;
                break;
              }
            }
          }
        }
        if (this.voidPassengerInfo[j].passengerType == 3) {
          for (let k = 0; k < this.voidPassengerInfo.length; k++) {
            if (this.voidPassengerInfo[j].associatedAdult == this.voidPassengerInfo[k].firstName) {
              if (!this.voidPassengerInfo[k].isVoid) {
                this.voidPassengerInfo[k].isVoid = true;
                break;
              }
            }
          }
        }
      }
      else {
        if (!this.voidPassengerInfo[j].isVoid) {
          if (this.voidPassengerInfo[j].passengerType == 1) {
            for (let k = 0; k < this.voidPassengerInfo.length; k++) {
              if (this.voidPassengerInfo[j].firstName == this.voidPassengerInfo[k].associatedAdult) {
                if (this.voidPassengerInfo[k].isVoid) {
                  this.voidPassengerInfo[k].isVoid = false;
                  break;
                }
              }
            }
          }
          if (this.voidPassengerInfo[j].passengerType == 3) {
            for (let k = 0; k < this.voidPassengerInfo.length; k++) {
              if (this.voidPassengerInfo[j].associatedAdult == this.voidPassengerInfo[k].firstName) {
                if (this.voidPassengerInfo[k].isVoid) {
                  this.voidPassengerInfo[k].isVoid = false;
                  break;
                }
              }
            }
          }
        }
      }


    }


  }

  ssrIssueTicketHitit() {
    this.NewSuccess.dismissAll();
    this.buttonagreed_Issue = true;
    this.loadervisible = true;
    this.stopTimerToRefresh();
    // this.agencyService.GetAgencyBranchPendingCreditS(this.bookingInfo.finalBuyerID).subscribe((data) =>
    /* {*/
    //this.creditData = data;
    //let credit = 0;
    //if (this.creditData.agencyMasterProp.length > 0)
    //  credit = this.creditData.agencyMasterProp[0].pendingcreditLimit;
    //else
    //  credit = this.creditData.branchInfoProp[0].pendingcreditLimit;

    // if (this.bookingInfo.anciHititIssue.totalIssueAmount * this.bookingInfo.anciHititIssue.currencyValue <= credit)
    {
      if (this.tktPnrRight.issueTicket) {

        this.postMofifyservice.SSRIssueTicket(this.bookingInfo).subscribe((data) => {
          if (data.isSaved) {
            this.ngOnInit();
            this.buttonagreed_Issue = false;
          }
          else {

            this.loadervisible = false;
            this.buttonagreed_Issue = false;
            document.querySelector(".error-dialogfor-ist").classList.remove("ist-hide");
            document.querySelector(".message-ist").innerHTML = data.errorInfo;
            const overlay = document.querySelector("#overlay") as HTMLElement
            overlay.style.display = "block";
          }

        });
      }

    }

    //  }
    //  else {
    //    this.loadervisible = false;
    //    this.buttonagreed_Issue = false;
    //    document.querySelector(".error-dialogfor-ist").classList.remove("ist-hide");
    //    document.querySelector(".message-ist").innerHTML = "SSR Ticket can't be issued due to low balance";
    //    const overlay = document.querySelector("#overlay") as HTMLElement;
    //    overlay.style.display = "block";
    //  }
    //});

  }


  ticketTimer() {



    let countDownDate = new Date(this.bookingInfo.lastTicketingTime).getTime();

    if (this.bookingStatus == "Booked") {



      let x = setInterval(function () {

        let tim = document.getElementById("timer") as HTMLParagraphElement;

        tim.style.display = 'block';

        let now = new Date().getTime();

        let distance = countDownDate - now;

        let days = Math.floor(distance / (1000 * 60 * 60 * 24));

        let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));

        let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));

        let seconds = Math.floor((distance % (1000 * 60)) / 1000);



        document.getElementById("timer").innerHTML = "Issuance expires in " + days + "d " + hours + "h "

          + minutes + "m " + seconds + "s ";



        if (distance < 0) {

          clearInterval(x);

          document.getElementById("timer").innerHTML = "! Issuance EXPIRED";

        }

      }, 1000);

    }

  }



  errorClose() {
    document.querySelector(".error-dialogfor-ist").classList.add("ist-hide");
    const overlay = document.querySelector("#overlay") as HTMLElement;
    overlay.style.display = "none";
  }
  font: string = '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';
  issuetktopen(targetmodel) {
    this.NewSuccess.open(targetmodel, {

      /* windowClass: "searchpassengerpopupmodal"*/
      windowClass: "warningPopupmodal", centered: true
    })
  }

  repricetktopen(targetmodel) {
    this.NewSuccess.open(targetmodel, {

      /* windowClass: "searchpassengerpopupmodal"*/
      windowClass: "warningPopupmodal", centered: true
    })
  }

  repriceTicket() {
    this.NewSuccess.dismissAll();
    this.bookingInfo.issuanceUser = Number(localStorage.getItem("UserId"));
    this.bookingInfo.userBackSystemCompanyId = Number(localStorage.getItem("BackSystemCompanyId"));
    this.bookingInfo.userBackSystemCustomer = localStorage.getItem("BackSystemCompanyCustomer");
    this.bookingInfo.backCompanyUserId = this.selectedBackCompanyUserId;
    this.buttonagreed_Reprice = true;
    this.loadervisible = true;
    this.stopTimerToRefresh();

    this.ticketIssuanceService.RepriceGalileoTicket(this.bookingInfo).subscribe((data) => {
      if (data.isSaved) {
        this.bookingID = data.bookingID;
        this.ngOnInit();
        this.router.navigateByUrl('/ticket-issuance');
        this.messageservice.add({ severity: 'success', summary: 'Success', detail: 'PNR repriced successfully!' });
      }
      else {
        this.loadervisible = false;
       // this.buttonagreed_Reprice = false;
       // this.refreshTktopen = true;
       // this.errorIssueticketMessage = data.errorInfo;
        this.messageservice.add({ severity: 'error', summary: 'Rejected', detail: data.errorInfo });
      }
    });
  }
  openPassportDetailsModel(targetmodel) {
    let result = this.bookingInfo.bookingPassengerInfoProperties;

    this.NewSuccess.open(targetmodel, {

      /* windowClass: "searchpassengerpopupmodal"*/
      windowClass: "warningPopupmodal", centered: true, size: 'lg'
    })
  }
  openServiceChargesModel(targetmodel) {
    let result = this.bookingInfo.bookingPassengerInfoProperties;

    this.NewSuccess.open(targetmodel, {

      /* windowClass: "searchpassengerpopupmodal"*/
      windowClass: "warningPopupmodal", centered: true, size: 'lg'
    })
  }
  formatDate(date: Date): string {
    if (!date) return null;

    const d = new Date(date);
    const month = ('0' + (d.getMonth() + 1)).slice(-2);
    const day = ('0' + d.getDate()).slice(-2);

    return `${d.getFullYear()}-${month}-${day}`;
  }

  parseDate(value: string, obj: any) {
    obj.passportValidTo = value ? new Date(value) : null;
  }
  CheckRequiredValidation() {
    //let result = this.bookingInfo.bookingPassengerInfoProperties;
    /// Check all validtion and then hide model

    for (let i = 0; i < this.bookingInfo.bookingPassengerInfoProperties.length; i++) {


      if (this.bookingInfo.bookingPassengerInfoProperties[i].passportNumber == undefined || this.bookingInfo.bookingPassengerInfoProperties[i].passportNumber == "") {

        document.getElementById(`messagePPNRquired${i}`).innerHTML = "Required Pass No";



        document.getElementById(`passportnum${i}`).classList.add("newRequired-BoxColor");

        document.getElementById(`ppnlabel${i}`).style.color = "red";

        setTimeout(function () {

          document.getElementById(`messagePPNRquired${i}`).innerHTML = "";

          document.getElementById(`passportnum${i}`).classList.remove("newRequired-BoxColor");



          document.getElementById(`ppnlabel${i}`).style.color = "";

        }

          , 6000);
        return;

      }


      if (this.bookingInfo.bookingPassengerInfoProperties[i].passportValidTo == undefined || this.bookingInfo.bookingPassengerInfoProperties[i].passportValidTo == null) {

        document.getElementById(`messagePassExpRquired${i}`).innerHTML = "Required Ps Expiry";

        document.getElementById(`pasportvalidto${i}`).classList.add("newRequired-BoxColor");



        document.getElementById(`pexplabel${i}`).style.color = "red";

        setTimeout(function () {

          document.getElementById(`messagePassExpRquired${i}`).innerHTML = "";

          document.getElementById(`pasportvalidto${i}`).classList.remove("newRequired-BoxColor");



          document.getElementById(`pexplabel${i}`).style.color = "";

        }

          , 6000);
        return;

      }
      if (this.expiryValidation(this.bookingInfo.bookingPassengerInfoProperties[i].passportValidTo) == false) {
        document.getElementById(`messagePassExpRquired${i}`).innerHTML = "Passport Expiry not validated. Passport must be valid up to the departure date.";
        document.getElementById(`pasportvalidto${i}`).classList.add("newRequired-BoxColor");
        document.getElementById(`pexplabel${i}`).style.color = "red";
        /*        document.getElementById(`countryborderClass${i}`).style.height = "38%";*/

        setTimeout(function () {
          document.getElementById(`messagePassExpRquired${i}`).innerHTML = "";
          document.getElementById(`pasportvalidto${i}`).classList.remove("newRequired-BoxColor");
          document.getElementById(`pexplabel${i}`).style.color = "";
          /*        document.getElementById(`countryborderClass${i}`).style.height = "50%";*/
        }
          , 6000);
        return;
      }

      if (this.bookingInfo.bookingPassengerInfoProperties[i].countryOfIssuance == undefined || this.bookingInfo.bookingPassengerInfoProperties[i].countryOfIssuance == "") {

        document.getElementById(`messageCoIRquired${i}`).innerHTML = "Required Country";



        //document.getElementById(`countryborderClass${i}`).style.height = "38%";

        document.getElementById(`countryborderClass${i}`).classList.add("newRequired-BoxColor");

        document.getElementById(`countryLabel${i}`).style.color = "red";

        setTimeout(function () {

          document.getElementById(`messageCoIRquired${i}`).innerHTML = "";

          document.getElementById(`countryborderClass${i}`).classList.remove("newRequired-BoxColor");

          /*          document.getElementById(`countryborderClass${i}`).style.height = "50%";*/

          document.getElementById(`countryLabel${i}`).style.color = "";

        }

          , 6000);


        return;
      }
      else if (this.bookingInfo.bookingPassengerInfoProperties[i].countryOfIssuance != undefined || this.bookingInfo.bookingPassengerInfoProperties[i].countryOfIssuance != "") {

        /*        document.getElementById(`countryborderClass${i}`).style.height = "38%";*/

        setTimeout(function () {

          document.getElementById(`messageCoIRquired${i}`).innerHTML = "";



          /*          document.getElementById(`countryborderClass${i}`).style.height = "50%";*/

          document.getElementById(`countryLabel${i}`).style.color = "";

        }
          , 6000);

      }


      if (this.bookingInfo.providerCode != "1G") {
        if (this.bookingInfo.bookingPassengerInfoProperties[i].paxNationality == undefined || this.bookingInfo.bookingPassengerInfoProperties[i].paxNationality == "") {

          document.getElementById(`messageNationRquired${i}`).innerHTML = "Required nation";

          document.getElementById(`nationcc${i}`).classList.add("newRequired-BoxColor");



          //document.getElementById(`nationcc${i}`).style.height = "38%";

          document.getElementById(`nationLabel${i}`).style.color = "red";

          setTimeout(function () {

            document.getElementById(`messageNationRquired${i}`).innerHTML = "";

            document.getElementById(`nationcc${i}`).classList.remove("newRequired-BoxColor");

            /*          document.getElementById(`nationcc${i}`).style.height = "50%";*/

            document.getElementById(`nationLabel${i}`).style.color = "";

          }

            , 6000);

          return;

        }
        else if (this.bookingInfo.bookingPassengerInfoProperties[i].paxNationality != undefined || this.bookingInfo.bookingPassengerInfoProperties[i].paxNationality != "") {

          //document.getElementById(`nationcc${i}`).style.height = "38%";

          setTimeout(function () {

            document.getElementById(`messageNationRquired${i}`).innerHTML = "";



            /*       document.getElementById(`nationcc${i}`).style.height = "50%";*/

            document.getElementById(`nationLabel${i}`).style.color = "";

          }

            , 6000);

        }

      }



    }



    this.NewSuccess.dismissAll();

  }

  isPassportNumberPassportExpiryDateValidated: boolean = true;
  SkipPassportNumberPassportExpiryDateValidation() {
    //let result = this.bookingInfo.bookingPassengerInfoProperties;
    /// Check all validtion and then hide model

    for (let i = 0; i < this.bookingInfo.bookingPassengerInfoProperties.length; i++) {


      if (this.bookingInfo.bookingPassengerInfoProperties[i].passportNumber == undefined || this.bookingInfo.bookingPassengerInfoProperties[i].passportNumber == "") {

        this.isPassportNumberPassportExpiryDateValidated = false;
        return this.isPassportNumberPassportExpiryDateValidated;

      }


      if (this.bookingInfo.bookingPassengerInfoProperties[i].passportValidTo == undefined || this.bookingInfo.bookingPassengerInfoProperties[i].passportValidTo == null) {

        this.isPassportNumberPassportExpiryDateValidated = false;
        return this.isPassportNumberPassportExpiryDateValidated;

      }
      if (this.bookingInfo.providerCode == "1GGDS" || this.bookingInfo.providerCode == "1GNDC") {
        if (this.bookingInfo.bookingPassengerInfoProperties[i].paxNationality == undefined || this.bookingInfo.bookingPassengerInfoProperties[i].paxNationality == "") {
          this.isPassportNumberPassportExpiryDateValidated = false;
          return this.isPassportNumberPassportExpiryDateValidated;

        }

      }

      if (this.bookingInfo.bookingPassengerInfoProperties[i].countryOfIssuance == undefined || this.bookingInfo.bookingPassengerInfoProperties[i].countryOfIssuance == "") {

        this.isPassportNumberPassportExpiryDateValidated = false;
        return this.isPassportNumberPassportExpiryDateValidated;


      }
      if (this.expiryValidation(this.bookingInfo.bookingPassengerInfoProperties[i].passportValidTo) == false) {

        this.isPassportNumberPassportExpiryDateValidated = false;
        return this.isPassportNumberPassportExpiryDateValidated;
      }
      else {
        this.isPassportNumberPassportExpiryDateValidated = true;
        return this.isPassportNumberPassportExpiryDateValidated;
      }


    }



    // this.NewSuccess.dismissAll();

  }

  isExpiryValidated: boolean;
  expiryDifference: number;

  expiryValidation(str) {
    if (!str) {
      this.isExpiryValidated = false;
      return false;
    }

    let departureDate = new Date(
      this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo[0].departureDate
    );

    let passportDate = new Date(str);

    this.isExpiryValidated = passportDate >= departureDate;

    return this.isExpiryValidated;
  }
  onPassportNumberChange(index: number): void {
    try {
      this.bookingInfo.bookingPassengerInfoProperties[index].passportNumber = this.bookingInfo.bookingPassengerInfoProperties[index].passportNumber.replace(/\s+/g, '');
    }
    catch (e) {
      this.bookingInfo.bookingPassengerInfoProperties[index].passportNumber = "";
    }
  }
  pnrCancelopen(targetmodel) {
    this.NewSuccess.open(targetmodel, {

      /* windowClass: "searchpassengerpopupmodal"*/
      windowClass: "warningPopupmodal", centered: true
    })
  }
  voidTktopen(targetmodel) {
    this.NewSuccess.open(targetmodel, {

      /* windowClass: "searchpassengerpopupmodal"*/
      windowClass: "warningPopupmodal", centered: true
    })
  }
  cancelPopup(targetmodel) {
    this.NewSuccess.open(targetmodel, {

      /* windowClass: "searchpassengerpopupmodal"*/
      windowClass: "warningPopupmodal", centered: true
    })
  }
  CancelButton() {
    if (this.fromroute == "OfflinePage") {
      this.NewSuccess.dismissAll();
      this.offlineTempId = this.offlineIdRequestFromOfflineList;
      this.offlineIdRequestFromOfflineList = 0;
      this.router.navigateByUrl('/offlineRequestList');
      this.offlineTempId = 0;
    }
    if (this.fromroute == "OfflinePagemanger") {
      this.NewSuccess.dismissAll();
      this.offlineTempId = this.offlineIdRequestFromOfflineList;
      this.offlineIdRequestFromOfflineList = 0;
      this.router.navigateByUrl('/managerOfflineRequestList');
      this.offlineTempId = 0;
    }
    else if (this.fromroute == "BookingPage") {
      this.NewSuccess.dismissAll();
      this.router.navigateByUrl('/bookingList');
      this.offlineTempId = this.offlineIdRequestFromOfflineList;
      this.offlineIdRequestFromOfflineList = 0;
      this.offlineTempId = 0;
    }
    else if (this.fromroute == "B2BBackofficePage") {
      this.NewSuccess.dismissAll();
      this.router.navigateByUrl('/B2BbackOffice');
      this.offlineTempId = this.offlineIdRequestFromOfflineList;
      this.offlineIdRequestFromOfflineList = 0;
      this.offlineTempId = 0;
    }
    else if (this.fromroute == "BookingPageSearch") {
      this.NewSuccess.dismissAll();
      this.router.navigateByUrl('/BookingSearch');
      this.offlineTempId = this.offlineIdRequestFromOfflineList;
      this.offlineIdRequestFromOfflineList = 0;
      this.offlineTempId = 0;
    }
    else {
      this.NewSuccess.dismissAll();
      this.router.navigateByUrl('/bookingList');
      this.offlineTempId = this.offlineIdRequestFromOfflineList;
      this.offlineIdRequestFromOfflineList = 0;
      this.offlineTempId = 0;
    }

  }
  RefundPopupForConfirmation(targetmodel) {
    this.NewSuccess.open(targetmodel, {

      windowClass: "warningPopupmodal", centered: true
    })
  }



  RefundTicketPopup() {
    this.NewSuccess.dismissAll();
    this.bookingrefundinfo.bookingPassengerInfoProperties = [];
    if (this.bookingInfo.providerCode == "PA" || this.bookingInfo.providerCode == "FZ" || this.bookingInfo.providerCode == "AI" || this.bookingInfo.providerCode == "EK" || this.bookingInfo.providerCode == "HITITNDC") {
      for (let r = 0; r < this.bookingInfo.bookingPassengerInfoProperties.length; r++) {
        if (!this.bookingInfo.bookingPassengerInfoProperties[r].isRefund) {
          this.bookingrefundinfo.bookingPassengerInfoProperties.push(this.bookingInfo.bookingPassengerInfoProperties[r]);
        }
      }
      if (this.bookingrefundinfo.bookingPassengerInfoProperties.length > 0) {
        $("#myModalRefund").modal('show');
      }
      else {
        this.messageservice.add({ severity: 'warning', summary: 'Warning', detail: 'All Passenger Is Refunded!' });
      }
    } else if (this.bookingInfo.providerCode == "SG") {
      for (let r = 0; r < this.bookingInfo.bookingPassengerInfoProperties.length; r++) {
        if (!this.bookingInfo.bookingPassengerInfoProperties[r].isRefund) {
          this.bookingrefundinfo.bookingPassengerInfoProperties.push(this.bookingInfo.bookingPassengerInfoProperties[r]);
          this.bookingInfo.bookingPassengerInfoProperties[r].isRefund = true;
        }
      }
      if (this.bookingrefundinfo.bookingPassengerInfoProperties.length > 0) {
        $("#myModalRefund").modal('show');
      }
      else {
        this.messageservice.add({ severity: 'warning', summary: 'Warning', detail: 'All Passenger Is Refunded!' });
      }
    }
  }
  RefundTicket() {
    this.buttonagreed_refund = true;
    this.loadervisible = true;
    this.stopTimerToRefresh();
    if (this.tktPnrRight.refund == false) {

      this.ticketIssuanceService.RefundOfflineRequest(this.bookingrefundinfo).subscribe((data) => {

        if (data == true) {
          this.messageservice.add({ severity: 'success', summary: 'Success', detail: 'Request Send!' });
          localStorage.setItem("OnlineBookingId", JSON.stringify(this.bookingID));
          localStorage.setItem("IsRefund", "True");
          $("#myModalRefund").modal('hide');
          this.offlineTempId = 0;
          this.loadervisible = false;
          this.router.navigateByUrl('/offlineRequestList');
        }
        else {
          this.loadervisible = false;
          this.buttonagreed_refund = false;
        }

      })

    }
    else if (this.tktPnrRight.refund) {
      this.ticketIssuanceService.RefundOnlineTicket(this.bookingrefundinfo).subscribe((data) => {
        if (data.isSaved == true) {

          this.bookingID = data.bookingID;
          this.ngOnInit();
          this.messageservice.add({ severity: 'success', summary: 'Success', detail: 'Refunded!' });
          $("#myModalRefund").modal('hide');
        }
        else {
          this.buttonagreed_refund = false;
          $("#myModalRefund").modal('hide');
          this.loadervisible = false;
          this.messageservice.add({ severity: 'error', summary: 'Rejected', detail: 'Refund can`t be made at this moment' });

        }
      });

    }

  }
  ModifyAirAiternary() {
    this.stopTimerToRefresh();
    if (this.bookingInfo.providerCode == "1GGDS") {
      localStorage.setItem("bookingInfotravelport", JSON.stringify(this.bookingInfo));
      localStorage.setItem("flightmodifysearch", JSON.stringify(this.bookingAllData$.bookingInfo.galileoBookingProp.flightProp));
      localStorage.setItem("actiontype", "changeBooking");
      this.router.navigateByUrl('/travelPortModify');

    }
    else if (this.bookingInfo.providerCode != "EK") {
      localStorage.setItem("flightmodifyBookingInfo", JSON.stringify(this.bookingInfo));
      localStorage.setItem("flightmodifysearch", JSON.stringify(this.bookingAllData$.bookingInfo.galileoBookingProp.flightProp));
      this.router.navigateByUrl('/flightResultModify');
    }
    else if (this.bookingInfo.providerCode == "EK") {
      localStorage.setItem("bookingInfoEmirates", JSON.stringify(this.bookingInfo));
      localStorage.setItem("flightmodifysearch", JSON.stringify(this.bookingAllData$.bookingInfo.galileoBookingProp.flightProp));
      localStorage.setItem("actiontype", "changeBooking");
      this.router.navigateByUrl('/emiratesModify');
    }

  }
  ModifyPassengerInfo() {
    this.stopTimerToRefresh();
    if (this.bookingInfo.providerCode == "FZ") {
      this.bookingInfo.passengerFares = this.bookingAllData$.bookingInfo.passengerFares;
      localStorage.setItem("flightmodifyPassengerInfo", JSON.stringify(this.bookingInfo));
      this.router.navigateByUrl('/flyDubaiModify');
    }
    else if (this.bookingInfo.providerCode == "PA") {
      this.bookingInfo.passengerFares = this.bookingAllData$.bookingInfo.passengerFares;
      localStorage.setItem("flightmodifyPassengerInfo", JSON.stringify(this.bookingInfo));
      this.router.navigateByUrl('/airBlueModify');
    }
    else if (this.bookingInfo.providerCode == "1GGDS") {
      localStorage.setItem("bookingInfotravelport", JSON.stringify(this.bookingInfo));
      localStorage.setItem("flightmodifysearch", JSON.stringify(this.bookingAllData$.bookingInfo.galileoBookingProp.flightProp));
      localStorage.setItem("actiontype", "passengerDetails");
      this.router.navigateByUrl('/travelPortModify');
    }


  }
  RedirecttoRemovePassenger() {
    this.stopTimerToRefresh();
    localStorage.setItem("bookingInfoEmirates", JSON.stringify(this.bookingInfo));
    localStorage.setItem("actiontype", "removepassengers");
    this.router.navigateByUrl('/emiratesModify');
  }

  NewLoaderEmirates: boolean = false;
  Refundcheckpassenger(passenger: BookingPassengerInfoProperties) {
    if (this.bookingInfo.providerCode == "EK") {
      if (passenger.isRefund) {
        if (passenger.passengerType == 1) {
          for (let k = 0; k < this.bookingInfo.bookingPassengerInfoProperties.length; k++) {
            if (passenger.firstName == this.bookingInfo.bookingPassengerInfoProperties[k].associatedAdult) {
              if (!this.bookingInfo.bookingPassengerInfoProperties[k].isRefund) {
                this.bookingInfo.bookingPassengerInfoProperties[k].isRefund = true;
                break;
              }
            }
          }
        }
        if (passenger.passengerType == 3) {
          for (let k = 0; k < this.bookingInfo.bookingPassengerInfoProperties.length; k++) {
            if (passenger.associatedAdult == this.bookingInfo.bookingPassengerInfoProperties[k].firstName) {
              if (!this.bookingInfo.bookingPassengerInfoProperties[k].isRefund) {
                this.bookingInfo.bookingPassengerInfoProperties[k].isRefund = true;
                break;
              }
            }
          }
        }
      }
      else {
        if (!passenger.isRefund) {
          if (passenger.passengerType == 1) {
            for (let k = 0; k < this.bookingInfo.bookingPassengerInfoProperties.length; k++) {
              if (passenger.firstName == this.bookingInfo.bookingPassengerInfoProperties[k].associatedAdult) {
                if (this.bookingInfo.bookingPassengerInfoProperties[k].isRefund) {
                  this.bookingInfo.bookingPassengerInfoProperties[k].isRefund = false;
                  break;
                }
              }
            }
          }
          if (passenger.passengerType == 3) {
            for (let k = 0; k < this.bookingInfo.bookingPassengerInfoProperties.length; k++) {
              if (passenger.associatedAdult == this.bookingInfo.bookingPassengerInfoProperties[k].firstName) {
                if (this.bookingInfo.bookingPassengerInfoProperties[k].isRefund) {
                  this.bookingInfo.bookingPassengerInfoProperties[k].isRefund = false;
                  break;
                }
              }
            }
          }
        }
      }


    }
  }
  emiratesEnumsForExchangedDivide = new EmiratesEnumsForExchangedDivide();
  voidCheckBookingType: number = 0;
  refundCheckBookingType: number = 0;
  refundPassengerPop: boolean = false;
  voidPassengerPop: boolean = false;
  beforeemiratesChangeCheck(fucntionCallName: number) {
    if (fucntionCallName == this.emiratesEnumsForExchangedDivide.exchangedVoidTicket ||
      fucntionCallName == this.emiratesEnumsForExchangedDivide.initialVoidTicket) {

      this.confirmationService.confirm({
        header: 'Confirmation',
        message: 'Please confirm to proceed moving forward.',
        acceptIcon: 'pi pi-check mr-2',
        rejectIcon: 'pi pi-times mr-2',
        rejectButtonStyleClass: 'p-button-sm',
        acceptButtonStyleClass: 'p-button-outlined p-button-sm',
        accept: () => {

          this.ExchangeEmirates(fucntionCallName);
        },
        reject: () => {
          this.messageservice.add({ severity: 'error', summary: 'Rejected', detail: 'Not Void', life: 3000 });
          this.removePassengerPopup = false;
        }
      });
    }
    else if (fucntionCallName == this.emiratesEnumsForExchangedDivide.exchangedRefundTicket ||
      fucntionCallName == this.emiratesEnumsForExchangedDivide.initialRefundTicket) {
      this.confirmationService.confirm({
        header: 'Confirmation',
        message: 'Please confirm to proceed moving forward.',
        acceptIcon: 'pi pi-check mr-2',
        rejectIcon: 'pi pi-times mr-2',
        rejectButtonStyleClass: 'p-button-sm',
        acceptButtonStyleClass: 'p-button-outlined p-button-sm',
        accept: () => {
          this.ExchangeEmirates(fucntionCallName);
        },
        reject: () => {
          this.messageservice.add({ severity: 'error', summary: 'Rejected', detail: 'Not Refund', life: 3000 });
          this.removePassengerPopup = false;
        }
      });
    }
    else if (fucntionCallName == this.emiratesEnumsForExchangedDivide.exchangedIssueSSRTicket
      || fucntionCallName == this.emiratesEnumsForExchangedDivide.initialIssueSSRTicket) {
      this.confirmationService.confirm({
        header: 'Confirmation',
        message: 'Please confirm to proceed moving forward.',
        acceptIcon: 'pi pi-check mr-2',
        rejectIcon: 'pi pi-times mr-2',
        rejectButtonStyleClass: 'p-button-sm',
        acceptButtonStyleClass: 'p-button-outlined p-button-sm',
        accept: () => {
          this.ExchangeEmirates(fucntionCallName);
        },
        reject: () => {
          this.messageservice.add({ severity: 'error', summary: 'Rejected', detail: 'Not Issued', life: 3000 });
          this.removePassengerPopup = false;
        }
      });
    }
    else {
      this.ExchangeEmirates(fucntionCallName);
    }

  }
  async ExchangeEmirates(fucntionCallName: number): Promise<void> {
    this.stopTimerToRefresh();
    try {
      if (fucntionCallName == this.emiratesEnumsForExchangedDivide.exchangedAnciAvail ||
        fucntionCallName == this.emiratesEnumsForExchangedDivide.initialAnciAvail) {
        this.loadervisible = true;
        let data = new PostAncillaryGetProperties();
        if (fucntionCallName == this.emiratesEnumsForExchangedDivide.exchangedAnciAvail) {
          data = await this.exchangedModel.GetAnciAvailREQ(this.emiratesEnumsForExchangedDivide.exchanged, this.bookingInfo);
          if (data.isBaggageAvailable || data.isSeatAvailable) {
            localStorage.setItem("postanci", JSON.stringify(data.bookingObj));
            sessionStorage.setItem("seatandbaganci", JSON.stringify(data));
            localStorage.setItem("typeofbooking", this.emiratesEnumsForExchangedDivide.exchanged.toString());
            this.loadervisible = false;
            this.router.navigate([("/postAncillary")]);
          }
          else {
            if (data.error.includes("SSL")) {
              this.messageservice.add({ severity: 'error', summary: 'Try Again', detail: 'Please Try Again!!' });

            }
            else {
              this.messageservice.add({ severity: 'error', summary: 'Unavailable', detail: 'Not Availiable!' });

            }
            this.loadervisible = false;
          }
        }
        else {
          data = await this.exchangedModel.GetAnciAvailREQ(this.emiratesEnumsForExchangedDivide.initial, this.bookingInfo);
          if (data.isBaggageAvailable || data.isSeatAvailable) {
            localStorage.setItem("postanci", JSON.stringify(data.bookingObj));
            sessionStorage.setItem("seatandbaganci", JSON.stringify(data));
            localStorage.setItem("typeofbooking", this.emiratesEnumsForExchangedDivide.initial.toString());
            this.loadervisible = false;
            this.router.navigate([("/postAncillary")]);
          }
          else {
            if (data.error.includes("SSL")) {
              this.messageservice.add({ severity: 'error', summary: 'Try Again', detail: 'Please Try Again!!' });

            }
            else {
              this.messageservice.add({ severity: 'error', summary: 'Unavailable', detail: 'Not Availiable!' });

            }
            this.loadervisible = false;
          }
        }




      }

      //for ssr issue
      else if (fucntionCallName == this.emiratesEnumsForExchangedDivide.exchangedIssueSSRTicket) {
        this.NewSuccess.dismissAll();
        this.buttonagreed_Issue = true;
        this.loadervisible = true;

        if (this.tktPnrRight.issueTicket) {

          this.postMofifyservice.ExchangeSSRIssueTicket(this.bookingInfo).subscribe((data) => {
            if (data.isSaved) {
              this.ngOnInit();
              this.buttonagreed_Issue = false;
            }
            else {

              this.loadervisible = false;
              this.buttonagreed_Issue = false;
              document.querySelector(".error-dialogfor-ist").classList.remove("ist-hide");
              document.querySelector(".message-ist").innerHTML = data.errorInfo;
              const overlay = document.querySelector("#overlay") as HTMLElement
              overlay.style.display = "block";
            }

          });
        }


      }
      else if (fucntionCallName == this.emiratesEnumsForExchangedDivide.initialIssueSSRTicket) {
        this.NewSuccess.dismissAll();
        this.buttonagreed_Issue = true;
        this.loadervisible = true;

        if (this.tktPnrRight.issueTicket) {

          this.postMofifyservice.InitialSSRIssueTicket(this.bookingInfo).subscribe((data) => {
            if (data.isSaved) {
              this.ngOnInit();
              this.buttonagreed_Issue = false;
            }
            else {

              this.loadervisible = false;
              this.buttonagreed_Issue = false;
              document.querySelector(".error-dialogfor-ist").classList.remove("ist-hide");
              document.querySelector(".message-ist").innerHTML = data.errorInfo;
              const overlay = document.querySelector("#overlay") as HTMLElement
              overlay.style.display = "block";
            }

          });
        }
      }

      // for void ticket
      else if (fucntionCallName == this.emiratesEnumsForExchangedDivide.exchangedVoidTicket ||
        fucntionCallName == this.emiratesEnumsForExchangedDivide.initialVoidTicket) {


        this.loadervisible = true;

        this.buttonagreed_void = true;
        if (this.tktPnrRight.voidTicket == false) {
          this.bookingrefundinfo.bookingPassengerInfoProperties = this.voidPassengerInfo;
          this.ticketIssuanceService.VoidOfflineRequest(this.bookingrefundinfo).subscribe((data) => {
            if (data == true) {
              localStorage.setItem("OnlineBookingId", JSON.stringify(this.bookingID));
              localStorage.setItem("IsVoid", "True");
              $("#myModalVoid").modal('hide');
              this.offlineTempId = 0;

              this.router.navigateByUrl('/offlineRequestList');
            }
          })
        }
        //new work
        else {
          if (this.tktPnrRight.voidTicket) {
            let voidticket: number = 0;
            for (let j = 0; j < this.voidPassengerInfo.length; j++) {
              if (this.voidPassengerInfo[j].isVoid) {
                voidticket++;
              }
            }
            if (voidticket == 0) {
              document.getElementById("voidrequiredmsg").innerHTML = "Required at least one!";
              setTimeout(() => {
                document.getElementById("voidrequiredmsg").innerHTML = "";
              }, 3000);
              return;
            }
            $("#myModalVoid").modal('hide');
            let pscreation = new PassengerCreationResponse();
            if (fucntionCallName == this.emiratesEnumsForExchangedDivide.initialVoidTicket) {
              pscreation = await this.exchangedModel.VoidTicketExchanged(this.voidPassengerInfo, this.emiratesEnumsForExchangedDivide.initial, this.bookingInfo);

            }
            else {
              pscreation = await this.exchangedModel.VoidTicketExchanged(this.voidPassengerInfo, this.emiratesEnumsForExchangedDivide.exchanged, this.bookingInfo);

            }
            if (pscreation.isSaved) {
              this.voidPassengerPop = false;
              this.bookingID = pscreation.bookingID;
              if (this.offlineIdRequestFromOfflineList > 0) {
                this.service.UpdateOfflineTktRequest(this.offlineIdRequestFromOfflineList, localStorage.getItem("UserId")).subscribe((data) => {
                  if (data == true) {
                    this.offlinetoOnlineproperty = new OfflineToOnlineProperties();
                    this.ngOnInit();

                    this.offlineTempId = this.offlineIdRequestFromOfflineList;
                    this.offlineIdRequestFromOfflineList = 0;

                    this.router.navigateByUrl('/ticket-issuance');

                  }

                });
              }
              else {
                this.router.navigateByUrl('/ticket-issuance');
              }
              this.ngOnInit();
            }
            else {
              this.buttonagreed_void = false;
              this.loadervisible = false;
              document.querySelector(".error-dialogfor-ist").classList.remove("ist-hide");
              document.querySelector(".message-ist").innerHTML = "Void cant be issued at this moment."
              const overlay = document.querySelector("#overlay") as HTMLElement;
              overlay.style.display = "block";
            }
          }

        }
      }

      // for refund ticket
      else if (fucntionCallName == this.emiratesEnumsForExchangedDivide.exchangedRefundTicket
        || fucntionCallName == this.emiratesEnumsForExchangedDivide.initialRefundTicket) {
        this.buttonagreed_refund = true;
        this.loadervisible = true;
        //if (this.tktPnrRight.refund == false) {

        //  this.ticketIssuanceService.RefundOfflineRequest(this.bookingrefundinfo).subscribe((data) => {

        //    if (data == true) {
        //      this.messageservice.add({ severity: 'success', summary: 'Success', detail: 'Request Send!' });
        //      localStorage.setItem("OnlineBookingId", JSON.stringify(this.bookingID));
        //      localStorage.setItem("IsRefund", "True");
        //      $("#myModalRefund").modal('hide');
        //      this.offlineTempId = 0;
        //      this.loadervisible = false;
        //      this.router.navigateByUrl('/offlineRequestList');
        //    }
        //    else {
        //      this.loadervisible = false;
        //      this.buttonagreed_refund = false;
        //    }

        //  })

        //}
        //else if (this.tktPnrRight.refund)
        {
          if (fucntionCallName == this.emiratesEnumsForExchangedDivide.exchangedRefundTicket) {
            this.postMofifyservice.ExchangeRefundReq(this.bookingrefundinfo).subscribe((data) => {
              if (data.isSaved == true) {
                this.refundPassengerPop = false;
                this.bookingID = data.bookingID;
                this.ngOnInit();
                this.messageservice.add({ severity: 'success', summary: 'Success', detail: 'Refunded!' });
                $("#myModalRefund").modal('hide');
              }
              else {
                this.buttonagreed_refund = false;
                $("#myModalRefund").modal('hide');
                this.loadervisible = false;
                this.messageservice.add({ severity: 'error', summary: 'Rejected', detail: 'Refund can`t be made at this moment' });

              }
            });

          }
          else if (this.emiratesEnumsForExchangedDivide.initialRefundTicket) {
            this.postMofifyservice.InitialRefundReq(this.bookingrefundinfo).subscribe((data) => {
              if (data.isSaved == true) {
                this.refundPassengerPop = false;
                this.bookingID = data.bookingID;
                this.ngOnInit();
                this.messageservice.add({ severity: 'success', summary: 'Success', detail: 'Refunded!' });
                this.refundPassengerPop = false;
              }
              else {
                this.buttonagreed_refund = false;
                this.refundPassengerPop = false;
                this.loadervisible = false;
                this.messageservice.add({ severity: 'error', summary: 'Rejected', detail: 'Refund can`t be made at this moment' });

              }
            });
          }

        }
      }

      //pop open of void initial
      else if (fucntionCallName == this.emiratesEnumsForExchangedDivide.initialtktvoidpopOpen) {

        this.voidCheckBookingType = this.emiratesEnumsForExchangedDivide.initialVoidTicket;
        this.voidPassengerInfo = this.exchangedModel.voidpopOpen(this.bookingInfo, this.emiratesEnumsForExchangedDivide.initial);
        if (this.voidPassengerInfo.length > 0) {
          this.voidPassengerPop = true;
        } else {
          this.messageservice.add({ severity: 'warning', summary: 'Warning', detail: 'All iniital Passenger Is Voided!' });
        }
      }
      //pop open of void exchanged
      else if (fucntionCallName == this.emiratesEnumsForExchangedDivide.exchangedtktvoidpopOpen) {

        this.voidCheckBookingType = this.emiratesEnumsForExchangedDivide.exchangedVoidTicket;
        this.voidPassengerInfo = this.exchangedModel.voidpopOpen(this.bookingInfo, this.emiratesEnumsForExchangedDivide.exchanged);
        if (this.voidPassengerInfo.length > 0) {
          this.voidPassengerPop = true;
        } else {
          this.messageservice.add({ severity: 'warning', summary: 'Warning', detail: 'All exchange Passenger Is Voided!' });
        }
      }
      //pop open of refund initial
      else if (fucntionCallName == this.emiratesEnumsForExchangedDivide.initialtktrefundpopOpen) {
        this.refundCheckBookingType = this.emiratesEnumsForExchangedDivide.initialRefundTicket;
        this.bookingrefundinfo = this.exchangedModel.refundpopOpen(this.bookingInfo, this.emiratesEnumsForExchangedDivide.initial);
        if (this.bookingrefundinfo.bookingPassengerInfoProperties.length > 0) {
          this.refundPassengerPop = true;
        }
        else {
          this.messageservice.add({ severity: 'warning', summary: 'Warning', detail: 'All initial Passenger Is Refunded!' });
        }
      }
      //pop open of refund exchanged
      else if (fucntionCallName == this.emiratesEnumsForExchangedDivide.exchangedtktrefundpopOpen) {
        this.refundCheckBookingType = this.emiratesEnumsForExchangedDivide.exchangedRefundTicket;
        this.bookingrefundinfo = this.exchangedModel.refundpopOpen(this.bookingInfo, this.emiratesEnumsForExchangedDivide.exchanged);
        if (this.bookingrefundinfo.bookingPassengerInfoProperties.length > 0) {
          this.refundPassengerPop = true;
        }
        else {
          this.messageservice.add({ severity: 'warning', summary: 'Warning', detail: 'All exchange Passenger Is Refunded!' });
        }
      }

    } catch (error) {
      console.error("Error:", error);
    }
  }


  //Izza Before NEw Print
  //emailItineraryFinance(type: boolean) {
  //  try {
  //    if (this.emailRegex == false) {
  //      document.getElementById("messageEmail").innerHTML = 'Please Follow The Pattern';
  //      setTimeout(() => { document.getElementById("messageEmail").innerHTML = ''; }, 5000);
  //      return;
  //    }
  //    this.isLoadPanelVisible = true;
  //    this.showBtnLoader();


  //    let sectorIcon = '../../assets/img/printsectoricon.png';
  //    let OneWayImage = '../../assets/img/take-off-24.png';
  //    let twowayImage = '../../assets/img/printsectoricon.png';

  //    //let sectorIcon = '../../assets/img/printsectoricon.png';
  //    //let OneWayImage = '../../assets/img/OneWayImage.png';
  //    //let twowayImage = '../../assets/img/RoundWayImage.png';

  //    this.flightLogoX = 10;
  //    this.flightLogoY = 40;
  //    this.airlineNameX = 33;



  //    // ======= Asad Working ============
  //    this.airlineNameY = 40;
  //    // ======= Asad Working ============

  //    this.airlineCodeX = 33;
  //    this.airlineCodeY = 53;
  //    this.airBusTypeX = 20;
  //    this.airBusTypeY = 80;
  //    this.fromCityX = 60;
  //    this.fromCityY = 50;
  //    this.fromAirportX = 60;
  //    this.fromAirportY = 45;
  //    this.fromAirportX1 = 75;
  //    this.fromAirportY1 = 45;
  //    this.departDateX = 61;
  //    this.departDateY = 80;
  //    this.toCityX = 130;
  //    this.toCityY = 50;
  //    this.toAirportX = 143;
  //    this.toAirportY = 45;
  //    this.arrivalDateX = 123;
  //    this.arrivalDateY = 80;
  //    this.cabinClassX = 175;
  //    this.cabinClassY = 45;
  //    this.noStopsX = 160;
  //    this.noStopsY = 45;
  //    this.pnrX = 174;
  //    this.pnrY = 50;
  //    this.pnrY1 = 32;
  //    this.desX = 71;
  //    this.desY = 47;
  //    this.cityRouteX = 10;
  //    this.sectSpace = 0;
  //    this.iterationWidth = 0
  //    this.pnrsX = 174;
  //    this.pnrsY = 50;
  //    let bookingDateString = this.bookingInfo.bookingDate;

  //    let bookingDate = new Date(bookingDateString);

  //    let fullDateFormat = bookingDate.toLocaleString('en-US', {
  //      year: 'numeric',
  //      month: 'long',
  //      day: 'numeric',
  //    });




  //    let doc = new jsPDF("p", "mm", "a4");

  //    doc.setLineWidth(1);
  //    doc.rect(5, 5, doc.internal.pageSize.width - 10, doc.internal.pageSize.height - 10);


  //    doc.setFontSize(7);
  //    doc.addFileToVFS('Poppins-Regular-normal.ttf', this.font);
  //    doc.addFont('Poppins-Regular-normal.ttf', 'Poppins-Regular-normal', 'normal');
  //    doc.setFont('Poppins-Regular-normal');


  //    exportDataGrid({
  //      jsPDFDocument: doc,
  //      component: this.dataGrid3.instance,
  //      autoTableOptions: {
  //        border: {
  //          borderRight: 0,
  //          borderLeft: 0
  //        },
  //        margin: {
  //          top: 0,
  //        },
  //        headStyles: {
  //          textColor: "#FFF",
  //          fontSize: 8
  //        },

  //        bodyStyles: {
  //          textColor: "#000",
  //          fontSize: 7
  //        },
  //      }
  //    })



  //      .then(async () => {



  //        if (this.bookingPassengerInfo.length >= 1) {



  //          let agencyLogoName = this.agencyOnline.logoFileName;
  //          let imgType = agencyLogoName.substring(agencyLogoName.lastIndexOf(".") + 1);
  //          var imageString = 'data:image/' + imgType + ';base64,' + this.agencyOnline.logoFilePath;


  //          doc.addImage(imageString, imgType, 170, 10, 25, 15);


  //          if (this.newsectorInfo.length == 1) {
  //            doc.setFontSize(14);
  //            doc.setFont('csvsdvsd', 'bold');
  //            doc.setTextColor(0, 0, 0);

  //            doc.text(this.newsectorInfo[0].fromAirport, this.cityRouteX, 10, { baseline: 'top' });


  //            this.iterationWidth = doc.getTextWidth(this.newsectorInfo[0].fromAirport) + 10;
  //            this.cityRouteX = this.iterationWidth + 3;

  //            doc.addImage(OneWayImage, 'png', this.cityRouteX, 10, 5, 5);

  //            this.iterationWidth = doc.getTextWidth(this.newsectorInfo[0].fromAirport) + 10;
  //            this.cityRouteX = this.iterationWidth + 10;
  //            doc.text(this.newsectorInfo[0].toAirport, this.cityRouteX, 10, { baseline: 'top' });
  //          }
  //          else if (this.newsectorInfo.length > 1) {
  //            doc.setFontSize(10);
  //            doc.setFont('csvsdvsd', 'bold');
  //            doc.setTextColor(0, 0, 0);

  //            this.cityRouteX = 10;

  //            for (let i = 0; i < this.newsectorInfo.length; i++) {
  //              const sector = this.newsectorInfo[i];

  //              doc.text(sector.fromAirport, this.cityRouteX, 10, { baseline: 'top' });

  //              this.cityRouteX += 8;

  //              doc.addImage(twowayImage, 'png', this.cityRouteX, 10, 0, 4);
  //              this.cityRouteX += 5;

  //              doc.text(sector.toAirport, this.cityRouteX, 10, { baseline: 'top' });
  //              this.cityRouteX += 10;
  //            }
  //          }


  //          doc.setFontSize(11);
  //          doc.setFont('Poppins-Regular-normal');
  //          doc.setTextColor('#000');
  //          var bookingid = (this.bookingInfo.finalBuyerID).toString() + "-" + (this.bookingInfo.bookingID).toString();
  //          doc.text("Booking ID: " + bookingid, 10, 20, { baseline: 'top' });



  //          doc.setFontSize(11);
  //          doc.setFont('Poppins-Regular-normal');
  //          doc.setTextColor('#000');
  //          doc.text("PNR: " + this.bookingInfo.pnr, 10, 25, { baseline: 'top' });

  //          doc.setFontSize(12);
  //          doc.setFont('Poppins-Regular-normal');
  //          doc.setTextColor('#000');
  //          doc.text("" + this.bookingStatus, 140, 25, { baseline: 'top' });


  //          doc.setFontSize(12);
  //          doc.setFont('Poppins-Regular-normal');
  //          doc.setTextColor(105, 105, 105);
  //          doc.text("" + fullDateFormat, 10, 15, { baseline: 'top' });


  //          doc.setLineWidth(0.8);
  //          doc.setDrawColor(255, 170, 0);
  //          doc.line(10, 30, doc.internal.pageSize.width - 10, 30);


  //          doc.setDrawColor(107, 107, 107);
  //          doc.setFillColor(227, 227, 227);
  //          doc.roundedRect(88, 32, 22, 8, 1, 1, 'F')


  //          doc.setFontSize(12);
  //          doc.setFont('Poppins-Regular-normal-bold');
  //          doc.setTextColor('#000');
  //          doc.text("Itinerary ", 90, 34, { baseline: 'top' });

  //          // Airline Details
  //          for (let j = 0; j < this.newsectorInfo.length; j++) {


  //            let flightLogoPath = 'assets/img/' + this.newsectorInfo[j].airlineLogo;

  //            if (this.newsectorInfo[j].airlineLogo.includes(".svg")) {

  //              const canvass = document.createElement('canvas');
  //              canvass.width = 200;
  //              canvass.height = 200;
  //              const ctx = canvass.getContext('2d');
  //              const v = await Canvg.from(ctx, flightLogoPath);

  //              v.start();
  //              var processedFlightLogo = canvass.toDataURL("img/png");

  //              doc.addImage(processedFlightLogo, 'png', this.flightLogoX, this.flightLogoY, 15, 10);
  //            } else {
  //              doc.addImage("assets/img/" + this.newsectorInfo[j].airlineLogo, 'png', this.flightLogoX, this.flightLogoY, 15, 10);
  //            }



  //            doc.setFontSize(9);
  //            doc.setFont('Poppins-Regular-normal');
  //            doc.setTextColor('#000');
  //            doc.text(this.newsectorInfo[j].cabinClass + "(" + this.newsectorInfo[j].rbd + ")", this.cabinClassX, this.cabinClassY, { baseline: 'top' });

  //            doc.setFontSize(10);
  //            doc.setFont('Poppins-Regular-normal');
  //            doc.setTextColor('#000');
  //            var flighn = this.newsectorInfo[j].airlinePrefixCode + (this.newsectorInfo[j].flightNumber).toString();
  //            doc.text(flighn, this.airlineCodeX - 18, this.airlineCodeY, { baseline: 'top' });

  //            doc.setFontSize(10);
  //            doc.setFont('Poppins-Regular-normal');
  //            doc.setTextColor('#000');
  //            doc.text(this.newsectorInfo[j].departureTime.substring(0, 5), this.fromAirportX - 25, this.fromAirportY, { baseline: 'top' });

  //            doc.setFontSize(10);
  //            doc.setFont('Poppins-Regular-normal');
  //            doc.setTextColor('#000');
  //            doc.text(this.newsectorInfo[j].arrivalTime.substring(0, 5), this.toAirportX - 10, this.toAirportY, { baseline: 'top' });



  //            doc.setLineWidth(0.8);
  //            doc.setDrawColor(169, 169, 169);
  //            doc.line(this.desX - 25, this.desY, this.desX + 60, this.desY);
  //            doc.setDrawColor(255, 170, 0);
  //            doc.circle(this.desX - 25, this.desY, 1.5, 'F');
  //            doc.setDrawColor(255, 170, 0);
  //            doc.circle(this.desX + 60, this.desY, 1.5, 'F');
  //            doc.setDrawColor(169, 169, 169);


  //            doc.setFontSize(10);
  //            doc.setFont('Poppins-Regular-normal');
  //            doc.setTextColor(105, 105, 105);
  //            for (let j = 0; j < this.newsectorInfo.length; j++) {
  //              doc.text(this.newsectorInfo[j].noOfStops + " Stops", this.noStopsX, this.noStopsY, { baseline: 'top' });
  //            }

  //            doc.setFontSize(8);
  //            doc.setTextColor('#000');
  //            doc.setFont('Poppins-Regular-normal');
  //            doc.text(this.newsectorInfo[j].fromCity + " (" + this.newsectorInfo[j].fromAirport + ")", this.fromCityX - 25, this.fromCityY, { baseline: 'top' });


  //            doc.setFontSize(8);
  //            doc.setTextColor('#000');
  //            doc.setFont('Poppins-Regular-normal');
  //            doc.text(this.newsectorInfo[j].fromAirportName, this.fromCityX - 25, this.fromCityY + 4, { baseline: 'top' });

  //            doc.setFontSize(8);
  //            doc.setTextColor('#000');
  //            doc.setFont('Poppins-Regular-normal');
  //            let formattedDepartureDate = new DatePipe('en-US').transform(this.newsectorInfo[j].departureDate, 'dd-MM-yyyy');

  //            doc.text(formattedDepartureDate, this.airlineCodeX + 2, this.airlineCodeY + 4.5, { baseline: 'top' });


  //            if (this.newsectorInfo[j].departureTerminal != null && this.newsectorInfo[j].departureTerminal != undefined && this.newsectorInfo[j].departureTerminal != "") {
  //              doc.setFontSize(8);
  //              doc.setTextColor('#000');
  //              doc.setFont('Poppins-Regular-normal');
  //              doc.text("Terminal:" + this.newsectorInfo[j].departureTerminal, this.airlineCodeX + 2, this.airlineCodeY + 8, { baseline: 'top' });
  //            }
  //            else {
  //              doc.setFontSize(8);
  //              doc.setTextColor('#000');
  //              doc.setFont('Poppins-Regular-normal');
  //              doc.text("Terminal:" + "", this.airlineCodeX + 2, this.airlineCodeY + 8, { baseline: 'top' });
  //            }


  //            doc.setFontSize(8);
  //            doc.setTextColor('#000');
  //            doc.setFont('Poppins-Regular-normal');
  //            doc.text(this.newsectorInfo[j].toCity + " (" + this.newsectorInfo[j].toAirport + ")", this.toCityX - 10, this.toCityY, { baseline: 'top' });

  //            doc.setFontSize(8);
  //            doc.setTextColor('#000');
  //            doc.setFont('Poppins-Regular-normal');
  //            doc.text(this.newsectorInfo[j].toAirportName, this.toCityX - 10, this.toCityY + 4, { baseline: 'top' });

  //            doc.setFontSize(8);
  //            doc.setTextColor('#000');
  //            doc.setFont('Poppins-Regular-normal');
  //            let formattedArrivalDate = new DatePipe('en-US').transform(this.newsectorInfo[j].arrivalDate, 'dd-MM-yyyy');
  //            doc.text(formattedArrivalDate, this.airlineCodeX + 87, this.airlineCodeY + 4.5, { baseline: 'top' });

  //            if (this.newsectorInfo[j].arrivalTerminal != null && this.newsectorInfo[j].arrivalTerminal != undefined && this.newsectorInfo[j].arrivalTerminal != "") {
  //              doc.setFontSize(8);
  //              doc.setTextColor('#000');
  //              doc.setFont('Poppins-Regular-normal');
  //              doc.text("Terminal:" + this.newsectorInfo[j].arrivalTerminal, this.airlineCodeX + 87, this.airlineCodeY + 8, { baseline: 'top' });
  //            }
  //            else {
  //              doc.setFontSize(8);
  //              doc.setTextColor('#000');
  //              doc.setFont('Poppins-Regular-normal');
  //              doc.text("Terminal:" + "", this.airlineCodeX + 87, this.airlineCodeY + 8, { baseline: 'top' });
  //            }



  //            if (j == 0) {
  //              doc.setFontSize(9);
  //              doc.setFont('Poppins-Regular-normal');
  //              doc.setTextColor('#000');
  //              doc.text(" SPNR: " + this.bookingInfo.supplierLocatorCode, this.pnrX, this.pnrY - 15, { baseline: 'top' });
  //            }




  //            this.airlineNameY = this.airlineNameY + 22;
  //            this.airlineCodeY = this.airlineCodeY + 22;
  //            this.airBusTypeY = this.airBusTypeY + 22;
  //            this.fromCityY = this.fromCityY + 22;
  //            this.fromAirportY = this.fromAirportY + 22;
  //            this.departDateY = this.departDateY + 22;
  //            this.toCityY = this.toCityY + 22;
  //            this.toAirportY = this.toAirportY + 22;
  //            this.arrivalDateY = this.arrivalDateY + 22;
  //            this.cabinClassY = this.cabinClassY + 22;
  //            this.noStopsY = this.noStopsY + 22;
  //            this.pnrY = this.pnrY + 22;
  //            this.pnrY1 = this.pnrY1 + 32;
  //            this.desY = this.desY + 22;
  //            this.flightLogoY = this.flightLogoY + 22;
  //            this.fromAirportY1 = this.fromAirportY1 + 22;
  //            this.pnrsY = this.pnrsY + 22;
  //          }

  //          doc.setLineWidth(0.8);
  //          doc.setDrawColor(255, 170, 0);
  //          doc.line(10, this.pnrY, doc.internal.pageSize.width - 10, this.pnrY);


  //          doc.setDrawColor(107, 107, 107);
  //          doc.setFillColor(227, 227, 227);
  //          doc.roundedRect(84, this.pnrY + 2, 35, 7, 1, 1, 'F')

  //          doc.setFontSize(12);
  //          doc.setFont('Poppins-Regular-normal-bold');
  //          doc.setTextColor('#000');
  //          doc.text("Booking Details ", 87, this.pnrY + 3.5, { baseline: 'top' });

  //          this.paxInfoY = this.pnrY + 15;
  //          var bodyData = [];

  //          this.passengerBaggage.forEach((el, index, array) => {
  //            bodyData.push([el.fromAirport.trim() + '        ' + el.toAirport, el.firstName + ' ' + el.lastName + " (" + el.typeName + ")", el.baggageCheckIn, el.baggageCabin, el.ticketNo, el.seatNum, el.meal])
  //          })

  //          autoTable(doc, {
  //            head: [['Sector', 'Traveller', 'CheckIn', 'Cabin', 'E-Ticket', 'Seat', 'Meal']],
  //            headStyles: { fillColor: [255, 170, 0], textColor: [255, 255, 255], halign: "center", fontStyle: "bold" },
  //            body: bodyData,
  //            didDrawCell: (data) => {
  //              doc.setDrawColor(0, 0, 0);
  //              doc.rect(data.cell.x, data.cell.y, data.cell.width, data.cell.height, 'S');

  //              if (data.section === 'body' && data.column.index === 0) {
  //                doc.addImage(sectorIcon, 'png', data.cell.x + 10, data.cell.y + 2, 0, 4);
  //              }
  //            },
  //            columnStyles: {
  //              0: { fontSize: 9, fontStyle: 'bold', valign: 'middle' },
  //              1: { fontSize: 9, fontStyle: 'bold', valign: 'middle', halign: 'center' },
  //              2: { fontSize: 9, valign: 'middle', halign: 'center' },
  //              3: { fontSize: 9, valign: 'middle', halign: 'center' },
  //              4: { fontSize: 9, valign: 'middle', halign: 'center' },
  //              5: { fontSize: 9, valign: 'middle', halign: 'center' },
  //              6: { fontSize: 9, valign: 'middle', halign: 'center' },
  //              7: { fontSize: 9, valign: 'middle', halign: 'center' },
  //            },
  //            startY: this.paxInfoY,
  //            theme: 'plain',
  //          });



  //          let finalYs = (doc as any).lastAutoTable.finalY;
  //          let agencyys1: number;
  //          agencyys1 = finalYs;



  //          if (type) {
  //            var bodyData2 = [];

  //            this.bookingPassengerInfo.forEach((els, index, array) => {
  //              bodyData2.push([els.firstName + ' ' + els.lastName + " (" + els.typeName + ")", els.exchangeCurrency + " " + els.baseFare, els.exchangeCurrency + " " + els.serviceCharges, els.exchangeCurrency + " " + (els.totalTaxes + els.markup + els.runtimeMarkup), els.exchangeCurrency + " " + els.netFromCustomer])
  //            })


  //            autoTable(doc, {
  //              head: [['Passenger Name', 'Fare', 'Paid Services', 'Taxes & Fees', 'Total']],
  //              headStyles: { fillColor: [255, 170, 0], textColor: [255, 255, 255], halign: "center", fontStyle: "bold" },
  //              body: bodyData2,
  //              didDrawCell: (data) => {
  //                doc.setDrawColor(0, 0, 0);
  //                doc.rect(data.cell.x, data.cell.y, data.cell.width, data.cell.height, 'S');
  //              },
  //              columnStyles: {
  //                0: { fontSize: 9, valign: 'middle', textColor: [0, 0, 0], fontStyle: 'bold', halign: 'center' },
  //                1: { fontSize: 9, valign: 'middle', halign: 'center' },
  //                2: { fontSize: 9, valign: 'middle', halign: 'center' },
  //                3: { fontSize: 9, valign: 'middle', halign: 'center' },
  //                4: { fontSize: 9, valign: 'middle', halign: 'center' },
  //              },
  //              startY: agencyys1 + 15,
  //              theme: 'plain',
  //            });

  //            doc.setDrawColor(107, 107, 107);
  //            doc.setFillColor(227, 227, 227);
  //            doc.roundedRect(84, agencyys1 + 2, 37, 7, 1, 1, 'F');

  //            doc.setFontSize(12);
  //            doc.setFont('Poppins-Regular-normal-bold');
  //            doc.setTextColor('#000');
  //            doc.text("Passenger Details", 87, agencyys1 + 3.5, { baseline: 'top' });


  //          }

  //          let finalYs1 = (doc as any).lastAutoTable.finalY;
  //          let agencyys: number;
  //          agencyys = finalYs1 + 5;
  //          this.agRectY = agencyys;


  //          const remainingSpace = doc.internal.pageSize.height - 10 - this.agRectY;
  //          const requiredSpace = 30;
  //          if (remainingSpace < requiredSpace) {
  //            doc.addPage();
  //            this.agRectY = 10;
  //          }



  //          doc.setDrawColor(107, 107, 107);
  //          doc.setFillColor(227, 227, 227);
  //          doc.rect(12, this.agRectY, 185, 9, 'F');

  //          doc.setDrawColor(213, 213, 213);
  //          doc.line(100, this.agRectY + 3, 100, this.agRectY + 3);


  //          //Consultant Info
  //          doc.setFontSize(10);
  //          doc.setFont('Poppins-Regular-normal');
  //          doc.setTextColor('#000');
  //          doc.text("Consultant ", 15, this.agRectY + 3, { baseline: 'top' });

  //          doc.setFontSize(10);
  //          doc.setFont('Poppins-Regular-normal');
  //          doc.setTextColor('#000');
  //          doc.text("Company Name: " + this.agencyOnline.agencyName + ", " + this.agencyOnline.city, 15, this.agRectY + 10, { baseline: 'top' });

  //          doc.setFontSize(10);
  //          doc.setFont('Poppins-Regular-normal');
  //          doc.setTextColor('#000');
  //          doc.text("Address: " + this.agencyOnline.address1 + this.agencyOnline.address2, 15, this.agRectY + 15, { baseline: 'top' });

  //          doc.setFontSize(10);
  //          doc.setFont('Poppins-Regular-normal');
  //          doc.setTextColor('#000');
  //          doc.text("Tel: " + this.agencyOnline.telephoneNumber, 15, this.agRectY + 20, { baseline: 'top' });

  //          doc.setFontSize(10);
  //          doc.setFont('Poppins-Regular-normal');
  //          doc.setTextColor('#000');
  //          doc.text("Email: " + this.agencyOnline.emailAddress, 15, this.agRectY + 25, { baseline: 'top' });



  //          doc.setFontSize(10);
  //          doc.setFont('Poppins-Regular-normal');
  //          doc.setTextColor('#000');
  //          doc.text("Agent Name: " + this.userOnline.firstName + " " + this.userOnline.lastName, 15, this.agRectY + 30, { baseline: 'top' });


  //          doc.setFontSize(10);
  //          doc.setFont('Poppins-Regular-normal');
  //          doc.setTextColor('#000');
  //          doc.text("Tel: " + this.userOnline.mobile, 15, this.agRectY + 35, { baseline: 'top' });

  //          doc.setFontSize(10);
  //          doc.setFont('Poppins-Regular-normal');
  //          doc.setTextColor('#000');
  //          doc.text("Email: " + this.userOnline.email, 15, this.agRectY + 40, { baseline: 'top' });

  //        }

  //      })
  //      .then(() => {
  //        this.hideBtnLoader();
  //        let pdf = doc.output('blob');
  //        //////////console.log (pdf);
  //        this.ticketEmailObj.subject = "Your E-Ticket is Here";
  //        let pdfFile = new File([pdf], "pdfFile", { type: "application/pdf" });
  //        //////////console.log (pdfFile);
  //        var formData = new FormData();

  //        formData.append("subject", this.ticketEmailObj.subject);
  //        formData.append("customerEmail", this.ticketEmailObj.customerEmail);
  //        formData.append("agencyId", localStorage.getItem("AgencyId"));
  //        formData.append("pdfFile", pdfFile, `Booking Itinerary_${this.bookingInfo.bookingID}`)
  //        /* doc.save('Booking Itinerary' + '_' + this.bookingInfo.bookingID + '.pdf');*/

  //        this.emailService.emailIterniaryMulti(formData).subscribe((data) => {
  //          //      //////console.log (data);
  //          this.isLoadPanelVisible = false;
  //          if (data == true) {
  //            this.NewSuccess.dismissAll();
  //          }
  //          else {
  //            document.getElementById("messageEmail").innerHTML = 'Please Try Again!';
  //            setTimeout(() => { document.getElementById("messageEmail").innerHTML = ''; }, 5000);
  //          }
  //        })
  //      });


  //  }
  //  catch (e) {
  //    this.isLoadPanelVisible = false;
  //    //////////console.log (e);
  //  }

  //}

  //IzzaBefore Print
  //printItinerary1(type: boolean) {
  //  try {

  //    this.showBtnLoader();


  //    let sectorIcon = '../../assets/img/printsectoricon.png';
  //    let OneWayImage = '../../assets/img/take-off-24.png';
  //    let twowayImage = '../../assets/img/printsectoricon.png';

  //    //let sectorIcon = '../../assets/img/printsectoricon.png';
  //    //let OneWayImage = '../../assets/img/OneWayImage.png';
  //    //let twowayImage = '../../assets/img/RoundWayImage.png';

  //    this.flightLogoX = 10;
  //    this.flightLogoY = 40;
  //    this.airlineNameX = 33;



  //    // ======= Asad Working ============
  //    this.airlineNameY = 40;
  //    // ======= Asad Working ============

  //    this.airlineCodeX = 33;
  //    this.airlineCodeY = 53;
  //    this.airBusTypeX = 20;
  //    this.airBusTypeY = 80;
  //    this.fromCityX = 60;
  //    this.fromCityY = 50;
  //    this.fromAirportX = 60;
  //    this.fromAirportY = 45;
  //    this.fromAirportX1 = 75;
  //    this.fromAirportY1 = 45;
  //    this.departDateX = 61;
  //    this.departDateY = 80;
  //    this.toCityX = 130;
  //    this.toCityY = 50;
  //    this.toAirportX = 143;
  //    this.toAirportY = 45;
  //    this.arrivalDateX = 123;
  //    this.arrivalDateY = 80;
  //    this.cabinClassX = 175;
  //    this.cabinClassY = 45;
  //    this.noStopsX = 160;
  //    this.noStopsY = 45;
  //    this.pnrX = 174;
  //    this.pnrY = 50;
  //    this.pnrY1 = 32;
  //    this.desX = 71;
  //    this.desY = 47;
  //    this.cityRouteX = 10;
  //    this.sectSpace = 0;
  //    this.iterationWidth = 0
  //    this.pnrsX = 174;
  //    this.pnrsY = 50;
  //    let bookingDateString = this.bookingInfo.bookingDate;

  //    let bookingDate = new Date(bookingDateString);

  //    let fullDateFormat = bookingDate.toLocaleString('en-US', {
  //      year: 'numeric',
  //      month: 'long',
  //      day: 'numeric',
  //    });




  //    let doc = new jsPDF("p", "mm", "a4");

  //    doc.setLineWidth(1);
  //    doc.rect(5, 5, doc.internal.pageSize.width - 10, doc.internal.pageSize.height - 10);


  //    doc.setFontSize(7);
  //    doc.addFileToVFS('Poppins-Regular-normal.ttf', this.font);
  //    doc.addFont('Poppins-Regular-normal.ttf', 'Poppins-Regular-normal', 'normal');
  //    doc.setFont('Poppins-Regular-normal');


  //    exportDataGrid({
  //      jsPDFDocument: doc,
  //      component: this.dataGrid3.instance,
  //      autoTableOptions: {
  //        border: {
  //          borderRight: 0,
  //          borderLeft: 0
  //        },
  //        margin: {
  //          top: 0,
  //        },
  //        headStyles: {
  //          textColor: "#FFF",
  //          fontSize: 8
  //        },

  //        bodyStyles: {
  //          textColor: "#000",
  //          fontSize: 7
  //        },
  //      }
  //    })



  //      .then(async () => {



  //        if (this.bookingPassengerInfo.length >= 1) {



  //          let agencyLogoName = this.agencyOnline.logoFileName;
  //          let imgType = agencyLogoName.substring(agencyLogoName.lastIndexOf(".") + 1);
  //          var imageString = 'data:image/' + imgType + ';base64,' + this.agencyOnline.logoFilePath;


  //          doc.addImage(imageString, imgType, 170, 10, 25, 15);


  //          if (this.newsectorInfo.length == 1) {
  //            doc.setFontSize(14);
  //            doc.setFont('csvsdvsd', 'bold');
  //            doc.setTextColor(0, 0, 0);

  //            doc.text(this.newsectorInfo[0].fromAirport, this.cityRouteX, 10, { baseline: 'top' });


  //            this.iterationWidth = doc.getTextWidth(this.newsectorInfo[0].fromAirport) + 10;
  //            this.cityRouteX = this.iterationWidth + 3;

  //            doc.addImage(OneWayImage, 'png', this.cityRouteX, 10, 5, 5);

  //            this.iterationWidth = doc.getTextWidth(this.newsectorInfo[0].fromAirport) + 10;
  //            this.cityRouteX = this.iterationWidth + 10;
  //            doc.text(this.newsectorInfo[0].toAirport, this.cityRouteX, 10, { baseline: 'top' });
  //          }
  //          else if (this.newsectorInfo.length > 1) {
  //            doc.setFontSize(10);
  //            doc.setFont('csvsdvsd', 'bold');
  //            doc.setTextColor(0, 0, 0);

  //            this.cityRouteX = 10;

  //            for (let i = 0; i < this.newsectorInfo.length; i++) {
  //              const sector = this.newsectorInfo[i];

  //              doc.text(sector.fromAirport, this.cityRouteX, 10, { baseline: 'top' });

  //              this.cityRouteX += 8;

  //              doc.addImage(twowayImage, 'png', this.cityRouteX, 10, 0, 4);
  //              this.cityRouteX += 5;

  //              doc.text(sector.toAirport, this.cityRouteX, 10, { baseline: 'top' });
  //              this.cityRouteX += 10;
  //            }
  //          }


  //          doc.setFontSize(11);
  //          doc.setFont('Poppins-Regular-normal');
  //          doc.setTextColor('#000');
  //          var bookingid = (this.bookingInfo.finalBuyerID).toString() + "-" + (this.bookingInfo.bookingID).toString();
  //          doc.text("Booking ID: " + bookingid, 10, 20, { baseline: 'top' });



  //          doc.setFontSize(11);
  //          doc.setFont('Poppins-Regular-normal');
  //          doc.setTextColor('#000');
  //          doc.text("PNR: " + this.bookingInfo.pnr, 10, 25, { baseline: 'top' });

  //          doc.setFontSize(12);
  //          doc.setFont('Poppins-Regular-normal');
  //          doc.setTextColor('#000');
  //          doc.text("" + this.bookingStatus, 140, 25, { baseline: 'top' });


  //          doc.setFontSize(12);
  //          doc.setFont('Poppins-Regular-normal');
  //          doc.setTextColor(105, 105, 105);
  //          doc.text("" + fullDateFormat, 10, 15, { baseline: 'top' });


  //          doc.setLineWidth(0.8);
  //          doc.setDrawColor(255, 170, 0);
  //          doc.line(10, 30, doc.internal.pageSize.width - 10, 30);


  //          doc.setDrawColor(107, 107, 107);
  //          doc.setFillColor(227, 227, 227);
  //          doc.roundedRect(88, 32, 22, 8, 1, 1, 'F')


  //          doc.setFontSize(12);
  //          doc.setFont('Poppins-Regular-normal-bold');
  //          doc.setTextColor('#000');
  //          doc.text("Itinerary ", 90, 34, { baseline: 'top' });

  //          // Airline Details
  //          for (let j = 0; j < this.newsectorInfo.length; j++) {


  //            let flightLogoPath = 'assets/img/' + this.newsectorInfo[j].airlineLogo;

  //            if (this.newsectorInfo[j].airlineLogo.includes(".svg")) {

  //              const canvass = document.createElement('canvas');
  //              canvass.width = 200;
  //              canvass.height = 200;
  //              const ctx = canvass.getContext('2d');
  //              const v = await Canvg.from(ctx, flightLogoPath);

  //              v.start();
  //              var processedFlightLogo = canvass.toDataURL("img/png");

  //              doc.addImage(processedFlightLogo, 'png', this.flightLogoX, this.flightLogoY, 15, 10);
  //            } else {
  //              doc.addImage("assets/img/" + this.newsectorInfo[j].airlineLogo, 'png', this.flightLogoX, this.flightLogoY, 15, 10);
  //            }



  //            doc.setFontSize(9);
  //            doc.setFont('Poppins-Regular-normal');
  //            doc.setTextColor('#000');
  //            doc.text(this.newsectorInfo[j].cabinClass + "(" + this.newsectorInfo[j].rbd + ")", this.cabinClassX, this.cabinClassY, { baseline: 'top' });

  //            doc.setFontSize(10);
  //            doc.setFont('Poppins-Regular-normal');
  //            doc.setTextColor('#000');
  //            var flighn = this.newsectorInfo[j].airlinePrefixCode + (this.newsectorInfo[j].flightNumber).toString();
  //            doc.text(flighn, this.airlineCodeX - 18, this.airlineCodeY, { baseline: 'top' });

  //            doc.setFontSize(10);
  //            doc.setFont('Poppins-Regular-normal');
  //            doc.setTextColor('#000');
  //            doc.text(this.newsectorInfo[j].departureTime.substring(0, 5), this.fromAirportX - 25, this.fromAirportY, { baseline: 'top' });

  //            doc.setFontSize(10);
  //            doc.setFont('Poppins-Regular-normal');
  //            doc.setTextColor('#000');
  //            doc.text(this.newsectorInfo[j].arrivalTime.substring(0, 5), this.toAirportX - 10, this.toAirportY, { baseline: 'top' });



  //            doc.setLineWidth(0.8);
  //            doc.setDrawColor(169, 169, 169);
  //            doc.line(this.desX - 25, this.desY, this.desX + 60, this.desY);
  //            doc.setDrawColor(255, 170, 0);
  //            doc.circle(this.desX - 25, this.desY, 1.5, 'F');
  //            doc.setDrawColor(255, 170, 0);
  //            doc.circle(this.desX + 60, this.desY, 1.5, 'F');
  //            doc.setDrawColor(169, 169, 169);


  //            doc.setFontSize(10);
  //            doc.setFont('Poppins-Regular-normal');
  //            doc.setTextColor(105, 105, 105);
  //            for (let j = 0; j < this.newsectorInfo.length; j++) {
  //              doc.text(this.newsectorInfo[j].noOfStops + " Stops", this.noStopsX, this.noStopsY, { baseline: 'top' });
  //            }

  //            doc.setFontSize(8);
  //            doc.setTextColor('#000');
  //            doc.setFont('Poppins-Regular-normal');
  //            doc.text(this.newsectorInfo[j].fromCity + " (" + this.newsectorInfo[j].fromAirport + ")", this.fromCityX - 25, this.fromCityY, { baseline: 'top' });


  //            doc.setFontSize(8);
  //            doc.setTextColor('#000');
  //            doc.setFont('Poppins-Regular-normal');
  //            doc.text(this.newsectorInfo[j].fromAirportName, this.fromCityX - 25, this.fromCityY + 4, { baseline: 'top' });

  //            doc.setFontSize(8);
  //            doc.setTextColor('#000');
  //            doc.setFont('Poppins-Regular-normal');
  //            let formattedDepartureDate = new DatePipe('en-US').transform(this.newsectorInfo[j].departureDate, 'dd-MM-yyyy');

  //            doc.text(formattedDepartureDate, this.airlineCodeX + 2, this.airlineCodeY + 4.5, { baseline: 'top' });


  //            if (this.newsectorInfo[j].departureTerminal != null && this.newsectorInfo[j].departureTerminal != undefined && this.newsectorInfo[j].departureTerminal != "") {
  //              doc.setFontSize(8);
  //              doc.setTextColor('#000');
  //              doc.setFont('Poppins-Regular-normal');
  //              doc.text("Terminal:" + this.newsectorInfo[j].departureTerminal, this.airlineCodeX + 2, this.airlineCodeY + 8, { baseline: 'top' });
  //            }
  //            else {
  //              doc.setFontSize(8);
  //              doc.setTextColor('#000');
  //              doc.setFont('Poppins-Regular-normal');
  //              doc.text("Terminal:" + "", this.airlineCodeX + 2, this.airlineCodeY + 8, { baseline: 'top' });
  //            }


  //            doc.setFontSize(8);
  //            doc.setTextColor('#000');
  //            doc.setFont('Poppins-Regular-normal');
  //            doc.text(this.newsectorInfo[j].toCity + " (" + this.newsectorInfo[j].toAirport + ")", this.toCityX - 10, this.toCityY, { baseline: 'top' });

  //            doc.setFontSize(8);
  //            doc.setTextColor('#000');
  //            doc.setFont('Poppins-Regular-normal');
  //            doc.text(this.newsectorInfo[j].toAirportName, this.toCityX - 10, this.toCityY + 4, { baseline: 'top' });

  //            doc.setFontSize(8);
  //            doc.setTextColor('#000');
  //            doc.setFont('Poppins-Regular-normal');
  //            let formattedArrivalDate = new DatePipe('en-US').transform(this.newsectorInfo[j].arrivalDate, 'dd-MM-yyyy');
  //            doc.text(formattedArrivalDate, this.airlineCodeX + 87, this.airlineCodeY + 4.5, { baseline: 'top' });

  //            if (this.newsectorInfo[j].arrivalTerminal != null && this.newsectorInfo[j].arrivalTerminal != undefined && this.newsectorInfo[j].arrivalTerminal != "") {
  //              doc.setFontSize(8);
  //              doc.setTextColor('#000');
  //              doc.setFont('Poppins-Regular-normal');
  //              doc.text("Terminal:" + this.newsectorInfo[j].arrivalTerminal, this.airlineCodeX + 87, this.airlineCodeY + 8, { baseline: 'top' });
  //            }
  //            else {
  //              doc.setFontSize(8);
  //              doc.setTextColor('#000');
  //              doc.setFont('Poppins-Regular-normal');
  //              doc.text("Terminal:" + "", this.airlineCodeX + 87, this.airlineCodeY + 8, { baseline: 'top' });
  //            }



  //            if (j == 0) {
  //              doc.setFontSize(9);
  //              doc.setFont('Poppins-Regular-normal');
  //              doc.setTextColor('#000');
  //              doc.text(" SPNR: " + this.bookingInfo.supplierLocatorCode, this.pnrX, this.pnrY - 15, { baseline: 'top' });
  //            }




  //            this.airlineNameY = this.airlineNameY + 22;
  //            this.airlineCodeY = this.airlineCodeY + 22;
  //            this.airBusTypeY = this.airBusTypeY + 22;
  //            this.fromCityY = this.fromCityY + 22;
  //            this.fromAirportY = this.fromAirportY + 22;
  //            this.departDateY = this.departDateY + 22;
  //            this.toCityY = this.toCityY + 22;
  //            this.toAirportY = this.toAirportY + 22;
  //            this.arrivalDateY = this.arrivalDateY + 22;
  //            this.cabinClassY = this.cabinClassY + 22;
  //            this.noStopsY = this.noStopsY + 22;
  //            this.pnrY = this.pnrY + 22;
  //            this.pnrY1 = this.pnrY1 + 32;
  //            this.desY = this.desY + 22;
  //            this.flightLogoY = this.flightLogoY + 22;
  //            this.fromAirportY1 = this.fromAirportY1 + 22;
  //            this.pnrsY = this.pnrsY + 22;
  //          }

  //          doc.setLineWidth(0.8);
  //          doc.setDrawColor(255, 170, 0);
  //          doc.line(10, this.pnrY, doc.internal.pageSize.width - 10, this.pnrY);


  //          doc.setDrawColor(107, 107, 107);
  //          doc.setFillColor(227, 227, 227);
  //          doc.roundedRect(84, this.pnrY + 2, 35, 7, 1, 1, 'F')

  //          doc.setFontSize(12);
  //          doc.setFont('Poppins-Regular-normal-bold');
  //          doc.setTextColor('#000');
  //          doc.text("Booking Details ", 87, this.pnrY + 3.5, { baseline: 'top' });

  //          this.paxInfoY = this.pnrY + 15;
  //          var bodyData = [];

  //          this.passengerBaggage.forEach((el, index, array) => {
  //            bodyData.push([el.fromAirport.trim() + '        ' + el.toAirport, el.firstName + ' ' + el.lastName + " (" + el.typeName + ")", el.baggageCheckIn, el.baggageCabin, el.ticketNo, el.seatNum, el.meal])
  //          })

  //          autoTable(doc, {
  //            head: [['Sector', 'Traveller', 'CheckIn', 'Cabin', 'E-Ticket', 'Seat', 'Meal']],
  //            headStyles: { fillColor: [255, 170, 0], textColor: [255, 255, 255], halign: "center", fontStyle: "bold" },
  //            body: bodyData,
  //            didDrawCell: (data) => {
  //              doc.setDrawColor(0, 0, 0);
  //              doc.rect(data.cell.x, data.cell.y, data.cell.width, data.cell.height, 'S');

  //              if (data.section === 'body' && data.column.index === 0) {
  //                doc.addImage(sectorIcon, 'png', data.cell.x + 10, data.cell.y + 2, 0, 4);
  //              }
  //            },
  //            columnStyles: {
  //              0: { fontSize: 9, fontStyle: 'bold', valign: 'middle' },
  //              1: { fontSize: 9, fontStyle: 'bold', valign: 'middle', halign: 'center' },
  //              2: { fontSize: 9, valign: 'middle', halign: 'center' },
  //              3: { fontSize: 9, valign: 'middle', halign: 'center' },
  //              4: { fontSize: 9, valign: 'middle', halign: 'center' },
  //              5: { fontSize: 9, valign: 'middle', halign: 'center' },
  //              6: { fontSize: 9, valign: 'middle', halign: 'center' },
  //              7: { fontSize: 9, valign: 'middle', halign: 'center' },
  //            },
  //            startY: this.paxInfoY,
  //            theme: 'plain',
  //          });



  //          let finalYs = (doc as any).lastAutoTable.finalY;
  //          let agencyys1: number;
  //          agencyys1 = finalYs;



  //          if (type) {
  //            var bodyData2 = [];

  //            this.bookingPassengerInfo.forEach((els, index, array) => {
  //              bodyData2.push([els.firstName + ' ' + els.lastName + " (" + els.typeName + ")", els.exchangeCurrency + " " + els.baseFare, els.exchangeCurrency + " " + els.serviceCharges, els.exchangeCurrency + " " + (els.totalTaxes + els.markup + els.runtimeMarkup), els.exchangeCurrency + " " + els.netFromCustomer])
  //            })


  //            autoTable(doc, {
  //              head: [['Passenger Name', 'Fare', 'Paid Services', 'Taxes & Fees', 'Total']],
  //              headStyles: { fillColor: [255, 170, 0], textColor: [255, 255, 255], halign: "center", fontStyle: "bold" },
  //              body: bodyData2,
  //              didDrawCell: (data) => {
  //                doc.setDrawColor(0, 0, 0);
  //                doc.rect(data.cell.x, data.cell.y, data.cell.width, data.cell.height, 'S');
  //              },
  //              columnStyles: {
  //                0: { fontSize: 9, valign: 'middle', textColor: [0, 0, 0], fontStyle: 'bold', halign: 'center' },
  //                1: { fontSize: 9, valign: 'middle', halign: 'center' },
  //                2: { fontSize: 9, valign: 'middle', halign: 'center' },
  //                3: { fontSize: 9, valign: 'middle', halign: 'center' },
  //                4: { fontSize: 9, valign: 'middle', halign: 'center' },
  //              },
  //              startY: agencyys1 + 15,
  //              theme: 'plain',
  //            });

  //            doc.setDrawColor(107, 107, 107);
  //            doc.setFillColor(227, 227, 227);
  //            doc.roundedRect(84, agencyys1 + 2, 37, 7, 1, 1, 'F');

  //            doc.setFontSize(12);
  //            doc.setFont('Poppins-Regular-normal-bold');
  //            doc.setTextColor('#000');
  //            doc.text("Passenger Details", 87, agencyys1 + 3.5, { baseline: 'top' });


  //          }

  //          let finalYs1 = (doc as any).lastAutoTable.finalY;
  //          let agencyys: number;
  //          agencyys = finalYs1 + 5;
  //          this.agRectY = agencyys;


  //          const remainingSpace = doc.internal.pageSize.height - 10 - this.agRectY;
  //          const requiredSpace = 30;
  //          if (remainingSpace < requiredSpace) {
  //            doc.addPage();
  //            this.agRectY = 10;
  //          }



  //          doc.setDrawColor(107, 107, 107);
  //          doc.setFillColor(227, 227, 227);
  //          doc.rect(12, this.agRectY, 185, 9, 'F');

  //          doc.setDrawColor(213, 213, 213);
  //          doc.line(100, this.agRectY + 3, 100, this.agRectY + 3);


  //          //Consultant Info
  //          doc.setFontSize(10);
  //          doc.setFont('Poppins-Regular-normal');
  //          doc.setTextColor('#000');
  //          doc.text("Consultant ", 15, this.agRectY + 3, { baseline: 'top' });

  //          doc.setFontSize(10);
  //          doc.setFont('Poppins-Regular-normal');
  //          doc.setTextColor('#000');
  //          doc.text("Company Name: " + this.agencyOnline.agencyName + ", " + this.agencyOnline.city, 15, this.agRectY + 10, { baseline: 'top' });

  //          doc.setFontSize(10);
  //          doc.setFont('Poppins-Regular-normal');
  //          doc.setTextColor('#000');
  //          doc.text("Address: " + this.agencyOnline.address1 + this.agencyOnline.address2, 15, this.agRectY + 15, { baseline: 'top' });

  //          doc.setFontSize(10);
  //          doc.setFont('Poppins-Regular-normal');
  //          doc.setTextColor('#000');
  //          doc.text("Tel: " + this.agencyOnline.telephoneNumber, 15, this.agRectY + 20, { baseline: 'top' });

  //          doc.setFontSize(10);
  //          doc.setFont('Poppins-Regular-normal');
  //          doc.setTextColor('#000');
  //          doc.text("Email: " + this.agencyOnline.emailAddress, 15, this.agRectY + 25, { baseline: 'top' });



  //          doc.setFontSize(10);
  //          doc.setFont('Poppins-Regular-normal');
  //          doc.setTextColor('#000');
  //          doc.text("Agent Name: " + this.userOnline.firstName + " " + this.userOnline.lastName, 15, this.agRectY + 30, { baseline: 'top' });


  //          doc.setFontSize(10);
  //          doc.setFont('Poppins-Regular-normal');
  //          doc.setTextColor('#000');
  //          doc.text("Tel: " + this.userOnline.mobile, 15, this.agRectY + 35, { baseline: 'top' });

  //          doc.setFontSize(10);
  //          doc.setFont('Poppins-Regular-normal');
  //          doc.setTextColor('#000');
  //          doc.text("Email: " + this.userOnline.email, 15, this.agRectY + 40, { baseline: 'top' });




  //          //doc.setFontSize(10);
  //          //doc.setFont('Poppins-Regular-normal');
  //          //doc.setTextColor('#000');
  //          //doc.text(this.agencyOnline.agencyName + ", " + this.agencyOnline.city, 110, this.agRectY + 3, { baseline: 'top' });

  //          //const address1Lines = doc.splitTextToSize(this.agencyOnline.address1, 100);
  //          //const address2Lines = doc.splitTextToSize(this.agencyOnline.address2, 100);

  //          //const lineHeight = 2;

  //          //let currentY = this.agRectY + 10;

  //          //doc.setFontSize(10);
  //          //doc.setFont('Poppins-Regular-normal');
  //          //doc.setTextColor('#000');
  //          //doc.text(address1Lines, 100, currentY, { baseline: 'top' });

  //          //currentY += address1Lines.length * lineHeight + 4;

  //          //doc.text(address2Lines, 100, currentY, { baseline: 'top' });

  //          //currentY += address2Lines.length * lineHeight + 4;

  //          //doc.text("Tel: " + this.agencyOnline.telephoneNumber, 100, currentY, { baseline: 'top' });

  //          //currentY += lineHeight + 3;

  //          //doc.text("Email: " + this.agencyOnline.emailAddress, 100, currentY, { baseline: 'top' });

  //        }

  //      })
  //      .then(() => {
  //        this.hideBtnLoader();
  //        doc.save('Booking Itinerary' + '_' + this.bookingInfo.bookingID);
  //      });


  //  }
  //  catch (e) {
  //    //////////console.log (e);
  //  }

  //}

  //printItinerary1(type: boolean) {
  //  try {

  //    this.showBtnLoader();


  //    let sectorIcon = '../../assets/img/printsectoricon.png';
  //    let OneWayImage = '../../assets/img/take-off-24.png';
  //    let twowayImage = '../../assets/img/printsectoricon.png';

  //    //let sectorIcon = '../../assets/img/printsectoricon.png';
  //    //let OneWayImage = '../../assets/img/OneWayImage.png';
  //    //let twowayImage = '../../assets/img/RoundWayImage.png';

  //    this.flightLogoX = 10;
  //    this.flightLogoY = 40;
  //    this.airlineNameX = 33;



  //    // ======= Asad Working ============
  //    this.airlineNameY = 40;
  //    // ======= Asad Working ============

  //    this.airlineCodeX = 33;
  //    this.airlineCodeY = 53;
  //    this.airBusTypeX = 20;
  //    this.airBusTypeY = 80;
  //    this.fromCityX = 60;
  //    this.fromCityY = 50;
  //    this.fromAirportX = 60;
  //    this.fromAirportY = 45;
  //    this.fromAirportX1 = 75;
  //    this.fromAirportY1 = 45;
  //    this.departDateX = 61;
  //    this.departDateY = 80;
  //    this.toCityX = 130;
  //    this.toCityY = 50;
  //    this.toAirportX = 143;
  //    this.toAirportY = 45;
  //    this.arrivalDateX = 123;
  //    this.arrivalDateY = 80;
  //    this.cabinClassX = 175;
  //    this.cabinClassY = 45;
  //    this.noStopsX = 160;
  //    this.noStopsY = 45;
  //    this.pnrX = 174;
  //    this.pnrY = 50;
  //    this.pnrY1 = 32;
  //    this.desX = 71;
  //    this.desY = 47;
  //    this.cityRouteX = 10;
  //    this.sectSpace = 0;
  //    this.iterationWidth = 0
  //    this.pnrsX = 174;
  //    this.pnrsY = 50;
  //    let bookingDateString = this.bookingInfo.bookingDate;

  //    let bookingDate = new Date(bookingDateString);

  //    let fullDateFormat = bookingDate.toLocaleString('en-US', {
  //      year: 'numeric',
  //      month: 'long',
  //      day: 'numeric',
  //    });




  //    let doc = new jsPDF("p", "mm", "a4");

  //    doc.setLineWidth(1);
  //    doc.rect(5, 5, doc.internal.pageSize.width - 10, doc.internal.pageSize.height - 10);


  //    doc.setFontSize(7);
  //    doc.addFileToVFS('Poppins-Regular-normal.ttf', this.font);
  //    doc.addFont('Poppins-Regular-normal.ttf', 'Poppins-Regular-normal', 'normal');
  //    doc.setFont('Poppins-Regular-normal');


  //    exportDataGrid({
  //      jsPDFDocument: doc,
  //      component: this.dataGrid3.instance,
  //      autoTableOptions: {
  //        border: {
  //          borderRight: 0,
  //          borderLeft: 0
  //        },
  //        margin: {
  //          top: 0,
  //        },
  //        headStyles: {
  //          textColor: "#FFF",
  //          fontSize: 8
  //        },

  //        bodyStyles: {
  //          textColor: "#000",
  //          fontSize: 7
  //        },
  //      }
  //    })



  //      .then(async () => {



  //        if (this.bookingPassengerInfo.length >= 1) {



  //          let agencyLogoName = this.agencyOnline.logoFileName;
  //          let imgType = agencyLogoName.substring(agencyLogoName.lastIndexOf(".") + 1);
  //          var imageString = 'data:image/' + imgType + ';base64,' + this.agencyOnline.logoFilePath;


  //          doc.addImage(imageString, imgType, 170, 10, 25, 15);


  //          if (this.newsectorInfo.length == 1) {
  //            doc.setFontSize(14);
  //            doc.setFont('csvsdvsd', 'bold');
  //            doc.setTextColor(0, 0, 0);

  //            doc.text(this.newsectorInfo[0].fromAirport, this.cityRouteX, 10, { baseline: 'top' });


  //            this.iterationWidth = doc.getTextWidth(this.newsectorInfo[0].fromAirport) + 10;
  //            this.cityRouteX = this.iterationWidth + 3;

  //            doc.addImage(OneWayImage, 'png', this.cityRouteX, 10, 5, 5);

  //            this.iterationWidth = doc.getTextWidth(this.newsectorInfo[0].fromAirport) + 10;
  //            this.cityRouteX = this.iterationWidth + 10;
  //            doc.text(this.newsectorInfo[0].toAirport, this.cityRouteX, 10, { baseline: 'top' });
  //          }
  //          else if (this.newsectorInfo.length > 1) {
  //            doc.setFontSize(10);
  //            doc.setFont('csvsdvsd', 'bold');
  //            doc.setTextColor(0, 0, 0);

  //            this.cityRouteX = 10;

  //            for (let i = 0; i < this.newsectorInfo.length; i++) {
  //              const sector = this.newsectorInfo[i];

  //              doc.text(sector.fromAirport, this.cityRouteX, 10, { baseline: 'top' });

  //              this.cityRouteX += 8;

  //              doc.addImage(twowayImage, 'png', this.cityRouteX, 10, 0, 4);
  //              this.cityRouteX += 5;

  //              doc.text(sector.toAirport, this.cityRouteX, 10, { baseline: 'top' });
  //              this.cityRouteX += 10;
  //            }
  //          }


  //          doc.setFontSize(11);
  //          doc.setFont('Poppins-Regular-normal');
  //          doc.setTextColor('#000');
  //          var bookingid = (this.bookingInfo.finalBuyerID).toString() + "-" + (this.bookingInfo.bookingID).toString();
  //          doc.text("Booking ID: " + bookingid, 10, 20, { baseline: 'top' });



  //          doc.setFontSize(11);
  //          doc.setFont('Poppins-Regular-normal');
  //          doc.setTextColor('#000');
  //          doc.text("PNR: " + this.bookingInfo.pnr, 10, 25, { baseline: 'top' });

  //          doc.setFontSize(12);
  //          doc.setFont('Poppins-Regular-normal');
  //          doc.setTextColor('#000');
  //          doc.text("" + this.bookingStatus, 140, 25, { baseline: 'top' });


  //          doc.setFontSize(12);
  //          doc.setFont('Poppins-Regular-normal');
  //          doc.setTextColor(105, 105, 105);
  //          doc.text("" + fullDateFormat, 10, 15, { baseline: 'top' });


  //          doc.setLineWidth(0.8);
  //          doc.setDrawColor(255, 170, 0);
  //          doc.line(10, 30, doc.internal.pageSize.width - 10, 30);


  //          doc.setDrawColor(107, 107, 107);
  //          doc.setFillColor(227, 227, 227);
  //          doc.roundedRect(88, 32, 22, 8, 1, 1, 'F')


  //          doc.setFontSize(12);
  //          doc.setFont('Poppins-Regular-normal-bold');
  //          doc.setTextColor('#000');
  //          doc.text("Itinerary ", 90, 34, { baseline: 'top' });

  //          // Airline Details
  //          for (let j = 0; j < this.newsectorInfo.length; j++) {


  //            let flightLogoPath = 'assets/img/' + this.newsectorInfo[j].airlineLogo;

  //            if (this.newsectorInfo[j].airlineLogo.includes(".svg")) {

  //              const canvass = document.createElement('canvas');
  //              canvass.width = 200;
  //              canvass.height = 200;
  //              const ctx = canvass.getContext('2d');
  //              const v = await Canvg.from(ctx, flightLogoPath);

  //              v.start();
  //              var processedFlightLogo = canvass.toDataURL("img/png");

  //              doc.addImage(processedFlightLogo, 'png', this.flightLogoX, this.flightLogoY, 15, 10);
  //            } else {
  //              doc.addImage("assets/img/" + this.newsectorInfo[j].airlineLogo, 'png', this.flightLogoX, this.flightLogoY, 15, 10);
  //            }



  //            doc.setFontSize(9);
  //            doc.setFont('Poppins-Regular-normal');
  //            doc.setTextColor('#000');
  //            doc.text(this.newsectorInfo[j].cabinClass + "(" + this.newsectorInfo[j].rbd + ")", this.cabinClassX, this.cabinClassY, { baseline: 'top' });

  //            doc.setFontSize(10);
  //            doc.setFont('Poppins-Regular-normal');
  //            doc.setTextColor('#000');
  //            var flighn = this.newsectorInfo[j].airlinePrefixCode + (this.newsectorInfo[j].flightNumber).toString();
  //            doc.text(flighn, this.airlineCodeX - 18, this.airlineCodeY, { baseline: 'top' });

  //            doc.setFontSize(10);
  //            doc.setFont('Poppins-Regular-normal');
  //            doc.setTextColor('#000');
  //            doc.text(this.newsectorInfo[j].departureTime.substring(0, 5), this.fromAirportX - 25, this.fromAirportY, { baseline: 'top' });

  //            doc.setFontSize(10);
  //            doc.setFont('Poppins-Regular-normal');
  //            doc.setTextColor('#000');
  //            doc.text(this.newsectorInfo[j].arrivalTime.substring(0, 5), this.toAirportX - 10, this.toAirportY, { baseline: 'top' });



  //            doc.setLineWidth(0.8);
  //            doc.setDrawColor(169, 169, 169);
  //            doc.line(this.desX - 25, this.desY, this.desX + 60, this.desY);
  //            doc.setDrawColor(255, 170, 0);
  //            doc.circle(this.desX - 25, this.desY, 1.5, 'F');
  //            doc.setDrawColor(255, 170, 0);
  //            doc.circle(this.desX + 60, this.desY, 1.5, 'F');
  //            doc.setDrawColor(169, 169, 169);


  //            doc.setFontSize(10);
  //            doc.setFont('Poppins-Regular-normal');
  //            doc.setTextColor(105, 105, 105);
  //            for (let j = 0; j < this.newsectorInfo.length; j++) {
  //              doc.text(this.newsectorInfo[j].noOfStops + " Stops", this.noStopsX, this.noStopsY, { baseline: 'top' });
  //            }

  //            doc.setFontSize(8);
  //            doc.setTextColor('#000');
  //            doc.setFont('Poppins-Regular-normal');
  //            doc.text(this.newsectorInfo[j].fromCity + " (" + this.newsectorInfo[j].fromAirport + ")", this.fromCityX - 25, this.fromCityY, { baseline: 'top' });


  //            doc.setFontSize(8);
  //            doc.setTextColor('#000');
  //            doc.setFont('Poppins-Regular-normal');
  //            doc.text(this.newsectorInfo[j].fromAirportName, this.fromCityX - 25, this.fromCityY + 4, { baseline: 'top' });

  //            doc.setFontSize(8);
  //            doc.setTextColor('#000');
  //            doc.setFont('Poppins-Regular-normal');
  //            let formattedDepartureDate = new DatePipe('en-US').transform(this.newsectorInfo[j].departureDate, 'dd-MM-yyyy');

  //            doc.text(formattedDepartureDate, this.airlineCodeX + 2, this.airlineCodeY + 4.5, { baseline: 'top' });


  //            if (this.newsectorInfo[j].departureTerminal != null && this.newsectorInfo[j].departureTerminal != undefined && this.newsectorInfo[j].departureTerminal != "") {
  //              doc.setFontSize(8);
  //              doc.setTextColor('#000');
  //              doc.setFont('Poppins-Regular-normal');
  //              doc.text("Terminal:" + this.newsectorInfo[j].departureTerminal, this.airlineCodeX + 2, this.airlineCodeY + 8, { baseline: 'top' });
  //            }
  //            else {
  //              doc.setFontSize(8);
  //              doc.setTextColor('#000');
  //              doc.setFont('Poppins-Regular-normal');
  //              doc.text("Terminal:" + "", this.airlineCodeX + 2, this.airlineCodeY + 8, { baseline: 'top' });
  //            }


  //            doc.setFontSize(8);
  //            doc.setTextColor('#000');
  //            doc.setFont('Poppins-Regular-normal');
  //            doc.text(this.newsectorInfo[j].toCity + " (" + this.newsectorInfo[j].toAirport + ")", this.toCityX - 10, this.toCityY, { baseline: 'top' });

  //            doc.setFontSize(8);
  //            doc.setTextColor('#000');
  //            doc.setFont('Poppins-Regular-normal');
  //            doc.text(this.newsectorInfo[j].toAirportName, this.toCityX - 10, this.toCityY + 4, { baseline: 'top' });

  //            doc.setFontSize(8);
  //            doc.setTextColor('#000');
  //            doc.setFont('Poppins-Regular-normal');
  //            let formattedArrivalDate = new DatePipe('en-US').transform(this.newsectorInfo[j].arrivalDate, 'dd-MM-yyyy');
  //            doc.text(formattedArrivalDate, this.airlineCodeX + 87, this.airlineCodeY + 4.5, { baseline: 'top' });

  //            if (this.newsectorInfo[j].arrivalTerminal != null && this.newsectorInfo[j].arrivalTerminal != undefined && this.newsectorInfo[j].arrivalTerminal != "") {
  //              doc.setFontSize(8);
  //              doc.setTextColor('#000');
  //              doc.setFont('Poppins-Regular-normal');
  //              doc.text("Terminal:" + this.newsectorInfo[j].arrivalTerminal, this.airlineCodeX + 87, this.airlineCodeY + 8, { baseline: 'top' });
  //            }
  //            else {
  //              doc.setFontSize(8);
  //              doc.setTextColor('#000');
  //              doc.setFont('Poppins-Regular-normal');
  //              doc.text("Terminal:" + "", this.airlineCodeX + 87, this.airlineCodeY + 8, { baseline: 'top' });
  //            }



  //            if (j == 0) {
  //              doc.setFontSize(9);
  //              doc.setFont('Poppins-Regular-normal');
  //              doc.setTextColor('#000');
  //              doc.text(" SPNR: " + this.bookingInfo.supplierLocatorCode, this.pnrX, this.pnrY - 15, { baseline: 'top' });
  //            }




  //            this.airlineNameY = this.airlineNameY + 22;
  //            this.airlineCodeY = this.airlineCodeY + 22;
  //            this.airBusTypeY = this.airBusTypeY + 22;
  //            this.fromCityY = this.fromCityY + 22;
  //            this.fromAirportY = this.fromAirportY + 22;
  //            this.departDateY = this.departDateY + 22;
  //            this.toCityY = this.toCityY + 22;
  //            this.toAirportY = this.toAirportY + 22;
  //            this.arrivalDateY = this.arrivalDateY + 22;
  //            this.cabinClassY = this.cabinClassY + 22;
  //            this.noStopsY = this.noStopsY + 22;
  //            this.pnrY = this.pnrY + 22;
  //            this.pnrY1 = this.pnrY1 + 32;
  //            this.desY = this.desY + 22;
  //            this.flightLogoY = this.flightLogoY + 22;
  //            this.fromAirportY1 = this.fromAirportY1 + 22;
  //            this.pnrsY = this.pnrsY + 22;
  //          }

  //          doc.setLineWidth(0.8);
  //          doc.setDrawColor(255, 170, 0);
  //          doc.line(10, this.pnrY, doc.internal.pageSize.width - 10, this.pnrY);


  //          doc.setDrawColor(107, 107, 107);
  //          doc.setFillColor(227, 227, 227);
  //          doc.roundedRect(84, this.pnrY + 2, 35, 7, 1, 1, 'F')

  //          doc.setFontSize(12);
  //          doc.setFont('Poppins-Regular-normal-bold');
  //          doc.setTextColor('#000');
  //          doc.text("Booking Details ", 87, this.pnrY + 3.5, { baseline: 'top' });

  //          this.paxInfoY = this.pnrY + 15;
  //          var bodyData = [];

  //          this.passengerBaggage.forEach((el, index, array) => {
  //            bodyData.push([el.fromAirport.trim() + '        ' + el.toAirport, el.firstName + ' ' + el.lastName + " (" + el.typeName + ")", el.baggageCheckIn, el.baggageCabin, el.ticketNo, el.seatNum, el.meal])
  //          })

  //          autoTable(doc, {
  //            head: [['Sector', 'Traveller', 'CheckIn', 'Cabin', 'E-Ticket', 'Seat', 'Meal']],
  //            headStyles: { fillColor: [255, 170, 0], textColor: [255, 255, 255], halign: "center", fontStyle: "bold" },
  //            body: bodyData,
  //            didDrawCell: (data) => {
  //              doc.setDrawColor(0, 0, 0);
  //              doc.rect(data.cell.x, data.cell.y, data.cell.width, data.cell.height, 'S');

  //              if (data.section === 'body' && data.column.index === 0) {
  //                doc.addImage(sectorIcon, 'png', data.cell.x + 10, data.cell.y + 2, 0, 4);
  //              }
  //            },
  //            columnStyles: {
  //              0: { fontSize: 9, fontStyle: 'bold', valign: 'middle' },
  //              1: { fontSize: 9, fontStyle: 'bold', valign: 'middle', halign: 'center' },
  //              2: { fontSize: 9, valign: 'middle', halign: 'center' },
  //              3: { fontSize: 9, valign: 'middle', halign: 'center' },
  //              4: { fontSize: 9, valign: 'middle', halign: 'center' },
  //              5: { fontSize: 9, valign: 'middle', halign: 'center' },
  //              6: { fontSize: 9, valign: 'middle', halign: 'center' },
  //              7: { fontSize: 9, valign: 'middle', halign: 'center' },
  //            },
  //            startY: this.paxInfoY,
  //            theme: 'plain',
  //          });



  //          let finalYs = (doc as any).lastAutoTable.finalY;
  //          let agencyys1: number;
  //          agencyys1 = finalYs;



  //          if (type) {
  //            var bodyData2 = [];

  //            this.bookingPassengerInfo.forEach((els, index, array) => {
  //              bodyData2.push([els.firstName + ' ' + els.lastName + " (" + els.typeName + ")", els.exchangeCurrency + " " + els.baseFare, els.exchangeCurrency + " " + els.serviceCharges, els.exchangeCurrency + " " + (els.totalTaxes + els.markup + els.runtimeMarkup), els.exchangeCurrency + " " + els.netFromCustomer])
  //            })


  //            autoTable(doc, {
  //              head: [['Passenger Name', 'Fare', 'Paid Services', 'Taxes & Fees', 'Total']],
  //              headStyles: { fillColor: [255, 170, 0], textColor: [255, 255, 255], halign: "center", fontStyle: "bold" },
  //              body: bodyData2,
  //              didDrawCell: (data) => {
  //                doc.setDrawColor(0, 0, 0);
  //                doc.rect(data.cell.x, data.cell.y, data.cell.width, data.cell.height, 'S');
  //              },
  //              columnStyles: {
  //                0: { fontSize: 9, valign: 'middle', textColor: [0, 0, 0], fontStyle: 'bold', halign: 'center' },
  //                1: { fontSize: 9, valign: 'middle', halign: 'center' },
  //                2: { fontSize: 9, valign: 'middle', halign: 'center' },
  //                3: { fontSize: 9, valign: 'middle', halign: 'center' },
  //                4: { fontSize: 9, valign: 'middle', halign: 'center' },
  //              },
  //              startY: agencyys1 + 15,
  //              theme: 'plain',
  //            });

  //            doc.setDrawColor(107, 107, 107);
  //            doc.setFillColor(227, 227, 227);
  //            doc.roundedRect(84, agencyys1 + 2, 37, 7, 1, 1, 'F');

  //            doc.setFontSize(12);
  //            doc.setFont('Poppins-Regular-normal-bold');
  //            doc.setTextColor('#000');
  //            doc.text("Passenger Details", 87, agencyys1 + 3.5, { baseline: 'top' });


  //          }

  //          let finalYs1 = (doc as any).lastAutoTable.finalY;
  //          let agencyys: number;
  //          agencyys = finalYs1 + 5;
  //          this.agRectY = agencyys;


  //          const remainingSpace = doc.internal.pageSize.height - 10 - this.agRectY;
  //          const requiredSpace = 30;
  //          if (remainingSpace < requiredSpace) {
  //            doc.addPage();
  //            this.agRectY = 10;
  //          }



  //          doc.setDrawColor(107, 107, 107);
  //          doc.setFillColor(227, 227, 227);
  //          doc.rect(12, this.agRectY, 185, 9, 'F');

  //          doc.setDrawColor(213, 213, 213);
  //          doc.line(100, this.agRectY + 3, 100, this.agRectY + 3);


  //          //Consultant Info
  //          doc.setFontSize(10);
  //          doc.setFont('Poppins-Regular-normal');
  //          doc.setTextColor('#000');
  //          doc.text("Consultant ", 15, this.agRectY + 3, { baseline: 'top' });

  //          doc.setFontSize(10);
  //          doc.setFont('Poppins-Regular-normal');
  //          doc.setTextColor('#000');
  //          doc.text("Company Name: " + this.agencyOnline.agencyName + ", " + this.agencyOnline.city, 15, this.agRectY + 10, { baseline: 'top' });

  //          doc.setFontSize(10);
  //          doc.setFont('Poppins-Regular-normal');
  //          doc.setTextColor('#000');
  //          doc.text("Address: " + this.agencyOnline.address1 + this.agencyOnline.address2, 15, this.agRectY + 15, { baseline: 'top' });

  //          doc.setFontSize(10);
  //          doc.setFont('Poppins-Regular-normal');
  //          doc.setTextColor('#000');
  //          doc.text("Tel: " + this.agencyOnline.telephoneNumber, 15, this.agRectY + 20, { baseline: 'top' });

  //          doc.setFontSize(10);
  //          doc.setFont('Poppins-Regular-normal');
  //          doc.setTextColor('#000');
  //          doc.text("Email: " + this.agencyOnline.emailAddress, 15, this.agRectY + 25, { baseline: 'top' });



  //          doc.setFontSize(10);
  //          doc.setFont('Poppins-Regular-normal');
  //          doc.setTextColor('#000');
  //          doc.text("Agent Name: " + this.userOnline.firstName + " " + this.userOnline.lastName, 15, this.agRectY + 30, { baseline: 'top' });


  //          doc.setFontSize(10);
  //          doc.setFont('Poppins-Regular-normal');
  //          doc.setTextColor('#000');
  //          doc.text("Tel: " + this.userOnline.mobile, 15, this.agRectY + 35, { baseline: 'top' });

  //          doc.setFontSize(10);
  //          doc.setFont('Poppins-Regular-normal');
  //          doc.setTextColor('#000');
  //          doc.text("Email: " + this.userOnline.email, 15, this.agRectY + 40, { baseline: 'top' });




  //          //doc.setFontSize(10);
  //          //doc.setFont('Poppins-Regular-normal');
  //          //doc.setTextColor('#000');
  //          //doc.text(this.agencyOnline.agencyName + ", " + this.agencyOnline.city, 110, this.agRectY + 3, { baseline: 'top' });

  //          //const address1Lines = doc.splitTextToSize(this.agencyOnline.address1, 100);
  //          //const address2Lines = doc.splitTextToSize(this.agencyOnline.address2, 100);

  //          //const lineHeight = 2;

  //          //let currentY = this.agRectY + 10;

  //          //doc.setFontSize(10);
  //          //doc.setFont('Poppins-Regular-normal');
  //          //doc.setTextColor('#000');
  //          //doc.text(address1Lines, 100, currentY, { baseline: 'top' });

  //          //currentY += address1Lines.length * lineHeight + 4;

  //          //doc.text(address2Lines, 100, currentY, { baseline: 'top' });

  //          //currentY += address2Lines.length * lineHeight + 4;

  //          //doc.text("Tel: " + this.agencyOnline.telephoneNumber, 100, currentY, { baseline: 'top' });

  //          //currentY += lineHeight + 3;

  //          //doc.text("Email: " + this.agencyOnline.emailAddress, 100, currentY, { baseline: 'top' });

  //        }

  //      })
  //      .then(() => {
  //        this.hideBtnLoader();
  //        doc.save('Booking Itinerary' + '_' + this.bookingInfo.bookingID);
  //      });


  //  }
  //  catch (e) {
  //    //////console.log (e);
  //  }

  //}


  // old print ticket function, before revamping. Still here for usage untill new one is asked for usage.
  printItinerary1Old(type: boolean, alleach: string) {
    try {

      this.showBtnLoader();


      let sectorIcon = '../../assets/img/printsectoricon.png';
      let OneWayImage = '../../assets/img/take-off-24.png';
      let twowayImage = '../../assets/img/printsectoricon.png';

      //let sectorIcon = '../../assets/img/printsectoricon.png';
      //let OneWayImage = '../../assets/img/OneWayImage.png';
      //let twowayImage = '../../assets/img/RoundWayImage.png';

      this.flightLogoX = 10;
      this.flightLogoY = 40;
      this.airlineNameX = 33;



      // ======= Asad Working ============
      this.airlineNameY = 40;
      // ======= Asad Working ============

      this.airlineCodeX = 33;
      this.airlineCodeY = 53;
      this.airBusTypeX = 20;
      this.airBusTypeY = 80;
      this.fromCityX = 60;
      this.fromCityY = 50;
      this.fromAirportX = 60;
      this.fromAirportY = 45;
      this.fromAirportX1 = 75;
      this.fromAirportY1 = 45;
      this.departDateX = 61;
      this.departDateY = 80;
      this.toCityX = 130;
      this.toCityY = 50;
      this.toAirportX = 143;
      this.toAirportY = 45;
      this.arrivalDateX = 123;
      this.arrivalDateY = 80;
      this.cabinClassX = 175;
      this.cabinClassY = 45;
      this.noStopsX = 160;
      this.noStopsY = 45;
      this.pnrX = 174;
      this.pnrY = 50;
      this.pnrY1 = 32;
      this.desX = 71;
      this.desY = 47;
      this.cityRouteX = 10;
      this.sectSpace = 0;
      this.iterationWidth = 0
      this.pnrsX = 174;
      this.pnrsY = 50;
      let bookingDateString = this.bookingInfo.bookingDate;

      let bookingDate = new Date(bookingDateString);

      let fullDateFormat = bookingDate.toLocaleString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });




      let doc = new jsPDF("p", "mm", "a4");

      doc.setLineWidth(1);
      doc.rect(5, 5, doc.internal.pageSize.width - 10, doc.internal.pageSize.height - 10);


      doc.setFontSize(7);
      doc.addFileToVFS('Poppins-Regular-normal.ttf', this.font);
      doc.addFont('Poppins-Regular-normal.ttf', 'Poppins-Regular-normal', 'normal');
      doc.setFont('Poppins-Regular-normal');


      exportDataGrid({
        jsPDFDocument: doc,
        component: this.dataGrid3.instance,
        autoTableOptions: {
          border: {
            borderRight: 0,
            borderLeft: 0
          },
          margin: {
            top: 0,
          },
          headStyles: {
            textColor: "#FFF",
            fontSize: 8
          },

          bodyStyles: {
            textColor: "#000",
            fontSize: 7
          },
        }
      } as any)



        .then(async () => {



          if (this.bookingPassengerInfo.length >= 1) {



            let agencyLogoName = this.agencyOnline.logoFileName;
            let imgType = agencyLogoName.substring(agencyLogoName.lastIndexOf(".") + 1);
            var imageString = 'data:image/' + imgType + ';base64,' + this.agencyOnline.logoFilePath;


            doc.addImage(imageString, imgType, 170, 10, 25, 15);


            if (this.newsectorInfo.length == 1) {
              doc.setFontSize(14);
              doc.setFont('csvsdvsd', 'bold');
              doc.setTextColor(0, 0, 0);

              doc.text(this.newsectorInfo[0].fromAirport, this.cityRouteX, 10, { baseline: 'top' });


              this.iterationWidth = doc.getTextWidth(this.newsectorInfo[0].fromAirport) + 10;
              this.cityRouteX = this.iterationWidth + 3;

              doc.addImage(OneWayImage, 'png', this.cityRouteX, 10, 5, 5);

              this.iterationWidth = doc.getTextWidth(this.newsectorInfo[0].fromAirport) + 10;
              this.cityRouteX = this.iterationWidth + 10;
              doc.text(this.newsectorInfo[0].toAirport, this.cityRouteX, 10, { baseline: 'top' });
            }
            else if (this.newsectorInfo.length > 1) {
              doc.setFontSize(10);
              doc.setFont('csvsdvsd', 'bold');
              doc.setTextColor(0, 0, 0);

              this.cityRouteX = 10;

              for (let i = 0; i < this.newsectorInfo.length; i++) {
                const sector = this.newsectorInfo[i];

                doc.text(sector.fromAirport, this.cityRouteX, 10, { baseline: 'top' });

                this.cityRouteX += 8;

                doc.addImage(twowayImage, 'png', this.cityRouteX, 10, 0, 4);
                this.cityRouteX += 5;

                doc.text(sector.toAirport, this.cityRouteX, 10, { baseline: 'top' });
                this.cityRouteX += 10;
              }
            }


            doc.setFontSize(11);
            doc.setFont('Poppins-Regular-normal');
            doc.setTextColor('#000');
            var bookingid = (this.bookingInfo.finalBuyerID).toString() + "-" + (this.bookingInfo.bookingID).toString();
            doc.text("Booking ID: " + bookingid, 10, 20, { baseline: 'top' });



            doc.setFontSize(11);
            doc.setFont('Poppins-Regular-normal');
            doc.setTextColor('#000');
            doc.text("PNR: " + this.bookingInfo.pnr, 10, 25, { baseline: 'top' });

            doc.setFontSize(12);
            doc.setFont('Poppins-Regular-normal');
            doc.setTextColor('#000');
            doc.text("" + this.bookingStatus, 140, 25, { baseline: 'top' });


            doc.setFontSize(12);
            doc.setFont('Poppins-Regular-normal');
            doc.setTextColor(105, 105, 105);
            doc.text("" + fullDateFormat, 10, 15, { baseline: 'top' });


            doc.setLineWidth(0.8);
            doc.setDrawColor(255, 170, 0);
            doc.line(10, 30, doc.internal.pageSize.width - 10, 30);


            doc.setDrawColor(107, 107, 107);
            doc.setFillColor(227, 227, 227);
            doc.roundedRect(88, 32, 22, 8, 1, 1, 'F')


            doc.setFontSize(12);
            doc.setFont('Poppins-Regular-normal-bold');
            doc.setTextColor('#000');
            doc.text("Itinerary ", 90, 34, { baseline: 'top' });

            // Airline Details
            for (let j = 0; j < this.newsectorInfo.length; j++) {


              let flightLogoPath = 'assets/img/' + this.newsectorInfo[j].airlineLogo;

              if (this.newsectorInfo[j].airlineLogo.includes(".svg")) {

                const canvass = document.createElement('canvas');
                canvass.width = 200;
                canvass.height = 200;
                const ctx = canvass.getContext('2d');
                const v = await Canvg.from(ctx, flightLogoPath);

                v.start();
                var processedFlightLogo = canvass.toDataURL("img/png");

                doc.addImage(processedFlightLogo, 'png', this.flightLogoX, this.flightLogoY, 15, 10);
              } else {
                doc.addImage("assets/img/" + this.newsectorInfo[j].airlineLogo, 'png', this.flightLogoX, this.flightLogoY, 15, 10);
              }



              doc.setFontSize(9);
              doc.setFont('Poppins-Regular-normal');
              doc.setTextColor('#000');
              doc.text(this.newsectorInfo[j].cabinClass + "(" + this.newsectorInfo[j].rbd + ")", this.cabinClassX, this.cabinClassY, { baseline: 'top' });

              doc.setFontSize(10);
              doc.setFont('Poppins-Regular-normal');
              doc.setTextColor('#000');
              var flighn = this.newsectorInfo[j].airlinePrefixCode + (this.newsectorInfo[j].flightNumber).toString();
              doc.text(flighn, this.airlineCodeX - 18, this.airlineCodeY, { baseline: 'top' });

              doc.setFontSize(10);
              doc.setFont('Poppins-Regular-normal');
              doc.setTextColor('#000');
              doc.text(this.newsectorInfo[j].departureTime.substring(0, 5), this.fromAirportX - 25, this.fromAirportY, { baseline: 'top' });

              doc.setFontSize(10);
              doc.setFont('Poppins-Regular-normal');
              doc.setTextColor('#000');
              doc.text(this.newsectorInfo[j].arrivalTime.substring(0, 5), this.toAirportX - 10, this.toAirportY, { baseline: 'top' });



              doc.setLineWidth(0.8);
              doc.setDrawColor(169, 169, 169);
              doc.line(this.desX - 25, this.desY, this.desX + 60, this.desY);
              doc.setDrawColor(255, 170, 0);
              doc.circle(this.desX - 25, this.desY, 1.5, 'F');
              doc.setDrawColor(255, 170, 0);
              doc.circle(this.desX + 60, this.desY, 1.5, 'F');
              doc.setDrawColor(169, 169, 169);


              doc.setFontSize(10);
              doc.setFont('Poppins-Regular-normal');
              doc.setTextColor(105, 105, 105);
              for (let j = 0; j < this.newsectorInfo.length; j++) {
                doc.text(this.newsectorInfo[j].noOfStops + " Stops", this.noStopsX, this.noStopsY, { baseline: 'top' });
              }

              doc.setFontSize(8);
              doc.setTextColor('#000');
              doc.setFont('Poppins-Regular-normal');
              doc.text(this.newsectorInfo[j].fromCity + " (" + this.newsectorInfo[j].fromAirport + ")", this.fromCityX - 25, this.fromCityY, { baseline: 'top' });


              doc.setFontSize(8);
              doc.setTextColor('#000');
              doc.setFont('Poppins-Regular-normal');
              doc.text(this.newsectorInfo[j].fromAirportName, this.fromCityX - 25, this.fromCityY + 4, { baseline: 'top' });

              doc.setFontSize(8);
              doc.setTextColor('#000');
              doc.setFont('Poppins-Regular-normal');
              let formattedDepartureDate = new DatePipe('en-US').transform(this.newsectorInfo[j].departureDate, 'dd-MM-yyyy');

              doc.text(formattedDepartureDate, this.airlineCodeX + 2, this.airlineCodeY + 4.5, { baseline: 'top' });


              if (this.newsectorInfo[j].departureTerminal != null && this.newsectorInfo[j].departureTerminal != undefined && this.newsectorInfo[j].departureTerminal != "") {
                doc.setFontSize(8);
                doc.setTextColor('#000');
                doc.setFont('Poppins-Regular-normal');
                doc.text("Terminal:" + this.newsectorInfo[j].departureTerminal, this.airlineCodeX + 2, this.airlineCodeY + 8, { baseline: 'top' });
              }
              else {
                doc.setFontSize(8);
                doc.setTextColor('#000');
                doc.setFont('Poppins-Regular-normal');
                doc.text("Terminal:" + "", this.airlineCodeX + 2, this.airlineCodeY + 8, { baseline: 'top' });
              }


              doc.setFontSize(8);
              doc.setTextColor('#000');
              doc.setFont('Poppins-Regular-normal');
              doc.text(this.newsectorInfo[j].toCity + " (" + this.newsectorInfo[j].toAirport + ")", this.toCityX - 10, this.toCityY, { baseline: 'top' });

              doc.setFontSize(8);
              doc.setTextColor('#000');
              doc.setFont('Poppins-Regular-normal');
              doc.text(this.newsectorInfo[j].toAirportName, this.toCityX - 10, this.toCityY + 4, { baseline: 'top' });

              doc.setFontSize(8);
              doc.setTextColor('#000');
              doc.setFont('Poppins-Regular-normal');
              let formattedArrivalDate = new DatePipe('en-US').transform(this.newsectorInfo[j].arrivalDate, 'dd-MM-yyyy');
              doc.text(formattedArrivalDate, this.airlineCodeX + 87, this.airlineCodeY + 4.5, { baseline: 'top' });

              if (this.newsectorInfo[j].arrivalTerminal != null && this.newsectorInfo[j].arrivalTerminal != undefined && this.newsectorInfo[j].arrivalTerminal != "") {
                doc.setFontSize(8);
                doc.setTextColor('#000');
                doc.setFont('Poppins-Regular-normal');
                doc.text("Terminal:" + this.newsectorInfo[j].arrivalTerminal, this.airlineCodeX + 87, this.airlineCodeY + 8, { baseline: 'top' });
              }
              else {
                doc.setFontSize(8);
                doc.setTextColor('#000');
                doc.setFont('Poppins-Regular-normal');
                doc.text("Terminal:" + "", this.airlineCodeX + 87, this.airlineCodeY + 8, { baseline: 'top' });
              }



              if (j == 0) {
                doc.setFontSize(9);
                doc.setFont('Poppins-Regular-normal');
                doc.setTextColor('#000');
                doc.text(" SPNR: " + this.bookingInfo.supplierLocatorCode, this.pnrX, this.pnrY - 15, { baseline: 'top' });
              }




              this.airlineNameY = this.airlineNameY + 22;
              this.airlineCodeY = this.airlineCodeY + 22;
              this.airBusTypeY = this.airBusTypeY + 22;
              this.fromCityY = this.fromCityY + 22;
              this.fromAirportY = this.fromAirportY + 22;
              this.departDateY = this.departDateY + 22;
              this.toCityY = this.toCityY + 22;
              this.toAirportY = this.toAirportY + 22;
              this.arrivalDateY = this.arrivalDateY + 22;
              this.cabinClassY = this.cabinClassY + 22;
              this.noStopsY = this.noStopsY + 22;
              this.pnrY = this.pnrY + 22;
              this.pnrY1 = this.pnrY1 + 32;
              this.desY = this.desY + 22;
              this.flightLogoY = this.flightLogoY + 22;
              this.fromAirportY1 = this.fromAirportY1 + 22;
              this.pnrsY = this.pnrsY + 22;
            }

            doc.setLineWidth(0.8);
            doc.setDrawColor(255, 170, 0);
            doc.line(10, this.pnrY, doc.internal.pageSize.width - 10, this.pnrY);


            doc.setDrawColor(107, 107, 107);
            doc.setFillColor(227, 227, 227);
            doc.roundedRect(84, this.pnrY + 2, 35, 7, 1, 1, 'F')

            doc.setFontSize(12);
            doc.setFont('Poppins-Regular-normal-bold');
            doc.setTextColor('#000');
            doc.text("Booking Details ", 87, this.pnrY + 3.5, { baseline: 'top' });

            this.paxInfoY = this.pnrY + 15;
            var bodyData = [];

            this.passengerBaggage.forEach((el, index, array) => {
              bodyData.push([el.fromAirport.trim() + '        ' + el.toAirport, el.firstName + ' ' + el.lastName + " (" + el.typeName + ")", el.baggageCheckIn, el.baggageCabin, el.ticketNo, el.seatNum, el.meal])
            })

            autoTable(doc, {
              head: [['Sector', 'Traveller', 'CheckIn', 'Cabin', 'E-Ticket', 'Seat', 'Meal']],
              headStyles: { fillColor: [255, 170, 0], textColor: [255, 255, 255], halign: "center", fontStyle: "bold" },
              body: bodyData,
              didDrawCell: (data) => {
                doc.setDrawColor(0, 0, 0);
                doc.rect(data.cell.x, data.cell.y, data.cell.width, data.cell.height, 'S');

                if (data.section === 'body' && data.column.index === 0) {
                  doc.addImage(sectorIcon, 'png', data.cell.x + 10, data.cell.y + 2, 0, 4);
                }
              },
              columnStyles: {
                0: { fontSize: 9, fontStyle: 'bold', valign: 'middle' },
                1: { fontSize: 9, fontStyle: 'bold', valign: 'middle', halign: 'center' },
                2: { fontSize: 9, valign: 'middle', halign: 'center' },
                3: { fontSize: 9, valign: 'middle', halign: 'center' },
                4: { fontSize: 9, valign: 'middle', halign: 'center' },
                5: { fontSize: 9, valign: 'middle', halign: 'center' },
                6: { fontSize: 9, valign: 'middle', halign: 'center' },
                7: { fontSize: 9, valign: 'middle', halign: 'center' },
              },
              startY: this.paxInfoY,
              theme: 'plain',
            });



            let finalYs = (doc as any).lastAutoTable.finalY;
            let agencyys1: number;
            agencyys1 = finalYs;



            if (type) {
              var bodyData2 = [];

              this.bookingPassengerInfo.forEach((els, index, array) => {
                bodyData2.push([els.firstName + ' ' + els.lastName + " (" + els.typeName + ")", els.exchangeCurrency + " " + els.baseFare, els.exchangeCurrency + " " + els.serviceCharges, els.exchangeCurrency + " " + (els.totalTaxes + els.markup + els.runtimeMarkup), els.exchangeCurrency + " " + els.netFromCustomer])
              })


              autoTable(doc, {
                head: [['Passenger Name', 'Fare', 'Paid Services', 'Taxes & Fees', 'Total']],
                headStyles: { fillColor: [255, 170, 0], textColor: [255, 255, 255], halign: "center", fontStyle: "bold" },
                body: bodyData2,
                didDrawCell: (data) => {
                  doc.setDrawColor(0, 0, 0);
                  doc.rect(data.cell.x, data.cell.y, data.cell.width, data.cell.height, 'S');
                },
                columnStyles: {
                  0: { fontSize: 9, valign: 'middle', textColor: [0, 0, 0], fontStyle: 'bold', halign: 'center' },
                  1: { fontSize: 9, valign: 'middle', halign: 'center' },
                  2: { fontSize: 9, valign: 'middle', halign: 'center' },
                  3: { fontSize: 9, valign: 'middle', halign: 'center' },
                  4: { fontSize: 9, valign: 'middle', halign: 'center' },
                },
                startY: agencyys1 + 15,
                theme: 'plain',
              });

              doc.setDrawColor(107, 107, 107);
              doc.setFillColor(227, 227, 227);
              doc.roundedRect(84, agencyys1 + 2, 37, 7, 1, 1, 'F');

              doc.setFontSize(12);
              doc.setFont('Poppins-Regular-normal-bold');
              doc.setTextColor('#000');
              doc.text("Passenger Details", 87, agencyys1 + 3.5, { baseline: 'top' });


            }

            let finalYs1 = (doc as any).lastAutoTable.finalY;
            let agencyys: number;
            agencyys = finalYs1 + 5;
            this.agRectY = agencyys;


            const remainingSpace = doc.internal.pageSize.height - 10 - this.agRectY;
            const requiredSpace = 30;
            if (remainingSpace < requiredSpace) {
              doc.addPage();
              this.agRectY = 10;
            }



            doc.setDrawColor(107, 107, 107);
            doc.setFillColor(227, 227, 227);
            doc.rect(12, this.agRectY, 185, 9, 'F');

            doc.setDrawColor(213, 213, 213);
            doc.line(100, this.agRectY + 3, 100, this.agRectY + 3);


            //Consultant Info
            doc.setFontSize(10);
            doc.setFont('Poppins-Regular-normal');
            doc.setTextColor('#000');
            doc.text("Consultant ", 15, this.agRectY + 3, { baseline: 'top' });

            doc.setFontSize(10);
            doc.setFont('Poppins-Regular-normal');
            doc.setTextColor('#000');
            doc.text("Company Name: " + this.agencyOnline.agencyName + ", " + this.agencyOnline.city, 15, this.agRectY + 10, { baseline: 'top' });

            doc.setFontSize(10);
            doc.setFont('Poppins-Regular-normal');
            doc.setTextColor('#000');
            doc.text("Address: " + this.agencyOnline.address1 + this.agencyOnline.address2, 15, this.agRectY + 15, { baseline: 'top' });

            doc.setFontSize(10);
            doc.setFont('Poppins-Regular-normal');
            doc.setTextColor('#000');
            doc.text("Tel: " + this.agencyOnline.telephoneNumber, 15, this.agRectY + 20, { baseline: 'top' });

            doc.setFontSize(10);
            doc.setFont('Poppins-Regular-normal');
            doc.setTextColor('#000');
            doc.text("Email: " + this.agencyOnline.emailAddress, 15, this.agRectY + 25, { baseline: 'top' });



            doc.setFontSize(10);
            doc.setFont('Poppins-Regular-normal');
            doc.setTextColor('#000');
            doc.text("Agent Name: " + this.userOnline.firstName + " " + this.userOnline.lastName, 15, this.agRectY + 30, { baseline: 'top' });


            doc.setFontSize(10);
            doc.setFont('Poppins-Regular-normal');
            doc.setTextColor('#000');
            doc.text("Tel: " + this.userOnline.mobile, 15, this.agRectY + 35, { baseline: 'top' });

            doc.setFontSize(10);
            doc.setFont('Poppins-Regular-normal');
            doc.setTextColor('#000');
            doc.text("Email: " + this.userOnline.email, 15, this.agRectY + 40, { baseline: 'top' });




            //doc.setFontSize(10);
            //doc.setFont('Poppins-Regular-normal');
            //doc.setTextColor('#000');
            //doc.text(this.agencyOnline.agencyName + ", " + this.agencyOnline.city, 110, this.agRectY + 3, { baseline: 'top' });

            //const address1Lines = doc.splitTextToSize(this.agencyOnline.address1, 100);
            //const address2Lines = doc.splitTextToSize(this.agencyOnline.address2, 100);

            //const lineHeight = 2;

            //let currentY = this.agRectY + 10;

            //doc.setFontSize(10);
            //doc.setFont('Poppins-Regular-normal');
            //doc.setTextColor('#000');
            //doc.text(address1Lines, 100, currentY, { baseline: 'top' });

            //currentY += address1Lines.length * lineHeight + 4;

            //doc.text(address2Lines, 100, currentY, { baseline: 'top' });

            //currentY += address2Lines.length * lineHeight + 4;

            //doc.text("Tel: " + this.agencyOnline.telephoneNumber, 100, currentY, { baseline: 'top' });

            //currentY += lineHeight + 3;

            //doc.text("Email: " + this.agencyOnline.emailAddress, 100, currentY, { baseline: 'top' });

          }

        })
        .then(() => {
          this.hideBtnLoader();
          doc.save('Booking Itinerary' + '_' + this.bookingInfo.bookingID);
        });


    }
    catch (e) {
      //////console.log (e);
    }

  }


  // old email ticket function (used to send itinerary via email), before revamping. Still here for usage untill new one is asked for usage.
  emailItineraryFinanceOld(type: boolean, alleach: string) {
    try {
      if (this.emailRegex == false) {
        document.getElementById("messageEmail").innerHTML = 'Please Follow The Pattern';
        setTimeout(() => { document.getElementById("messageEmail").innerHTML = ''; }, 5000);
        return;
      }
      this.isLoadPanelVisible = true;
      this.showBtnLoader();


      let sectorIcon = '../../assets/img/printsectoricon.png';
      let OneWayImage = '../../assets/img/take-off-24.png';
      let twowayImage = '../../assets/img/printsectoricon.png';

      //let sectorIcon = '../../assets/img/printsectoricon.png';
      //let OneWayImage = '../../assets/img/OneWayImage.png';
      //let twowayImage = '../../assets/img/RoundWayImage.png';

      this.flightLogoX = 10;
      this.flightLogoY = 40;
      this.airlineNameX = 33;



      // ======= Asad Working ============
      this.airlineNameY = 40;
      // ======= Asad Working ============

      this.airlineCodeX = 33;
      this.airlineCodeY = 53;
      this.airBusTypeX = 20;
      this.airBusTypeY = 80;
      this.fromCityX = 60;
      this.fromCityY = 50;
      this.fromAirportX = 60;
      this.fromAirportY = 45;
      this.fromAirportX1 = 75;
      this.fromAirportY1 = 45;
      this.departDateX = 61;
      this.departDateY = 80;
      this.toCityX = 130;
      this.toCityY = 50;
      this.toAirportX = 143;
      this.toAirportY = 45;
      this.arrivalDateX = 123;
      this.arrivalDateY = 80;
      this.cabinClassX = 175;
      this.cabinClassY = 45;
      this.noStopsX = 160;
      this.noStopsY = 45;
      this.pnrX = 174;
      this.pnrY = 50;
      this.pnrY1 = 32;
      this.desX = 71;
      this.desY = 47;
      this.cityRouteX = 10;
      this.sectSpace = 0;
      this.iterationWidth = 0
      this.pnrsX = 174;
      this.pnrsY = 50;
      let bookingDateString = this.bookingInfo.bookingDate;

      let bookingDate = new Date(bookingDateString);

      let fullDateFormat = bookingDate.toLocaleString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });




      let doc = new jsPDF("p", "mm", "a4");

      doc.setLineWidth(1);
      doc.rect(5, 5, doc.internal.pageSize.width - 10, doc.internal.pageSize.height - 10);


      doc.setFontSize(7);
      doc.addFileToVFS('Poppins-Regular-normal.ttf', this.font);
      doc.addFont('Poppins-Regular-normal.ttf', 'Poppins-Regular-normal', 'normal');
      doc.setFont('Poppins-Regular-normal');


      exportDataGrid({
        jsPDFDocument: doc,
        component: this.dataGrid3.instance,
        autoTableOptions: {
          border: {
            borderRight: 0,
            borderLeft: 0
          },
          margin: {
            top: 0,
          },
          headStyles: {
            textColor: "#FFF",
            fontSize: 8
          },

          bodyStyles: {
            textColor: "#000",
            fontSize: 7
          },
        }
      } as any)



        .then(async () => {



          if (this.bookingPassengerInfo.length >= 1) {



            let agencyLogoName = this.agencyOnline.logoFileName;
            let imgType = agencyLogoName.substring(agencyLogoName.lastIndexOf(".") + 1);
            var imageString = 'data:image/' + imgType + ';base64,' + this.agencyOnline.logoFilePath;


            doc.addImage(imageString, imgType, 170, 10, 25, 15);


            if (this.newsectorInfo.length == 1) {
              doc.setFontSize(14);
              doc.setFont('csvsdvsd', 'bold');
              doc.setTextColor(0, 0, 0);

              doc.text(this.newsectorInfo[0].fromAirport, this.cityRouteX, 10, { baseline: 'top' });


              this.iterationWidth = doc.getTextWidth(this.newsectorInfo[0].fromAirport) + 10;
              this.cityRouteX = this.iterationWidth + 3;

              doc.addImage(OneWayImage, 'png', this.cityRouteX, 10, 5, 5);

              this.iterationWidth = doc.getTextWidth(this.newsectorInfo[0].fromAirport) + 10;
              this.cityRouteX = this.iterationWidth + 10;
              doc.text(this.newsectorInfo[0].toAirport, this.cityRouteX, 10, { baseline: 'top' });
            }
            else if (this.newsectorInfo.length > 1) {
              doc.setFontSize(10);
              doc.setFont('csvsdvsd', 'bold');
              doc.setTextColor(0, 0, 0);

              this.cityRouteX = 10;

              for (let i = 0; i < this.newsectorInfo.length; i++) {
                const sector = this.newsectorInfo[i];

                doc.text(sector.fromAirport, this.cityRouteX, 10, { baseline: 'top' });

                this.cityRouteX += 8;

                doc.addImage(twowayImage, 'png', this.cityRouteX, 10, 0, 4);
                this.cityRouteX += 5;

                doc.text(sector.toAirport, this.cityRouteX, 10, { baseline: 'top' });
                this.cityRouteX += 10;
              }
            }


            doc.setFontSize(11);
            doc.setFont('Poppins-Regular-normal');
            doc.setTextColor('#000');
            var bookingid = (this.bookingInfo.finalBuyerID).toString() + "-" + (this.bookingInfo.bookingID).toString();
            doc.text("Booking ID: " + bookingid, 10, 20, { baseline: 'top' });



            doc.setFontSize(11);
            doc.setFont('Poppins-Regular-normal');
            doc.setTextColor('#000');
            doc.text("PNR: " + this.bookingInfo.pnr, 10, 25, { baseline: 'top' });

            doc.setFontSize(12);
            doc.setFont('Poppins-Regular-normal');
            doc.setTextColor('#000');
            doc.text("" + this.bookingStatus, 140, 25, { baseline: 'top' });


            doc.setFontSize(12);
            doc.setFont('Poppins-Regular-normal');
            doc.setTextColor(105, 105, 105);
            doc.text("" + fullDateFormat, 10, 15, { baseline: 'top' });


            doc.setLineWidth(0.8);
            doc.setDrawColor(255, 170, 0);
            doc.line(10, 30, doc.internal.pageSize.width - 10, 30);


            doc.setDrawColor(107, 107, 107);
            doc.setFillColor(227, 227, 227);
            doc.roundedRect(88, 32, 22, 8, 1, 1, 'F')


            doc.setFontSize(12);
            doc.setFont('Poppins-Regular-normal-bold');
            doc.setTextColor('#000');
            doc.text("Itinerary ", 90, 34, { baseline: 'top' });

            // Airline Details
            for (let j = 0; j < this.newsectorInfo.length; j++) {


              let flightLogoPath = 'assets/img/' + this.newsectorInfo[j].airlineLogo;

              if (this.newsectorInfo[j].airlineLogo.includes(".svg")) {

                const canvass = document.createElement('canvas');
                canvass.width = 200;
                canvass.height = 200;
                const ctx = canvass.getContext('2d');
                const v = await Canvg.from(ctx, flightLogoPath);

                v.start();
                var processedFlightLogo = canvass.toDataURL("img/png");

                doc.addImage(processedFlightLogo, 'png', this.flightLogoX, this.flightLogoY, 15, 10);
              } else {
                doc.addImage("assets/img/" + this.newsectorInfo[j].airlineLogo, 'png', this.flightLogoX, this.flightLogoY, 15, 10);
              }



              doc.setFontSize(9);
              doc.setFont('Poppins-Regular-normal');
              doc.setTextColor('#000');
              doc.text(this.newsectorInfo[j].cabinClass + "(" + this.newsectorInfo[j].rbd + ")", this.cabinClassX, this.cabinClassY, { baseline: 'top' });

              doc.setFontSize(10);
              doc.setFont('Poppins-Regular-normal');
              doc.setTextColor('#000');
              var flighn = this.newsectorInfo[j].airlinePrefixCode + (this.newsectorInfo[j].flightNumber).toString();
              doc.text(flighn, this.airlineCodeX - 18, this.airlineCodeY, { baseline: 'top' });

              doc.setFontSize(10);
              doc.setFont('Poppins-Regular-normal');
              doc.setTextColor('#000');
              doc.text(this.newsectorInfo[j].departureTime.substring(0, 5), this.fromAirportX - 25, this.fromAirportY, { baseline: 'top' });

              doc.setFontSize(10);
              doc.setFont('Poppins-Regular-normal');
              doc.setTextColor('#000');
              doc.text(this.newsectorInfo[j].arrivalTime.substring(0, 5), this.toAirportX - 10, this.toAirportY, { baseline: 'top' });



              doc.setLineWidth(0.8);
              doc.setDrawColor(169, 169, 169);
              doc.line(this.desX - 25, this.desY, this.desX + 60, this.desY);
              doc.setDrawColor(255, 170, 0);
              doc.circle(this.desX - 25, this.desY, 1.5, 'F');
              doc.setDrawColor(255, 170, 0);
              doc.circle(this.desX + 60, this.desY, 1.5, 'F');
              doc.setDrawColor(169, 169, 169);


              doc.setFontSize(10);
              doc.setFont('Poppins-Regular-normal');
              doc.setTextColor(105, 105, 105);
              for (let j = 0; j < this.newsectorInfo.length; j++) {
                doc.text(this.newsectorInfo[j].noOfStops + " Stops", this.noStopsX, this.noStopsY, { baseline: 'top' });
              }

              doc.setFontSize(8);
              doc.setTextColor('#000');
              doc.setFont('Poppins-Regular-normal');
              doc.text(this.newsectorInfo[j].fromCity + " (" + this.newsectorInfo[j].fromAirport + ")", this.fromCityX - 25, this.fromCityY, { baseline: 'top' });


              doc.setFontSize(8);
              doc.setTextColor('#000');
              doc.setFont('Poppins-Regular-normal');
              doc.text(this.newsectorInfo[j].fromAirportName, this.fromCityX - 25, this.fromCityY + 4, { baseline: 'top' });

              doc.setFontSize(8);
              doc.setTextColor('#000');
              doc.setFont('Poppins-Regular-normal');
              let formattedDepartureDate = new DatePipe('en-US').transform(this.newsectorInfo[j].departureDate, 'dd-MM-yyyy');

              doc.text(formattedDepartureDate, this.airlineCodeX + 2, this.airlineCodeY + 4.5, { baseline: 'top' });


              if (this.newsectorInfo[j].departureTerminal != null && this.newsectorInfo[j].departureTerminal != undefined && this.newsectorInfo[j].departureTerminal != "") {
                doc.setFontSize(8);
                doc.setTextColor('#000');
                doc.setFont('Poppins-Regular-normal');
                doc.text("Terminal:" + this.newsectorInfo[j].departureTerminal, this.airlineCodeX + 2, this.airlineCodeY + 8, { baseline: 'top' });
              }
              else {
                doc.setFontSize(8);
                doc.setTextColor('#000');
                doc.setFont('Poppins-Regular-normal');
                doc.text("Terminal:" + "", this.airlineCodeX + 2, this.airlineCodeY + 8, { baseline: 'top' });
              }


              doc.setFontSize(8);
              doc.setTextColor('#000');
              doc.setFont('Poppins-Regular-normal');
              doc.text(this.newsectorInfo[j].toCity + " (" + this.newsectorInfo[j].toAirport + ")", this.toCityX - 10, this.toCityY, { baseline: 'top' });

              doc.setFontSize(8);
              doc.setTextColor('#000');
              doc.setFont('Poppins-Regular-normal');
              doc.text(this.newsectorInfo[j].toAirportName, this.toCityX - 10, this.toCityY + 4, { baseline: 'top' });

              doc.setFontSize(8);
              doc.setTextColor('#000');
              doc.setFont('Poppins-Regular-normal');
              let formattedArrivalDate = new DatePipe('en-US').transform(this.newsectorInfo[j].arrivalDate, 'dd-MM-yyyy');
              doc.text(formattedArrivalDate, this.airlineCodeX + 87, this.airlineCodeY + 4.5, { baseline: 'top' });

              if (this.newsectorInfo[j].arrivalTerminal != null && this.newsectorInfo[j].arrivalTerminal != undefined && this.newsectorInfo[j].arrivalTerminal != "") {
                doc.setFontSize(8);
                doc.setTextColor('#000');
                doc.setFont('Poppins-Regular-normal');
                doc.text("Terminal:" + this.newsectorInfo[j].arrivalTerminal, this.airlineCodeX + 87, this.airlineCodeY + 8, { baseline: 'top' });
              }
              else {
                doc.setFontSize(8);
                doc.setTextColor('#000');
                doc.setFont('Poppins-Regular-normal');
                doc.text("Terminal:" + "", this.airlineCodeX + 87, this.airlineCodeY + 8, { baseline: 'top' });
              }



              if (j == 0) {
                doc.setFontSize(9);
                doc.setFont('Poppins-Regular-normal');
                doc.setTextColor('#000');
                doc.text(" SPNR: " + this.bookingInfo.supplierLocatorCode, this.pnrX, this.pnrY - 15, { baseline: 'top' });
              }




              this.airlineNameY = this.airlineNameY + 22;
              this.airlineCodeY = this.airlineCodeY + 22;
              this.airBusTypeY = this.airBusTypeY + 22;
              this.fromCityY = this.fromCityY + 22;
              this.fromAirportY = this.fromAirportY + 22;
              this.departDateY = this.departDateY + 22;
              this.toCityY = this.toCityY + 22;
              this.toAirportY = this.toAirportY + 22;
              this.arrivalDateY = this.arrivalDateY + 22;
              this.cabinClassY = this.cabinClassY + 22;
              this.noStopsY = this.noStopsY + 22;
              this.pnrY = this.pnrY + 22;
              this.pnrY1 = this.pnrY1 + 32;
              this.desY = this.desY + 22;
              this.flightLogoY = this.flightLogoY + 22;
              this.fromAirportY1 = this.fromAirportY1 + 22;
              this.pnrsY = this.pnrsY + 22;
            }

            doc.setLineWidth(0.8);
            doc.setDrawColor(255, 170, 0);
            doc.line(10, this.pnrY, doc.internal.pageSize.width - 10, this.pnrY);


            doc.setDrawColor(107, 107, 107);
            doc.setFillColor(227, 227, 227);
            doc.roundedRect(84, this.pnrY + 2, 35, 7, 1, 1, 'F')

            doc.setFontSize(12);
            doc.setFont('Poppins-Regular-normal-bold');
            doc.setTextColor('#000');
            doc.text("Booking Details ", 87, this.pnrY + 3.5, { baseline: 'top' });

            this.paxInfoY = this.pnrY + 15;
            var bodyData = [];

            this.passengerBaggage.forEach((el, index, array) => {
              bodyData.push([el.fromAirport.trim() + '        ' + el.toAirport, el.firstName + ' ' + el.lastName + " (" + el.typeName + ")", el.baggageCheckIn, el.baggageCabin, el.ticketNo, el.seatNum, el.meal])
            })

            autoTable(doc, {
              head: [['Sector', 'Traveller', 'CheckIn', 'Cabin', 'E-Ticket', 'Seat', 'Meal']],
              headStyles: { fillColor: [255, 170, 0], textColor: [255, 255, 255], halign: "center", fontStyle: "bold" },
              body: bodyData,
              didDrawCell: (data) => {
                doc.setDrawColor(0, 0, 0);
                doc.rect(data.cell.x, data.cell.y, data.cell.width, data.cell.height, 'S');

                if (data.section === 'body' && data.column.index === 0) {
                  doc.addImage(sectorIcon, 'png', data.cell.x + 10, data.cell.y + 2, 0, 4);
                }
              },
              columnStyles: {
                0: { fontSize: 9, fontStyle: 'bold', valign: 'middle' },
                1: { fontSize: 9, fontStyle: 'bold', valign: 'middle', halign: 'center' },
                2: { fontSize: 9, valign: 'middle', halign: 'center' },
                3: { fontSize: 9, valign: 'middle', halign: 'center' },
                4: { fontSize: 9, valign: 'middle', halign: 'center' },
                5: { fontSize: 9, valign: 'middle', halign: 'center' },
                6: { fontSize: 9, valign: 'middle', halign: 'center' },
                7: { fontSize: 9, valign: 'middle', halign: 'center' },
              },
              startY: this.paxInfoY,
              theme: 'plain',
            });



            let finalYs = (doc as any).lastAutoTable.finalY;
            let agencyys1: number;
            agencyys1 = finalYs;



            if (type) {
              var bodyData2 = [];

              this.bookingPassengerInfo.forEach((els, index, array) => {
                bodyData2.push([els.firstName + ' ' + els.lastName + " (" + els.typeName + ")", els.exchangeCurrency + " " + els.baseFare, els.exchangeCurrency + " " + els.serviceCharges, els.exchangeCurrency + " " + (els.totalTaxes + els.markup + els.runtimeMarkup), els.exchangeCurrency + " " + els.netFromCustomer])
              })


              autoTable(doc, {
                head: [['Passenger Name', 'Fare', 'Paid Services', 'Taxes & Fees', 'Total']],
                headStyles: { fillColor: [255, 170, 0], textColor: [255, 255, 255], halign: "center", fontStyle: "bold" },
                body: bodyData2,
                didDrawCell: (data) => {
                  doc.setDrawColor(0, 0, 0);
                  doc.rect(data.cell.x, data.cell.y, data.cell.width, data.cell.height, 'S');
                },
                columnStyles: {
                  0: { fontSize: 9, valign: 'middle', textColor: [0, 0, 0], fontStyle: 'bold', halign: 'center' },
                  1: { fontSize: 9, valign: 'middle', halign: 'center' },
                  2: { fontSize: 9, valign: 'middle', halign: 'center' },
                  3: { fontSize: 9, valign: 'middle', halign: 'center' },
                  4: { fontSize: 9, valign: 'middle', halign: 'center' },
                },
                startY: agencyys1 + 15,
                theme: 'plain',
              });

              doc.setDrawColor(107, 107, 107);
              doc.setFillColor(227, 227, 227);
              doc.roundedRect(84, agencyys1 + 2, 37, 7, 1, 1, 'F');

              doc.setFontSize(12);
              doc.setFont('Poppins-Regular-normal-bold');
              doc.setTextColor('#000');
              doc.text("Passenger Details", 87, agencyys1 + 3.5, { baseline: 'top' });


            }

            let finalYs1 = (doc as any).lastAutoTable.finalY;
            let agencyys: number;
            agencyys = finalYs1 + 5;
            this.agRectY = agencyys;


            const remainingSpace = doc.internal.pageSize.height - 10 - this.agRectY;
            const requiredSpace = 30;
            if (remainingSpace < requiredSpace) {
              doc.addPage();
              this.agRectY = 10;
            }



            doc.setDrawColor(107, 107, 107);
            doc.setFillColor(227, 227, 227);
            doc.rect(12, this.agRectY, 185, 9, 'F');

            doc.setDrawColor(213, 213, 213);
            doc.line(100, this.agRectY + 3, 100, this.agRectY + 3);


            //Consultant Info
            doc.setFontSize(10);
            doc.setFont('Poppins-Regular-normal');
            doc.setTextColor('#000');
            doc.text("Consultant ", 15, this.agRectY + 3, { baseline: 'top' });

            doc.setFontSize(10);
            doc.setFont('Poppins-Regular-normal');
            doc.setTextColor('#000');
            doc.text("Company Name: " + this.agencyOnline.agencyName + ", " + this.agencyOnline.city, 15, this.agRectY + 10, { baseline: 'top' });

            doc.setFontSize(10);
            doc.setFont('Poppins-Regular-normal');
            doc.setTextColor('#000');
            doc.text("Address: " + this.agencyOnline.address1 + this.agencyOnline.address2, 15, this.agRectY + 15, { baseline: 'top' });

            doc.setFontSize(10);
            doc.setFont('Poppins-Regular-normal');
            doc.setTextColor('#000');
            doc.text("Tel: " + this.agencyOnline.telephoneNumber, 15, this.agRectY + 20, { baseline: 'top' });

            doc.setFontSize(10);
            doc.setFont('Poppins-Regular-normal');
            doc.setTextColor('#000');
            doc.text("Email: " + this.agencyOnline.emailAddress, 15, this.agRectY + 25, { baseline: 'top' });



            doc.setFontSize(10);
            doc.setFont('Poppins-Regular-normal');
            doc.setTextColor('#000');
            doc.text("Agent Name: " + this.userOnline.firstName + " " + this.userOnline.lastName, 15, this.agRectY + 30, { baseline: 'top' });


            doc.setFontSize(10);
            doc.setFont('Poppins-Regular-normal');
            doc.setTextColor('#000');
            doc.text("Tel: " + this.userOnline.mobile, 15, this.agRectY + 35, { baseline: 'top' });

            doc.setFontSize(10);
            doc.setFont('Poppins-Regular-normal');
            doc.setTextColor('#000');
            doc.text("Email: " + this.userOnline.email, 15, this.agRectY + 40, { baseline: 'top' });

          }

        })
        .then(() => {
          this.hideBtnLoader();
          let pdf = doc.output('blob');
          //////console.log (pdf);
          this.ticketEmailObj.subject = "Your E-Ticket is Here";
          let pdfFile = new File([pdf], "pdfFile", { type: "application/pdf" });
          //////console.log (pdfFile);
          var formData = new FormData();

          formData.append("subject", this.ticketEmailObj.subject);
          formData.append("customerEmail", this.ticketEmailObj.customerEmail);
          formData.append("agencyId", localStorage.getItem("AgencyId"));
          formData.append("pdfFile", pdfFile, `Booking Itinerary_${this.bookingInfo.bookingID}`)
          /* doc.save('Booking Itinerary' + '_' + this.bookingInfo.bookingID + '.pdf');*/

          this.emailService.emailIterniaryMulti(formData).subscribe((data) => {
            //      //////console.log (data);
            this.isLoadPanelVisible = false;
            if (data == true) {
              this.NewSuccess.dismissAll();
            }
            else {
              document.getElementById("messageEmail").innerHTML = 'Please Try Again!';
              setTimeout(() => { document.getElementById("messageEmail").innerHTML = ''; }, 5000);
            }
          })
        });


    }
    catch (e) {
      this.isLoadPanelVisible = false;
      //////console.log (e);
    }

  }



  flightSearchProperties: FlightSearchProperties = new FlightSearchProperties();
  classifySectors(flightSearchDestinations: FlightSearchDestinationProperties[], sectors: SectorInformationProperties[]) {
    const OnewaySectors: SectorInformationProperties[] = [];
    const RoundTripSectors: SectorInformationProperties[] = [];
    const MultiCitySectors: { flightInfo: string; sectorInfo: SectorInformationProperties[], multiStopsAt: string[] }[] = [];
    const isRoundTrip = flightSearchDestinations.length === 2 && this.bookingInfo.galileoBookingProp.flightProp.tripType === "single-round";
    const isMulti = flightSearchDestinations.length > 1 && this.bookingInfo.galileoBookingProp.flightProp.tripType === "multi";
    const oneWayFrom = flightSearchDestinations[0].fromAirport.split("-")[1].split("-")[0].trim();
    const oneWayTo = flightSearchDestinations[0].toAirport.split("-")[1].split("-")[0].trim();

    let returnFrom = "";
    let returnTo = "";

    if (isRoundTrip) {
      returnFrom = flightSearchDestinations[1].fromAirport.split("-")[1].split("-")[0].trim();
      returnTo = flightSearchDestinations[1].toAirport.split("-")[1].split("-")[0].trim();
    }

    function getJourneySectorsOWRT(journeyFrom: string, journeyTo: string, processedSectors: Set<number>): SectorInformationProperties[] {
      let journeySectors: SectorInformationProperties[] = [];
      let currentCity = journeyFrom;
      let remainingSectors = sectors.filter((s) => !processedSectors.has(s.id));

      while (true) {
        let nextSector = remainingSectors.find((s) => s.fromCity === currentCity);
        if (!nextSector) break;

        processedSectors.add(nextSector.id);
        journeySectors.push(nextSector);
        currentCity = nextSector.toCity;

        if (currentCity === journeyTo) break;
      }
      return journeySectors;
    }
    function findSectorsForMultiCityJourney(journeyFrom: string, journeyTo: string, processedSectorsMulti: Set<number>): SectorInformationProperties[] {
      let journeySectors: SectorInformationProperties[] = [];
      let currentCity = journeyFrom;
      let remainingSectors = sectors.filter((s) => !processedSectorsMulti.has(s.id));

      while (true) {
        let nextSector = remainingSectors.find((s) => s.fromCity === currentCity);
        if (!nextSector) break;

        processedSectorsMulti.add(nextSector.id);
        journeySectors.push(nextSector);
        currentCity = nextSector.toCity;

        if (currentCity === journeyTo) break;
      }
      return journeySectors;
    }

    let processedSectors = new Set<number>();
    let processedSectorsMulti = new Set<number>();

    if (!isMulti) {

      let oneWaySectors = getJourneySectorsOWRT(oneWayFrom, oneWayTo, processedSectors);
      OnewaySectors.push(...oneWaySectors);
      if (isRoundTrip) {
        let roundTripSectors = getJourneySectorsOWRT(returnFrom, returnTo, processedSectors);
        RoundTripSectors.push(...roundTripSectors);
      }
      return { OnewaySectors, RoundTripSectors, MultiCitySectors, isRoundTrip, isMulti };
    } else {

      for (let i = 0; i < flightSearchDestinations.length; i++) {
        const currentFlight = flightSearchDestinations[i];
        let currentFlightFromAirportCity = currentFlight.fromAirport.split("-")[1].split("-")[0].trim();
        let currentFlightToAirportCity = currentFlight.toAirport.split("-")[1].split("-")[0].trim();
        let stopsAt: string[] = [];
        let flightSectors = findSectorsForMultiCityJourney(currentFlightFromAirportCity, currentFlightToAirportCity, processedSectorsMulti);

        for (let ind = 0; ind < flightSectors.length; ind++) {
          if (ind != flightSectors.length - 1) {
            stopsAt.push(flightSectors[ind].toCity);
          } else {
            continue;
          }
        };
        MultiCitySectors.push({
          flightInfo: `${currentFlightFromAirportCity} ----> ${currentFlightToAirportCity}`,
          sectorInfo: flightSectors,
          multiStopsAt: stopsAt
        });
      }

      return { OnewaySectors, RoundTripSectors, MultiCitySectors, isRoundTrip, isMulti };
    }
  }


  private loadLogos(sectors: SectorInformationProperties[]): Promise<any[]> {
    const imagePromises = sectors.map(sector => this.convertLogo('assets/img/' + sector.airlineLogo));
    return Promise.all(imagePromises);
  }
  private convertLogo(flightLogoPath: string): Promise<string> {
    return new Promise((resolve, reject) => {
      let binary = '';
      if (flightLogoPath.endsWith(".svg")) {
        this.http.get(flightLogoPath, { responseType: 'text' }).subscribe(
          async (data: string) => {
            resolve(data);
          },
          error => {
            resolve(null);
          }
        );
      } else {
        this.http.get(flightLogoPath, { responseType: 'arraybuffer' }).subscribe(
          (data: ArrayBuffer) => {
            try {
              let bytes = new Uint8Array(data);
              let length = bytes.byteLength;
              for (let i = 0; i < length; i++) {
                binary += String.fromCharCode(bytes[i]);
              }
              let base64 = window.btoa(binary);
              resolve(`data:image/png;base64,${base64}`);
            } catch (ex) {
              ////console.log (ex);
            }
          },
          error => {
            resolve(null);
          }
        );
      }
    });
  }
  convertImageToBase64(path: string): Promise<string> {
    return new Promise((resolve, reject) => {
      this.http.get(path, { responseType: 'arraybuffer' }).subscribe(
        (data: ArrayBuffer) => {
          try {
            let binary = '';
            let bytes = new Uint8Array(data);
            let len = bytes.byteLength;

            for (let i = 0; i < len; i++) {
              binary += String.fromCharCode(bytes[i]);
            }

            // Detect extension for MIME type
            let ext = path.split('.').pop().toLowerCase();
            let mime = (ext === 'jpg' || ext === 'jpeg') ? 'image/jpeg' :
              (ext === 'svg') ? 'image/svg+xml' : 'image/png';

            let base64 = window.btoa(binary);
            resolve(`data:${mime};base64,${base64}`);
          } catch (err) {
            reject(err);
          }
        },
        error => reject(error)
      );
    });
  }

  createSectorPassengerManifest(bookingPassengerInfoProperties: BookingPassengerInfoProperties[], locale: string): TicketPaxBaggageSectorSortedProperties[] {

    // Create a map to group by sector key
    const sectorMap = new Map<string, TicketPaxBaggageSectorSortedProperties>();

    // Track processed combinations to avoid duplicates
    const processedCombinations = new Set<string>();

    // Iterate through each passenger
    for (let pi = 0; pi < bookingPassengerInfoProperties.length; pi++) {
      const passenger = bookingPassengerInfoProperties[pi];

      // Iterate through each sector for this passenger
      for (let si = 0; si < passenger.sectorInformationProperties.length; si++) {
        const sector = passenger.sectorInformationProperties[si];

        // Create unique sector key (use more fields for uniqueness)
        const sectorKey = `${sector.fromAirport}-${sector.toAirport}-${sector.flightNumber}-${sector.departureDate.toString()}`;

        // Check if we've already added this passenger to this sector
        const combinationKey = `${sectorKey}-${passenger.passengerID}`;

        if (processedCombinations.has(combinationKey)) {
          continue; // Skip if already added
        }

        // Get or create sector group
        let sectorGroup = sectorMap.get(sectorKey);
        if (!sectorGroup) {
          sectorGroup = new TicketPaxBaggageSectorSortedProperties();
          sectorGroup.sector = `${sector.fromAirport} - ${sector.toAirport}`;
          sectorGroup.fromAirport = sector.fromAirport;
          sectorGroup.toAirport = sector.toAirport;
          sectorGroup.flightNo = sector.airlinePrefixCode ?
            `${sector.airlinePrefixCode}${sector.flightNumber}` :
            sector.flightNumber;
          sectorGroup.departureDate = formatDate(sector.departureDate, 'mediumDate', locale);
          sectorGroup.status = this.bookingInfo.bookingStatus.toString() || '';
          sectorMap.set(sectorKey, sectorGroup);
        }

        // Create passenger entry with sector-specific data
        const paxEntry = new TicketSortedPaxs();
        paxEntry.passengerID = passenger.passengerID;
        paxEntry.passengerType = passenger.passengerType;
        paxEntry.paxName = `${passenger.title} ${passenger.firstName} ${passenger.lastName}`.trim();

        // IMPORTANT: Use sector-specific data, not passenger-level data
        paxEntry.ticketNo = passenger.ticketNo || '-'; // Assuming ticketNo is at passenger level
        paxEntry.passportNo = passenger.passportNumber || '';
        paxEntry.mobileNo = passenger.mobile || '';

        // These should come from the sector (since they're sector-specific)
        paxEntry.seatNo = sector.seatNumber || 'any';
        paxEntry.meal = sector.meal || sector.mealname || '-';
        paxEntry.checkIn = sector.baggageCheckIn || '';
        paxEntry.cabin = sector.baggageCabin || '';

        sectorGroup.paxs.push(paxEntry);
        processedCombinations.add(combinationKey);
      }
    }

    // Convert map to array and sort if needed
    return Array.from(sectorMap.values());
  }

  agencyLogo = "";
  baggageImage = "";
  barcodeImage = "";
  attentionIcon = "";
  buildingIcon = "";
  agentIcon = "";
  passportIcon = "";
  planeIcon = "";
  luggageIcon = "";
  // new print function for ticket. Improved professional design, with data structure changes. This function is for both one way and return tickets. Could be printed with or without finances.
  printItinerary1(financeType: boolean, alleach: string) {
    let agencyLogoName = this.agencyOnline.logoFileName;
    let imgType = agencyLogoName.substring(agencyLogoName.lastIndexOf(".") + 1);
    this.agencyLogo = 'data:image/' + imgType + ';base64,' + this.agencyOnline.logoFilePath;
    this.convertImageToBase64('assets/barcode.png').then(base64 => {
      this.barcodeImage = base64;
    }).catch(err => {
      console.error('Error converting image:', err);
    });
    this.convertImageToBase64('assets/baggage.png').then(base64 => {
      this.baggageImage = base64;
    }).catch(err => {
      console.error('Error converting image:', err);
    });
    this.convertImageToBase64('assets/building.png').then(base64 => {
      this.buildingIcon = base64;
    }).catch(err => {
      console.error('Error converting image:', err);
    });
    this.convertImageToBase64('assets/online-support.png').then(base64 => {
      this.agentIcon = base64;
    }).catch(err => {
      console.error('Error converting image:', err);
    });
    this.convertImageToBase64('assets/passport.png').then(base64 => {
      this.passportIcon = base64;
    }).catch(err => {
      console.error('Error converting image:', err);
    });
    this.convertImageToBase64('assets/attention.png').then(base64 => {
      this.attentionIcon = base64;
    }).catch(err => {
      console.error('Error converting image:', err);
    });
    this.convertImageToBase64('assets/luggage.png').then(base64 => {
      this.luggageIcon = base64;
    }).catch(err => {
      console.error('Error converting image:', err);
    });
    this.convertImageToBase64('assets/ticketIcon.png').then(base64 => {
      this.planeIcon = base64;
    }).catch(err => {
      console.error('Error converting image:', err);
    });

    let bookingDateString = this.bookingInfo.creationTime.toString();
    let bookingDate = new Date(bookingDateString);
    let formatedBookingDate = bookingDate.toLocaleString('en-US', { year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
    let issuanceDate = new Date(this.bookingInfo.issuanceDateTime);
    let formatedIssuanceDate = issuanceDate.toLocaleString('en-US', { year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
    this.loadLogos(this.newsectorInfo).then(base64Logos => {
      for (let ln = 0; ln < base64Logos.length; ln++) {
        this.newsectorInfo[ln].airlineLogoTicket = base64Logos[ln];
      }
      const { OnewaySectors, RoundTripSectors, MultiCitySectors, isRoundTrip, isMulti } = this.classifySectors(this.flightSearchProperties.flightLocationInfo, this.newsectorInfo);
      let sortedBaggageInfo: TicketPaxBaggageSectorSortedProperties[] = [];
      sortedBaggageInfo = this.createSectorPassengerManifest(this.bookingInfo.bookingPassengerInfoProperties, this.locale);
      let onewayStopsAt: string[] = [];
      let returnStopsAt: string[] = [];
      for (let index = 0; index < OnewaySectors.length; index++) {
        if (index != OnewaySectors.length - 1) {
          onewayStopsAt.push(OnewaySectors[index].toCity);
        } else {
          continue;
        }
      };
      for (let index = 0; index < RoundTripSectors.length; index++) {
        if (index != RoundTripSectors.length - 1) {
          returnStopsAt.push(RoundTripSectors[index].toCity);
        } else {
          continue;
        }
      };

      const withoutEachContent = this.bookingPassengerInfo.map((item, index) => {
        return [
          //Doc header
          {
            columns: [
              {
                width: 'auto', text: "eTicket", bold: true, fontSize: 16
              },
              {
                width: '*', text: `${this.agencyOnline.agencyName}`, bold: false, fontSize: 12, alignment: 'center'
              },
              {
                width: 215, margin: [-20, 0, 0, 0],
                columns: [
                  {
                    text: [
                      { text: `SPNR \n`, bold: false, fontSize: 10 },
                      { text: `${this.bookingInfo.supplierLocatorCode != null ? this.bookingInfo.supplierLocatorCode : ''}`, bold: true, fontSize: 14, color: '#6A1717' }
                    ],
                    alignment: 'right',
                    width: 70
                  },
                  {
                    text: [
                      { text: `BOOKING REF. \n`, bold: false, fontSize: 10 },
                      { text: `${this.bookingInfo.pnr}`, bold: true, fontSize: 14, color: '#6A1717' }
                    ],
                    alignment: 'right',
                    width: 70
                  },
                  {
                    image: this.barcodeImage, width: 75, height: 30
                  },
                ]
              }
            ],
            columnGap: 10,
            border: [false, false, false, true]
          },
          {
            canvas: [
              {
                type: 'line',
                x1: 0, // Starting X coordinate (relative to the canvas's top-left)
                y1: 0, // Starting Y coordinate (relative to the canvas's top-left)
                x2: 515, // Ending X coordinate (adjust for desired length)
                y2: 0, // Ending Y coordinate (same as y1 for a horizontal line)
                lineWidth: 1, // Line thickness
                lineColor: 'black' // Line color (optional)
              }
            ], margin: [0, 5]
          },
          {
            columns: [
              { image: `${this.agencyLogo != null ? this.agencyLogo : ''}`, width: 60, height: 45 },
              {
                table: {
                  widths: [150, 150],
                  body: [
                    [
                      { text: `Reserved on ${formatedBookingDate}`, fontSize: 9 },
                      { text: `Ticketed on ${this.bookingStatus == "Ticketed" ? formatedIssuanceDate : "---"}`, fontSize: 9, alignment: 'right' }
                    ],
                    [
                      // Left cell
                      {
                        text: [
                          { text: "Booked By:\n", fontSize: 9 },
                          { text: `${this.userOnline.firstName} ${this.userOnline.lastName}`, fontSize: 11, bold: true, color: '#204D72' }
                        ]
                      },
                      // Right cell
                      {
                        stack: [
                          {
                            columns: [
                              { image: this.buildingIcon, width: 12, height: 12, margin: [10, 0, 0, 0], alignment: 'right' },
                              { text: "(Consultant)", fontSize: 10, alignment: 'right' }
                            ], columnGap: 0,           // disables pdfMake’s default gap
                            widths: ['auto', 'auto']
                          },
                          {
                            columns: [
                              { image: this.agentIcon, width: 12, height: 12, margin: [10, 0, 0, 0], alignment: 'right' },
                              { text: `${this.userOnline.mobile}`, fontSize: 10, bold: true, alignment: 'right', }
                            ], columnGap: 0,
                            widths: ['auto', 'auto']
                          }
                        ]
                      }
                    ]
                  ]
                }, layout: 'noBorders', margin: [140, 0, 0, 0]
              }
            ]
          },
          {
            canvas: [
              {
                type: 'line',
                x1: 0, // Starting X coordinate (relative to the canvas's top-left)
                y1: 0, // Starting Y coordinate (relative to the canvas's top-left)
                x2: 515, // Ending X coordinate (adjust for desired length)
                y2: 0, // Ending Y coordinate (same as y1 for a horizontal line)
                lineWidth: 1.5, // Line thickness
                lineColor: 'black' // Line color (optional)
              }
            ], margin: [0, 5]
          },

          // Passenger Information Table
          //{ text: 'Passenger Information', style: 'subHeader' },
          {
            table: {
              widths: ['auto', '*', '*', '*', '*'],
              body: [
                [{ text: 'passenger', fontSize: 9, bold: true }, { text: 'flight no', fontSize: 9, bold: true }, { text: 'route', fontSize: 9, bold: true }, { text: 'date', fontSize: 9, bold: true }, { text: 'status', fontSize: 9, bold: true }],
                ...sortedBaggageInfo.map(p => [
                  {
                    stack: [
                      { text: `${p.paxs[index].paxName}\n`, fontSize: 9, bold: true, color: '#444444' },
                      { columns: [{ image: this.passportIcon, width: 11, height: 11 }, { text: `${p.paxs[index].passportNo}\n`, fontSize: 9, bold: true, margin: [5, 0, 0, 0] }], columnGap: 1 },
                      { columns: [{ image: this.planeIcon, width: 11, height: 11 }, { text: `${p.paxs[index].ticketNo === null ? "-" : p.paxs[index].ticketNo} | seat: ${p.paxs[index].seatNo === null ? "any" : p.paxs[index].seatNo} | check-in: ${p.paxs[index].checkIn} | cabin: ${p.paxs[index].cabin} | meal: ${p.paxs[index].meal === null ? "-" : p.paxs[index].meal}`, fontSize: 9, bold: true, color: '#204D72', margin: [5, 0, 0, 0] }] }
                    ], alignment: 'left'
                  },
                  { text: p.flightNo === null ? "-" : p.flightNo, fontSize: 9, color: '#555555' },
                  { text: p.sector, fontSize: 9 },
                  { text: p.departureDate, fontSize: 9 },
                  { text: `${this.bookingStatus == "Ticketed" ? "Confirmed" : this.bookingStatus}`, fontSize: 9, color: "#555555" },
                ])
              ]
            },
            style: 'tableStyle',
            layout: 'lightHorizontalLines'
          },
          {
            canvas: [
              {
                type: 'line',
                x1: 0, // Starting X coordinate (relative to the canvas's top-left)
                y1: 0, // Starting Y coordinate (relative to the canvas's top-left)
                x2: 515, // Ending X coordinate (adjust for desired length)
                y2: 0, // Ending Y coordinate (same as y1 for a horizontal line)
                lineWidth: 1, // Line thickness
                lineColor: 'black' // Line color (optional)
              }
            ], margin: [0, 5]
          },
          {
            columns: [
              {
                columns:
                  [{ image: this.attentionIcon, width: 20, height: 20 },
                  {
                    text: [
                      { text: "NOTICE: ", fontSize: 9, bold: true },
                      { text: `Arrival at airport 3 hours before scheduled departure time on domestic flights and 4 hours before scheduled departure time on international flights. Check-in counters close 45 min before scheduled departure time for domestic, and 90minutes before scheduled departure time for international flights. Mobile check-in available now for domestic flights.\n`, fontSize: 9, bold: false },
                      { text: [{ text: `CHECK-IN BAG SIZE LIMIT `, fontSize: 9 }, { text: `${this.passengerBaggage[0].baggageCheckIn}\n`, fontSize: 9, bold: true }] },
                      { text: [{ text: `HAND CARRY BAG LIMIT `, fontSize: 9 }, { text: `${this.passengerBaggage[0].baggageCabin}\n`, fontSize: 9, bold: true }] },
                      { text: "NOTE: ", fontSize: 9, bold: true }, { text: `Excess baggage and payment is not accepted at check-in counters.\n`, fontSize: 9, bold: false },
                    ], width: '*'
                  }
                  ], alignment: 'left', columnGap: 3
              },
              { image: this.baggageImage, width: 96, height: 76 }
            ],
            columnGap: 5,
          },
          {
            canvas: [
              {
                type: 'line',
                x1: 0, // Starting X coordinate (relative to the canvas's top-left)
                y1: 0, // Starting Y coordinate (relative to the canvas's top-left)
                x2: 515, // Ending X coordinate (adjust for desired length)
                y2: 0, // Ending Y coordinate (same as y1 for a horizontal line)
                lineWidth: 1.5, // Line thickness
                lineColor: 'black' // Line color (optional)
              }
            ], margin: [0, 5]
          },
          { text: '\n' },
          OnewaySectors.length > 0 ? { text: [{ text: " ONWARD: ", style: 'itineraryHeaderLeft', fontSize: 11 }, { text: ` ${this.flightSearchProperties.flightLocationInfo[0].fromAirport.split('-')[1].split('-')[0]}  ---->  ${this.flightSearchProperties.flightLocationInfo[0].toAirport.split('-')[1].split('-')[0]}`, style: 'itineraryHeaderRight', fontSize: 11 }, { text: " | ", fontSize: 11, bold: true }, { text: `Stops: ${OnewaySectors[0].noOfStops}`, fontSize: 11, bold: true }, { text: onewayStopsAt.length > 0 ? ` (${onewayStopsAt.map(itm => itm).join(', ')}) ` : " ", fontSize: 11, bold: true }, { text: "| " + this.flightSearchProperties.cabinClass, fontSize: 11, bold: true }], color: '#204D72' } : {},
          OnewaySectors.length > 0 ? OnewaySectors.map((it, ind) => {
            return [
              {
                table: {
                  widths: [50, '*', '*', '*', /*50,*/ '*', '*'],
                  body: [
                    [{ text: '' }, ind == 0 ? { text: 'Flight No', bold: true, fontSize: 9 } : {}, ind == 0 ? { text: 'Origin', bold: true, fontSize: 9 } : {}, ind == 0 ? { text: 'Destination', bold: true, fontSize: 9 } : {}, /*ind == 0 ? { text: 'Duration', bold: true }:{},*/ ind == 0 ? { text: 'Dep. Date', bold: true, fontSize: 9 } : {}, ind == 0 ? { text: 'Arv. Date', bold: true, fontSize: 9 } : {}],
                    [it.airlineLogo.includes("svg") ? (it.airlineLogoTicket == null ? { text: it.airlineName, fontSize: 9, bold: true } : { svg: it.airlineLogoTicket, width: 50, height: 40 }) : (it.airlineLogoTicket == null ? { text: it.airlineName, fontSize: 7, bold: true } : { image: it.airlineLogoTicket, width: 36, height: 36 }),
                    { text: `${it.airlineName}\n(${it.airlinePrefixCode}${it.flightNumber})`, fontSize: 10 },
                    { text: [{ text: `${it.fromCity}\n`, fontSize: 10, color: '#204D72', bold: true }, { text: `${it.fromAirportName}\n`, fontSize: 7 }, { text: it.departureTerminal == null ? "" : it.departureTerminal, fontSize: 7, bold: true }] },
                    { text: [{ text: `${it.toCity}\n`, fontSize: 10, color: '#204D72', bold: true }, { text: `${it.toAirportName}\n`, fontSize: 7 }, { text: it.arrivalTerminal == null ? "" : it.arrivalTerminal, fontSize: 7, bold: true }] },
                    /*{ text: "-" },*/
                    { text: `${it.departureTime}\n${formatDate(it.departureDate, 'mediumDate', this.locale)}`, fontSize: 10 },
                    //{ text: `${it.departureTime}\n${it.departureDate}`},
                    { text: `${it.arrivalTime}\n${formatDate(it.arrivalDate, 'mediumDate', this.locale)}\n`, fontSize: 10 }
                      //{ text: `${it.arrivalTime}\n${it.arrivalDate}\n` }
                    ]
                  ]
                },
                style: 'tableStyle',
                layout: 'noBorders'
              }
            ];
          }) : [],

          isRoundTrip ? { text: [{ text: " RETURN: ", style: 'itineraryHeaderLeft' }, { text: ` ${this.flightSearchProperties.flightLocationInfo[1].fromAirport.split('-')[1].split('-')[0]}  ---->  ${this.flightSearchProperties.flightLocationInfo[1].toAirport.split('-')[1].split('-')[0]}`, style: 'itineraryHeaderRight' }, { text: " | ", fontSize: 11, bold: true }, { text: `Stops: ${RoundTripSectors[0].noOfStops}`, fontSize: 11, bold: true }, { text: returnStopsAt.length > 0 ? ` (${returnStopsAt.map(itm => itm).join(', ')}) ` : " ", fontSize: 11, bold: true }, { text: "| " + this.flightSearchProperties.cabinClass, fontSize: 11, bold: true }], color: '#204D72' } : {},
          isRoundTrip ? RoundTripSectors.map((it, ind) => {
            return [
              {
                table: {
                  widths: [50, '*', '*', '*', /*50,*/ '*', '*'],
                  body: [
                    [{ text: '' }, ind == 0 ? { text: 'Flight No', bold: true, fontSize: 9 } : {}, ind == 0 ? { text: 'Origin', bold: true, fontSize: 9 } : {}, ind == 0 ? { text: 'Destination', bold: true, fontSize: 9 } : {}, /*ind == 0 ? { text: 'Duration', bold: true }:{},*/ ind == 0 ? { text: 'Dep. Date', bold: true, fontSize: 9 } : {}, ind == 0 ? { text: 'Arv. Date', bold: true, fontSize: 9 } : {}],
                    [it.airlineLogo.includes("svg") ? (it.airlineLogoTicket == null ? { text: it.airlineName, fontSize: 9, bold: true } : { svg: it.airlineLogoTicket, width: 50, height: 40 }) : (it.airlineLogoTicket == null ? { text: it.airlineName, fontSize: 9, bold: true } : { image: it.airlineLogoTicket, width: 28, height: 21 }),
                    { text: `${it.airlineName}\n(${it.airlinePrefixCode}${it.flightNumber})`, fontSize: 10 },
                    { text: [{ text: `${it.fromCity}\n`, fontSize: 10, color: '#204D72', bold: true }, { text: `${it.fromAirportName}\n`, fontSize: 7 }, { text: it.departureTerminal == null ? "" : it.departureTerminal, fontSize: 7, bold: true }] },
                    { text: [{ text: `${it.toCity}\n`, fontSize: 10, color: '#204D72', bold: true }, { text: `${it.toAirportName}\n`, fontSize: 7 }, { text: it.arrivalTerminal == null ? "" : it.arrivalTerminal, fontSize: 7, bold: true }] },
                    /*{ text: "-" },*/
                    { text: `${it.departureTime}\n${formatDate(it.departureDate, 'mediumDate', this.locale)}`, fontSize: 10 },
                    { text: `${it.arrivalTime}\n${formatDate(it.arrivalDate, 'mediumDate', this.locale)}\n`, fontSize: 10 }]
                  ]
                },
                style: 'tableStyle',
                layout: 'noBorders'
              }
            ];
          }) : [],

          isMulti ? MultiCitySectors.map((oit) => {
            return [
              { text: [{ text: " ONWARD: ", style: 'itineraryHeaderLeft' }, { text: oit.flightInfo, style: 'itineraryHeaderRight' }, { text: " | ", fontSize: 11, bold: true }, { text: `Stops: ${oit.sectorInfo[0].noOfStops}`, fontSize: 11, bold: true }, { text: oit.multiStopsAt.length > 0 ? ` (${oit.multiStopsAt.map(itm => itm).join(', ')}) ` : " ", fontSize: 11, bold: true }, { text: "| " + this.flightSearchProperties.cabinClass, fontSize: 11, bold: true }], color: '#204D72' },
              {
                table: {
                  widths: [50, '*', '*', '*', /*50,*/ '*', '*'],
                  body: [
                    [{ text: '' }, { text: 'Flight No', bold: true, fontSize: 9 }, { text: 'Origin', bold: true, fontSize: 9 }, { text: 'Destination', bold: true, fontSize: 9 }, /*ind == 0 ? { text: 'Duration', bold: true }:{},*/ { text: 'Dep. Date', bold: true, fontSize: 9 }, { text: 'Arv. Date', bold: true, fontSize: 9 }],
                    ...oit.sectorInfo.map(iit =>
                      [
                        iit.airlineLogo.includes("svg") ? (iit.airlineLogoTicket == null ? { text: iit.airlineName, fontSize: 9, bold: true } : { svg: iit.airlineLogoTicket, width: 50, height: 40 }) : (iit.airlineLogoTicket == null ? { text: iit.airlineName, fontSize: 9, bold: true } : { image: iit.airlineLogoTicket, width: 28, height: 21 }),
                        { text: `${iit.airlineName}\n(${iit.airlinePrefixCode}${iit.flightNumber})`, fontSize: 10 },
                        { text: [{ text: `${iit.fromCity}\n`, fontSize: 10, color: '#204D72', bold: true }, { text: `${iit.fromAirportName}\n`, fontSize: 7 }, { text: iit.departureTerminal == null ? "" : iit.departureTerminal, fontSize: 7, bold: true }] },
                        { text: [{ text: `${iit.toCity}\n`, fontSize: 10, color: '#204D72', bold: true }, { text: `${iit.toAirportName}\n`, fontSize: 7 }, { text: iit.arrivalTerminal == null ? "" : iit.arrivalTerminal, fontSize: 7, bold: true }] },
                        /*{ text: "-" },*/
                        { text: `${iit.departureTime}\n${formatDate(iit.departureDate, 'mediumDate', this.locale)}`, fontSize: 10 },
                        { text: `${iit.arrivalTime}\n${formatDate(iit.arrivalDate, 'mediumDate', this.locale)}\n`, fontSize: 10 }
                      ]
                    )
                  ]
                },
                style: 'tableStyle',
                layout: 'noBorders'
              }
            ]
          }) : [],

          {
            canvas: [
              {
                type: 'line',
                x1: 0, // Starting X coordinate (relative to the canvas's top-left)
                y1: 0, // Starting Y coordinate (relative to the canvas's top-left)
                x2: 515, // Ending X coordinate (adjust for desired length)
                y2: 0, // Ending Y coordinate (same as y1 for a horizontal line)
                lineWidth: 1.5, // Line thickness
                lineColor: 'black' // Line color (optional)
              }
            ], margin: [0, 5]
          },
          { text: '', pageBreak: index < this.bookingPassengerInfo.length - 1 ? 'after' : undefined }, // Add page break except the last page
        ];
      });
      const withoutAllContent = [
        //Doc header
        {
          columns: [
            {
              width: 'auto', text: "eTicket", bold: true, fontSize: 16
            },
            {
              width: '*', text: `${this.agencyOnline.agencyName}`, bold: false, fontSize: 12, alignment: 'center'
            },
            {
              width: 215, margin: [-20, 0, 0, 0],
              columns: [
                {
                  text: [
                    { text: `SPNR \n`, bold: false, fontSize: 10 },
                    { text: `${this.bookingInfo.supplierLocatorCode != null ? this.bookingInfo.supplierLocatorCode : ''}`, bold: true, fontSize: 14, color: '#6A1717' }
                  ],
                  alignment: 'right',
                  width: 70
                },
                {
                  text: [
                    { text: `BOOKING REF. \n`, bold: false, fontSize: 10 },
                    { text: `${this.bookingInfo.pnr}`, bold: true, fontSize: 14, color: '#6A1717' }
                  ],
                  alignment: 'right',
                  width: 70
                },
                {
                  image: this.barcodeImage, width: 75, height: 30
                },
              ]
            }
          ],
          columnGap: 10,
          border: [false, false, false, true]
        },
        {
          canvas: [
            {
              type: 'line',
              x1: 0, // Starting X coordinate (relative to the canvas's top-left)
              y1: 0, // Starting Y coordinate (relative to the canvas's top-left)
              x2: 515, // Ending X coordinate (adjust for desired length)
              y2: 0, // Ending Y coordinate (same as y1 for a horizontal line)
              lineWidth: 1, // Line thickness
              lineColor: 'black' // Line color (optional)
            }
          ], margin: [0, 5]
        },
        //Agent and reservation info
        {
          columns: [
            { image: `${this.agencyLogo != null ? this.agencyLogo : ''}`, width: 60, height: 45 },
            {
              table: {
                widths: [150, 150],
                body: [
                  [
                    { text: `Reserved on ${formatedBookingDate}`, fontSize: 9 },
                    { text: `Ticketed on ${this.bookingStatus == "Ticketed" ? formatedIssuanceDate : "---"}`, fontSize: 9, alignment: 'right' }
                  ],
                  [
                    // Left cell
                    {
                      text: [
                        { text: "Booked By:\n", fontSize: 9 },
                        { text: `${this.userOnline.firstName} ${this.userOnline.lastName}`, fontSize: 11, bold: true, color: '#204D72' }
                      ]
                    },
                    // Right cell
                    {
                      stack: [
                        {
                          columns: [
                            { image: this.buildingIcon, width: 12, height: 12, margin: [10, 0, 0, 0], alignment: 'right' },
                            { text: "(Consultant)", fontSize: 10, alignment: 'right' }
                          ], columnGap: 0,           // disables pdfMake’s default gap
                          widths: ['auto', 'auto']
                        },
                        {
                          columns: [
                            { image: this.agentIcon, width: 12, height: 12, margin: [10, 0, 0, 0], alignment: 'right' },
                            { text: `${this.userOnline.mobile}`, fontSize: 10, bold: true, alignment: 'right', }
                          ], columnGap: 0,
                          widths: ['auto', 'auto']
                        }
                      ]
                    }
                  ]
                ]
              }, layout: 'noBorders', margin: [140, 0, 0, 0]
            }
          ]
        },
        {
          canvas: [
            {
              type: 'line',
              x1: 0, // Starting X coordinate (relative to the canvas's top-left)
              y1: 0, // Starting Y coordinate (relative to the canvas's top-left)
              x2: 515, // Ending X coordinate (adjust for desired length)
              y2: 0, // Ending Y coordinate (same as y1 for a horizontal line)
              lineWidth: 1.5, // Line thickness
              lineColor: 'black' // Line color (optional)
            }
          ], margin: [0, 5]
        },
        // Passenger Information Table
        {
          table: {
            widths: ['auto', '*', '*', '*', '*'],
            body: [
              [{ text: 'passenger', fontSize: 9, bold: true }, { text: 'flight no', fontSize: 9, bold: true }, { text: 'route', fontSize: 9, bold: true }, { text: 'date', fontSize: 9, bold: true }, { text: 'status', fontSize: 9, bold: true }],
              ...sortedBaggageInfo.map(p => [
                {
                  stack: p.paxs.map(nam => ({
                    stack: [
                      { text: nam.paxName, fontSize: 9, bold: true, color: '#444444' },

                      {
                        columns: [
                          { image: this.passportIcon, width: 10, height: 10, margin: [0, 0, 1, 0] },
                          { text: `${nam.passportNo}\n`, fontSize: 9, margin: [5, 0, 0, 0] }
                        ]
                      },
                      {
                        columns: [
                          { image: this.planeIcon, width: 10, height: 10, margin: [0, 0, 1, 0] },
                          { text: `${nam.ticketNo === null ? "-" : nam.ticketNo} | seat: ${nam.seatNo === null ? "any" : nam.seatNo} | check-in: ${nam.checkIn} | cabin: ${nam.cabin} | meal: ${nam.meal === null ? "-" : nam.meal}`, fontSize: 9, bold: true, color: '#204D72', margin: [5, 0, 0, 0] }
                        ]
                      }
                    ],
                    margin: [0, 0, 0, 4] // space between passengers
                  })),
                  alignment: 'left'
                },
                { text: p.flightNo === null ? "-" : p.flightNo, fontSize: 9, color: '#555555' },
                { text: p.sector, fontSize: 9 },
                { text: p.departureDate, fontSize: 9 },
                { text: `${this.bookingStatus == "Ticketed" ? "Confirmed" : this.bookingStatus}`, fontSize: 9, color: "#555555" },
              ])
            ]
          },
          style: 'tableStyle',
          layout: 'lightHorizontalLines'
        },
        {
          canvas: [
            {
              type: 'line',
              x1: 0, // Starting X coordinate (relative to the canvas's top-left)
              y1: 0, // Starting Y coordinate (relative to the canvas's top-left)
              x2: 515, // Ending X coordinate (adjust for desired length)
              y2: 0, // Ending Y coordinate (same as y1 for a horizontal line)
              lineWidth: 1, // Line thickness
              lineColor: 'black' // Line color (optional)
            }
          ], margin: [0, 5]
        },
        {
          columns: [
            {
              columns:
                [{ image: this.attentionIcon, width: 20, height: 20 },
                {
                  text: [
                    { text: "NOTICE: ", fontSize: 9, bold: true },
                    { text: `Arrival at airport 3 hours before scheduled departure time on domestic flights and 4 hours before scheduled departure time on international flights. Check-in counters close 45 min before scheduled departure time for domestic, and 90minutes before scheduled departure time for international flights. Mobile check-in available now for domestic flights.\n`, fontSize: 9, bold: false },
                    { text: [{ text: `CHECK-IN BAG SIZE LIMIT `, fontSize: 9 }, { text: `${this.passengerBaggage[0].baggageCheckIn}\n`, fontSize: 9, bold: true }] },
                    { text: [{ text: `HAND CARRY BAG LIMIT `, fontSize: 9 }, { text: `${this.passengerBaggage[0].baggageCabin}\n`, fontSize: 9, bold: true }] },
                    { text: "NOTE: ", fontSize: 9, bold: true }, { text: `Excess baggage and payment is not accepted at check-in counters.\n`, fontSize: 9, bold: false },
                  ], width: '*'
                }
                ], alignment: 'left', columnGap: 3
            },
            { image: this.baggageImage, width: 96, height: 76 }
          ],
          columnGap: 5,
        },
        {
          canvas: [
            {
              type: 'line',
              x1: 0, // Starting X coordinate (relative to the canvas's top-left)
              y1: 0, // Starting Y coordinate (relative to the canvas's top-left)
              x2: 515, // Ending X coordinate (adjust for desired length)
              y2: 0, // Ending Y coordinate (same as y1 for a horizontal line)
              lineWidth: 1.5, // Line thickness
              lineColor: 'black' // Line color (optional)
            }
          ], margin: [0, 5]
        },
        { text: '\n' },
        OnewaySectors.length > 0 ? { text: [{ text: " ONWARD: ", style: 'itineraryHeaderLeft' }, { text: ` ${this.flightSearchProperties.flightLocationInfo[0].fromAirport.split('-')[1].split('-')[0]}  ---->  ${this.flightSearchProperties.flightLocationInfo[0].toAirport.split('-')[1].split('-')[0]}`, style: 'itineraryHeaderRight' }, { text: " | ", fontSize: 11, bold: true }, { text: `Stops: ${OnewaySectors[0].noOfStops}`, fontSize: 11, bold: true }, { text: onewayStopsAt.length > 0 ? ` (${onewayStopsAt.map(itm => itm).join(', ')}) ` : " ", fontSize: 11, bold: true }, { text: "| " + this.flightSearchProperties.cabinClass, fontSize: 11, bold: true }], color: '#204D72' } : {},
        OnewaySectors.length > 0 ? OnewaySectors.map((it, ind) => {
          return [
            {
              table: {
                widths: [50, '*', '*', '*', /*50,*/ '*', '*'],
                body: [
                  [{ text: '' }, ind == 0 ? { text: 'Flight No', fontSize: 9, bold: true } : {}, ind == 0 ? { text: 'Origin', fontSize: 9, bold: true } : {}, ind == 0 ? { text: 'Destination', fontSize: 9, bold: true } : {}, /*ind == 0 ? { text: 'Duration', bold: true }:{},*/ ind == 0 ? { text: 'Dep. Date', fontSize: 9, bold: true } : {}, ind == 0 ? { text: 'Arv. Date', fontSize: 9, bold: true } : {}],
                  [it.airlineLogo.includes("svg") ? (it.airlineLogoTicket == null ? { text: it.airlineName, fontSize: 9, bold: true } : { svg: it.airlineLogoTicket, width: 50, height: 40 }) : (it.airlineLogoTicket == null ? { text: it.airlineName, fontSize: 9, bold: true } : { image: it.airlineLogoTicket, width: 28, height: 21 }),
                  { text: `${it.airlineName}\n(${it.airlinePrefixCode}${it.flightNumber})`, fontSize: 10 },
                  { text: [{ text: `${it.fromCity}\n`, fontSize: 10, color: '#204D72', bold: true }, { text: `${it.fromAirportName}\n`, fontSize: 7 }, { text: it.departureTerminal == null ? "" : it.departureTerminal, fontSize: 7, bold: true }] },
                  { text: [{ text: `${it.toCity}\n`, fontSize: 10, color: '#204D72', bold: true }, { text: `${it.toAirportName}\n`, fontSize: 7 }, { text: it.arrivalTerminal == null ? "" : it.arrivalTerminal, fontSize: 7, bold: true }] },
                  /*{ text: "-" },*/
                  { text: `${it.departureTime}\n${formatDate(it.departureDate, 'mediumDate', this.locale)}`, fontSize: 10 },
                  //{ text: `${it.departureTime}\n${it.departureDate}`, fontSize: 12 },
                  { text: `${it.arrivalTime}\n${formatDate(it.arrivalDate, 'mediumDate', this.locale)}\n`, fontSize: 10 }
                    //{ text: `${it.arrivalTime}\n${it.arrivalDate}\n`, fontSize: 12 }
                  ]
                ]
              },
              style: 'tableStyle',
              layout: 'noBorders'
            }
          ];
        }) : [],

        isRoundTrip ? { text: [{ text: " RETURN: ", style: 'itineraryHeaderLeft' }, { text: ` ${this.flightSearchProperties.flightLocationInfo[1].fromAirport.split('-')[1].split('-')[0]}  ---->  ${this.flightSearchProperties.flightLocationInfo[1].toAirport.split('-')[1].split('-')[0]}`, style: 'itineraryHeaderRight' }, { text: " | ", fontSize: 11, bold: true }, { text: `Stops: ${RoundTripSectors[0].noOfStops}`, fontSize: 11, bold: true }, { text: returnStopsAt.length > 0 ? ` (${returnStopsAt.map(itm => itm).join(', ')}) ` : " ", fontSize: 11, bold: true }, { text: "| " + this.flightSearchProperties.cabinClass, fontSize: 11, bold: true }], color: '#204D72' } : {},
        isRoundTrip ? RoundTripSectors.map((it, ind) => {
          return [
            {
              table: {
                widths: [50, '*', '*', '*', /*50,*/ '*', '*'],
                body: [
                  [{ text: '' }, ind == 0 ? { text: 'Flight No', fontSize: 9, bold: true } : {}, ind == 0 ? { text: 'Origin', fontSize: 9, bold: true } : {}, ind == 0 ? { text: 'Destination', fontSize: 9, bold: true } : {}, /*ind == 0 ? { text: 'Duration', bold: true }:{},*/ ind == 0 ? { text: 'Dep. Date', fontSize: 9, bold: true } : {}, ind == 0 ? { text: 'Arv. Date', fontSize: 9, bold: true } : {}],
                  [it.airlineLogo.includes("svg") ? (it.airlineLogoTicket == null ? { text: it.airlineName, fontSize: 9, bold: true } : { svg: it.airlineLogoTicket, width: 50, height: 40 }) : (it.airlineLogoTicket == null ? { text: it.airlineName, fontSize: 7, bold: true } : { image: it.airlineLogoTicket, width: 28, height: 21 }),
                  { text: `${it.airlineName}\n(${it.airlinePrefixCode}${it.flightNumber})`, fontSize: 10 },
                  { text: [{ text: `${it.fromCity}\n`, fontSize: 10, color: '#204D72', bold: true }, { text: `${it.fromAirportName}\n`, fontSize: 7 }, { text: it.departureTerminal == null ? "" : it.departureTerminal, fontSize: 7, bold: true }] },
                  { text: [{ text: `${it.toCity}\n`, fontSize: 10, color: '#204D72', bold: true }, { text: `${it.toAirportName}\n`, fontSize: 7 }, { text: it.arrivalTerminal == null ? "" : it.arrivalTerminal, fontSize: 7, bold: true }] },
                  /*{ text: "-" },*/
                  { text: `${it.departureTime}\n${formatDate(it.departureDate, 'mediumDate', this.locale)}`, fontSize: 10 },
                  { text: `${it.arrivalTime}\n${formatDate(it.arrivalDate, 'mediumDate', this.locale)}\n`, fontSize: 10 }]
                ]
              },
              style: 'tableStyle',
              layout: 'noBorders'
            }
          ];
        }) : [],

        isMulti ? MultiCitySectors.map((oit) => {
          return [
            { text: [{ text: " ONWARD: ", style: 'itineraryHeaderLeft' }, { text: oit.flightInfo, style: 'itineraryHeaderRight' }, { text: " | ", fontSize: 7, bold: true }, { text: `Stops: ${oit.sectorInfo[0].noOfStops}`, fontSize: 7, bold: true }, { text: oit.multiStopsAt.length > 0 ? ` (${oit.multiStopsAt.map(itm => itm).join(', ')}) ` : " ", fontSize: 7, bold: true }, { text: "| " + this.flightSearchProperties.cabinClass, fontSize: 7, bold: true }], color: '#204D72' },
            {
              table: {
                widths: [50, '*', '*', '*', /*50,*/ '*', '*'],
                body: [
                  [{ text: '' }, { text: 'Flight No', fontSize: 9, bold: true }, { text: 'Origin', fontSize: 9, bold: true }, { text: 'Destination', fontSize: 9, bold: true }, /*ind == 0 ? { text: 'Duration', bold: true }:{},*/ { text: 'Dep. Date', fontSize: 9, bold: true }, { text: 'Arv. Date', fontSize: 9, bold: true }],
                  ...oit.sectorInfo.map(iit =>
                    [
                      iit.airlineLogo.includes("svg") ? (iit.airlineLogoTicket == null ? { text: iit.airlineName, fontSize: 9, bold: true } : { svg: iit.airlineLogoTicket, width: 50, height: 40 }) : (iit.airlineLogoTicket == null ? { text: iit.airlineName, fontSize: 9, bold: true } : { image: iit.airlineLogoTicket, width: 28, height: 21 }),
                      { text: `${iit.airlineName}\n(${iit.airlinePrefixCode}${iit.flightNumber})`, fontSize: 10 },
                      { text: [{ text: `${iit.fromCity}\n`, fontSize: 10, color: '#204D72', bold: true }, { text: `${iit.fromAirportName}\n`, fontSize: 7 }, { text: iit.departureTerminal == null ? "" : iit.departureTerminal, fontSize: 7, bold: true }] },
                      { text: [{ text: `${iit.toCity}\n`, fontSize: 10, color: '#204D72', bold: true }, { text: `${iit.toAirportName}\n`, fontSize: 7 }, { text: iit.arrivalTerminal == null ? "" : iit.arrivalTerminal, fontSize: 7, bold: true }] },
                      /*{ text: "-" },*/
                      { text: `${iit.departureTime}\n${formatDate(iit.departureDate, 'mediumDate', this.locale)}`, fontSize: 10 },
                      { text: `${iit.arrivalTime}\n${formatDate(iit.arrivalDate, 'mediumDate', this.locale)}\n`, fontSize: 10 }
                    ])
                ]
              },
              style: 'tableStyle',
              layout: 'noBorders'
            }
          ]
        }) : [],

        {
          canvas: [
            {
              type: 'line',
              x1: 0, // Starting X coordinate (relative to the canvas's top-left)
              y1: 0, // Starting Y coordinate (relative to the canvas's top-left)
              x2: 515, // Ending X coordinate (adjust for desired length)
              y2: 0, // Ending Y coordinate (same as y1 for a horizontal line)
              lineWidth: 1.5, // Line thickness
              lineColor: 'black' // Line color (optional)
            }
          ], margin: [0, 5]
        }
      ];

      const documentDefinition = {
        info: {
          title: 'OK Travels Flight Ticket',
          author: 'Zabi Ullah @ OK Tech Labs',
          subject: 'OK Travels Flight Ticket from OK Tech Labs',
        },
        //watermark: 'OK Travels & Tourism (pvt) Ltd',
        pageSize: 'A4',
        language: 'en-GB',
        content: [
          ...financeType === false && alleach === "each" ? withoutEachContent : financeType === false && alleach === "all" ? withoutAllContent : [
            //Doc header
            {
              columns: [
                {
                  width: 'auto', text: "eTicket", bold: true, fontSize: 16
                },
                {
                  width: '*', text: `${this.agencyOnline.agencyName}`, bold: false, fontSize: 12, alignment: 'center'
                },
                {
                  width: 215, margin: [-20, 0, 0, 0],
                  columns: [
                    {
                      text: [
                        { text: `SPNR \n`, bold: false, fontSize: 10 },
                        { text: `${this.bookingInfo.supplierLocatorCode != null ? this.bookingInfo.supplierLocatorCode : ''}`, bold: true, fontSize: 14, color: '#6A1717' }
                      ],
                      alignment: 'right',
                      width: 70
                    },
                    {
                      text: [
                        { text: `BOOKING REF. \n`, bold: false, fontSize: 10 },
                        { text: `${this.bookingInfo.pnr}`, bold: true, fontSize: 14, color: '#6A1717' }
                      ],
                      alignment: 'right',
                      width: 70
                    },
                    {
                      image: this.barcodeImage, width: 75, height: 30
                    },
                  ]
                }
              ],
              columnGap: 10,
              border: [false, false, false, true]
            },
            {
              canvas: [
                {
                  type: 'line',
                  x1: 0, // Starting X coordinate (relative to the canvas's top-left)
                  y1: 0, // Starting Y coordinate (relative to the canvas's top-left)
                  x2: 515, // Ending X coordinate (adjust for desired length)
                  y2: 0, // Ending Y coordinate (same as y1 for a horizontal line)
                  lineWidth: 1, // Line thickness
                  lineColor: 'black' // Line color (optional)
                }
              ], margin: [0, 5]
            },
            {
              columns: [
                { image: `${this.agencyLogo != null ? this.agencyLogo : ''}`, width: 60, height: 45 },
                {
                  table: {
                    widths: [150, 150],
                    body: [
                      [
                        { text: `Reserved on ${formatedBookingDate}`, fontSize: 9 },
                        { text: `Ticketed on ${this.bookingStatus == "Ticketed" ? formatedIssuanceDate : "---"}`, fontSize: 9, alignment: 'right' }
                      ],
                      [
                        // Left cell
                        {
                          text: [
                            { text: "Booked By:\n", fontSize: 9 },
                            { text: `${this.userOnline.firstName} ${this.userOnline.lastName}`, fontSize: 11, bold: true, color: '#204D72' }
                          ]
                        },
                        // Right cell
                        {
                          stack: [
                            {
                              columns: [
                                { image: this.buildingIcon, width: 12, height: 12, margin: [0, 0, 5, 0], alignment: 'right' },
                                { text: "(Consultant)", fontSize: 10, alignment: 'right' }
                              ], columnGap: 0,
                              widths: ['auto', 'auto']
                            },
                            {
                              columns: [
                                { image: this.agentIcon, width: 12, height: 12, margin: [0, 0, 5, 0], alignment: 'right' },
                                { text: `${this.userOnline.mobile}`, fontSize: 10, bold: true, alignment: 'right', }
                              ], columnGap: 0,
                              widths: ['auto', 'auto']
                            }
                          ]
                        }
                      ]
                    ]
                  }, layout: 'noBorders', margin: [140, 0, 0, 0]
                }
              ]
            },
            // Passenger Information Table
            {
              table: {
                widths: ['auto', '*', '*', '*', '*'],
                body: [
                  [{ text: 'passenger', fontSize: 9, bold: true }, { text: 'flight no', fontSize: 9, bold: true }, { text: 'route', fontSize: 9, bold: true }, { text: 'date', fontSize: 9, bold: true }, { text: 'status', fontSize: 9, bold: true }],
                  ...sortedBaggageInfo.map(p => [
                    {
                      stack: p.paxs.map(nam => ({
                        stack: [
                          { text: nam.paxName, fontSize: 9, bold: true, color: '#444444' },

                          {
                            columns: [
                              { image: this.passportIcon, width: 10, height: 10, margin: [0, 0, 1, 0] },
                              { text: `${nam.passportNo}\n`, fontSize: 9, margin: [5, 0, 0, 0] }
                            ]
                          },
                          {
                            columns: [
                              { image: this.planeIcon, width: 10, height: 10, margin: [0, 0, 1, 0] },
                              { text: `${nam.ticketNo === null ? "-" : nam.ticketNo} | seat: ${nam.seatNo === null ? "any" : nam.seatNo} | check-in: ${nam.checkIn} | cabin: ${nam.cabin} | meal: ${nam.meal === null ? "-" : nam.meal}`, fontSize: 9, bold: true, color: '#204D72', margin: [5, 0, 0, 0] }
                            ]
                          }
                        ],
                        margin: [0, 0, 0, 4] // space between passengers
                      })),
                      alignment: 'left'
                    },
                    { text: p.flightNo === null ? "-" : p.flightNo, fontSize: 9, color: '#555555' },
                    { text: p.sector, fontSize: 9 },
                    { text: p.departureDate, fontSize: 9 },
                    { text: `${this.bookingStatus == "Ticketed" ? "Confirmed" : this.bookingStatus}`, fontSize: 9, color: "#555555" },
                  ])
                ]
              },
              style: 'tableStyle',
              layout: 'lightHorizontalLines'
            },
            {
              canvas: [
                {
                  type: 'line',
                  x1: 0, // Starting X coordinate (relative to the canvas's top-left)
                  y1: 0, // Starting Y coordinate (relative to the canvas's top-left)
                  x2: 515, // Ending X coordinate (adjust for desired length)
                  y2: 0, // Ending Y coordinate (same as y1 for a horizontal line)
                  lineWidth: 1.5, // Line thickness
                  lineColor: 'black' // Line color (optional)
                }
              ], margin: [0, 5]
            },
            {
              columns: [
                {
                  columns:
                    [{ image: this.attentionIcon, width: 20, height: 20 },
                    {
                      text: [
                        { text: "NOTICE: ", fontSize: 9, bold: true },
                        { text: `Arrival at airport 3 hours before scheduled departure time on domestic flights and 4 hours before scheduled departure time on international flights. Check-in counters close 45 min before scheduled departure time for domestic, and 90minutes before scheduled departure time for international flights. Mobile check-in available now for domestic flights.\n`, fontSize: 9, bold: false },
                        { text: [{ text: `CHECK-IN BAG SIZE LIMIT `, fontSize: 9 }, { text: `${this.passengerBaggage[0].baggageCheckIn}\n`, fontSize: 10, bold: true }] },
                        { text: [{ text: `HAND CARRY BAG LIMIT `, fontSize: 9 }, { text: `${this.passengerBaggage[0].baggageCabin}\n`, fontSize: 10, bold: true }] },
                        { text: "NOTE: ", fontSize: 9, bold: true }, { text: `Excess baggage and payment is not accepted at check-in counters.\n`, fontSize: 9, bold: false },
                      ], width: '*'
                    }
                    ], alignment: 'left', columnGap: 3
                },
                { image: this.baggageImage, width: 96, height: 76 }
              ],
              columnGap: 5,
            },
            {
              canvas: [
                {
                  type: 'line',
                  x1: 0, // Starting X coordinate (relative to the canvas's top-left)
                  y1: 0, // Starting Y coordinate (relative to the canvas's top-left)
                  x2: 515, // Ending X coordinate (adjust for desired length)
                  y2: 0, // Ending Y coordinate (same as y1 for a horizontal line)
                  lineWidth: 1.5, // Line thickness
                  lineColor: 'black' // Line color (optional)
                }
              ], margin: [0, 5]
            },
            { text: '\n' },
            OnewaySectors.length > 0 ? { text: [{ text: " ONWARD: ", style: 'itineraryHeaderLeft' }, { text: ` ${this.flightSearchProperties.flightLocationInfo[0].fromAirport.split('-')[1].split('-')[0]}  ---->  ${this.flightSearchProperties.flightLocationInfo[0].toAirport.split('-')[1].split('-')[0]}`, style: 'itineraryHeaderRight' }, { text: " | ", fontSize: 7, bold: true }, { text: `Stops: ${OnewaySectors[0].noOfStops}`, fontSize: 7, bold: true }, { text: onewayStopsAt.length > 0 ? ` (${onewayStopsAt.map(itm => itm).join(', ')}) ` : " ", fontSize: 7, bold: true }, { text: "| " + this.flightSearchProperties.cabinClass, fontSize: 7, bold: true }], color: '#204D72' } : {},
            OnewaySectors.length > 0 ? OnewaySectors.map((it, ind) => {
              return [
                {
                  table: {
                    widths: [50, '*', '*', '*', /*50,*/ '*', '*'],
                    body: [
                      [{ text: '' }, ind == 0 ? { text: 'Flight No', fontSize: 9, bold: true } : {}, ind == 0 ? { text: 'Origin', fontSize: 9, bold: true } : {}, ind == 0 ? { text: 'Destination', fontSize: 9, bold: true } : {}, /*ind == 0 ? { text: 'Duration', bold: true }:{},*/ ind == 0 ? { text: 'Dep. Date', fontSize: 9, bold: true } : {}, ind == 0 ? { text: 'Arv. Date', fontSize: 9, bold: true } : {}],
                      [it.airlineLogo.includes("svg") ? (it.airlineLogoTicket == null ? { text: it.airlineName, fontSize: 9, bold: true } : { svg: it.airlineLogoTicket, width: 50, height: 40 }) : (it.airlineLogoTicket == null ? { text: it.airlineName, fontSize: 7, bold: true } : { image: it.airlineLogoTicket, width: 28, height: 21 }),
                      { text: `${it.airlineName}\n(${it.airlinePrefixCode}${it.flightNumber})`, fontSize: 10 },
                      { text: [{ text: `${it.fromCity}\n`, fontSize: 10, color: '#204D72', bold: true }, { text: `${it.fromAirportName}\n`, fontSize: 7 }, { text: it.departureTerminal == null ? "" : it.departureTerminal, fontSize: 7, bold: true }] },
                      { text: [{ text: `${it.toCity}\n`, fontSize: 10, color: '#204D72', bold: true }, { text: `${it.toAirportName}\n`, fontSize: 7 }, { text: it.arrivalTerminal == null ? "" : it.arrivalTerminal, fontSize: 7, bold: true }] },
                      /*{ text: "-" },*/
                      { text: `${it.departureTime}\n${formatDate(it.departureDate, 'mediumDate', this.locale)}`, fontSize: 10 },
                      { text: `${it.arrivalTime}\n${formatDate(it.arrivalDate, 'mediumDate', this.locale)}\n`, fontSize: 10 }]
                    ]
                  },
                  style: 'tableStyle',
                  layout: 'noBorders'
                }
              ];
            }) : [],

            isRoundTrip ? { text: [{ text: " RETURN: ", style: 'itineraryHeaderLeft' }, { text: ` ${this.flightSearchProperties.flightLocationInfo[1].fromAirport.split('-')[1].split('-')[0]}  ---->  ${this.flightSearchProperties.flightLocationInfo[1].toAirport.split('-')[1].split('-')[0]}`, style: 'itineraryHeaderRight' }, { text: " | ", fontSize: 7, bold: true }, { text: `Stops: ${RoundTripSectors[0].noOfStops}`, fontSize: 7, bold: true }, { text: returnStopsAt.length > 0 ? ` (${returnStopsAt.map(itm => itm).join(', ')}) ` : " ", fontSize: 7, bold: true }, { text: "| " + this.flightSearchProperties.cabinClass, fontSize: 7, bold: true }], color: '#204D72' } : {},
            isRoundTrip ? RoundTripSectors.map((it, ind) => {
              return [
                {
                  table: {
                    widths: [50, '*', '*', '*', /*50,*/ '*', '*'],
                    body: [
                      [{ text: '' }, ind == 0 ? { text: 'Flight No', fontSize: 9, bold: true } : {}, ind == 0 ? { text: 'Origin', fontSize: 9, bold: true } : {}, ind == 0 ? { text: 'Destination', fontSize: 9, bold: true } : {}, /*ind == 0 ? { text: 'Duration', bold: true }:{},*/ ind == 0 ? { text: 'Dep. Date', fontSize: 9, bold: true } : {}, ind == 0 ? { text: 'Arv. Date', fontSize: 9, bold: true } : {}],
                      [it.airlineLogo.includes("svg") ? (it.airlineLogoTicket == null ? { text: it.airlineName, fontSize: 9, bold: true } : { svg: it.airlineLogoTicket, width: 50, height: 40 }) : (it.airlineLogoTicket == null ? { text: it.airlineName, fontSize: 7, bold: true } : { image: it.airlineLogoTicket, width: 28, height: 21 }),
                      { text: `${it.airlineName}\n(${it.airlinePrefixCode}${it.flightNumber})`, fontSize: 10 },
                      { text: [{ text: `${it.fromCity}\n`, fontSize: 10, color: '#204D72', bold: true }, { text: `${it.fromAirportName}\n`, fontSize: 7 }, { text: it.departureTerminal == null ? "" : it.departureTerminal, fontSize: 7, bold: true }] },
                      { text: [{ text: `${it.toCity}\n`, fontSize: 10, color: '#204D72', bold: true }, { text: `${it.toAirportName}\n`, fontSize: 7 }, { text: it.arrivalTerminal == null ? "" : it.arrivalTerminal, fontSize: 7, bold: true }] },
                      /*{ text: "-" },*/
                      { text: `${it.departureTime}\n${formatDate(it.departureDate, 'mediumDate', this.locale)}`, fontSize: 10 },
                      { text: `${it.arrivalTime}\n${formatDate(it.arrivalDate, 'mediumDate', this.locale)}\n`, fontSize: 10 }]
                    ]
                  },
                  style: 'tableStyle',
                  layout: 'noBorders'
                }
              ];
            }) : [],

            isMulti ? MultiCitySectors.map((oit) => {
              return [
                { text: [{ text: " ONWARD: ", style: 'itineraryHeaderLeft' }, { text: oit.flightInfo, style: 'itineraryHeaderRight' }, { text: " | ", fontSize: 7, bold: true }, { text: `Stops: ${oit.sectorInfo[0].noOfStops}`, fontSize: 7, bold: true }, { text: oit.multiStopsAt.length > 0 ? ` (${oit.multiStopsAt.map(itm => itm).join(', ')}) ` : " ", fontSize: 7, bold: true }, { text: "| " + this.flightSearchProperties.cabinClass, fontSize: 7, bold: true }], color: '#204D72' },
                {
                  table: {
                    widths: [50, '*', '*', '*', /*50,*/ '*', '*'],
                    body: [
                      [{ text: '' }, { text: 'Flight No', fontSize: 9, bold: true }, { text: 'Origin', fontSize: 9, bold: true }, { text: 'destination', bold: true }, /*ind == 0 ? { text: 'Duration', bold: true }:{},*/ { text: 'Dep. Date', fontSize: 9, bold: true }, { text: 'Arv. Date', fontSize: 9, bold: true }],
                      ...oit.sectorInfo.map(iit =>
                        [
                          iit.airlineLogo.includes("svg") ? (iit.airlineLogoTicket == null ? { text: iit.airlineName, fontSize: 9, bold: true } : { svg: iit.airlineLogoTicket, width: 50, height: 40 }) : (iit.airlineLogoTicket == null ? { text: iit.airlineName, fontSize: 9, bold: true } : { image: iit.airlineLogoTicket, width: 28, height: 21 }),
                          { text: `${iit.airlineName}\n(${iit.airlinePrefixCode}${iit.flightNumber})`, fontSize: 10 },
                          { text: [{ text: `${iit.fromCity}\n`, fontSize: 10, color: '#204D72', bold: true }, { text: `${iit.fromAirportName}\n`, fontSize: 7 }, { text: iit.departureTerminal == null ? "" : iit.departureTerminal, fontSize: 7, bold: true }] },
                          { text: [{ text: `${iit.toCity}\n`, fontSize: 10, color: '#204D72', bold: true }, { text: `${iit.toAirportName}\n`, fontSize: 7 }, { text: iit.arrivalTerminal == null ? "" : iit.arrivalTerminal, fontSize: 7, bold: true }] },
                          /*{ text: "-" },*/
                          { text: `${iit.departureTime}\n${formatDate(iit.departureDate, 'mediumDate', this.locale)}`, fontSize: 10 },
                          { text: `${iit.arrivalTime}\n${formatDate(iit.arrivalDate, 'mediumDate', this.locale)}\n`, fontSize: 10 }
                        ])
                    ]
                  },
                  style: 'tableStyle',
                  layout: 'noBorders'
                }
              ]
            }) : [],

            /*{ text: '\n' },*/
            {
              canvas: [
                {
                  type: 'line',
                  x1: 0, // Starting X coordinate (relative to the canvas's top-left)
                  y1: 0, // Starting Y coordinate (relative to the canvas's top-left)
                  x2: 515, // Ending X coordinate (adjust for desired length)
                  y2: 0, // Ending Y coordinate (same as y1 for a horizontal line)
                  lineWidth: 1.5, // Line thickness
                  lineColor: 'black' // Line color (optional)
                }
              ], margin: [0, 5]
            },

            // Financial Information Table
            {
              table: {
                widths: ['auto', '*', '*', '*', '*'],
                body: [
                  [{ text: 'passenger(s)', fontSize: 9, bold: true }, { text: 'base fare', fontSize: 9, bold: true }, { text: 'service fees', fontSize: 9, bold: true }, { text: 'taxes', fontSize: 9, bold: true }, { text: 'total', fontSize: 9, bold: true }],
                  ...this.bookingPassengerInfo.map(f => [
                    { text: `${f.title} ${f.firstName} ${f.lastName}`, fontSize: 9, color: "#333333", bold: true },
                    { text: f.exchangeCurrency + f.baseFare, fontSize: 9, color: "#555555" },
                    { text: f.exchangeCurrency + f.serviceCharges, fontSize: 9, color: "#555555" },
                    { text: `${f.exchangeCurrency}${(f.totalTaxes + f.markup + f.runtimeMarkup)}`, fontSize: 9, color: "#555555" },
                    { text: f.exchangeCurrency + f.netFromCustomer, fontSize: 9, color: "#333333", bold: true }
                  ])
                ]
              },
              style: 'tableStyle',
              layout: 'headerLineOnly'
            },

            {
              canvas: [
                {
                  type: 'line',
                  x1: 0, // Starting X coordinate (relative to the canvas's top-left)
                  y1: 0, // Starting Y coordinate (relative to the canvas's top-left)
                  x2: 515, // Ending X coordinate (adjust for desired length)
                  y2: 0, // Ending Y coordinate (same as y1 for a horizontal line)
                  lineWidth: 1.5, // Line thickness
                  lineColor: 'black' // Line color (optional)
                }
              ], margin: [0, 5]
            }
          ]
        ],
        styles: {
          //header: { fontSize: 11, bold: true, margin: [0, 5], alignment: 'justify' },
          itineraryHeaderLeft: { fontSize: 9, bold: true },
          itineraryHeaderRight: { fontSize: 9, bold: true },
          itinerarySummary: { fontSize: 9, margin: [0, 0] },
          tableStyle: { fontSize: 12, border: [false, false, false, true], margin: [0, 0], alignment: 'center' },
        }
      };
      this.hideBtnLoader();
      pdfMake.createPdf(documentDefinition).download(this.bookingInfo.pnr);
    });
  }

  //printItinerary1(financeType: boolean, alleach: string) {
  //  this.showBtnLoader();
  //  let agencyLogoName = this.agencyOnline.logoFileName;
  //  let imgType = agencyLogoName.substring(agencyLogoName.lastIndexOf(".") + 1);
  //  var agencyLogo = 'data:image/' + imgType + ';base64,' + this.agencyOnline.logoFilePath;
  //  let bookingDateString = this.bookingInfo.bookingDate;
  //  let bookingDate = new Date(bookingDateString);
  //  let formatedBookingDate = bookingDate.toLocaleString('en-US', { year: 'numeric', month: 'long', day: 'numeric', });
  //  this.loadLogos(this.newsectorInfo).then(base64Logos => {
  //    for (let ln = 0; ln < base64Logos.length; ln++) {
  //      this.newsectorInfo[ln].airlineLogoTicket = base64Logos[ln];
  //    }
  //    const { OnewaySectors, RoundTripSectors, MultiCitySectors, isRoundTrip, isMulti } = this.classifySectors(this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo, this.newsectorInfo);
  //    let sortedBaggageInfo: TicketPaxBaggageSectorSortedProperties[] = [];
  //    for (let si = 0; si < this.newsectorInfo.length; si++) {
  //      let sect = new TicketPaxBaggageSectorSortedProperties();
  //      sect.passengerId = this.newsectorInfo[si].passengerID;
  //      sect.sector = this.newsectorInfo[si].fromAirport + " ---> " + this.newsectorInfo[si].toAirport;
  //      sect.checkIn = this.newsectorInfo[si].baggageCheckIn;
  //      sect.cabin = this.newsectorInfo[si].baggageCabin;
  //      sect.ticketNo = this.newsectorInfo[si].ticketDesignator;
  //      sect.seatNo = this.newsectorInfo[si].seatNumber;
  //      sect.meal = this.newsectorInfo[si].meal;
  //      for (let pi = 0; pi < this.bookingPassengerInfo.length; pi++) {
  //        let pax = new TicketSortedPaxs();
  //        pax.paxName = this.bookingPassengerInfo[pi].firstName + " " + this.bookingPassengerInfo[pi].lastName;
  //        pax.ticketNo = this.bookingPassengerInfo[pi].ticketNo;
  //        sect.paxs.push(pax);
  //      }
  //      sortedBaggageInfo.push(sect);
  //    }
  //    let onewayStopsAt: string[] = [];
  //    let returnStopsAt: string[] = [];
  //    for (let index = 0; index < OnewaySectors.length; index++) {
  //      if (index != OnewaySectors.length - 1) {
  //        onewayStopsAt.push(OnewaySectors[index].toCity);
  //      } else {
  //        continue;
  //      }
  //    };
  //    for (let index = 0; index < RoundTripSectors.length; index++) {
  //      if (index != RoundTripSectors.length - 1) {
  //        returnStopsAt.push(RoundTripSectors[index].toCity);
  //      } else {
  //        continue;
  //      }
  //    };

  //    const withoutEachContent = this.bookingPassengerInfo.map((item, index) => {
  //      return [
  //        {
  //          columns: [
  //            {
  //              image: agencyLogo, width: 60, height: 45
  //            },
  //            {
  //              text: [
  //                { text: `${this.agencyOnline.agencyName}\n`, bold: true, fontSize: 14 }//,
  //                //{ text: `${this.agencyOnline.address1 + " - " + this.agencyOnline.address2}\n`, fontSize: 7, bold: false, italics: true },
  //                //{ text: `Agent: ${this.userOnline.firstName + " " + this.userOnline.lastName}\n`, fontSize: 7, bold: false },
  //                //{ text: `Phone: ${this.userOnline.mobile}\n`, fontSize: 7, bold: false },
  //                //{ text: `Email: ${this.userOnline.email}\n`, fontSize: 7, bold: false },
  //              ],
  //              alignment: 'right',
  //              margin: [0, 20, 10, 0]
  //            }
  //          ],
  //          columnGap: 20
  //        },
  //        { text: '\n\n' },

  //        {
  //          style: 'tableStyle',
  //          table: {
  //            widths: [90, 90, 90, 90, 90],
  //            body: [
  //              [{ text: 'Booking ID', border: [true, true, false, false] }, { text: 'Booking Date', border: [false, true, false, false] }, { text: 'Airline Ref.', border: [false, true, false, false] }, { text: 'PNR', border: [false, true, false, false] }, { text: 'Status', border: [false, true, true, false] }],
  //              [{ text: this.bookingInfo.bookingID, bold: true, border: [true, false, false, true] }, { text: formatedBookingDate, bold: true, border: [false, false, false, true] }, { text: this.bookingInfo.supplierLocatorCode, bold: true, border: [false, false, false, true] }, { text: this.bookingInfo.pnr, bold: true, border: [false, false, false, true] }, { text: this.bookingStatus, bold: true, border: [false, false, true, true] }]
  //            ]
  //          },
  //          layout: {
  //            hLineWidth: function (i, node) {
  //              return (i === 0 || i === node.table.body.length) ? 0.5 : 0.5;
  //            },
  //            vLineWidth: function (i, node) {
  //              return (i === 0 || i === node.table.widths.length) ? 0.5 : 0.5;
  //            },
  //            hLineColor: function (i, node) {
  //              return (i === 0 || i === node.table.body.length) ? 'gray' : 'gray';
  //            },
  //            vLineColor: function (i, node) {
  //              return (i === 0 || i === node.table.widths.length) ? 'gray' : 'gray';
  //            }
  //          }
  //        },
  //        //{ text: '\n' },
  //        OnewaySectors.length > 0 ? { text: [{ text: " ONWARD: ", style: 'itineraryHeaderLeft' }, { text: ` ${this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo[0].fromAirport.split('-')[1].split('-')[0]}  ---->  ${this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo[0].toAirport.split('-')[1].split('-')[0]}`, style: 'itineraryHeaderRight' }, { text: " | ", fontSize: 7, bold: true }, { text: `Stops: ${OnewaySectors[0].noOfStops}`, fontSize: 7, bold: true }, { text: onewayStopsAt.length > 0 ? ` (${onewayStopsAt.map(itm => itm).join(', ')}) ` : " ", fontSize: 7, bold: true }, { text: "| " + this.bookingInfo.galileoBookingProp.flightProp.cabinClass, fontSize: 7, bold: true }], style: 'itnTopMargin' } : {},
  //        OnewaySectors.length > 0 ? OnewaySectors.map((it, ind) => {
  //          return [
  //            {
  //              table: {
  //                widths: [50, '*', '*', '*', /*50,*/ '*', '*'],
  //                body: [
  //                  [{ text: '' }, ind == 0 ? { text: 'Flight No', bold: true } : {}, ind == 0 ? { text: 'Origin', bold: true } : {}, ind == 0 ? { text: 'Destination', bold: true } : {}, /*ind == 0 ? { text: 'Duration', bold: true }:{},*/ ind == 0 ? { text: 'Dep. Date', bold: true } : {}, ind == 0 ? { text: 'Arv. Date', bold: true } : {}],
  //                  [it.airlineLogo.includes("svg") ? (it.airlineLogoTicket == null ? { text: it.airlineName, fontSize: 7, bold: true } : { svg: it.airlineLogoTicket, width: 28, height: 21 }) : (it.airlineLogoTicket == null ? { text: it.airlineName, fontSize: 7, bold: true } : { image: it.airlineLogoTicket, width: 28, height: 21 }),
  //                  { text: it.airlinePrefixCode + it.flightNumber },
  //                  { text: [{ text: it.fromCity }, { text: ` [${it.fromAirport}] `, bold: true }, { text: '\n' }, { text: it.fromAirportName, fontSize: 6 }] },
  //                  { text: [{ text: it.toCity }, { text: ` [${it.toAirport}] `, bold: true }, { text: '\n' }, { text: it.toAirportName, fontSize: 6 }] },
  //                  /*{ text: "-" },*/
  //                  { text: `${it.departureTime}\n${formatDate(it.departureDate, 'dd MMMM yyyy', this.locale)}` },
  //                  { text: `${it.arrivalTime}\n${formatDate(it.arrivalDate, 'dd MMMM yyyy', this.locale)}\n` }]
  //                ]
  //              },
  //              style: 'tableStyle',
  //              layout: 'noBorders'
  //            }
  //          ];
  //        }) : [],

  //        isRoundTrip ? {
  //          text: [{ text: " RETURN: ", style: 'itineraryHeaderLeft' }, { text: ` ${this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo[1].fromAirport.split('-')[1].split('-')[0]}  ---->  ${this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo[1].toAirport.split('-')[1].split('-')[0]}`, style: 'itineraryHeaderRight' }, { text: " | ", fontSize: 7, bold: true }, { text: `Stops: ${RoundTripSectors[0].noOfStops}`, fontSize: 7, bold: true }, { text: returnStopsAt.length > 0 ? ` (${returnStopsAt.map(itm => itm).join(', ')}) ` : " ", fontSize: 7, bold: true }, { text: "| " + this.bookingInfo.galileoBookingProp.flightProp.cabinClass, fontSize: 7, bold: true }], style: 'itnTopMargin'
  //        } : {},

  //        isRoundTrip ? RoundTripSectors.map((it, ind) => {
  //          return [
  //            {
  //              table: {
  //                widths: [50, '*', '*', '*', /*50,*/ '*', '*'],
  //                body: [
  //                  [{ text: '' }, ind == 0 ? { text: 'Flight No', bold: true } : {}, ind == 0 ? { text: 'Origin', bold: true } : {}, ind == 0 ? { text: 'Destination', bold: true } : {}, /*ind == 0 ? { text: 'Duration', bold: true }:{},*/ ind == 0 ? { text: 'Dep. Date', bold: true } : {}, ind == 0 ? { text: 'Arv. Date', bold: true } : {}],
  //                  [it.airlineLogo.includes("svg") ? (it.airlineLogoTicket == null ? { text: it.airlineName, fontSize: 7, bold: true } : { svg: it.airlineLogoTicket, width: 28, height: 21 }) : (it.airlineLogoTicket == null ? { text: it.airlineName, fontSize: 7, bold: true } : { image: it.airlineLogoTicket, width: 28, height: 21 }),
  //                  { text: it.airlinePrefixCode + it.flightNumber },
  //                  { text: [{ text: it.fromCity }, { text: ` [${it.fromAirport}] `, bold: true }, { text: '\n' }, { text: it.fromAirportName, fontSize: 6 }] },
  //                  { text: [{ text: it.toCity }, { text: ` [${it.toAirport}] `, bold: true }, { text: '\n' }, { text: it.toAirportName, fontSize: 6 }] },
  //                  /*{ text: "-" },*/
  //                  { text: `${it.departureTime}\n${formatDate(it.departureDate, 'dd MMMM yyyy', this.locale)}` },
  //                  { text: `${it.arrivalTime}\n${formatDate(it.arrivalDate, 'dd MMMM yyyy', this.locale)}\n` }]
  //                ]
  //              },
  //              style: 'tableStyle',
  //              layout: 'noBorders'
  //            }
  //          ];
  //        }) : [],

  //        isMulti ? MultiCitySectors.map((oit) => {
  //          return [
  //            { text: [{ text: " ONWARD: ", style: 'itineraryHeaderLeft' }, { text: oit.flightInfo, style: 'itineraryHeaderRight' }, { text: " | ", fontSize: 7, bold: true }, { text: `Stops: ${oit.sectorInfo[0].noOfStops}`, fontSize: 7, bold: true }, { text: oit.multiStopsAt.length > 0 ? ` (${oit.multiStopsAt.map(itm => itm).join(', ')}) ` : " ", fontSize: 7, bold: true }, { text: "| " + this.bookingInfo.galileoBookingProp.flightProp.cabinClass, fontSize: 7, bold: true }], style: 'itnTopMargin' },
  //            {
  //              table: {
  //                widths: [50, '*', '*', '*', /*50,*/ '*', '*'],
  //                body: [
  //                  [{ text: '' }, { text: 'Flight No', bold: true }, { text: 'Origin', bold: true }, { text: 'Destination', bold: true }, /*ind == 0 ? { text: 'Duration', bold: true }:{},*/ { text: 'Dep. Date', bold: true }, { text: 'Arv. Date', bold: true }],
  //                  ...oit.sectorInfo.map(iit =>
  //                    [
  //                      iit.airlineLogo.includes("svg") ? (iit.airlineLogoTicket == null ? { text: iit.airlineName, fontSize: 7, bold: true } : { svg: iit.airlineLogoTicket, width: 28, height: 21 }) : (iit.airlineLogoTicket == null ? { text: iit.airlineName, fontSize: 7, bold: true } : { image: iit.airlineLogoTicket, width: 28, height: 21 }),
  //                      { text: iit.airlinePrefixCode + iit.flightNumber },
  //                      { text: [{ text: iit.fromCity }, { text: ` [${iit.fromAirport}] `, bold: true }, { text: '\n' }, { text: iit.fromAirportName, fontSize: 6 }] },
  //                      { text: [{ text: iit.toCity }, { text: ` [${iit.toAirport}] `, bold: true }, { text: '\n' }, { text: iit.toAirportName, fontSize: 6 }] },
  //                      /*{ text: "-" },*/
  //                      { text: `${iit.departureTime}\n${formatDate(iit.departureDate, 'dd MMMM yyyy', this.locale)}` },
  //                      { text: `${iit.arrivalTime}\n${formatDate(iit.arrivalDate, 'dd MMMM yyyy', this.locale)}\n` }
  //                    ]
  //                  )
  //                ]
  //              },
  //              style: 'tableStyle',
  //              layout: 'noBorders'
  //            }
  //          ]
  //        }) : [],

  //        { text: '\n' },
  //        // Passenger Information Table
  //        { text: 'Passenger Information', style: 'subHeader' },
  //        {
  //          table: {
  //            widths: ['*', '*', '*', '*', '*'],
  //            body: [
  //              [{ text: 'Sector', bold: true }, { text: 'Passenger Name', bold: true }, { text: 'CheckIn / Cabin', bold: true }, { text: 'Ticket No', bold: true }, { text: 'Seat / Meal', bold: true }],
  //              ...sortedBaggageInfo.map(p => [
  //                p.sector,
  //                p.paxs[index].paxName,
  //                p.checkIn + " / " + p.cabin,
  //                p.paxs[index].ticketNo === null ? "-" : p.paxs[index].ticketNo,
  //                `${p.seatNo === null ? "-" : p.seatNo} / ${p.meal === null ? "-" : p.meal}`
  //              ])
  //            ]
  //          },
  //          style: 'tableStyle',
  //          layout: 'lightHorizontalLines'
  //        },
  //        { text: '\n' },
  //        { text: 'Note:', style: 'subHeader' },
  //        { text: 'Please read the terms and conditions of your ticket carefully. These include rules regarding cancellations, changes, and refund policies.', margin: [0, 0], italics: true, fontSize: 7 },

  //        { text: '', pageBreak: index < this.bookingPassengerInfo.length - 1 ? 'after' : undefined }, // Add page break except the last page
  //      ];
  //    });
  //    const withoutAllContent = [
  //      {
  //        columns: [
  //          {
  //            image: agencyLogo, width: 60, height: 45
  //          },
  //          {
  //            text: [
  //              { text: `${this.agencyOnline.agencyName}\n`, bold: true, fontSize: 14 }//,
  //              //{ text: `${this.agencyOnline.address1 + " - " + this.agencyOnline.address2}\n`, fontSize: 7, bold: false, italics: true },
  //              //{ text: `Agent: ${this.userOnline.firstName + " " + this.userOnline.lastName}\n`, fontSize: 7, bold: false },
  //              //{ text: `Phone: ${this.userOnline.mobile}\n`, fontSize: 7, bold: false },
  //              //{ text: `Email: ${this.userOnline.email}\n`, fontSize: 7, bold: false },
  //            ],
  //            alignment: 'right',
  //            margin: [0, 20, 10, 0]
  //          }
  //        ],
  //        columnGap: 20
  //      },
  //      { text: '\n\n' },

  //      {
  //        style: 'tableStyle',
  //        table: {
  //          widths: [90, 90, 90, 90, 90],
  //          body: [
  //            [{ text: 'Booking ID', border: [true, true, false, false] }, { text: 'Booking Date', border: [false, true, false, false] }, { text: 'Airline Ref.', border: [false, true, false, false] }, { text: 'PNR', border: [false, true, false, false] }, { text: 'Status', border: [false, true, true, false] }],
  //            [{ text: this.bookingInfo.bookingID, bold: true, border: [true, false, false, true] }, { text: formatedBookingDate, bold: true, border: [false, false, false, true] }, { text: this.bookingInfo.supplierLocatorCode, bold: true, border: [false, false, false, true] }, { text: this.bookingInfo.pnr, bold: true, border: [false, false, false, true] }, { text: this.bookingStatus, bold: true, border: [false, false, true, true] }]
  //          ]
  //        },
  //        layout: {
  //          hLineWidth: function (i, node) {
  //            return (i === 0 || i === node.table.body.length) ? 0.5 : 0.5;
  //          },
  //          vLineWidth: function (i, node) {
  //            return (i === 0 || i === node.table.widths.length) ? 0.5 : 0.5;
  //          },
  //          hLineColor: function (i, node) {
  //            return (i === 0 || i === node.table.body.length) ? 'gray' : 'gray';
  //          },
  //          vLineColor: function (i, node) {
  //            return (i === 0 || i === node.table.widths.length) ? 'gray' : 'gray';
  //          }
  //        }
  //      },
  //      //{ text: '\n' },
  //      OnewaySectors.length > 0 ? { text: [{ text: " ONWARD: ", style: 'itineraryHeaderLeft' }, { text: ` ${this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo[0].fromAirport.split('-')[1].split('-')[0]}  ---->  ${this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo[0].toAirport.split('-')[1].split('-')[0]}`, style: 'itineraryHeaderRight' }, { text: " | ", fontSize: 7, bold: true }, { text: `Stops: ${OnewaySectors[0].noOfStops}`, fontSize: 7, bold: true }, { text: onewayStopsAt.length > 0 ? ` (${onewayStopsAt.map(itm => itm).join(', ')}) ` : " ", fontSize: 7, bold: true }, { text: "| " + this.bookingInfo.galileoBookingProp.flightProp.cabinClass, fontSize: 7, bold: true }], style: 'itnTopMargin' } : {},
  //      OnewaySectors.length > 0 ? OnewaySectors.map((it, ind) => {
  //        return [
  //          {
  //            table: {
  //              widths: [50, '*', '*', '*', /*50,*/ '*', '*'],
  //              body: [
  //                [{ text: '' }, ind == 0 ? { text: 'Flight No', bold: true } : {}, ind == 0 ? { text: 'Origin', bold: true } : {}, ind == 0 ? { text: 'Destination', bold: true } : {}, /*ind == 0 ? { text: 'Duration', bold: true }:{},*/ ind == 0 ? { text: 'Dep. Date', bold: true } : {}, ind == 0 ? { text: 'Arv. Date', bold: true } : {}],
  //                [it.airlineLogo.includes("svg") ? (it.airlineLogoTicket == null ? { text: it.airlineName, fontSize: 7, bold: true } : { svg: it.airlineLogoTicket, width: 28, height: 21 }) : (it.airlineLogoTicket == null ? { text: it.airlineName, fontSize: 7, bold: true } : { image: it.airlineLogoTicket, width: 28, height: 21 }),
  //                { text: it.airlinePrefixCode + it.flightNumber },
  //                { text: [{ text: it.fromCity }, { text: ` [${it.fromAirport}] `, bold: true }, { text: '\n' }, { text: it.fromAirportName, fontSize: 6 }] },
  //                { text: [{ text: it.toCity }, { text: ` [${it.toAirport}] `, bold: true }, { text: '\n' }, { text: it.toAirportName, fontSize: 6 }] },
  //                /*{ text: "-" },*/
  //                { text: `${it.departureTime}\n${formatDate(it.departureDate, 'dd MMMM yyyy', this.locale)}` },
  //                { text: `${it.arrivalTime}\n${formatDate(it.arrivalDate, 'dd MMMM yyyy', this.locale)}\n` }]
  //              ]
  //            },
  //            style: 'tableStyle',
  //            layout: 'noBorders'
  //          }
  //        ];
  //      }) : [],

  //      isRoundTrip ? {
  //        text: [{ text: " RETURN: ", style: 'itineraryHeaderLeft' }, { text: ` ${this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo[1].fromAirport.split('-')[1].split('-')[0]}  ---->  ${this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo[1].toAirport.split('-')[1].split('-')[0]}`, style: 'itineraryHeaderRight' }, { text: " | ", fontSize: 7, bold: true }, { text: `Stops: ${RoundTripSectors[0].noOfStops}`, fontSize: 7, bold: true }, { text: returnStopsAt.length > 0 ? ` (${returnStopsAt.map(itm => itm).join(', ')}) ` : " ", fontSize: 7, bold: true }, { text: "| " + this.bookingInfo.galileoBookingProp.flightProp.cabinClass, fontSize: 7, bold: true }], style: 'itnTopMargin'
  //      } : {},

  //      isRoundTrip ? RoundTripSectors.map((it, ind) => {
  //        return [
  //          {
  //            table: {
  //              widths: [50, '*', '*', '*', /*50,*/ '*', '*'],
  //              body: [
  //                [{ text: '' }, ind == 0 ? { text: 'Flight No', bold: true } : {}, ind == 0 ? { text: 'Origin', bold: true } : {}, ind == 0 ? { text: 'Destination', bold: true } : {}, /*ind == 0 ? { text: 'Duration', bold: true }:{},*/ ind == 0 ? { text: 'Dep. Date', bold: true } : {}, ind == 0 ? { text: 'Arv. Date', bold: true } : {}],
  //                [it.airlineLogo.includes("svg") ? (it.airlineLogoTicket == null ? { text: it.airlineName, fontSize: 7, bold: true } : { svg: it.airlineLogoTicket, width: 28, height: 21 }) : (it.airlineLogoTicket == null ? { text: it.airlineName, fontSize: 7, bold: true } : { image: it.airlineLogoTicket, width: 28, height: 21 }),
  //                { text: it.airlinePrefixCode + it.flightNumber },
  //                { text: [{ text: it.fromCity }, { text: ` [${it.fromAirport}] `, bold: true }, { text: '\n' }, { text: it.fromAirportName, fontSize: 6 }] },
  //                { text: [{ text: it.toCity }, { text: ` [${it.toAirport}] `, bold: true }, { text: '\n' }, { text: it.toAirportName, fontSize: 6 }] },
  //                /*{ text: "-" },*/
  //                { text: `${it.departureTime}\n${formatDate(it.departureDate, 'dd MMMM yyyy', this.locale)}` },
  //                { text: `${it.arrivalTime}\n${formatDate(it.arrivalDate, 'dd MMMM yyyy', this.locale)}\n` }]
  //              ]
  //            },
  //            style: 'tableStyle',
  //            layout: 'noBorders'
  //          }
  //        ];
  //      }) : [],

  //      isMulti ? MultiCitySectors.map((oit) => {
  //        return [
  //          { text: [{ text: " ONWARD: ", style: 'itineraryHeaderLeft' }, { text: oit.flightInfo, style: 'itineraryHeaderRight' }, { text: " | ", fontSize: 7, bold: true }, { text: `Stops: ${oit.sectorInfo[0].noOfStops}`, fontSize: 7, bold: true }, { text: oit.multiStopsAt.length > 0 ? ` (${oit.multiStopsAt.map(itm => itm).join(', ')}) ` : " ", fontSize: 7, bold: true }, { text: "| " + this.bookingInfo.galileoBookingProp.flightProp.cabinClass, fontSize: 7, bold: true }], style: 'itnTopMargin' },
  //          {
  //            table: {
  //              widths: [50, '*', '*', '*', /*50,*/ '*', '*'],
  //              body: [
  //                [{ text: '' }, { text: 'Flight No', bold: true }, { text: 'Origin', bold: true }, { text: 'Destination', bold: true }, /*ind == 0 ? { text: 'Duration', bold: true }:{},*/ { text: 'Dep. Date', bold: true }, { text: 'Arv. Date', bold: true }],
  //                ...oit.sectorInfo.map(iit =>
  //                  [
  //                    iit.airlineLogo.includes("svg") ? (iit.airlineLogoTicket == null ? { text: iit.airlineName, fontSize: 7, bold: true } : { svg: iit.airlineLogoTicket, width: 28, height: 21 }) : (iit.airlineLogoTicket == null ? { text: iit.airlineName, fontSize: 7, bold: true } : { image: iit.airlineLogoTicket, width: 28, height: 21 }),
  //                    { text: iit.airlinePrefixCode + iit.flightNumber },
  //                    { text: [{ text: iit.fromCity }, { text: ` [${iit.fromAirport}] `, bold: true }, { text: '\n' }, { text: iit.fromAirportName, fontSize: 6 }] },
  //                    { text: [{ text: iit.toCity }, { text: ` [${iit.toAirport}] `, bold: true }, { text: '\n' }, { text: iit.toAirportName, fontSize: 6 }] },
  //                    /*{ text: "-" },*/
  //                    { text: `${iit.departureTime}\n${formatDate(iit.departureDate, 'dd MMMM yyyy', this.locale)}` },
  //                    { text: `${iit.arrivalTime}\n${formatDate(iit.arrivalDate, 'dd MMMM yyyy', this.locale)}\n` }
  //                  ])
  //              ]
  //            },
  //            style: 'tableStyle',
  //            layout: 'noBorders'
  //          }
  //        ]
  //      }) : [],

  //      { text: '\n' },

  //      { text: 'Passenger Information', style: 'subHeader' },
  //      {
  //        table: {
  //          widths: ['*', '*', '*', '*', '*'],
  //          body: [
  //            [{ text: 'Sector', bold: true }, { text: 'Passenger Name', bold: true }, { text: 'CheckIn / Cabin', bold: true }, { text: 'Ticket No', bold: true }, { text: 'Seat / Meal', bold: true }],
  //            ...sortedBaggageInfo.map(p => [
  //              p.sector,
  //              p.paxs.map(nam => nam.paxName).join('\n'),
  //              p.checkIn + " / " + p.cabin,
  //              p.paxs.map(nam => nam.ticketNo === null ? "-" : nam.ticketNo).join('\n'),
  //              `${p.seatNo === null ? "-" : p.seatNo} / ${p.meal === null ? "-" : p.meal}`
  //            ])
  //          ]
  //        },
  //        style: 'tableStyle',
  //        layout: 'lightHorizontalLines'
  //      },
  //      { text: '\n' },
  //      { text: 'Note:', style: 'subHeader' },
  //      { text: 'Please read the terms and conditions of your ticket carefully. These include rules regarding cancellations, changes, and refund policies.', margin: [0, 0], italics: true, fontSize: 7 },

  //    ];

  //    const documentDefinition = {
  //      info: {
  //        title: 'OK Travels Flight Ticket',
  //        author: 'Zabi Ullah @ Soft Tech Bridge',
  //        subject: 'OK Travels Flight Ticket from Soft Tech Bridge',
  //      },
  //      //watermark: 'OK Travels & Tourism (pvt) Ltd',
  //      pageSize: 'A4',
  //      language: 'en-GB',
  //      content: [
  //        ...financeType === false && alleach === "each" ? withoutEachContent : financeType === false && alleach === "all" ? withoutAllContent : [{
  //          columns: [
  //            {
  //              image: agencyLogo, width: 60, height: 45
  //            },
  //            {
  //              text: [
  //                { text: `${this.agencyOnline.agencyName}\n`, bold: true, fontSize: 14 }//,
  //                //{ text: `${this.agencyOnline.address1 + " - " + this.agencyOnline.address2}\n`, fontSize: 7, bold: false, italics: true },
  //                //{ text: `Agent: ${this.userOnline.firstName + " " + this.userOnline.lastName}\n`, fontSize: 7, bold: false },
  //                //{ text: `Phone: ${this.userOnline.mobile}\n`, fontSize: 7, bold: false },
  //                //{ text: `Email: ${this.userOnline.email}\n`, fontSize: 7, bold: false },
  //              ],
  //              alignment: 'right',
  //              margin: [0, 20, 10, 0]
  //            }
  //          ],
  //          columnGap: 20
  //        },
  //        { text: '\n\n' },

  //        // Booking Info Section
  //        {
  //          style: 'tableStyle',
  //          table: {
  //            //headerRows: 1,
  //            widths: [90, 90, 90, 90, 90],
  //            body: [
  //              [{ text: 'Booking ID', border: [true, true, false, false] }, { text: 'Booking Date', border: [false, true, false, false] }, { text: 'Airline Ref.', border: [false, true, false, false] }, { text: 'PNR', border: [false, true, false, false] }, { text: 'Status', border: [false, true, true, false] }],
  //              [{ text: this.bookingInfo.bookingID, bold: true, border: [true, false, false, true] }, { text: formatedBookingDate, bold: true, border: [false, false, false, true] }, { text: this.bookingInfo.supplierLocatorCode, bold: true, border: [false, false, false, true] }, { text: this.bookingInfo.pnr, bold: true, border: [false, false, false, true] }, { text: this.bookingStatus, bold: true, border: [false, false, true, true] }]
  //            ]
  //          },
  //          layout: {
  //            hLineWidth: function (i, node) {
  //              return (i === 0 || i === node.table.body.length) ? 0.5 : 0.5;
  //            },
  //            vLineWidth: function (i, node) {
  //              return (i === 0 || i === node.table.widths.length) ? 0.5 : 0.5;
  //            },
  //            hLineColor: function (i, node) {
  //              return (i === 0 || i === node.table.body.length) ? 'gray' : 'gray';
  //            },
  //            vLineColor: function (i, node) {
  //              return (i === 0 || i === node.table.widths.length) ? 'gray' : 'gray';
  //            }
  //          }
  //        },
  //        //{ text: '\n' },
  //        OnewaySectors.length > 0 ? { text: [{ text: " ONWARD: ", style: 'itineraryHeaderLeft' }, { text: ` ${this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo[0].fromAirport.split('-')[1].split('-')[0]}  ---->  ${this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo[0].toAirport.split('-')[1].split('-')[0]}`, style: 'itineraryHeaderRight' }, { text: " | ", fontSize: 7, bold: true }, { text: `Stops: ${OnewaySectors[0].noOfStops}`, fontSize: 7, bold: true }, { text: onewayStopsAt.length > 0 ? ` (${onewayStopsAt.map(itm => itm).join(', ')}) ` : " ", fontSize: 7, bold: true }, { text: "| " + this.bookingInfo.galileoBookingProp.flightProp.cabinClass, fontSize: 7, bold: true }], style: 'itnTopMargin' } : {},
  //        OnewaySectors.length > 0 ? OnewaySectors.map((it, ind) => {
  //          return [
  //            {
  //              table: {
  //                widths: [50, '*', '*', '*', /*50,*/ '*', '*'],
  //                body: [
  //                  [{ text: '' }, ind == 0 ? { text: 'Flight No', bold: true } : {}, ind == 0 ? { text: 'Origin', bold: true } : {}, ind == 0 ? { text: 'Destination', bold: true } : {}, /*ind == 0 ? { text: 'Duration', bold: true }:{},*/ ind == 0 ? { text: 'Dep. Date', bold: true } : {}, ind == 0 ? { text: 'Arv. Date', bold: true } : {}],
  //                  [it.airlineLogo.includes("svg") ? (it.airlineLogoTicket == null ? { text: it.airlineName, fontSize: 7, bold: true } : { svg: it.airlineLogoTicket, width: 28, height: 21 }) : (it.airlineLogoTicket == null ? { text: it.airlineName, fontSize: 7, bold: true } : { image: it.airlineLogoTicket, width: 28, height: 21 }),
  //                  { text: it.airlinePrefixCode + it.flightNumber },
  //                  { text: [{ text: it.fromCity }, { text: ` [${it.fromAirport}] `, bold: true }, { text: '\n' }, { text: it.fromAirportName, fontSize: 6 }] },
  //                  { text: [{ text: it.toCity }, { text: ` [${it.toAirport}] `, bold: true }, { text: '\n' }, { text: it.toAirportName, fontSize: 6 }] },
  //                  /*{ text: "-" },*/
  //                  { text: `${it.departureTime}\n${formatDate(it.departureDate, 'dd MMMM yyyy', this.locale)}` },
  //                  { text: `${it.arrivalTime}\n${formatDate(it.arrivalDate, 'dd MMMM yyyy', this.locale)}\n` }]
  //                ]
  //              },
  //              style: 'tableStyle',
  //              layout: 'noBorders'
  //            }
  //          ];
  //        }) : [],

  //        isRoundTrip ? {
  //          text: [{ text: " RETURN: ", style: 'itineraryHeaderLeft' }, { text: ` ${this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo[1].fromAirport.split('-')[1].split('-')[0]}  ---->  ${this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo[1].toAirport.split('-')[1].split('-')[0]}`, style: 'itineraryHeaderRight' }, { text: " | ", fontSize: 7, bold: true }, { text: `Stops: ${RoundTripSectors[0].noOfStops}`, fontSize: 7, bold: true }, { text: returnStopsAt.length > 0 ? ` (${returnStopsAt.map(itm => itm).join(', ')}) ` : " ", fontSize: 7, bold: true }, { text: "| " + this.bookingInfo.galileoBookingProp.flightProp.cabinClass, fontSize: 7, bold: true }], style: 'itnTopMargin'
  //        } : {},

  //        isRoundTrip ? RoundTripSectors.map((it, ind) => {
  //          return [
  //            {
  //              table: {
  //                widths: [50, '*', '*', '*', /*50,*/ '*', '*'],
  //                body: [
  //                  [{ text: '' }, ind == 0 ? { text: 'Flight No', bold: true } : {}, ind == 0 ? { text: 'Origin', bold: true } : {}, ind == 0 ? { text: 'Destination', bold: true } : {}, /*ind == 0 ? { text: 'Duration', bold: true }:{},*/ ind == 0 ? { text: 'Dep. Date', bold: true } : {}, ind == 0 ? { text: 'Arv. Date', bold: true } : {}],
  //                  [it.airlineLogo.includes("svg") ? (it.airlineLogoTicket == null ? { text: it.airlineName, fontSize: 7, bold: true } : { svg: it.airlineLogoTicket, width: 28, height: 21 }) : (it.airlineLogoTicket == null ? { text: it.airlineName, fontSize: 7, bold: true } : { image: it.airlineLogoTicket, width: 28, height: 21 }),
  //                  { text: it.airlinePrefixCode + it.flightNumber },
  //                  { text: [{ text: it.fromCity }, { text: ` [${it.fromAirport}] `, bold: true }, { text: '\n' }, { text: it.fromAirportName, fontSize: 6 }] },
  //                  { text: [{ text: it.toCity }, { text: ` [${it.toAirport}] `, bold: true }, { text: '\n' }, { text: it.toAirportName, fontSize: 6 }] },
  //                  /*{ text: "-" },*/
  //                  { text: `${it.departureTime}\n${formatDate(it.departureDate, 'dd MMMM yyyy', this.locale)}` },
  //                  { text: `${it.arrivalTime}\n${formatDate(it.arrivalDate, 'dd MMMM yyyy', this.locale)}\n` }]
  //                ]
  //              },
  //              style: 'tableStyle',
  //              layout: 'noBorders'
  //            }
  //          ];
  //        }) : [],

  //        isMulti ? MultiCitySectors.map((oit) => {
  //          return [
  //            { text: [{ text: " ONWARD: ", style: 'itineraryHeaderLeft' }, { text: oit.flightInfo, style: 'itineraryHeaderRight' }, { text: " | ", fontSize: 7, bold: true }, { text: `Stops: ${oit.sectorInfo[0].noOfStops}`, fontSize: 7, bold: true }, { text: oit.multiStopsAt.length > 0 ? ` (${oit.multiStopsAt.map(itm => itm).join(', ')}) ` : " ", fontSize: 7, bold: true }, { text: "| " + this.bookingInfo.galileoBookingProp.flightProp.cabinClass, fontSize: 7, bold: true }], style: 'itnTopMargin' },
  //            {
  //              table: {
  //                widths: [50, '*', '*', '*', /*50,*/ '*', '*'],
  //                body: [
  //                  [{ text: '' }, { text: 'Flight No', bold: true }, { text: 'Origin', bold: true }, { text: 'Destination', bold: true }, /*ind == 0 ? { text: 'Duration', bold: true }:{},*/ { text: 'Dep. Date', bold: true }, { text: 'Arv. Date', bold: true }],
  //                  ...oit.sectorInfo.map(iit =>
  //                    [
  //                      iit.airlineLogo.includes("svg") ? (iit.airlineLogoTicket == null ? { text: iit.airlineName, fontSize: 6, bold: true } : { svg: iit.airlineLogoTicket, width: 28, height: 21 }) : (iit.airlineLogoTicket == null ? { text: iit.airlineName, fontSize: 6, bold: true } : { image: iit.airlineLogoTicket, width: 28, height: 21 }),
  //                      { text: iit.airlinePrefixCode + iit.flightNumber },
  //                      { text: [{ text: iit.fromCity }, { text: ` [${iit.fromAirport}] `, bold: true }, { text: '\n' }, { text: iit.fromAirportName, fontSize: 6 }] },
  //                      { text: [{ text: iit.toCity }, { text: ` [${iit.toAirport}] `, bold: true }, { text: '\n' }, { text: iit.toAirportName, fontSize: 6 }] },
  //                      /*{ text: "-" },*/
  //                      { text: `${iit.departureTime}\n${formatDate(iit.departureDate, 'dd MMMM yyyy', this.locale)}` },
  //                      { text: `${iit.arrivalTime}\n${formatDate(iit.arrivalDate, 'dd MMMM yyyy', this.locale)}\n` }
  //                    ])
  //                ]
  //              },
  //              style: 'tableStyle',
  //              layout: 'noBorders'
  //            }
  //          ]
  //        }) : [],

  //        { text: '\n' },

  //        // Passenger Information Table
  //        { text: 'Passenger Information', style: 'subHeader' },
  //        {
  //          table: {
  //            widths: ['*', '*', '*', '*', '*'],
  //            body: [
  //              [{ text: 'Sector', bold: true }, { text: 'Passenger(s)', bold: true }, { text: 'CheckIn / Cabin', bold: true }, { text: 'Ticket No', bold: true }, { text: 'Seat / Meal', bold: true }],
  //              ...sortedBaggageInfo.map(p => [
  //                p.sector,
  //                p.paxs.map(nam => nam.paxName).join('\n'),
  //                p.checkIn + " / " + p.cabin,
  //                p.paxs.map(nam => nam.ticketNo === null ? "-" : nam.ticketNo).join('\n'),
  //                `${p.seatNo === null ? "-" : p.seatNo} / ${p.meal === null ? "-" : p.meal}`
  //              ])
  //            ]
  //          },
  //          style: 'tableStyle',
  //          layout: 'lightHorizontalLines'
  //        },

  //        //{ text: '\n' },

  //        // Financial Information Table
  //        { text: 'Financial Summary', style: 'subHeader' },
  //        {
  //          table: {
  //            widths: ['*', '*', '*', '*', '*'],
  //            body: [
  //              [{ text: 'Passenger(s)', bold: true }, { text: 'Base Fare', bold: true }, { text: 'Service Fees', bold: true }, { text: 'Taxes', bold: true }, { text: 'Total', bold: true }],
  //              ...this.bookingPassengerInfo.map(f => [
  //                f.firstName + " " + f.lastName, f.exchangeCurrency + f.baseFare, f.exchangeCurrency + f.serviceCharges, f.exchangeCurrency + (f.totalTaxes + f.markup + f.runtimeMarkup), f.exchangeCurrency + f.netFromCustomer
  //              ])
  //            ]
  //          },
  //          style: 'tableStyle',
  //          layout: 'headerLineOnly'
  //        },

  //        { text: '\n' },

  //        // Conditions Text
  //        { text: 'Note:', style: 'subHeader' },
  //        { text: 'Please read the terms and conditions of your ticket carefully. These include rules regarding cancellations, changes, and refund policies.', margin: [0, 0], italics: true, fontSize: 7 },
  //        ]
  //      ],
  //      styles: {
  //        //header: { fontSize: 11, bold: true, margin: [0, 5], alignment: 'justify' },
  //        subHeader: { fontSize: 7, bold: true, margin: [0, 5], alignment: 'justify' },
  //        itineraryHeaderLeft: { fontSize: 7, bold: true },
  //        itineraryHeaderRight: { fontSize: 7, bold: true },
  //        itnTopMargin: { margin: [0, 20, 0, 10] },
  //        itinerarySummary: { fontSize: 7, margin: [0, 0] },
  //        tableStyle: { fontSize: 7, border: [false, false, false, true], margin: [0, 0], alignment: 'center' },
  //      }
  //    };
  //    this.hideBtnLoader();
  //    pdfMake.createPdf(documentDefinition).open();
  //  });
  //}




  //emailItineraryFinance(financeType: boolean, alleach: string) {
  //  this.showBtnLoader();
  //  this.isLoadPanelVisible = true;
  //  let agencyLogoName = this.agencyOnline.logoFileName;
  //  let imgType = agencyLogoName.substring(agencyLogoName.lastIndexOf(".") + 1);
  //  var agencyLogo = 'data:image/' + imgType + ';base64,' + this.agencyOnline.logoFilePath;
  //  let bookingDateString = this.bookingInfo.bookingDate;
  //  let bookingDate = new Date(bookingDateString!);
  //  let formatedBookingDate = bookingDate.toLocaleString('en-US', { year: 'numeric', month: 'long', day: 'numeric', });
  //  this.loadLogos(this.newsectorInfo).then(base64Logos => {
  //    for (let ln = 0; ln < base64Logos.length; ln++) {
  //      this.newsectorInfo[ln].airlineLogoTicket = base64Logos[ln];
  //    }
  //    const { OnewaySectors, RoundTripSectors, MultiCitySectors, isRoundTrip, isMulti } = this.classifySectors(this.bookingInfo.galileoBookingProp!.flightProp!.flightLocationInfo, this.newsectorInfo);
  //    let sortedBaggageInfo: TicketPaxBaggageSectorSortedProperties[] = [];
  //    for (let si = 0; si < this.newsectorInfo.length; si++) {
  //      let sect = new TicketPaxBaggageSectorSortedProperties();
  //      sect.sector = this.newsectorInfo[si].fromAirport + " ---> " + this.newsectorInfo[si].toAirport;
  //      sect.checkIn = this.newsectorInfo[si].baggageCheckIn!;
  //      sect.cabin = this.newsectorInfo[si].baggageCabin!;
  //      sect.ticketNo = this.newsectorInfo[si].ticketDesignator!;
  //      sect.seatNo = this.newsectorInfo[si].seatNumber;
  //      sect.meal = this.newsectorInfo[si].meal;
  //      for (let pi = 0; pi < this.bookingPassengerInfo.length; pi++) {
  //        let pax = new TicketSortedPaxs();
  //        pax.paxName = this.bookingPassengerInfo[pi].firstName + " " + this.bookingPassengerInfo[pi].lastName;
  //        pax.ticketNo = this.bookingPassengerInfo[pi].ticketNo;
  //        sect.paxs.push(pax);
  //      }
  //      sortedBaggageInfo.push(sect);
  //    }
  //    let onewayStopsAt: string[] = [];
  //    let returnStopsAt: string[] = [];
  //    for (let index = 0; index < OnewaySectors.length; index++) {
  //      if (index != OnewaySectors.length - 1) {
  //        onewayStopsAt.push(OnewaySectors[index].toCity!);
  //      } else {
  //        continue;
  //      }
  //    };
  //    for (let index = 0; index < RoundTripSectors.length; index++) {
  //      if (index != RoundTripSectors.length - 1) {
  //        returnStopsAt.push(RoundTripSectors[index].toCity!);
  //      } else {
  //        continue;
  //      }
  //    };

  //    const withoutEachContent = this.bookingPassengerInfo.map((item, index) => {
  //      return [
  //        {
  //          columns: [
  //            {
  //              image: agencyLogo, width: 60, height: 45
  //            },
  //            {
  //              text: [
  //                { text: `${this.agencyOnline.agencyName}\n`, bold: true, fontSize: 14 }//,
  //                //{ text: `${this.agencyOnline.address1 + " - " + this.agencyOnline.address2}\n`, fontSize: 7, bold: false, italics: true },
  //                //{ text: `Agent: ${this.userOnline.firstName + " " + this.userOnline.lastName}\n`, fontSize: 7, bold: false },
  //                //{ text: `Phone: ${this.userOnline.mobile}\n`, fontSize: 7, bold: false },
  //                //{ text: `Email: ${this.userOnline.email}\n`, fontSize: 7, bold: false },
  //              ],
  //              alignment: 'right',
  //              margin: [0, 20, 10, 0]
  //            }
  //          ],
  //          columnGap: 20
  //        },
  //        { text: '\n\n' },

  //        {
  //          style: 'tableStyle',
  //          table: {
  //            widths: [90, 90, 90, 90, 90],
  //            body: [
  //              [{ text: 'Booking ID', border: [true, true, false, false] }, { text: 'Booking Date', border: [false, true, false, false] }, { text: 'Airline Ref.', border: [false, true, false, false] }, { text: 'PNR', border: [false, true, false, false] }, { text: 'Status', border: [false, true, true, false] }],
  //              [{ text: this.bookingInfo.bookingID, bold: true, border: [true, false, false, true] }, { text: formatedBookingDate, bold: true, border: [false, false, false, true] }, { text: this.bookingInfo.supplierLocatorCode, bold: true, border: [false, false, false, true] }, { text: this.bookingInfo.pnr, bold: true, border: [false, false, false, true] }, { text: this.bookingStatus, bold: true, border: [false, false, true, true] }]
  //            ]
  //          },
  //          layout: {
  //            hLineWidth: function (i: number, node: any) {
  //              return (i === 0 || i === node.table.body.length) ? 0.5 : 0.5;
  //            },
  //            vLineWidth: function (i: number, node: any) {
  //              return (i === 0 || i === node.table.widths.length) ? 0.5 : 0.5;
  //            },
  //            hLineColor: function (i: number, node: any) {
  //              return (i === 0 || i === node.table.body.length) ? 'gray' : 'gray';
  //            },
  //            vLineColor: function (i: number, node: any) {
  //              return (i === 0 || i === node.table.widths.length) ? 'gray' : 'gray';
  //            }
  //          }
  //        },
  //        //{ text: '\n' },
  //        OnewaySectors.length > 0 ? { text: [{ text: " ONWARD: ", style: 'itineraryHeaderLeft' }, { text: ` ${this.bookingInfo.galileoBookingProp!.flightProp!.flightLocationInfo[0].fromAirport.split('-')[1].split('-')[0]}  ---->  ${this.bookingInfo.galileoBookingProp!.flightProp!.flightLocationInfo[0].toAirport.split('-')[1].split('-')[0]}`, style: 'itineraryHeaderRight' }, { text: " | ", fontSize: 7, bold: true }, { text: `Stops: ${OnewaySectors[0].noOfStops}`, fontSize: 7, bold: true }, { text: onewayStopsAt.length > 0 ? ` (${onewayStopsAt.map(itm => itm).join(', ')}) ` : " ", fontSize: 7, bold: true }, { text: "| " + this.bookingInfo.galileoBookingProp!.flightProp!.cabinClass, fontSize: 7, bold: true }], style: 'itnTopMargin' } : {},
  //        OnewaySectors.length > 0 ? OnewaySectors.map((it, ind) => {
  //          return [
  //            {
  //              table: {
  //                widths: [50, '*', '*', '*', /*50,*/ '*', '*'],
  //                body: [
  //                  [{ text: '' }, ind == 0 ? { text: 'Flight No', bold: true } : {}, ind == 0 ? { text: 'Origin', bold: true } : {}, ind == 0 ? { text: 'Destination', bold: true } : {}, /*ind == 0 ? { text: 'Duration', bold: true }:{},*/ ind == 0 ? { text: 'Dep. Date', bold: true } : {}, ind == 0 ? { text: 'Arv. Date', bold: true } : {}],
  //                  [it.airlineLogo!.includes("svg") ? (it.airlineLogoTicket == null ? { text: it.airlineName, fontSize: 7, bold: true } : { svg: it.airlineLogoTicket, width: 28, height: 21 }) : (it.airlineLogoTicket == null ? { text: it.airlineName, fontSize: 7, bold: true } : { image: it.airlineLogoTicket, width: 28, height: 21 }),
  //                  { text: it.airlinePrefixCode! + it.flightNumber },
  //                  { text: [{ text: it.fromCity }, { text: ` [${it.fromAirport}] `, bold: true }, { text: '\n' }, { text: it.fromAirportName, fontSize: 6 }] },
  //                  { text: [{ text: it.toCity }, { text: ` [${it.toAirport}] `, bold: true }, { text: '\n' }, { text: it.toAirportName, fontSize: 6 }] },
  //                  /*{ text: "-" },*/
  //                  { text: `${it.departureTime}\n${formatDate(it.departureDate!, 'dd MMMM yyyy', this.locale)}` },
  //                  { text: `${it.arrivalTime}\n${formatDate(it.arrivalDate!, 'dd MMMM yyyy', this.locale)}\n` }]
  //                ]
  //              },
  //              style: 'tableStyle',
  //              layout: 'noBorders'
  //            }
  //          ];
  //        }) : [],

  //        isRoundTrip ? {
  //          text: [{ text: " RETURN: ", style: 'itineraryHeaderLeft' }, { text: ` ${this.bookingInfo.galileoBookingProp!.flightProp!.flightLocationInfo[1].fromAirport.split('-')[1].split('-')[0]}  ---->  ${this.bookingInfo.galileoBookingProp!.flightProp!.flightLocationInfo[1].toAirport.split('-')[1].split('-')[0]}`, style: 'itineraryHeaderRight' }, { text: " | ", fontSize: 7, bold: true }, { text: `Stops: ${RoundTripSectors[0].noOfStops}`, fontSize: 7, bold: true }, { text: returnStopsAt.length > 0 ? ` (${returnStopsAt.map(itm => itm).join(', ')}) ` : " ", fontSize: 7, bold: true }, { text: "| " + this.bookingInfo.galileoBookingProp!.flightProp!.cabinClass, fontSize: 7, bold: true }], style: 'itnTopMargin'
  //        } : {},

  //        isRoundTrip ? RoundTripSectors.map((it, ind) => {
  //          return [
  //            {
  //              table: {
  //                widths: [50, '*', '*', '*', /*50,*/ '*', '*'],
  //                body: [
  //                  [{ text: '' }, ind == 0 ? { text: 'Flight No', bold: true } : {}, ind == 0 ? { text: 'Origin', bold: true } : {}, ind == 0 ? { text: 'Destination', bold: true } : {}, /*ind == 0 ? { text: 'Duration', bold: true }:{},*/ ind == 0 ? { text: 'Dep. Date', bold: true } : {}, ind == 0 ? { text: 'Arv. Date', bold: true } : {}],
  //                  [it.airlineLogo!.includes("svg") ? (it.airlineLogoTicket == null ? { text: it.airlineName, fontSize: 7, bold: true } : { svg: it.airlineLogoTicket, width: 28, height: 21 }) : (it.airlineLogoTicket == null ? { text: it.airlineName, fontSize: 7, bold: true } : { image: it.airlineLogoTicket, width: 28, height: 21 }),
  //                  { text: it.airlinePrefixCode! + it.flightNumber },
  //                  { text: [{ text: it.fromCity }, { text: ` [${it.fromAirport}] `, bold: true }, { text: '\n' }, { text: it.fromAirportName, fontSize: 6 }] },
  //                  { text: [{ text: it.toCity }, { text: ` [${it.toAirport}] `, bold: true }, { text: '\n' }, { text: it.toAirportName, fontSize: 6 }] },
  //                  /*{ text: "-" },*/
  //                  { text: `${it.departureTime}\n${formatDate(it.departureDate!, 'dd MMMM yyyy', this.locale)}` },
  //                  { text: `${it.arrivalTime}\n${formatDate(it.arrivalDate!, 'dd MMMM yyyy', this.locale)}\n` }]
  //                ]
  //              },
  //              style: 'tableStyle',
  //              layout: 'noBorders'
  //            }
  //          ];
  //        }) : [],

  //        isMulti ? MultiCitySectors.map((oit) => {
  //          return [
  //            { text: [{ text: " ONWARD: ", style: 'itineraryHeaderLeft' }, { text: oit.flightInfo, style: 'itineraryHeaderRight' }, { text: " | ", fontSize: 7, bold: true }, { text: `Stops: ${oit.sectorInfo[0].noOfStops}`, fontSize: 7, bold: true }, { text: oit.multiStopsAt.length > 0 ? ` (${oit.multiStopsAt.map(itm => itm).join(', ')}) ` : " ", fontSize: 7, bold: true }, { text: "| " + this.bookingInfo.galileoBookingProp!.flightProp!.cabinClass, fontSize: 7, bold: true }], style: 'itnTopMargin' },
  //            {
  //              table: {
  //                widths: [50, '*', '*', '*', /*50,*/ '*', '*'],
  //                body: [
  //                  [{ text: '' }, { text: 'Flight No', bold: true }, { text: 'Origin', bold: true }, { text: 'Destination', bold: true }, /*ind == 0 ? { text: 'Duration', bold: true }:{},*/ { text: 'Dep. Date', bold: true }, { text: 'Arv. Date', bold: true }],
  //                  ...oit.sectorInfo.map(iit =>
  //                    [
  //                      iit.airlineLogo!.includes("svg") ? (iit.airlineLogoTicket == null ? { text: iit.airlineName, fontSize: 7, bold: true } : { svg: iit.airlineLogoTicket, width: 28, height: 21 }) : (iit.airlineLogoTicket == null ? { text: iit.airlineName, fontSize: 7, bold: true } : { image: iit.airlineLogoTicket, width: 28, height: 21 }),
  //                      { text: iit.airlinePrefixCode! + iit.flightNumber },
  //                      { text: [{ text: iit.fromCity }, { text: ` [${iit.fromAirport}] `, bold: true }, { text: '\n' }, { text: iit.fromAirportName, fontSize: 6 }] },
  //                      { text: [{ text: iit.toCity }, { text: ` [${iit.toAirport}] `, bold: true }, { text: '\n' }, { text: iit.toAirportName, fontSize: 6 }] },
  //                      /*{ text: "-" },*/
  //                      { text: `${iit.departureTime}\n${formatDate(iit.departureDate!, 'dd MMMM yyyy', this.locale)}` },
  //                      { text: `${iit.arrivalTime}\n${formatDate(iit.arrivalDate!, 'dd MMMM yyyy', this.locale)}\n` }
  //                    ]
  //                  )
  //                ]
  //              },
  //              style: 'tableStyle',
  //              layout: 'noBorders'
  //            }
  //          ]
  //        }) : [],

  //        { text: '\n' },
  //        // Passenger Information Table
  //        { text: 'Passenger Information', style: 'subHeader' },
  //        {
  //          table: {
  //            widths: ['*', '*', '*', '*', '*'],
  //            body: [
  //              [{ text: 'Sector', bold: true }, { text: 'Passenger Name', bold: true }, { text: 'CheckIn / Cabin', bold: true }, { text: 'Ticket No', bold: true }, { text: 'Seat / Meal', bold: true }],
  //              ...sortedBaggageInfo.map(p => [
  //                p.sector,
  //                p.paxs[index].paxName,
  //                p.checkIn + " / " + p.cabin,
  //                p.paxs[index].ticketNo === null ? "-" : p.paxs[index].ticketNo,
  //                `${p.seatNo === null ? "-" : p.seatNo} / ${p.meal === null ? "-" : p.meal}`
  //              ])
  //            ]
  //          },
  //          style: 'tableStyle',
  //          layout: 'lightHorizontalLines'
  //        },
  //        { text: '\n' },
  //        { text: 'Note:', style: 'subHeader' },
  //        { text: 'Please read the terms and conditions of your ticket carefully. These include rules regarding cancellations, changes, and refund policies.', margin: [0, 0], italics: true, fontSize: 7 },

  //        { text: '', pageBreak: index < this.bookingPassengerInfo.length - 1 ? 'after' : undefined }, // Add page break except the last page
  //      ];
  //    });
  //    const withoutAllContent = [
  //      {
  //        columns: [
  //          {
  //            image: agencyLogo, width: 60, height: 45
  //          },
  //          {
  //            text: [
  //              { text: `${this.agencyOnline.agencyName}\n`, bold: true, fontSize: 14 }//,
  //              //{ text: `${this.agencyOnline.address1 + " - " + this.agencyOnline.address2}\n`, fontSize: 7, bold: false, italics: true },
  //              //{ text: `Agent: ${this.userOnline.firstName + " " + this.userOnline.lastName}\n`, fontSize: 7, bold: false },
  //              //{ text: `Phone: ${this.userOnline.mobile}\n`, fontSize: 7, bold: false },
  //              //{ text: `Email: ${this.userOnline.email}\n`, fontSize: 7, bold: false },
  //            ],
  //            alignment: 'right',
  //            margin: [0, 20, 10, 0]
  //          }
  //        ],
  //        columnGap: 20
  //      },
  //      { text: '\n\n' },

  //      {
  //        style: 'tableStyle',
  //        table: {
  //          widths: [90, 90, 90, 90, 90],
  //          body: [
  //            [{ text: 'Booking ID', border: [true, true, false, false] }, { text: 'Booking Date', border: [false, true, false, false] }, { text: 'Airline Ref.', border: [false, true, false, false] }, { text: 'PNR', border: [false, true, false, false] }, { text: 'Status', border: [false, true, true, false] }],
  //            [{ text: this.bookingInfo.bookingID, bold: true, border: [true, false, false, true] }, { text: formatedBookingDate, bold: true, border: [false, false, false, true] }, { text: this.bookingInfo.supplierLocatorCode, bold: true, border: [false, false, false, true] }, { text: this.bookingInfo.pnr, bold: true, border: [false, false, false, true] }, { text: this.bookingStatus, bold: true, border: [false, false, true, true] }]
  //          ]
  //        },
  //        layout: {
  //          hLineWidth: function (i: number, node: any) {
  //            return (i === 0 || i === node.table.body.length) ? 0.5 : 0.5;
  //          },
  //          vLineWidth: function (i: number, node: any) {
  //            return (i === 0 || i === node.table.widths.length) ? 0.5 : 0.5;
  //          },
  //          hLineColor: function (i: number, node: any) {
  //            return (i === 0 || i === node.table.body.length) ? 'gray' : 'gray';
  //          },
  //          vLineColor: function (i: number, node: any) {
  //            return (i === 0 || i === node.table.widths.length) ? 'gray' : 'gray';
  //          }
  //        }
  //      },
  //      //{ text: '\n' },
  //      OnewaySectors.length > 0 ? { text: [{ text: " ONWARD: ", style: 'itineraryHeaderLeft' }, { text: ` ${this.bookingInfo.galileoBookingProp!.flightProp!.flightLocationInfo[0].fromAirport.split('-')[1].split('-')[0]}  ---->  ${this.bookingInfo.galileoBookingProp!.flightProp!.flightLocationInfo[0].toAirport.split('-')[1].split('-')[0]}`, style: 'itineraryHeaderRight' }, { text: " | ", fontSize: 7, bold: true }, { text: `Stops: ${OnewaySectors[0].noOfStops}`, fontSize: 7, bold: true }, { text: onewayStopsAt.length > 0 ? ` (${onewayStopsAt.map(itm => itm).join(', ')}) ` : " ", fontSize: 7, bold: true }, { text: "| " + this.bookingInfo.galileoBookingProp!.flightProp!.cabinClass, fontSize: 7, bold: true }], style: 'itnTopMargin' } : {},
  //      OnewaySectors.length > 0 ? OnewaySectors.map((it, ind) => {
  //        return [
  //          {
  //            table: {
  //              widths: [50, '*', '*', '*', /*50,*/ '*', '*'],
  //              body: [
  //                [{ text: '' }, ind == 0 ? { text: 'Flight No', bold: true } : {}, ind == 0 ? { text: 'Origin', bold: true } : {}, ind == 0 ? { text: 'Destination', bold: true } : {}, /*ind == 0 ? { text: 'Duration', bold: true }:{},*/ ind == 0 ? { text: 'Dep. Date', bold: true } : {}, ind == 0 ? { text: 'Arv. Date', bold: true } : {}],
  //                [it.airlineLogo!.includes("svg") ? (it.airlineLogoTicket == null ? { text: it.airlineName, fontSize: 7, bold: true } : { svg: it.airlineLogoTicket, width: 28, height: 21 }) : (it.airlineLogoTicket == null ? { text: it.airlineName, fontSize: 7, bold: true } : { image: it.airlineLogoTicket, width: 28, height: 21 }),
  //                { text: it.airlinePrefixCode! + it.flightNumber },
  //                { text: [{ text: it.fromCity }, { text: ` [${it.fromAirport}] `, bold: true }, { text: '\n' }, { text: it.fromAirportName, fontSize: 6 }] },
  //                { text: [{ text: it.toCity }, { text: ` [${it.toAirport}] `, bold: true }, { text: '\n' }, { text: it.toAirportName, fontSize: 6 }] },
  //                /*{ text: "-" },*/
  //                { text: `${it.departureTime}\n${formatDate(it.departureDate!, 'dd MMMM yyyy', this.locale)}` },
  //                { text: `${it.arrivalTime}\n${formatDate(it.arrivalDate!, 'dd MMMM yyyy', this.locale)}\n` }]
  //              ]
  //            },
  //            style: 'tableStyle',
  //            layout: 'noBorders'
  //          }
  //        ];
  //      }) : [],

  //      isRoundTrip ? {
  //        text: [{ text: " RETURN: ", style: 'itineraryHeaderLeft' }, { text: ` ${this.bookingInfo.galileoBookingProp!.flightProp!.flightLocationInfo[1].fromAirport.split('-')[1].split('-')[0]}  ---->  ${this.bookingInfo.galileoBookingProp!.flightProp!.flightLocationInfo[1].toAirport.split('-')[1].split('-')[0]}`, style: 'itineraryHeaderRight' }, { text: " | ", fontSize: 7, bold: true }, { text: `Stops: ${RoundTripSectors[0].noOfStops}`, fontSize: 7, bold: true }, { text: returnStopsAt.length > 0 ? ` (${returnStopsAt.map(itm => itm).join(', ')}) ` : " ", fontSize: 7, bold: true }, { text: "| " + this.bookingInfo.galileoBookingProp!.flightProp!.cabinClass, fontSize: 7, bold: true }], style: 'itnTopMargin'
  //      } : {},

  //      isRoundTrip ? RoundTripSectors.map((it, ind) => {
  //        return [
  //          {
  //            table: {
  //              widths: [50, '*', '*', '*', /*50,*/ '*', '*'],
  //              body: [
  //                [{ text: '' }, ind == 0 ? { text: 'Flight No', bold: true } : {}, ind == 0 ? { text: 'Origin', bold: true } : {}, ind == 0 ? { text: 'Destination', bold: true } : {}, /*ind == 0 ? { text: 'Duration', bold: true }:{},*/ ind == 0 ? { text: 'Dep. Date', bold: true } : {}, ind == 0 ? { text: 'Arv. Date', bold: true } : {}],
  //                [it.airlineLogo!.includes("svg") ? (it.airlineLogoTicket == null ? { text: it.airlineName, fontSize: 7, bold: true } : { svg: it.airlineLogoTicket, width: 28, height: 21 }) : (it.airlineLogoTicket == null ? { text: it.airlineName, fontSize: 7, bold: true } : { image: it.airlineLogoTicket, width: 28, height: 21 }),
  //                { text: it.airlinePrefixCode! + it.flightNumber },
  //                { text: [{ text: it.fromCity }, { text: ` [${it.fromAirport}] `, bold: true }, { text: '\n' }, { text: it.fromAirportName, fontSize: 6 }] },
  //                { text: [{ text: it.toCity }, { text: ` [${it.toAirport}] `, bold: true }, { text: '\n' }, { text: it.toAirportName, fontSize: 6 }] },
  //                /*{ text: "-" },*/
  //                { text: `${it.departureTime}\n${formatDate(it.departureDate!, 'dd MMMM yyyy', this.locale)}` },
  //                { text: `${it.arrivalTime}\n${formatDate(it.arrivalDate!, 'dd MMMM yyyy', this.locale)}\n` }]
  //              ]
  //            },
  //            style: 'tableStyle',
  //            layout: 'noBorders'
  //          }
  //        ];
  //      }) : [],

  //      isMulti ? MultiCitySectors.map((oit) => {
  //        return [
  //          { text: [{ text: " ONWARD: ", style: 'itineraryHeaderLeft' }, { text: oit.flightInfo, style: 'itineraryHeaderRight' }, { text: " | ", fontSize: 7, bold: true }, { text: `Stops: ${oit.sectorInfo[0].noOfStops}`, fontSize: 7, bold: true }, { text: oit.multiStopsAt.length > 0 ? ` (${oit.multiStopsAt.map(itm => itm).join(', ')}) ` : " ", fontSize: 7, bold: true }, { text: "| " + this.bookingInfo.galileoBookingProp!.flightProp!.cabinClass, fontSize: 7, bold: true }], style: 'itnTopMargin' },
  //          {
  //            table: {
  //              widths: [50, '*', '*', '*', /*50,*/ '*', '*'],
  //              body: [
  //                [{ text: '' }, { text: 'Flight No', bold: true }, { text: 'Origin', bold: true }, { text: 'Destination', bold: true }, /*ind == 0 ? { text: 'Duration', bold: true }:{},*/ { text: 'Dep. Date', bold: true }, { text: 'Arv. Date', bold: true }],
  //                ...oit.sectorInfo.map(iit =>
  //                  [
  //                    iit.airlineLogo!.includes("svg") ? (iit.airlineLogoTicket == null ? { text: iit.airlineName, fontSize: 7, bold: true } : { svg: iit.airlineLogoTicket, width: 28, height: 21 }) : (iit.airlineLogoTicket == null ? { text: iit.airlineName, fontSize: 7, bold: true } : { image: iit.airlineLogoTicket, width: 28, height: 21 }),
  //                    { text: iit.airlinePrefixCode! + iit.flightNumber },
  //                    { text: [{ text: iit.fromCity }, { text: ` [${iit.fromAirport}] `, bold: true }, { text: '\n' }, { text: iit.fromAirportName, fontSize: 6 }] },
  //                    { text: [{ text: iit.toCity }, { text: ` [${iit.toAirport}] `, bold: true }, { text: '\n' }, { text: iit.toAirportName, fontSize: 6 }] },
  //                    /*{ text: "-" },*/
  //                    { text: `${iit.departureTime}\n${formatDate(iit.departureDate!, 'dd MMMM yyyy', this.locale)}` },
  //                    { text: `${iit.arrivalTime}\n${formatDate(iit.arrivalDate!, 'dd MMMM yyyy', this.locale)}\n` }
  //                  ])
  //              ]
  //            },
  //            style: 'tableStyle',
  //            layout: 'noBorders'
  //          }
  //        ]
  //      }) : [],

  //      { text: '\n' },

  //      { text: 'Passenger Information', style: 'subHeader' },
  //      {
  //        table: {
  //          widths: ['*', '*', '*', '*', '*'],
  //          body: [
  //            [{ text: 'Sector', bold: true }, { text: 'Passenger Name', bold: true }, { text: 'CheckIn / Cabin', bold: true }, { text: 'Ticket No', bold: true }, { text: 'Seat / Meal', bold: true }],
  //            ...sortedBaggageInfo.map(p => [
  //              p.sector,
  //              p.paxs.map(nam => nam.paxName).join('\n'),
  //              p.checkIn + " / " + p.cabin,
  //              p.paxs.map(nam => nam.ticketNo === null ? "-" : nam.ticketNo).join('\n'),
  //              `${p.seatNo === null ? "-" : p.seatNo} / ${p.meal === null ? "-" : p.meal}`
  //            ])
  //          ]
  //        },
  //        style: 'tableStyle',
  //        layout: 'lightHorizontalLines'
  //      },
  //      { text: '\n' },
  //      { text: 'Note:', style: 'subHeader' },
  //      { text: 'Please read the terms and conditions of your ticket carefully. These include rules regarding cancellations, changes, and refund policies.', margin: [0, 0], italics: true, fontSize: 7 },

  //    ];

  //    let documentDefinition = {
  //      info: {
  //        title: 'OK Travels Flight Ticket',
  //        author: 'Zabi Ullah @ Soft Tech Bridge',
  //        subject: 'OK Travels Flight Ticket from Soft Tech Bridge',
  //      },
  //      //watermark: 'OK Travels & Tourism (pvt) Ltd',
  //      pageSize: 'A4',
  //      language: 'en-GB',
  //      content: [
  //        ...financeType === false && alleach === "each" ? withoutEachContent : financeType === false && alleach === "all" ? withoutAllContent : [{
  //          columns: [
  //            {
  //              image: agencyLogo, width: 60, height: 45
  //            },
  //            {
  //              text: [
  //                { text: `${this.agencyOnline.agencyName}\n`, bold: true, fontSize: 14 }//,
  //                //{ text: `${this.agencyOnline.address1 + " - " + this.agencyOnline.address2}\n`, fontSize: 7, bold: false, italics: true },
  //                //{ text: `Agent: ${this.userOnline.firstName + " " + this.userOnline.lastName}\n`, fontSize: 7, bold: false },
  //                //{ text: `Phone: ${this.userOnline.mobile}\n`, fontSize: 7, bold: false },
  //                //{ text: `Email: ${this.userOnline.email}\n`, fontSize: 7, bold: false },
  //              ],
  //              alignment: 'right',
  //              margin: [0, 20, 10, 0]
  //            }
  //          ],
  //          columnGap: 20
  //        },
  //        { text: '\n\n' },

  //        // Booking Info Section
  //        {
  //          style: 'tableStyle',
  //          table: {
  //            //headerRows: 1,
  //            widths: [90, 90, 90, 90, 90],
  //            body: [
  //              [{ text: 'Booking ID', border: [true, true, false, false] }, { text: 'Booking Date', border: [false, true, false, false] }, { text: 'Airline Ref.', border: [false, true, false, false] }, { text: 'PNR', border: [false, true, false, false] }, { text: 'Status', border: [false, true, true, false] }],
  //              [{ text: this.bookingInfo.bookingID, bold: true, border: [true, false, false, true] }, { text: formatedBookingDate, bold: true, border: [false, false, false, true] }, { text: this.bookingInfo.supplierLocatorCode, bold: true, border: [false, false, false, true] }, { text: this.bookingInfo.pnr, bold: true, border: [false, false, false, true] }, { text: this.bookingStatus, bold: true, border: [false, false, true, true] }]
  //            ]
  //          },
  //          layout: {
  //            hLineWidth: function (i: number, node: any) {
  //              return (i === 0 || i === node.table.body.length) ? 0.5 : 0.5;
  //            },
  //            vLineWidth: function (i: number, node: any) {
  //              return (i === 0 || i === node.table.widths.length) ? 0.5 : 0.5;
  //            },
  //            hLineColor: function (i: number, node: any) {
  //              return (i === 0 || i === node.table.body.length) ? 'gray' : 'gray';
  //            },
  //            vLineColor: function (i: number, node: any) {
  //              return (i === 0 || i === node.table.widths.length) ? 'gray' : 'gray';
  //            }
  //          }
  //        },
  //        //{ text: '\n' },
  //        OnewaySectors.length > 0 ? { text: [{ text: " ONWARD: ", style: 'itineraryHeaderLeft' }, { text: ` ${this.bookingInfo.galileoBookingProp!.flightProp!.flightLocationInfo[0].fromAirport.split('-')[1].split('-')[0]}  ---->  ${this.bookingInfo.galileoBookingProp!.flightProp!.flightLocationInfo[0].toAirport.split('-')[1].split('-')[0]}`, style: 'itineraryHeaderRight' }, { text: " | ", fontSize: 7, bold: true }, { text: `Stops: ${OnewaySectors[0].noOfStops}`, fontSize: 7, bold: true }, { text: onewayStopsAt.length > 0 ? ` (${onewayStopsAt.map(itm => itm).join(', ')}) ` : " ", fontSize: 7, bold: true }, { text: "| " + this.bookingInfo.galileoBookingProp!.flightProp!.cabinClass, fontSize: 7, bold: true }], style: 'itnTopMargin' } : {},
  //        OnewaySectors.length > 0 ? OnewaySectors.map((it, ind) => {
  //          return [
  //            {
  //              table: {
  //                widths: [50, '*', '*', '*', /*50,*/ '*', '*'],
  //                body: [
  //                  [{ text: '' }, ind == 0 ? { text: 'Flight No', bold: true } : {}, ind == 0 ? { text: 'Origin', bold: true } : {}, ind == 0 ? { text: 'Destination', bold: true } : {}, /*ind == 0 ? { text: 'Duration', bold: true }:{},*/ ind == 0 ? { text: 'Dep. Date', bold: true } : {}, ind == 0 ? { text: 'Arv. Date', bold: true } : {}],
  //                  [it.airlineLogo!.includes("svg") ? (it.airlineLogoTicket == null ? { text: it.airlineName, fontSize: 7, bold: true } : { svg: it.airlineLogoTicket, width: 28, height: 21 }) : (it.airlineLogoTicket == null ? { text: it.airlineName, fontSize: 7, bold: true } : { image: it.airlineLogoTicket, width: 28, height: 21 }),
  //                  { text: it.airlinePrefixCode! + it.flightNumber },
  //                  { text: [{ text: it.fromCity }, { text: ` [${it.fromAirport}] `, bold: true }, { text: '\n' }, { text: it.fromAirportName, fontSize: 6 }] },
  //                  { text: [{ text: it.toCity }, { text: ` [${it.toAirport}] `, bold: true }, { text: '\n' }, { text: it.toAirportName, fontSize: 6 }] },
  //                  /*{ text: "-" },*/
  //                  { text: `${it.departureTime}\n${formatDate(it.departureDate!, 'dd MMMM yyyy', this.locale)}` },
  //                  { text: `${it.arrivalTime}\n${formatDate(it.arrivalDate!, 'dd MMMM yyyy', this.locale)}\n` }]
  //                ]
  //              },
  //              style: 'tableStyle',
  //              layout: 'noBorders'
  //            }
  //          ];
  //        }) : [],

  //        isRoundTrip ? {
  //          text: [{ text: " RETURN: ", style: 'itineraryHeaderLeft' }, { text: ` ${this.bookingInfo.galileoBookingProp!.flightProp!.flightLocationInfo[1].fromAirport.split('-')[1].split('-')[0]}  ---->  ${this.bookingInfo.galileoBookingProp!.flightProp!.flightLocationInfo[1].toAirport.split('-')[1].split('-')[0]}`, style: 'itineraryHeaderRight' }, { text: " | ", fontSize: 7, bold: true }, { text: `Stops: ${RoundTripSectors[0].noOfStops}`, fontSize: 7, bold: true }, { text: returnStopsAt.length > 0 ? ` (${returnStopsAt.map(itm => itm).join(', ')}) ` : " ", fontSize: 7, bold: true }, { text: "| " + this.bookingInfo.galileoBookingProp!.flightProp!.cabinClass, fontSize: 7, bold: true }], style: 'itnTopMargin'
  //        } : {},

  //        isRoundTrip ? RoundTripSectors.map((it, ind) => {
  //          return [
  //            {
  //              table: {
  //                widths: [50, '*', '*', '*', /*50,*/ '*', '*'],
  //                body: [
  //                  [{ text: '' }, ind == 0 ? { text: 'Flight No', bold: true } : {}, ind == 0 ? { text: 'Origin', bold: true } : {}, ind == 0 ? { text: 'Destination', bold: true } : {}, /*ind == 0 ? { text: 'Duration', bold: true }:{},*/ ind == 0 ? { text: 'Dep. Date', bold: true } : {}, ind == 0 ? { text: 'Arv. Date', bold: true } : {}],
  //                  [it.airlineLogo!.includes("svg") ? (it.airlineLogoTicket == null ? { text: it.airlineName, fontSize: 7, bold: true } : { svg: it.airlineLogoTicket, width: 28, height: 21 }) : (it.airlineLogoTicket == null ? { text: it.airlineName, fontSize: 7, bold: true } : { image: it.airlineLogoTicket, width: 28, height: 21 }),
  //                  { text: it.airlinePrefixCode! + it.flightNumber },
  //                  { text: [{ text: it.fromCity }, { text: ` [${it.fromAirport}] `, bold: true }, { text: '\n' }, { text: it.fromAirportName, fontSize: 6 }] },
  //                  { text: [{ text: it.toCity }, { text: ` [${it.toAirport}] `, bold: true }, { text: '\n' }, { text: it.toAirportName, fontSize: 6 }] },
  //                  /*{ text: "-" },*/
  //                  { text: `${it.departureTime}\n${formatDate(it.departureDate!, 'dd MMMM yyyy', this.locale)}` },
  //                  { text: `${it.arrivalTime}\n${formatDate(it.arrivalDate!, 'dd MMMM yyyy', this.locale)}\n` }]
  //                ]
  //              },
  //              style: 'tableStyle',
  //              layout: 'noBorders'
  //            }
  //          ];
  //        }) : [],

  //        isMulti ? MultiCitySectors.map((oit) => {
  //          return [
  //            { text: [{ text: " ONWARD: ", style: 'itineraryHeaderLeft' }, { text: oit.flightInfo, style: 'itineraryHeaderRight' }, { text: " | ", fontSize: 7, bold: true }, { text: `Stops: ${oit.sectorInfo[0].noOfStops}`, fontSize: 7, bold: true }, { text: oit.multiStopsAt.length > 0 ? ` (${oit.multiStopsAt.map(itm => itm).join(', ')}) ` : " ", fontSize: 7, bold: true }, { text: "| " + this.bookingInfo.galileoBookingProp!.flightProp!.cabinClass, fontSize: 7, bold: true }], style: 'itnTopMargin' },
  //            {
  //              table: {
  //                widths: [50, '*', '*', '*', /*50,*/ '*', '*'],
  //                body: [
  //                  [{ text: '' }, { text: 'Flight No', bold: true }, { text: 'Origin', bold: true }, { text: 'Destination', bold: true }, /*ind == 0 ? { text: 'Duration', bold: true }:{},*/ { text: 'Dep. Date', bold: true }, { text: 'Arv. Date', bold: true }],
  //                  ...oit.sectorInfo.map(iit =>
  //                    [
  //                      iit.airlineLogo!.includes("svg") ? (iit.airlineLogoTicket == null ? { text: iit.airlineName, fontSize: 6, bold: true } : { svg: iit.airlineLogoTicket, width: 28, height: 21 }) : (iit.airlineLogoTicket == null ? { text: iit.airlineName, fontSize: 6, bold: true } : { image: iit.airlineLogoTicket, width: 28, height: 21 }),
  //                      { text: iit.airlinePrefixCode! + iit.flightNumber },
  //                      { text: [{ text: iit.fromCity }, { text: ` [${iit.fromAirport}] `, bold: true }, { text: '\n' }, { text: iit.fromAirportName, fontSize: 6 }] },
  //                      { text: [{ text: iit.toCity }, { text: ` [${iit.toAirport}] `, bold: true }, { text: '\n' }, { text: iit.toAirportName, fontSize: 6 }] },
  //                      /*{ text: "-" },*/
  //                      { text: `${iit.departureTime}\n${formatDate(iit.departureDate!, 'dd MMMM yyyy', this.locale)}` },
  //                      { text: `${iit.arrivalTime}\n${formatDate(iit.arrivalDate!, 'dd MMMM yyyy', this.locale)}\n` }
  //                    ])
  //                ]
  //              },
  //              style: 'tableStyle',
  //              layout: 'noBorders'
  //            }
  //          ]
  //        }) : [],

  //        { text: '\n' },

  //        // Passenger Information Table
  //        { text: 'Passenger Information', style: 'subHeader' },
  //        {
  //          table: {
  //            widths: ['*', '*', '*', '*', '*'],
  //            body: [
  //              [{ text: 'Sector', bold: true }, { text: 'Passenger(s)', bold: true }, { text: 'CheckIn / Cabin', bold: true }, { text: 'Ticket No', bold: true }, { text: 'Seat / Meal', bold: true }],
  //              ...sortedBaggageInfo.map(p => [
  //                p.sector,
  //                p.paxs.map(nam => nam.paxName).join('\n'),
  //                p.checkIn + " / " + p.cabin,
  //                p.paxs.map(nam => nam.ticketNo === null ? "-" : nam.ticketNo).join('\n'),
  //                `${p.seatNo === null ? "-" : p.seatNo} / ${p.meal === null ? "-" : p.meal}`
  //              ])
  //            ]
  //          },
  //          style: 'tableStyle',
  //          layout: 'lightHorizontalLines'
  //        },

  //        //{ text: '\n' },

  //        // Financial Information Table
  //        { text: 'Financial Summary', style: 'subHeader' },
  //        {
  //          table: {
  //            widths: ['*', '*', '*', '*', '*'],
  //            body: [
  //              [{ text: 'Passenger(s)', bold: true }, { text: 'Base Fare', bold: true }, { text: 'Service Fees', bold: true }, { text: 'Taxes', bold: true }, { text: 'Total', bold: true }],
  //              ...this.bookingPassengerInfo.map(f => [
  //                f.firstName + " " + f.lastName, f.exchangeCurrency! + f.baseFare, f.exchangeCurrency! + f.serviceCharges, f.exchangeCurrency! + (f.totalTaxes + f.markup + f.runtimeMarkup), f.exchangeCurrency! + f.netFromCustomer
  //              ])
  //            ]
  //          },
  //          style: 'tableStyle',
  //          layout: 'headerLineOnly'
  //        },

  //        { text: '\n' },

  //        // Conditions Text
  //        { text: 'Note:', style: 'subHeader' },
  //        { text: 'Please read the terms and conditions of your ticket carefully. These include rules regarding cancellations, changes, and refund policies.', margin: [0, 0], italics: true, fontSize: 7 },
  //        ]
  //      ],
  //      styles: {
  //        //header: { fontSize: 11, bold: true, margin: [0, 5], alignment: 'justify' },
  //        subHeader: { fontSize: 7, bold: true, margin: [0, 5], alignment: 'justify' },
  //        itineraryHeaderLeft: { fontSize: 7, bold: true },
  //        itineraryHeaderRight: { fontSize: 7, bold: true },
  //        itnTopMargin: { margin: [0, 20, 0, 10] },
  //        itinerarySummary: { fontSize: 7, margin: [0, 0] },
  //        tableStyle: { fontSize: 7, border: [false, false, false, true], margin: [0, 0], alignment: 'center' },
  //      }
  //    } as any;
  //    this.hideBtnLoader();
  //    pdfMake.createPdf(documentDefinition).getBlob((blob) => {
  //      let pdfFile = new File([blob], `Booking Itinerary_${this.bookingInfo.bookingID}.pdf`, { type: "application/pdf" });
  //      this.ticketEmailObj.subject = "Your E-Ticket is Here";
  //      var formData = new FormData();
  //      formData.append("subject", this.ticketEmailObj.subject);
  //      formData.append("customerEmail", this.ticketEmailObj.customerEmail);
  //      formData.append("agencyId", localStorage.getItem("AgencyId"));
  //      formData.append("pdfFile", pdfFile);

  //      this.emailService.emailIterniaryMulti(formData).subscribe((data) => {
  //        this.isLoadPanelVisible = false;
  //        if (data == true) {
  //          this.NewSuccess.dismissAll();
  //          this.isLoadPanelVisible = false;
  //          this.hideBtnLoader();
  //        } else {
  //          document.getElementById("messageEmail").innerHTML = 'Please Try Again!';
  //          setTimeout(() => { document.getElementById("messageEmail").innerHTML = ''; }, 5000);
  //          this.isLoadPanelVisible = false;
  //          this.hideBtnLoader();
  //        }
  //      });
  //    });
  //  });
  //}
  // new send itinerary/ticket via email function, well structured and optimized, with both all and each options, with and without financials
  emailItineraryFinance(financeType: boolean, alleach: string) {
    this.showBtnLoader();
    this.isLoadPanelVisible = true;
    let agencyLogoName = this.agencyOnline.logoFileName;
    let imgType = agencyLogoName.substring(agencyLogoName.lastIndexOf(".") + 1);
    this.agencyLogo = 'data:image/' + imgType + ';base64,' + this.agencyOnline.logoFilePath;
    this.convertImageToBase64('assets/barcode.png').then(base64 => {
      this.barcodeImage = base64;
    }).catch(err => {
      console.error('Error converting image:', err);
    });
    this.convertImageToBase64('assets/baggage.png').then(base64 => {
      this.baggageImage = base64;
    }).catch(err => {
      console.error('Error converting image:', err);
    });
    this.convertImageToBase64('assets/building.png').then(base64 => {
      this.buildingIcon = base64;
    }).catch(err => {
      console.error('Error converting image:', err);
    });
    this.convertImageToBase64('assets/online-support.png').then(base64 => {
      this.agentIcon = base64;
    }).catch(err => {
      console.error('Error converting image:', err);
    });
    this.convertImageToBase64('assets/passport.png').then(base64 => {
      this.passportIcon = base64;
    }).catch(err => {
      console.error('Error converting image:', err);
    });
    this.convertImageToBase64('assets/attention.png').then(base64 => {
      this.attentionIcon = base64;
    }).catch(err => {
      console.error('Error converting image:', err);
    });
    this.convertImageToBase64('assets/luggage.png').then(base64 => {
      this.luggageIcon = base64;
    }).catch(err => {
      console.error('Error converting image:', err);
    });
    this.convertImageToBase64('assets/ticketIcon.png').then(base64 => {
      this.planeIcon = base64;
    }).catch(err => {
      console.error('Error converting image:', err);
    });

    let bookingDateString = this.bookingInfo.creationTime.toString();
    let bookingDate = new Date(bookingDateString);
    let formatedBookingDate = bookingDate.toLocaleString('en-US', { year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
    let issuanceDate = new Date(this.bookingInfo.issuanceDateTime);
    let formatedIssuanceDate = issuanceDate.toLocaleString('en-US', { year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
    this.loadLogos(this.newsectorInfo).then(base64Logos => {
      for (let ln = 0; ln < base64Logos.length; ln++) {
        this.newsectorInfo[ln].airlineLogoTicket = base64Logos[ln];
      }
      const { OnewaySectors, RoundTripSectors, MultiCitySectors, isRoundTrip, isMulti } = this.classifySectors(this.flightSearchProperties.flightLocationInfo, this.newsectorInfo);
      let sortedBaggageInfo: TicketPaxBaggageSectorSortedProperties[] = [];
      sortedBaggageInfo = this.createSectorPassengerManifest(this.bookingInfo.bookingPassengerInfoProperties, this.locale);
      let onewayStopsAt: string[] = [];
      let returnStopsAt: string[] = [];
      for (let index = 0; index < OnewaySectors.length; index++) {
        if (index != OnewaySectors.length - 1) {
          onewayStopsAt.push(OnewaySectors[index].toCity);
        } else {
          continue;
        }
      };
      for (let index = 0; index < RoundTripSectors.length; index++) {
        if (index != RoundTripSectors.length - 1) {
          returnStopsAt.push(RoundTripSectors[index].toCity);
        } else {
          continue;
        }
      };

      const withoutEachContent = this.bookingPassengerInfo.map((item, index) => {
        return [
          //Doc header
          {
            columns: [
              {
                width: 'auto', text: "eTicket", bold: true, fontSize: 16
              },
              {
                width: '*', text: `${this.agencyOnline.agencyName}`, bold: false, fontSize: 12, alignment: 'center'
              },
              {
                width: 215, margin: [-20, 0, 0, 0],
                columns: [
                  {
                    text: [
                      { text: `SPNR \n`, bold: false, fontSize: 10 },
                      { text: `${this.bookingInfo.supplierLocatorCode != null ? this.bookingInfo.supplierLocatorCode : ''}`, bold: true, fontSize: 14, color: '#6A1717' }
                    ],
                    alignment: 'right',
                    width: 70
                  },
                  {
                    text: [
                      { text: `BOOKING REF. \n`, bold: false, fontSize: 10 },
                      { text: `${this.bookingInfo.pnr}`, bold: true, fontSize: 14, color: '#6A1717' }
                    ],
                    alignment: 'right',
                    width: 70
                  },
                  {
                    image: this.barcodeImage, width: 75, height: 30
                  },
                ]
              }
            ],
            columnGap: 10,
            border: [false, false, false, true]
          },
          {
            canvas: [
              {
                type: 'line',
                x1: 0, // Starting X coordinate (relative to the canvas's top-left)
                y1: 0, // Starting Y coordinate (relative to the canvas's top-left)
                x2: 515, // Ending X coordinate (adjust for desired length)
                y2: 0, // Ending Y coordinate (same as y1 for a horizontal line)
                lineWidth: 1, // Line thickness
                lineColor: 'black' // Line color (optional)
              }
            ], margin: [0, 5]
          },
          {
            columns: [
              { image: `${this.agencyLogo != null ? this.agencyLogo : ''}`, width: 60, height: 45 },
              {
                table: {
                  widths: [150, 150],
                  body: [
                    [
                      { text: `Reserved on ${formatedBookingDate}`, fontSize: 9 },
                      { text: `Ticketed on ${this.bookingStatus == "Ticketed" ? formatedIssuanceDate : "---"}`, fontSize: 9, alignment: 'right' }
                    ],
                    [
                      // Left cell
                      {
                        text: [
                          { text: "Booked By:\n", fontSize: 9 },
                          { text: `${this.userOnline.firstName} ${this.userOnline.lastName}`, fontSize: 11, bold: true, color: '#204D72' }
                        ]
                      },
                      // Right cell
                      {
                        stack: [
                          {
                            columns: [
                              { image: this.buildingIcon, width: 12, height: 12, margin: [10, 0, 0, 0], alignment: 'right' },
                              { text: "(Consultant)", fontSize: 10, alignment: 'right' }
                            ], columnGap: 0,           // disables pdfMake’s default gap
                            widths: ['auto', 'auto']
                          },
                          {
                            columns: [
                              { image: this.agentIcon, width: 12, height: 12, margin: [10, 0, 0, 0], alignment: 'right' },
                              { text: `${this.userOnline.mobile}`, fontSize: 10, bold: true, alignment: 'right', }
                            ], columnGap: 0,
                            widths: ['auto', 'auto']
                          }
                        ]
                      }
                    ]
                  ]
                }, layout: 'noBorders', margin: [140, 0, 0, 0]
              }
            ]
          },
          {
            canvas: [
              {
                type: 'line',
                x1: 0, // Starting X coordinate (relative to the canvas's top-left)
                y1: 0, // Starting Y coordinate (relative to the canvas's top-left)
                x2: 515, // Ending X coordinate (adjust for desired length)
                y2: 0, // Ending Y coordinate (same as y1 for a horizontal line)
                lineWidth: 1.5, // Line thickness
                lineColor: 'black' // Line color (optional)
              }
            ], margin: [0, 5]
          },

          // Passenger Information Table
          //{ text: 'Passenger Information', style: 'subHeader' },
          {
            table: {
              widths: ['auto', '*', '*', '*', '*'],
              body: [
                [{ text: 'passenger', fontSize: 9, bold: true }, { text: 'flight no', fontSize: 9, bold: true }, { text: 'route', fontSize: 9, bold: true }, { text: 'date', fontSize: 9, bold: true }, { text: 'status', fontSize: 9, bold: true }],
                ...sortedBaggageInfo.map(p => [
                  {
                    stack: [
                      { text: `${p.paxs[index].paxName}\n`, fontSize: 9, bold: true, color: '#444444' },
                      { columns: [{ image: this.passportIcon, width: 11, height: 11 }, { text: `${p.paxs[index].passportNo}\n`, fontSize: 9, bold: true, margin: [5, 0, 0, 0] }], columnGap: 1 },
                      { columns: [{ image: this.planeIcon, width: 11, height: 11 }, { text: `${p.paxs[index].ticketNo === null ? "-" : p.paxs[index].ticketNo} | seat: ${p.paxs[index].seatNo === null ? "any" : p.paxs[index].seatNo} | check-in: ${p.paxs[index].checkIn} | cabin: ${p.paxs[index].cabin} | meal: ${p.paxs[index].meal === null ? "-" : p.paxs[index].meal}`, fontSize: 9, bold: true, color: '#204D72', margin: [5, 0, 0, 0] }] }
                    ], alignment: 'left'
                  },
                  { text: p.flightNo === null ? "-" : p.flightNo, fontSize: 9, color: '#555555' },
                  { text: p.sector, fontSize: 9 },
                  { text: p.departureDate, fontSize: 9 },
                  { text: `${this.bookingStatus == "Ticketed" ? "Confirmed" : this.bookingStatus}`, fontSize: 9, color: "#555555" },
                ])
              ]
            },
            style: 'tableStyle',
            layout: 'lightHorizontalLines'
          },
          {
            canvas: [
              {
                type: 'line',
                x1: 0, // Starting X coordinate (relative to the canvas's top-left)
                y1: 0, // Starting Y coordinate (relative to the canvas's top-left)
                x2: 515, // Ending X coordinate (adjust for desired length)
                y2: 0, // Ending Y coordinate (same as y1 for a horizontal line)
                lineWidth: 1, // Line thickness
                lineColor: 'black' // Line color (optional)
              }
            ], margin: [0, 5]
          },
          {
            columns: [
              {
                columns:
                  [{ image: this.attentionIcon, width: 20, height: 20 },
                  {
                    text: [
                      { text: "NOTICE: ", fontSize: 9, bold: true },
                      { text: `Arrival at airport 3 hours before scheduled departure time on domestic flights and 4 hours before scheduled departure time on international flights. Check-in counters close 45 min before scheduled departure time for domestic, and 90minutes before scheduled departure time for international flights. Mobile check-in available now for domestic flights.\n`, fontSize: 9, bold: false },
                      { text: [{ text: `CHECK-IN BAG SIZE LIMIT `, fontSize: 9 }, { text: `${this.passengerBaggage[0].baggageCheckIn}\n`, fontSize: 9, bold: true }] },
                      { text: [{ text: `HAND CARRY BAG LIMIT `, fontSize: 9 }, { text: `${this.passengerBaggage[0].baggageCabin}\n`, fontSize: 9, bold: true }] },
                      { text: "NOTE: ", fontSize: 9, bold: true }, { text: `Excess baggage and payment is not accepted at check-in counters.\n`, fontSize: 9, bold: false },
                    ], width: '*'
                  }
                  ], alignment: 'left', columnGap: 3
              },
              { image: this.baggageImage, width: 96, height: 76 }
            ],
            columnGap: 5,
          },
          {
            canvas: [
              {
                type: 'line',
                x1: 0, // Starting X coordinate (relative to the canvas's top-left)
                y1: 0, // Starting Y coordinate (relative to the canvas's top-left)
                x2: 515, // Ending X coordinate (adjust for desired length)
                y2: 0, // Ending Y coordinate (same as y1 for a horizontal line)
                lineWidth: 1.5, // Line thickness
                lineColor: 'black' // Line color (optional)
              }
            ], margin: [0, 5]
          },
          { text: '\n' },
          OnewaySectors.length > 0 ? { text: [{ text: " ONWARD: ", style: 'itineraryHeaderLeft', fontSize: 11 }, { text: ` ${this.flightSearchProperties.flightLocationInfo[0].fromAirport.split('-')[1].split('-')[0]}  ---->  ${this.flightSearchProperties.flightLocationInfo[0].toAirport.split('-')[1].split('-')[0]}`, style: 'itineraryHeaderRight', fontSize: 11 }, { text: " | ", fontSize: 11, bold: true }, { text: `Stops: ${OnewaySectors[0].noOfStops}`, fontSize: 11, bold: true }, { text: onewayStopsAt.length > 0 ? ` (${onewayStopsAt.map(itm => itm).join(', ')}) ` : " ", fontSize: 11, bold: true }, { text: "| " + this.flightSearchProperties.cabinClass, fontSize: 11, bold: true }], color: '#204D72' } : {},
          OnewaySectors.length > 0 ? OnewaySectors.map((it, ind) => {
            return [
              {
                table: {
                  widths: [50, '*', '*', '*', /*50,*/ '*', '*'],
                  body: [
                    [{ text: '' }, ind == 0 ? { text: 'Flight No', bold: true, fontSize: 9 } : {}, ind == 0 ? { text: 'Origin', bold: true, fontSize: 9 } : {}, ind == 0 ? { text: 'Destination', bold: true, fontSize: 9 } : {}, /*ind == 0 ? { text: 'Duration', bold: true }:{},*/ ind == 0 ? { text: 'Dep. Date', bold: true, fontSize: 9 } : {}, ind == 0 ? { text: 'Arv. Date', bold: true, fontSize: 9 } : {}],
                    [it.airlineLogo.includes("svg") ? (it.airlineLogoTicket == null ? { text: it.airlineName, fontSize: 9, bold: true } : { svg: it.airlineLogoTicket, width: 50, height: 40 }) : (it.airlineLogoTicket == null ? { text: it.airlineName, fontSize: 7, bold: true } : { image: it.airlineLogoTicket, width: 36, height: 36 }),
                    { text: `${it.airlineName}\n(${it.airlinePrefixCode}${it.flightNumber})`, fontSize: 10 },
                    { text: [{ text: `${it.fromCity}\n`, fontSize: 10, color: '#204D72', bold: true }, { text: `${it.fromAirportName}\n`, fontSize: 7 }, { text: it.departureTerminal == null ? "" : it.departureTerminal, fontSize: 7, bold: true }] },
                    { text: [{ text: `${it.toCity}\n`, fontSize: 10, color: '#204D72', bold: true }, { text: `${it.toAirportName}\n`, fontSize: 7 }, { text: it.arrivalTerminal == null ? "" : it.arrivalTerminal, fontSize: 7, bold: true }] },
                    /*{ text: "-" },*/
                    { text: `${it.departureTime}\n${formatDate(it.departureDate, 'mediumDate', this.locale)}`, fontSize: 10 },
                    //{ text: `${it.departureTime}\n${it.departureDate}`},
                    { text: `${it.arrivalTime}\n${formatDate(it.arrivalDate, 'mediumDate', this.locale)}\n`, fontSize: 10 }
                      //{ text: `${it.arrivalTime}\n${it.arrivalDate}\n` }
                    ]
                  ]
                },
                style: 'tableStyle',
                layout: 'noBorders'
              }
            ];
          }) : [],

          isRoundTrip ? { text: [{ text: " RETURN: ", style: 'itineraryHeaderLeft' }, { text: ` ${this.flightSearchProperties.flightLocationInfo[1].fromAirport.split('-')[1].split('-')[0]}  ---->  ${this.flightSearchProperties.flightLocationInfo[1].toAirport.split('-')[1].split('-')[0]}`, style: 'itineraryHeaderRight' }, { text: " | ", fontSize: 11, bold: true }, { text: `Stops: ${RoundTripSectors[0].noOfStops}`, fontSize: 11, bold: true }, { text: returnStopsAt.length > 0 ? ` (${returnStopsAt.map(itm => itm).join(', ')}) ` : " ", fontSize: 11, bold: true }, { text: "| " + this.flightSearchProperties.cabinClass, fontSize: 11, bold: true }], color: '#204D72' } : {},
          isRoundTrip ? RoundTripSectors.map((it, ind) => {
            return [
              {
                table: {
                  widths: [50, '*', '*', '*', /*50,*/ '*', '*'],
                  body: [
                    [{ text: '' }, ind == 0 ? { text: 'Flight No', bold: true, fontSize: 9 } : {}, ind == 0 ? { text: 'Origin', bold: true, fontSize: 9 } : {}, ind == 0 ? { text: 'Destination', bold: true, fontSize: 9 } : {}, /*ind == 0 ? { text: 'Duration', bold: true }:{},*/ ind == 0 ? { text: 'Dep. Date', bold: true, fontSize: 9 } : {}, ind == 0 ? { text: 'Arv. Date', bold: true, fontSize: 9 } : {}],
                    [it.airlineLogo.includes("svg") ? (it.airlineLogoTicket == null ? { text: it.airlineName, fontSize: 9, bold: true } : { svg: it.airlineLogoTicket, width: 50, height: 40 }) : (it.airlineLogoTicket == null ? { text: it.airlineName, fontSize: 9, bold: true } : { image: it.airlineLogoTicket, width: 28, height: 21 }),
                    { text: `${it.airlineName}\n(${it.airlinePrefixCode}${it.flightNumber})`, fontSize: 10 },
                    { text: [{ text: `${it.fromCity}\n`, fontSize: 10, color: '#204D72', bold: true }, { text: `${it.fromAirportName}\n`, fontSize: 7 }, { text: it.departureTerminal == null ? "" : it.departureTerminal, fontSize: 7, bold: true }] },
                    { text: [{ text: `${it.toCity}\n`, fontSize: 10, color: '#204D72', bold: true }, { text: `${it.toAirportName}\n`, fontSize: 7 }, { text: it.arrivalTerminal == null ? "" : it.arrivalTerminal, fontSize: 7, bold: true }] },
                    /*{ text: "-" },*/
                    { text: `${it.departureTime}\n${formatDate(it.departureDate, 'mediumDate', this.locale)}`, fontSize: 10 },
                    { text: `${it.arrivalTime}\n${formatDate(it.arrivalDate, 'mediumDate', this.locale)}\n`, fontSize: 10 }]
                  ]
                },
                style: 'tableStyle',
                layout: 'noBorders'
              }
            ];
          }) : [],

          isMulti ? MultiCitySectors.map((oit) => {
            return [
              { text: [{ text: " ONWARD: ", style: 'itineraryHeaderLeft' }, { text: oit.flightInfo, style: 'itineraryHeaderRight' }, { text: " | ", fontSize: 11, bold: true }, { text: `Stops: ${oit.sectorInfo[0].noOfStops}`, fontSize: 11, bold: true }, { text: oit.multiStopsAt.length > 0 ? ` (${oit.multiStopsAt.map(itm => itm).join(', ')}) ` : " ", fontSize: 11, bold: true }, { text: "| " + this.flightSearchProperties.cabinClass, fontSize: 11, bold: true }], color: '#204D72' },
              {
                table: {
                  widths: [50, '*', '*', '*', /*50,*/ '*', '*'],
                  body: [
                    [{ text: '' }, { text: 'Flight No', bold: true, fontSize: 9 }, { text: 'Origin', bold: true, fontSize: 9 }, { text: 'Destination', bold: true, fontSize: 9 }, /*ind == 0 ? { text: 'Duration', bold: true }:{},*/ { text: 'Dep. Date', bold: true, fontSize: 9 }, { text: 'Arv. Date', bold: true, fontSize: 9 }],
                    ...oit.sectorInfo.map(iit =>
                      [
                        iit.airlineLogo.includes("svg") ? (iit.airlineLogoTicket == null ? { text: iit.airlineName, fontSize: 9, bold: true } : { svg: iit.airlineLogoTicket, width: 50, height: 40 }) : (iit.airlineLogoTicket == null ? { text: iit.airlineName, fontSize: 9, bold: true } : { image: iit.airlineLogoTicket, width: 28, height: 21 }),
                        { text: `${iit.airlineName}\n(${iit.airlinePrefixCode}${iit.flightNumber})`, fontSize: 10 },
                        { text: [{ text: `${iit.fromCity}\n`, fontSize: 10, color: '#204D72', bold: true }, { text: `${iit.fromAirportName}\n`, fontSize: 7 }, { text: iit.departureTerminal == null ? "" : iit.departureTerminal, fontSize: 7, bold: true }] },
                        { text: [{ text: `${iit.toCity}\n`, fontSize: 10, color: '#204D72', bold: true }, { text: `${iit.toAirportName}\n`, fontSize: 7 }, { text: iit.arrivalTerminal == null ? "" : iit.arrivalTerminal, fontSize: 7, bold: true }] },
                        /*{ text: "-" },*/
                        { text: `${iit.departureTime}\n${formatDate(iit.departureDate, 'mediumDate', this.locale)}`, fontSize: 10 },
                        { text: `${iit.arrivalTime}\n${formatDate(iit.arrivalDate, 'mediumDate', this.locale)}\n`, fontSize: 10 }
                      ]
                    )
                  ]
                },
                style: 'tableStyle',
                layout: 'noBorders'
              }
            ]
          }) : [],

          {
            canvas: [
              {
                type: 'line',
                x1: 0, // Starting X coordinate (relative to the canvas's top-left)
                y1: 0, // Starting Y coordinate (relative to the canvas's top-left)
                x2: 515, // Ending X coordinate (adjust for desired length)
                y2: 0, // Ending Y coordinate (same as y1 for a horizontal line)
                lineWidth: 1.5, // Line thickness
                lineColor: 'black' // Line color (optional)
              }
            ], margin: [0, 5]
          },
          { text: '', pageBreak: index < this.bookingPassengerInfo.length - 1 ? 'after' : undefined }, // Add page break except the last page
        ];
      });
      const withoutAllContent = [
        //Doc header
        {
          columns: [
            {
              width: 'auto', text: "eTicket", bold: true, fontSize: 16
            },
            {
              width: '*', text: `${this.agencyOnline.agencyName}`, bold: false, fontSize: 12, alignment: 'center'
            },
            {
              width: 215, margin: [-20, 0, 0, 0],
              columns: [
                {
                  text: [
                    { text: `SPNR \n`, bold: false, fontSize: 10 },
                    { text: `${this.bookingInfo.supplierLocatorCode != null ? this.bookingInfo.supplierLocatorCode : ''}`, bold: true, fontSize: 14, color: '#6A1717' }
                  ],
                  alignment: 'right',
                  width: 70
                },
                {
                  text: [
                    { text: `BOOKING REF. \n`, bold: false, fontSize: 10 },
                    { text: `${this.bookingInfo.pnr}`, bold: true, fontSize: 14, color: '#6A1717' }
                  ],
                  alignment: 'right',
                  width: 70
                },
                {
                  image: this.barcodeImage, width: 75, height: 30
                },
              ]
            }
          ],
          columnGap: 10,
          border: [false, false, false, true]
        },
        {
          canvas: [
            {
              type: 'line',
              x1: 0, // Starting X coordinate (relative to the canvas's top-left)
              y1: 0, // Starting Y coordinate (relative to the canvas's top-left)
              x2: 515, // Ending X coordinate (adjust for desired length)
              y2: 0, // Ending Y coordinate (same as y1 for a horizontal line)
              lineWidth: 1, // Line thickness
              lineColor: 'black' // Line color (optional)
            }
          ], margin: [0, 5]
        },
        //Agent and reservation info
        {
          columns: [
            { image: `${this.agencyLogo != null ? this.agencyLogo : ''}`, width: 60, height: 45 },
            {
              table: {
                widths: [150, 150],
                body: [
                  [
                    { text: `Reserved on ${formatedBookingDate}`, fontSize: 9 },
                    { text: `Ticketed on ${this.bookingStatus == "Ticketed" ? formatedIssuanceDate : "---"}`, fontSize: 9, alignment: 'right' }
                  ],
                  [
                    // Left cell
                    {
                      text: [
                        { text: "Booked By:\n", fontSize: 9 },
                        { text: `${this.userOnline.firstName} ${this.userOnline.lastName}`, fontSize: 11, bold: true, color: '#204D72' }
                      ]
                    },
                    // Right cell
                    {
                      stack: [
                        {
                          columns: [
                            { image: this.buildingIcon, width: 12, height: 12, margin: [10, 0, 0, 0], alignment: 'right' },
                            { text: "(Consultant)", fontSize: 10, alignment: 'right' }
                          ], columnGap: 0,           // disables pdfMake’s default gap
                          widths: ['auto', 'auto']
                        },
                        {
                          columns: [
                            { image: this.agentIcon, width: 12, height: 12, margin: [10, 0, 0, 0], alignment: 'right' },
                            { text: `${this.userOnline.mobile}`, fontSize: 10, bold: true, alignment: 'right', }
                          ], columnGap: 0,
                          widths: ['auto', 'auto']
                        }
                      ]
                    }
                  ]
                ]
              }, layout: 'noBorders', margin: [140, 0, 0, 0]
            }
          ]
        },
        {
          canvas: [
            {
              type: 'line',
              x1: 0, // Starting X coordinate (relative to the canvas's top-left)
              y1: 0, // Starting Y coordinate (relative to the canvas's top-left)
              x2: 515, // Ending X coordinate (adjust for desired length)
              y2: 0, // Ending Y coordinate (same as y1 for a horizontal line)
              lineWidth: 1.5, // Line thickness
              lineColor: 'black' // Line color (optional)
            }
          ], margin: [0, 5]
        },
        // Passenger Information Table
        {
          table: {
            widths: ['auto', '*', '*', '*', '*'],
            body: [
              [{ text: 'passenger', fontSize: 9, bold: true }, { text: 'flight no', fontSize: 9, bold: true }, { text: 'route', fontSize: 9, bold: true }, { text: 'date', fontSize: 9, bold: true }, { text: 'status', fontSize: 9, bold: true }],
              ...sortedBaggageInfo.map(p => [
                {
                  stack: p.paxs.map(nam => ({
                    stack: [
                      { text: nam.paxName, fontSize: 9, bold: true, color: '#444444' },

                      {
                        columns: [
                          { image: this.passportIcon, width: 10, height: 10, margin: [0, 0, 1, 0] },
                          { text: `${nam.passportNo}\n`, fontSize: 9, margin: [5, 0, 0, 0] }
                        ]
                      },
                      {
                        columns: [
                          { image: this.planeIcon, width: 10, height: 10, margin: [0, 0, 1, 0] },
                          { text: `${nam.ticketNo === null ? "-" : nam.ticketNo} | seat: ${nam.seatNo === null ? "any" : nam.seatNo} | check-in: ${nam.checkIn} | cabin: ${nam.cabin} | meal: ${nam.meal === null ? "-" : nam.meal}`, fontSize: 9, bold: true, color: '#204D72', margin: [5, 0, 0, 0] }
                        ]
                      }
                    ],
                    margin: [0, 0, 0, 4] // space between passengers
                  })),
                  alignment: 'left'
                },
                { text: p.flightNo === null ? "-" : p.flightNo, fontSize: 9, color: '#555555' },
                { text: p.sector, fontSize: 9 },
                { text: p.departureDate, fontSize: 9 },
                { text: `${this.bookingStatus == "Ticketed" ? "Confirmed" : this.bookingStatus}`, fontSize: 9, color: "#555555" },
              ])
            ]
          },
          style: 'tableStyle',
          layout: 'lightHorizontalLines'
        },
        {
          canvas: [
            {
              type: 'line',
              x1: 0, // Starting X coordinate (relative to the canvas's top-left)
              y1: 0, // Starting Y coordinate (relative to the canvas's top-left)
              x2: 515, // Ending X coordinate (adjust for desired length)
              y2: 0, // Ending Y coordinate (same as y1 for a horizontal line)
              lineWidth: 1, // Line thickness
              lineColor: 'black' // Line color (optional)
            }
          ], margin: [0, 5]
        },
        {
          columns: [
            {
              columns:
                [{ image: this.attentionIcon, width: 20, height: 20 },
                {
                  text: [
                    { text: "NOTICE: ", fontSize: 9, bold: true },
                    { text: `Arrival at airport 3 hours before scheduled departure time on domestic flights and 4 hours before scheduled departure time on international flights. Check-in counters close 45 min before scheduled departure time for domestic, and 90minutes before scheduled departure time for international flights. Mobile check-in available now for domestic flights.\n`, fontSize: 9, bold: false },
                    { text: [{ text: `CHECK-IN BAG SIZE LIMIT `, fontSize: 9 }, { text: `${this.passengerBaggage[0].baggageCheckIn}\n`, fontSize: 9, bold: true }] },
                    { text: [{ text: `HAND CARRY BAG LIMIT `, fontSize: 9 }, { text: `${this.passengerBaggage[0].baggageCabin}\n`, fontSize: 9, bold: true }] },
                    { text: "NOTE: ", fontSize: 9, bold: true }, { text: `Excess baggage and payment is not accepted at check-in counters.\n`, fontSize: 9, bold: false },
                  ], width: '*'
                }
                ], alignment: 'left', columnGap: 3
            },
            { image: this.baggageImage, width: 96, height: 76 }
          ],
          columnGap: 5,
        },
        {
          canvas: [
            {
              type: 'line',
              x1: 0, // Starting X coordinate (relative to the canvas's top-left)
              y1: 0, // Starting Y coordinate (relative to the canvas's top-left)
              x2: 515, // Ending X coordinate (adjust for desired length)
              y2: 0, // Ending Y coordinate (same as y1 for a horizontal line)
              lineWidth: 1.5, // Line thickness
              lineColor: 'black' // Line color (optional)
            }
          ], margin: [0, 5]
        },
        { text: '\n' },
        OnewaySectors.length > 0 ? { text: [{ text: " ONWARD: ", style: 'itineraryHeaderLeft' }, { text: ` ${this.flightSearchProperties.flightLocationInfo[0].fromAirport.split('-')[1].split('-')[0]}  ---->  ${this.flightSearchProperties.flightLocationInfo[0].toAirport.split('-')[1].split('-')[0]}`, style: 'itineraryHeaderRight' }, { text: " | ", fontSize: 11, bold: true }, { text: `Stops: ${OnewaySectors[0].noOfStops}`, fontSize: 11, bold: true }, { text: onewayStopsAt.length > 0 ? ` (${onewayStopsAt.map(itm => itm).join(', ')}) ` : " ", fontSize: 11, bold: true }, { text: "| " + this.flightSearchProperties.cabinClass, fontSize: 11, bold: true }], color: '#204D72' } : {},
        OnewaySectors.length > 0 ? OnewaySectors.map((it, ind) => {
          return [
            {
              table: {
                widths: [50, '*', '*', '*', /*50,*/ '*', '*'],
                body: [
                  [{ text: '' }, ind == 0 ? { text: 'Flight No', fontSize: 9, bold: true } : {}, ind == 0 ? { text: 'Origin', fontSize: 9, bold: true } : {}, ind == 0 ? { text: 'Destination', fontSize: 9, bold: true } : {}, /*ind == 0 ? { text: 'Duration', bold: true }:{},*/ ind == 0 ? { text: 'Dep. Date', fontSize: 9, bold: true } : {}, ind == 0 ? { text: 'Arv. Date', fontSize: 9, bold: true } : {}],
                  [it.airlineLogo.includes("svg") ? (it.airlineLogoTicket == null ? { text: it.airlineName, fontSize: 9, bold: true } : { svg: it.airlineLogoTicket, width: 50, height: 40 }) : (it.airlineLogoTicket == null ? { text: it.airlineName, fontSize: 9, bold: true } : { image: it.airlineLogoTicket, width: 28, height: 21 }),
                  { text: `${it.airlineName}\n(${it.airlinePrefixCode}${it.flightNumber})`, fontSize: 10 },
                  { text: [{ text: `${it.fromCity}\n`, fontSize: 10, color: '#204D72', bold: true }, { text: `${it.fromAirportName}\n`, fontSize: 7 }, { text: it.departureTerminal == null ? "" : it.departureTerminal, fontSize: 7, bold: true }] },
                  { text: [{ text: `${it.toCity}\n`, fontSize: 10, color: '#204D72', bold: true }, { text: `${it.toAirportName}\n`, fontSize: 7 }, { text: it.arrivalTerminal == null ? "" : it.arrivalTerminal, fontSize: 7, bold: true }] },
                  /*{ text: "-" },*/
                  { text: `${it.departureTime}\n${formatDate(it.departureDate, 'mediumDate', this.locale)}`, fontSize: 10 },
                  //{ text: `${it.departureTime}\n${it.departureDate}`, fontSize: 12 },
                  { text: `${it.arrivalTime}\n${formatDate(it.arrivalDate, 'mediumDate', this.locale)}\n`, fontSize: 10 }
                    //{ text: `${it.arrivalTime}\n${it.arrivalDate}\n`, fontSize: 12 }
                  ]
                ]
              },
              style: 'tableStyle',
              layout: 'noBorders'
            }
          ];
        }) : [],

        isRoundTrip ? { text: [{ text: " RETURN: ", style: 'itineraryHeaderLeft' }, { text: ` ${this.flightSearchProperties.flightLocationInfo[1].fromAirport.split('-')[1].split('-')[0]}  ---->  ${this.flightSearchProperties.flightLocationInfo[1].toAirport.split('-')[1].split('-')[0]}`, style: 'itineraryHeaderRight' }, { text: " | ", fontSize: 11, bold: true }, { text: `Stops: ${RoundTripSectors[0].noOfStops}`, fontSize: 11, bold: true }, { text: returnStopsAt.length > 0 ? ` (${returnStopsAt.map(itm => itm).join(', ')}) ` : " ", fontSize: 11, bold: true }, { text: "| " + this.flightSearchProperties.cabinClass, fontSize: 11, bold: true }], color: '#204D72' } : {},
        isRoundTrip ? RoundTripSectors.map((it, ind) => {
          return [
            {
              table: {
                widths: [50, '*', '*', '*', /*50,*/ '*', '*'],
                body: [
                  [{ text: '' }, ind == 0 ? { text: 'Flight No', fontSize: 9, bold: true } : {}, ind == 0 ? { text: 'Origin', fontSize: 9, bold: true } : {}, ind == 0 ? { text: 'Destination', fontSize: 9, bold: true } : {}, /*ind == 0 ? { text: 'Duration', bold: true }:{},*/ ind == 0 ? { text: 'Dep. Date', fontSize: 9, bold: true } : {}, ind == 0 ? { text: 'Arv. Date', fontSize: 9, bold: true } : {}],
                  [it.airlineLogo.includes("svg") ? (it.airlineLogoTicket == null ? { text: it.airlineName, fontSize: 9, bold: true } : { svg: it.airlineLogoTicket, width: 50, height: 40 }) : (it.airlineLogoTicket == null ? { text: it.airlineName, fontSize: 7, bold: true } : { image: it.airlineLogoTicket, width: 28, height: 21 }),
                  { text: `${it.airlineName}\n(${it.airlinePrefixCode}${it.flightNumber})`, fontSize: 10 },
                  { text: [{ text: `${it.fromCity}\n`, fontSize: 10, color: '#204D72', bold: true }, { text: `${it.fromAirportName}\n`, fontSize: 7 }, { text: it.departureTerminal == null ? "" : it.departureTerminal, fontSize: 7, bold: true }] },
                  { text: [{ text: `${it.toCity}\n`, fontSize: 10, color: '#204D72', bold: true }, { text: `${it.toAirportName}\n`, fontSize: 7 }, { text: it.arrivalTerminal == null ? "" : it.arrivalTerminal, fontSize: 7, bold: true }] },
                  /*{ text: "-" },*/
                  { text: `${it.departureTime}\n${formatDate(it.departureDate, 'mediumDate', this.locale)}`, fontSize: 10 },
                  { text: `${it.arrivalTime}\n${formatDate(it.arrivalDate, 'mediumDate', this.locale)}\n`, fontSize: 10 }]
                ]
              },
              style: 'tableStyle',
              layout: 'noBorders'
            }
          ];
        }) : [],

        isMulti ? MultiCitySectors.map((oit) => {
          return [
            { text: [{ text: " ONWARD: ", style: 'itineraryHeaderLeft' }, { text: oit.flightInfo, style: 'itineraryHeaderRight' }, { text: " | ", fontSize: 7, bold: true }, { text: `Stops: ${oit.sectorInfo[0].noOfStops}`, fontSize: 7, bold: true }, { text: oit.multiStopsAt.length > 0 ? ` (${oit.multiStopsAt.map(itm => itm).join(', ')}) ` : " ", fontSize: 7, bold: true }, { text: "| " + this.flightSearchProperties.cabinClass, fontSize: 7, bold: true }], color: '#204D72' },
            {
              table: {
                widths: [50, '*', '*', '*', /*50,*/ '*', '*'],
                body: [
                  [{ text: '' }, { text: 'Flight No', fontSize: 9, bold: true }, { text: 'Origin', fontSize: 9, bold: true }, { text: 'Destination', fontSize: 9, bold: true }, /*ind == 0 ? { text: 'Duration', bold: true }:{},*/ { text: 'Dep. Date', fontSize: 9, bold: true }, { text: 'Arv. Date', fontSize: 9, bold: true }],
                  ...oit.sectorInfo.map(iit =>
                    [
                      iit.airlineLogo.includes("svg") ? (iit.airlineLogoTicket == null ? { text: iit.airlineName, fontSize: 9, bold: true } : { svg: iit.airlineLogoTicket, width: 50, height: 40 }) : (iit.airlineLogoTicket == null ? { text: iit.airlineName, fontSize: 9, bold: true } : { image: iit.airlineLogoTicket, width: 28, height: 21 }),
                      { text: `${iit.airlineName}\n(${iit.airlinePrefixCode}${iit.flightNumber})`, fontSize: 10 },
                      { text: [{ text: `${iit.fromCity}\n`, fontSize: 10, color: '#204D72', bold: true }, { text: `${iit.fromAirportName}\n`, fontSize: 7 }, { text: iit.departureTerminal == null ? "" : iit.departureTerminal, fontSize: 7, bold: true }] },
                      { text: [{ text: `${iit.toCity}\n`, fontSize: 10, color: '#204D72', bold: true }, { text: `${iit.toAirportName}\n`, fontSize: 7 }, { text: iit.arrivalTerminal == null ? "" : iit.arrivalTerminal, fontSize: 7, bold: true }] },
                      /*{ text: "-" },*/
                      { text: `${iit.departureTime}\n${formatDate(iit.departureDate, 'mediumDate', this.locale)}`, fontSize: 10 },
                      { text: `${iit.arrivalTime}\n${formatDate(iit.arrivalDate, 'mediumDate', this.locale)}\n`, fontSize: 10 }
                    ])
                ]
              },
              style: 'tableStyle',
              layout: 'noBorders'
            }
          ]
        }) : [],

        {
          canvas: [
            {
              type: 'line',
              x1: 0, // Starting X coordinate (relative to the canvas's top-left)
              y1: 0, // Starting Y coordinate (relative to the canvas's top-left)
              x2: 515, // Ending X coordinate (adjust for desired length)
              y2: 0, // Ending Y coordinate (same as y1 for a horizontal line)
              lineWidth: 1.5, // Line thickness
              lineColor: 'black' // Line color (optional)
            }
          ], margin: [0, 5]
        }
      ];

      const documentDefinition = {
        info: {
          title: 'OK Travels Flight Ticket',
          author: 'Zabi Ullah @ OK Tech Labs',
          subject: 'OK Travels Flight Ticket from OK Tech Labs',
        },
        //watermark: 'OK Travels & Tourism (pvt) Ltd',
        pageSize: 'A4',
        language: 'en-GB',
        content: [
          ...financeType === false && alleach === "each" ? withoutEachContent : financeType === false && alleach === "all" ? withoutAllContent : [
            //Doc header
            {
              columns: [
                {
                  width: 'auto', text: "eTicket", bold: true, fontSize: 16
                },
                {
                  width: '*', text: `${this.agencyOnline.agencyName}`, bold: false, fontSize: 12, alignment: 'center'
                },
                {
                  width: 215, margin: [-20, 0, 0, 0],
                  columns: [
                    {
                      text: [
                        { text: `SPNR \n`, bold: false, fontSize: 10 },
                        { text: `${this.bookingInfo.supplierLocatorCode != null ? this.bookingInfo.supplierLocatorCode : ''}`, bold: true, fontSize: 14, color: '#6A1717' }
                      ],
                      alignment: 'right',
                      width: 70
                    },
                    {
                      text: [
                        { text: `BOOKING REF. \n`, bold: false, fontSize: 10 },
                        { text: `${this.bookingInfo.pnr}`, bold: true, fontSize: 14, color: '#6A1717' }
                      ],
                      alignment: 'right',
                      width: 70
                    },
                    {
                      image: this.barcodeImage, width: 75, height: 30
                    },
                  ]
                }
              ],
              columnGap: 10,
              border: [false, false, false, true]
            },
            {
              canvas: [
                {
                  type: 'line',
                  x1: 0, // Starting X coordinate (relative to the canvas's top-left)
                  y1: 0, // Starting Y coordinate (relative to the canvas's top-left)
                  x2: 515, // Ending X coordinate (adjust for desired length)
                  y2: 0, // Ending Y coordinate (same as y1 for a horizontal line)
                  lineWidth: 1, // Line thickness
                  lineColor: 'black' // Line color (optional)
                }
              ], margin: [0, 5]
            },
            {
              columns: [
                { image: `${this.agencyLogo != null ? this.agencyLogo : ''}`, width: 60, height: 45 },
                {
                  table: {
                    widths: [150, 150],
                    body: [
                      [
                        { text: `Reserved on ${formatedBookingDate}`, fontSize: 9 },
                        { text: `Ticketed on ${this.bookingStatus == "Ticketed" ? formatedIssuanceDate : "---"}`, fontSize: 9, alignment: 'right' }
                      ],
                      [
                        // Left cell
                        {
                          text: [
                            { text: "Booked By:\n", fontSize: 9 },
                            { text: `${this.userOnline.firstName} ${this.userOnline.lastName}`, fontSize: 11, bold: true, color: '#204D72' }
                          ]
                        },
                        // Right cell
                        {
                          stack: [
                            {
                              columns: [
                                { image: this.buildingIcon, width: 12, height: 12, margin: [0, 0, 5, 0], alignment: 'right' },
                                { text: "(Consultant)", fontSize: 10, alignment: 'right' }
                              ], columnGap: 0,
                              widths: ['auto', 'auto']
                            },
                            {
                              columns: [
                                { image: this.agentIcon, width: 12, height: 12, margin: [0, 0, 5, 0], alignment: 'right' },
                                { text: `${this.userOnline.mobile}`, fontSize: 10, bold: true, alignment: 'right', }
                              ], columnGap: 0,
                              widths: ['auto', 'auto']
                            }
                          ]
                        }
                      ]
                    ]
                  }, layout: 'noBorders', margin: [140, 0, 0, 0]
                }
              ]
            },
            // Passenger Information Table
            {
              table: {
                widths: ['auto', '*', '*', '*', '*'],
                body: [
                  [{ text: 'passenger', fontSize: 9, bold: true }, { text: 'flight no', fontSize: 9, bold: true }, { text: 'route', fontSize: 9, bold: true }, { text: 'date', fontSize: 9, bold: true }, { text: 'status', fontSize: 9, bold: true }],
                  ...sortedBaggageInfo.map(p => [
                    {
                      stack: p.paxs.map(nam => ({
                        stack: [
                          { text: nam.paxName, fontSize: 9, bold: true, color: '#444444' },

                          {
                            columns: [
                              { image: this.passportIcon, width: 10, height: 10, margin: [0, 0, 1, 0] },
                              { text: `${nam.passportNo}\n`, fontSize: 9, margin: [5, 0, 0, 0] }
                            ]
                          },
                          {
                            columns: [
                              { image: this.planeIcon, width: 10, height: 10, margin: [0, 0, 1, 0] },
                              { text: `${nam.ticketNo === null ? "-" : nam.ticketNo} | seat: ${nam.seatNo === null ? "any" : nam.seatNo} | check-in: ${nam.checkIn} | cabin: ${nam.cabin} | meal: ${nam.meal === null ? "-" : nam.meal}`, fontSize: 9, bold: true, color: '#204D72', margin: [5, 0, 0, 0] }
                            ]
                          }
                        ],
                        margin: [0, 0, 0, 4] // space between passengers
                      })),
                      alignment: 'left'
                    },
                    { text: p.flightNo === null ? "-" : p.flightNo, fontSize: 9, color: '#555555' },
                    { text: p.sector, fontSize: 9 },
                    { text: p.departureDate, fontSize: 9 },
                    { text: `${this.bookingStatus == "Ticketed" ? "Confirmed" : this.bookingStatus}`, fontSize: 9, color: "#555555" },
                  ])
                ]
              },
              style: 'tableStyle',
              layout: 'lightHorizontalLines'
            },
            {
              canvas: [
                {
                  type: 'line',
                  x1: 0, // Starting X coordinate (relative to the canvas's top-left)
                  y1: 0, // Starting Y coordinate (relative to the canvas's top-left)
                  x2: 515, // Ending X coordinate (adjust for desired length)
                  y2: 0, // Ending Y coordinate (same as y1 for a horizontal line)
                  lineWidth: 1.5, // Line thickness
                  lineColor: 'black' // Line color (optional)
                }
              ], margin: [0, 5]
            },
            {
              columns: [
                {
                  columns:
                    [{ image: this.attentionIcon, width: 20, height: 20 },
                    {
                      text: [
                        { text: "NOTICE: ", fontSize: 9, bold: true },
                        { text: `Arrival at airport 3 hours before scheduled departure time on domestic flights and 4 hours before scheduled departure time on international flights. Check-in counters close 45 min before scheduled departure time for domestic, and 90minutes before scheduled departure time for international flights. Mobile check-in available now for domestic flights.\n`, fontSize: 9, bold: false },
                        { text: [{ text: `CHECK-IN BAG SIZE LIMIT `, fontSize: 9 }, { text: `${this.passengerBaggage[0].baggageCheckIn}\n`, fontSize: 10, bold: true }] },
                        { text: [{ text: `HAND CARRY BAG LIMIT `, fontSize: 9 }, { text: `${this.passengerBaggage[0].baggageCabin}\n`, fontSize: 10, bold: true }] },
                        { text: "NOTE: ", fontSize: 9, bold: true }, { text: `Excess baggage and payment is not accepted at check-in counters.\n`, fontSize: 9, bold: false },
                      ], width: '*'
                    }
                    ], alignment: 'left', columnGap: 3
                },
                { image: this.baggageImage, width: 96, height: 76 }
              ],
              columnGap: 5,
            },
            {
              canvas: [
                {
                  type: 'line',
                  x1: 0, // Starting X coordinate (relative to the canvas's top-left)
                  y1: 0, // Starting Y coordinate (relative to the canvas's top-left)
                  x2: 515, // Ending X coordinate (adjust for desired length)
                  y2: 0, // Ending Y coordinate (same as y1 for a horizontal line)
                  lineWidth: 1.5, // Line thickness
                  lineColor: 'black' // Line color (optional)
                }
              ], margin: [0, 5]
            },
            { text: '\n' },
            OnewaySectors.length > 0 ? { text: [{ text: " ONWARD: ", style: 'itineraryHeaderLeft' }, { text: ` ${this.flightSearchProperties.flightLocationInfo[0].fromAirport.split('-')[1].split('-')[0]}  ---->  ${this.flightSearchProperties.flightLocationInfo[0].toAirport.split('-')[1].split('-')[0]}`, style: 'itineraryHeaderRight' }, { text: " | ", fontSize: 7, bold: true }, { text: `Stops: ${OnewaySectors[0].noOfStops}`, fontSize: 7, bold: true }, { text: onewayStopsAt.length > 0 ? ` (${onewayStopsAt.map(itm => itm).join(', ')}) ` : " ", fontSize: 7, bold: true }, { text: "| " + this.flightSearchProperties.cabinClass, fontSize: 7, bold: true }], color: '#204D72' } : {},
            OnewaySectors.length > 0 ? OnewaySectors.map((it, ind) => {
              return [
                {
                  table: {
                    widths: [50, '*', '*', '*', /*50,*/ '*', '*'],
                    body: [
                      [{ text: '' }, ind == 0 ? { text: 'Flight No', fontSize: 9, bold: true } : {}, ind == 0 ? { text: 'Origin', fontSize: 9, bold: true } : {}, ind == 0 ? { text: 'Destination', fontSize: 9, bold: true } : {}, /*ind == 0 ? { text: 'Duration', bold: true }:{},*/ ind == 0 ? { text: 'Dep. Date', fontSize: 9, bold: true } : {}, ind == 0 ? { text: 'Arv. Date', fontSize: 9, bold: true } : {}],
                      [it.airlineLogo.includes("svg") ? (it.airlineLogoTicket == null ? { text: it.airlineName, fontSize: 9, bold: true } : { svg: it.airlineLogoTicket, width: 50, height: 40 }) : (it.airlineLogoTicket == null ? { text: it.airlineName, fontSize: 7, bold: true } : { image: it.airlineLogoTicket, width: 28, height: 21 }),
                      { text: `${it.airlineName}\n(${it.airlinePrefixCode}${it.flightNumber})`, fontSize: 10 },
                      { text: [{ text: `${it.fromCity}\n`, fontSize: 10, color: '#204D72', bold: true }, { text: `${it.fromAirportName}\n`, fontSize: 7 }, { text: it.departureTerminal == null ? "" : it.departureTerminal, fontSize: 7, bold: true }] },
                      { text: [{ text: `${it.toCity}\n`, fontSize: 10, color: '#204D72', bold: true }, { text: `${it.toAirportName}\n`, fontSize: 7 }, { text: it.arrivalTerminal == null ? "" : it.arrivalTerminal, fontSize: 7, bold: true }] },
                      /*{ text: "-" },*/
                      { text: `${it.departureTime}\n${formatDate(it.departureDate, 'mediumDate', this.locale)}`, fontSize: 10 },
                      { text: `${it.arrivalTime}\n${formatDate(it.arrivalDate, 'mediumDate', this.locale)}\n`, fontSize: 10 }]
                    ]
                  },
                  style: 'tableStyle',
                  layout: 'noBorders'
                }
              ];
            }) : [],

            isRoundTrip ? { text: [{ text: " RETURN: ", style: 'itineraryHeaderLeft' }, { text: ` ${this.flightSearchProperties.flightLocationInfo[1].fromAirport.split('-')[1].split('-')[0]}  ---->  ${this.flightSearchProperties.flightLocationInfo[1].toAirport.split('-')[1].split('-')[0]}`, style: 'itineraryHeaderRight' }, { text: " | ", fontSize: 7, bold: true }, { text: `Stops: ${RoundTripSectors[0].noOfStops}`, fontSize: 7, bold: true }, { text: returnStopsAt.length > 0 ? ` (${returnStopsAt.map(itm => itm).join(', ')}) ` : " ", fontSize: 7, bold: true }, { text: "| " + this.flightSearchProperties.cabinClass, fontSize: 7, bold: true }], color: '#204D72' } : {},
            isRoundTrip ? RoundTripSectors.map((it, ind) => {
              return [
                {
                  table: {
                    widths: [50, '*', '*', '*', /*50,*/ '*', '*'],
                    body: [
                      [{ text: '' }, ind == 0 ? { text: 'Flight No', fontSize: 9, bold: true } : {}, ind == 0 ? { text: 'Origin', fontSize: 9, bold: true } : {}, ind == 0 ? { text: 'Destination', fontSize: 9, bold: true } : {}, /*ind == 0 ? { text: 'Duration', bold: true }:{},*/ ind == 0 ? { text: 'Dep. Date', fontSize: 9, bold: true } : {}, ind == 0 ? { text: 'Arv. Date', fontSize: 9, bold: true } : {}],
                      [it.airlineLogo.includes("svg") ? (it.airlineLogoTicket == null ? { text: it.airlineName, fontSize: 9, bold: true } : { svg: it.airlineLogoTicket, width: 50, height: 40 }) : (it.airlineLogoTicket == null ? { text: it.airlineName, fontSize: 7, bold: true } : { image: it.airlineLogoTicket, width: 28, height: 21 }),
                      { text: `${it.airlineName}\n(${it.airlinePrefixCode}${it.flightNumber})`, fontSize: 10 },
                      { text: [{ text: `${it.fromCity}\n`, fontSize: 10, color: '#204D72', bold: true }, { text: `${it.fromAirportName}\n`, fontSize: 7 }, { text: it.departureTerminal == null ? "" : it.departureTerminal, fontSize: 7, bold: true }] },
                      { text: [{ text: `${it.toCity}\n`, fontSize: 10, color: '#204D72', bold: true }, { text: `${it.toAirportName}\n`, fontSize: 7 }, { text: it.arrivalTerminal == null ? "" : it.arrivalTerminal, fontSize: 7, bold: true }] },
                      /*{ text: "-" },*/
                      { text: `${it.departureTime}\n${formatDate(it.departureDate, 'mediumDate', this.locale)}`, fontSize: 10 },
                      { text: `${it.arrivalTime}\n${formatDate(it.arrivalDate, 'mediumDate', this.locale)}\n`, fontSize: 10 }]
                    ]
                  },
                  style: 'tableStyle',
                  layout: 'noBorders'
                }
              ];
            }) : [],

            isMulti ? MultiCitySectors.map((oit) => {
              return [
                { text: [{ text: " ONWARD: ", style: 'itineraryHeaderLeft' }, { text: oit.flightInfo, style: 'itineraryHeaderRight' }, { text: " | ", fontSize: 7, bold: true }, { text: `Stops: ${oit.sectorInfo[0].noOfStops}`, fontSize: 7, bold: true }, { text: oit.multiStopsAt.length > 0 ? ` (${oit.multiStopsAt.map(itm => itm).join(', ')}) ` : " ", fontSize: 7, bold: true }, { text: "| " + this.flightSearchProperties.cabinClass, fontSize: 7, bold: true }], color: '#204D72' },
                {
                  table: {
                    widths: [50, '*', '*', '*', /*50,*/ '*', '*'],
                    body: [
                      [{ text: '' }, { text: 'Flight No', fontSize: 9, bold: true }, { text: 'Origin', fontSize: 9, bold: true }, { text: 'destination', bold: true }, /*ind == 0 ? { text: 'Duration', bold: true }:{},*/ { text: 'Dep. Date', fontSize: 9, bold: true }, { text: 'Arv. Date', fontSize: 9, bold: true }],
                      ...oit.sectorInfo.map(iit =>
                        [
                          iit.airlineLogo.includes("svg") ? (iit.airlineLogoTicket == null ? { text: iit.airlineName, fontSize: 9, bold: true } : { svg: iit.airlineLogoTicket, width: 50, height: 40 }) : (iit.airlineLogoTicket == null ? { text: iit.airlineName, fontSize: 9, bold: true } : { image: iit.airlineLogoTicket, width: 28, height: 21 }),
                          { text: `${iit.airlineName}\n(${iit.airlinePrefixCode}${iit.flightNumber})`, fontSize: 10 },
                          { text: [{ text: `${iit.fromCity}\n`, fontSize: 10, color: '#204D72', bold: true }, { text: `${iit.fromAirportName}\n`, fontSize: 7 }, { text: iit.departureTerminal == null ? "" : iit.departureTerminal, fontSize: 7, bold: true }] },
                          { text: [{ text: `${iit.toCity}\n`, fontSize: 10, color: '#204D72', bold: true }, { text: `${iit.toAirportName}\n`, fontSize: 7 }, { text: iit.arrivalTerminal == null ? "" : iit.arrivalTerminal, fontSize: 7, bold: true }] },
                          /*{ text: "-" },*/
                          { text: `${iit.departureTime}\n${formatDate(iit.departureDate, 'mediumDate', this.locale)}`, fontSize: 10 },
                          { text: `${iit.arrivalTime}\n${formatDate(iit.arrivalDate, 'mediumDate', this.locale)}\n`, fontSize: 10 }
                        ])
                    ]
                  },
                  style: 'tableStyle',
                  layout: 'noBorders'
                }
              ]
            }) : [],

            /*{ text: '\n' },*/
            {
              canvas: [
                {
                  type: 'line',
                  x1: 0, // Starting X coordinate (relative to the canvas's top-left)
                  y1: 0, // Starting Y coordinate (relative to the canvas's top-left)
                  x2: 515, // Ending X coordinate (adjust for desired length)
                  y2: 0, // Ending Y coordinate (same as y1 for a horizontal line)
                  lineWidth: 1.5, // Line thickness
                  lineColor: 'black' // Line color (optional)
                }
              ], margin: [0, 5]
            },

            // Financial Information Table
            {
              table: {
                widths: ['auto', '*', '*', '*', '*'],
                body: [
                  [{ text: 'passenger(s)', fontSize: 9, bold: true }, { text: 'base fare', fontSize: 9, bold: true }, { text: 'service fees', fontSize: 9, bold: true }, { text: 'taxes', fontSize: 9, bold: true }, { text: 'total', fontSize: 9, bold: true }],
                  ...this.bookingPassengerInfo.map(f => [
                    { text: `${f.title} ${f.firstName} ${f.lastName}`, fontSize: 9, color: "#333333", bold: true },
                    { text: f.exchangeCurrency + f.baseFare, fontSize: 9, color: "#555555" },
                    { text: f.exchangeCurrency + f.serviceCharges, fontSize: 9, color: "#555555" },
                    { text: `${f.exchangeCurrency}${(f.totalTaxes + f.markup + f.runtimeMarkup)}`, fontSize: 9, color: "#555555" },
                    { text: f.exchangeCurrency + f.netFromCustomer, fontSize: 9, color: "#333333", bold: true }
                  ])
                ]
              },
              style: 'tableStyle',
              layout: 'headerLineOnly'
            },

            {
              canvas: [
                {
                  type: 'line',
                  x1: 0, // Starting X coordinate (relative to the canvas's top-left)
                  y1: 0, // Starting Y coordinate (relative to the canvas's top-left)
                  x2: 515, // Ending X coordinate (adjust for desired length)
                  y2: 0, // Ending Y coordinate (same as y1 for a horizontal line)
                  lineWidth: 1.5, // Line thickness
                  lineColor: 'black' // Line color (optional)
                }
              ], margin: [0, 5]
            }
          ]
        ],
        styles: {
          //header: { fontSize: 11, bold: true, margin: [0, 5], alignment: 'justify' },
          itineraryHeaderLeft: { fontSize: 9, bold: true },
          itineraryHeaderRight: { fontSize: 9, bold: true },
          itinerarySummary: { fontSize: 9, margin: [0, 0] },
          tableStyle: { fontSize: 12, border: [false, false, false, true], margin: [0, 0], alignment: 'center' },
        }
      };
      this.hideBtnLoader();
      pdfMake.createPdf(documentDefinition).getBlob((blob) => {
        let pdfFile = new File([blob], `Booking_Itinerary_${this.bookingInfo.pnr}.pdf`, { type: "application/pdf" });
        this.ticketEmailObj.subject = "Your E-Ticket is Here";
        var formData = new FormData();
        formData.append("subject", this.ticketEmailObj.subject);
        formData.append("customerEmail", this.ticketEmailObj.customerEmail);
        formData.append("agencyId", localStorage.getItem("AgencyId"));
        formData.append("pdfFile", pdfFile);

        this.emailService.emailIterniaryMulti(formData).subscribe((data) => {
          this.isLoadPanelVisible = false;
          if (data == true) {
            this.NewSuccess.dismissAll();
            this.isLoadPanelVisible = false;
            this.hideBtnLoader();
          } else {
            document.getElementById("messageEmail").innerHTML = 'Please Try Again!';
            setTimeout(() => { document.getElementById("messageEmail").innerHTML = ''; }, 5000);
            this.isLoadPanelVisible = false;
            this.hideBtnLoader();
          }
        });
      });
    });
  }

}



